import './assets/pointsGraph.css';var rf = Object.defineProperty;
var of = (e, t, n) => t in e ? rf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var E = (e, t, n) => of(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as f, jsxs as k, Fragment as ht } from "react/jsx-runtime";
import * as Wn from "react";
import Rt, { useState as Y, useEffect as mt, forwardRef as Ft, useRef as kt, useImperativeHandle as Wt, useMemo as Ki, useLayoutEffect as af, useCallback as Tc, lazy as lf, Suspense as cf } from "react";
import { useTheme as tn, Avatar as Nn, Badge as ao, alpha as Tn, Paper as _i, Box as R, CircularProgress as wi, Typography as H, Chip as Dt, Button as ot, Dialog as lo, DialogTitle as df, DialogActions as uf, Stack as gt, AppBar as ff, Toolbar as hf, IconButton as li, TextField as yn, ButtonGroup as Ec, LinearProgress as pf, Input as Rc, Link as Lc, Skeleton as at, FormControlLabel as zn, Checkbox as gf, Alert as ke, Tooltip as ls, Popover as Fc, ClickAwayListener as mf, Menu as bf, MenuItem as cs, Switch as co, FormLabel as uo, FormControl as Ms, InputLabel as fo, Select as yf, ListSubheader as xf, RadioGroup as Nc, Radio as zc, OutlinedInput as Bc, InputAdornment as Wc, Card as jc, CardContent as vf, Grid as Us, Divider as $c, DialogContent as _f, AlertTitle as wf, FormHelperText as Sf, TableCell as Pn, styled as Vc, TableHead as Cf, Accordion as kf, AccordionSummary as Pf, AccordionDetails as Af, TableContainer as Mf, Table as If, TableBody as Df, TableRow as xr, Grow as Of, Tabs as Tf, Tab as Jo, MenuList as Ef, ListItemIcon as ta, ListItemText as ea, Collapse as Rf } from "@mui/material";
import { message as Lf } from "./queries/message/index.js";
import { contact as Hc } from "./queries/contact/index.js";
import "./queries/calendars/index.js";
import { DaymapQuery as Ff } from "./queries/daymapQuery.js";
import "./queries/student/index.js";
import { settings as Nf } from "./queries/settings/index.js";
import { points as zf } from "./queries/points/index.js";
import "./queries/assessment/index.js";
import { annotations as Bf } from "./queries/assessment/annotations/index.js";
import "./queries/assessment/rubrics/index.js";
import "./queries/assessment/qcesubjects/index.js";
import "./queries/assessment/extensionrequest/index.js";
import { files as Si } from "./queries/files/index.js";
import "./queries/attendance/index.js";
import { forms as ho } from "./queries/forms/index.js";
import "./queries/notifications/index.js";
import { interviews as ci } from "./queries/interviews/index.js";
import "./queries/notes/index.js";
import "./queries/annoucements/index.js";
import { payments as Uc } from "./queries/payments/index.js";
import "./queries/assessment/analysis/index.js";
import "./queries/group/index.js";
import "./queries/projects/index.js";
import { courses as Wf } from "./queries/courses/index.js";
import "./queries/password/index.js";
import { grey as An, indigo as Yc, red as ds, cyan as po, green as go, blue as re, orange as jf, deepOrange as us, teal as $f, amber as Vf, lightGreen as Hf, blueGrey as na, yellow as qc } from "@mui/material/colors";
import { useAuth as Ne } from "./context/auth/index.js";
import { useSchool as me } from "./context/school/index.js";
import { useApp as Uf } from "./context/app/index.js";
import "./context/notifications/index.js";
import "./context/pushnotifications/index.js";
import { C as Yf } from "./index-D7cgykJH.js";
import { B as qf } from "./index-BZpqZYNM.js";
import Xc from "@mui/icons-material/FileUpload";
import Xf from "@mui/icons-material/Newspaper";
import vr from "@mui/icons-material/Message";
import Gc from "@mui/icons-material/Announcement";
import Gf from "@mui/icons-material/PersonSearch";
import Kc from "@mui/icons-material/ThreeP";
import Kf from "@mui/icons-material/Article";
import Qc from "@mui/icons-material/DirectionsBus";
import Qf from "@mui/icons-material/CalendarToday";
import Zf from "@mui/icons-material/CalendarMonth";
import Jf from "@mui/icons-material/Class";
import th from "@mui/icons-material/Note";
import Zc from "@mui/icons-material/EditCalendar";
import eh from "@mui/icons-material/Grading";
import nh from "@mui/icons-material/Groups";
import Jc from "@mui/icons-material/Person";
import ih from "@mui/icons-material/Place";
import td from "@mui/icons-material/Info";
import sh from "@mui/icons-material/Assignment";
import ed from "@mui/icons-material/AttachFile";
import rh from "@mui/icons-material/Forum";
import oh from "@mui/icons-material/KeyboardReturn";
import ah from "@mui/icons-material/EmojiEvents";
import lh from "@mui/icons-material/Notifications";
import ch from "@mui/icons-material/Schedule";
import dh from "@mui/icons-material/HowToReg";
import uh from "@mui/icons-material/Description";
import fh from "@mui/icons-material/AccountBox";
import hh from "@mui/icons-material/Home";
import ph from "@mui/icons-material/MoreHoriz";
import Is from "@mui/icons-material/Edit";
import nd from "@mui/icons-material/Clear";
import gh from "@mui/icons-material/ThumbUp";
import mh from "@mui/icons-material/Pending";
import bh from "@mui/icons-material/Payment";
import mo from "@mui/icons-material/Add";
import yh from "@mui/icons-material/Logout";
import xh from "@mui/icons-material/LightMode";
import vh from "@mui/icons-material/DarkMode";
import _h from "@mui/icons-material/LockReset";
import ia from "@mui/icons-material/OpenInNew";
import wh from "@mui/icons-material/Check";
import Sh from "@mui/icons-material/TimeLapse";
import Ch from "@mui/icons-material/ChevronRight";
import kh from "@mui/icons-material/ChevronLeft";
import Ph from "@mui/icons-material/Bolt";
import Ah from "@mui/icons-material/RateReview";
import Mh from "@mui/icons-material/Download";
import Ih from "@mui/icons-material/ZoomIn";
import Dh from "@mui/icons-material/ZoomOut";
import Oh from "@mui/icons-material/Task";
import Th from "@mui/icons-material/Warning";
import Eh from "@mui/icons-material/InsertDriveFile";
import Rh from "@mui/icons-material/FindInPage";
import Lh from "@mui/icons-material/ExpandLess";
import id from "@mui/icons-material/ExpandMore";
import Fh from "@mui/icons-material/Alarm";
import Nh from "@mui/icons-material/Fullscreen";
import zh from "@mui/icons-material/AddCircle";
import Bh from "@mui/icons-material/RemoveCircle";
import Wh from "@mui/icons-material/PlayCircle";
import jh from "@mui/icons-material/Search";
import sd from "@mui/icons-material/Send";
import $h from "@mui/icons-material/Settings";
import bo from "@mui/icons-material/Save";
import Vh from "@mui/icons-material/Link";
import Hh from "@mui/icons-material/Upload";
import rd from "@mui/icons-material/Reply";
import Uh from "@mui/icons-material/ReplyAll";
import Yh from "@mui/icons-material/Restore";
import qh from "@mui/icons-material/Visibility";
import Xh from "@mui/icons-material/VisibilityOff";
import Ci from "@mui/icons-material/Delete";
import sa from "@mui/icons-material/AttachMoney";
import od from "@mui/icons-material/PriorityHigh";
import yo from "@mui/icons-material/Close";
import ra from "@mui/icons-material/Done";
import Gh from "@mui/icons-material/QuestionMark";
import { a as ad } from "./_commonjsHelpers-BItOPCY9.js";
import "./types/interviews/index.js";
import "./types/contacts/index.js";
import "./types/points/index.js";
import "./types/projects/index.js";
import "./types/groups/index.js";
import Kh from "@mui/material/ButtonBase/TouchRipple";
import { prettyDate as Zt, isToday as Qh, prettyDateRange as ld } from "./helpers/dates.js";
import { MessageType as ue, DiaryEntryType as ye, DiaryItemPropertyTypeEnum as rn, NotificationType as je, FileLocationEnum as oa, DiaryItemAttendanceStatus as on, MessageAttachmentType as fs, PaymentStatusEnum as te, RecordStatusType as an, FormFieldFlags as ee, MessageActions as Ii } from "./helpers/daymaptypes.js";
import { useStudent as cd, openExternalUrl as Zh } from "./helpers/index.js";
import { stringAvatar as Jh, urlDecode as aa, urlEncode as la } from "./helpers/strings.js";
import { useBlocker as tp } from "react-router-dom";
import { useMutation as ep, useQueryClient as xo } from "@tanstack/react-query";
import { Toast as hs } from "./components/Toast/index.js";
import "./files-CxGPn86v.js";
import np from "@mui/icons-material/List";
import "@mui/icons-material/Folder";
import "@mui/icons-material/DoNotDisturb";
import "@mui/icons-material/Create";
import "@mui/icons-material/PersonAdd";
import "@mui/icons-material/PersonRemove";
import "@mui/icons-material/EventAvailable";
import "@mui/icons-material/EventBusy";
import "@mui/icons-material/PlaylistAdd";
import "@mui/icons-material/PlaylistRemove";
import Mt from "dayjs";
import "@mui/icons-material/ArrowBack";
import "@mui/icons-material/Menu";
import "@mui/icons-material/Login";
import ip from "@mui/material/IconButton";
import ca from "@mui/icons-material/School";
import { styled as sp } from "@mui/system";
import "@mui/material/Button";
import "@mui/material/Popover";
import { DateTimePicker as rp, DatePicker as op, TimePicker as ap } from "@mui/x-date-pickers";
import "./components/pickers/multiGroupPicker.js";
import "./components/pickers/WeekPicker.js";
import "@mui/icons-material/Refresh";
import lp from "dayjs/plugin/isoWeek";
import { AzureUpload as cp, useAzureUpload as dd } from "./components/files/upload/AzureUpload.js";
import { PaymentAmount as dp, getFormattedAmounts as up } from "./components/payments/PaymentAmount.js";
import { Payments as fp } from "./helpers/payments.js";
import { ProcessPayment as hp } from "./components/payments/ProcessPayment.js";
import { Invoice as pp } from "./components/payments/Invoice.js";
import gp from "@mui/icons-material/Print";
import { M as oe, S as ae, L as da } from "./Label-DyVniv3J.js";
import { Hidden as mp } from "./components/records/fields/Hidden.js";
import bp from "@mui/icons-material/RestoreFromTrash";
import "@mui/icons-material/ArrowForward";
import "@mui/material/Grid";
import { DaymapSkeleton as Ds } from "./components/skeletons/index.js";
import { UploadTypeEnum as ud } from "./components/files/upload/AzureUploadArgs.js";
import "./components/pdf/index.js";
import "./components/inputs/NumberField.js";
import "@mui/icons-material/Archive";
import "@mui/icons-material/MarkChatRead";
import { LoadingOverlay as yp } from "./components/loadingoverlay/index.js";
var ua;
((e) => {
  ((i) => {
    i[i.NoActivities = 0] = "NoActivities", i[i.StudentActivitiesOnly = 1] = "StudentActivitiesOnly", i[i.TeacherActivitiesOnly = 2] = "TeacherActivitiesOnly", i[i.StudentAndTeacherActivities = 3] = "StudentAndTeacherActivities";
  })(e.PeriodType || (e.PeriodType = {})), e.getPeriodTypeLabel = (i) => {
    switch (i) {
      case 0:
        return "No Activities";
      case 1:
        return "Student Activities Only";
      case 2:
        return "Teacher Activities Only";
      case 3:
        return "Student and Teacher Activities";
      default:
        return "";
    }
  };
  class t extends Ff {
    constructor(s) {
      super(
        ["Periods", s.day],
        s,
        `/lms/api/calendar/timetable/periods/config?timetableDayID=${s.day ?? "0"}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minute
      );
    }
  }
  e.PeriodConfiguration = t;
  function n(i) {
    const { Post: s } = Ne(), { baseUrl: r } = me();
    return ep({
      mutationFn: async (o) => s({
        url: `${r}/lms/api/calendar/timetable/periods/save?timetableDayID=${i || 0}`,
        config: null,
        data: o
      })
    });
  }
  e.useSavePeriod = n;
})(ua || (ua = {}));
function xp() {
  const { isPending: e, error: t, data: n } = new Nf.get().ToQuery();
  return { isPending: e, error: t, settings: n, hasFeature: (l) => e ? !1 : (l & n.Licence.FeatureMask) !== 0, isState: (l) => e ? !1 : (l & n.Licence.State) !== 0, isCategory: (l) => e ? !1 : (l & n.Licence.Category) !== 0, hasTab: (l) => e ? !1 : (l & n.portalTabs) !== 0, isAtLeastThisVersion: (l, c = 0, d = 0) => {
    if (e || t)
      return !1;
    const h = n.daymapVersion.match(/^\d+(?:\.\d+){0,2}/);
    if (!h) return !1;
    const p = h[0].split(".").map((y) => Number(y)), [m = 0, g = 0, b = 0] = [...p, 0, 0].slice(0, 3).map((y) => Number.isFinite(y) ? y : 0);
    return m > l ? !0 : m < l ? !1 : g > c ? !0 : g < c ? !1 : b >= d;
  } };
}
var vp = /* @__PURE__ */ ((e) => (e[e.Core = 1] = "Core", e[e.AssessmentPlus = 2] = "AssessmentPlus", e[e.Calendars = 4] = "Calendars", e[e.CheckIn = 8] = "CheckIn", e[e.Communication = 16] = "Communication", e[e.Curriculum = 32] = "Curriculum", e[e.CurriculumLimited = 64] = "CurriculumLimited", e[e.DataAnalysis = 128] = "DataAnalysis", e[e.EventManagement = 256] = "EventManagement", e[e.MobileApp = 512] = "MobileApp", e[e.ParentPortal = 1024] = "ParentPortal", e[e.RecordManagement = 2048] = "RecordManagement", e[e.Reporting = 4096] = "Reporting", e[e.StandardTests = 8192] = "StandardTests", e[e.StudentData = 16384] = "StudentData", e[e.Theming = 32768] = "Theming", e[e.UserMovement = 131072] = "UserMovement", e[e.Integration = 262144] = "Integration", e[e.StudentPortal = 524288] = "StudentPortal", e[e.CaseManager = 1048576] = "CaseManager", e[e.UnitPlanning = 2097152] = "UnitPlanning", e[e.StaffHub = 4194304] = "StaffHub", e[e.Any = 8388607] = "Any", e[e.CalendarEvents = 260] = "CalendarEvents", e[e.Curriculums = 96] = "Curriculums", e))(vp || {}), _p = /* @__PURE__ */ ((e) => (e[e.Gov = 1] = "Gov", e[e.Independent = 2] = "Independent", e[e.Unknown = 0] = "Unknown", e))(_p || {}), wp = /* @__PURE__ */ ((e) => (e[e.NSW = 1] = "NSW", e[e.QLD = 2] = "QLD", e[e.SA = 4] = "SA", e[e.VIC = 8] = "VIC", e[e.Unknown = 0] = "Unknown", e))(wp || {}), Sp = /* @__PURE__ */ ((e) => (e[e.Messaging = 1] = "Messaging", e[e.Attendance = 2] = "Attendance", e[e.Assessment = 4] = "Assessment", e[e.Schedule = 8] = "Schedule", e[e.Results = 16] = "Results", e[e.Reports = 32] = "Reports", e[e.AssessmentPlan = 64] = "AssessmentPlan", e[e.CourseOutline = 128] = "CourseOutline", e[e.Records = 256] = "Records", e[e.Attachments = 512] = "Attachments", e[e.Notes = 1024] = "Notes", e[e.DefaultView = 311] = "DefaultView", e))(Sp || {});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const Cp = {
  prefix: "fas",
  iconName: "table",
  icon: [512, 512, [], "f0ce", "M64 256l0-96 160 0 0 96L64 256zm0 64l160 0 0 96L64 416l0-96zm224 96l0-96 160 0 0 96-160 0zM448 256l-160 0 0-96 160 0 0 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
}, kp = {
  prefix: "fas",
  iconName: "user-pen",
  icon: [640, 512, ["user-edit"], "f4ff", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
}, Pp = {
  prefix: "fas",
  iconName: "file-word",
  icon: [384, 512, [], "f1c2", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"]
}, Ap = {
  prefix: "fas",
  iconName: "file-powerpoint",
  icon: [384, 512, [], "f1c4", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM136 240l68 0c42 0 76 34 76 76s-34 76-76 76l-44 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-104c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28l-44 0 0 56 44 0z"]
}, Mp = {
  prefix: "fas",
  iconName: "file-excel",
  icon: [384, 512, [], "f1c3", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"]
}, Ip = {
  prefix: "fas",
  iconName: "file-image",
  icon: [384, 512, [128443], "f1c5", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-88 0-40 0-48 0-48 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"]
}, Dp = {
  prefix: "fas",
  iconName: "file-video",
  icon: [384, 512, [], "f1c8", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96zM300.9 397.9L256 368l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
}, Op = {
  prefix: "fas",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"]
}, fa = {
  prefix: "fas",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function Tp(e, t, n) {
  return (t = Rp(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ha(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function D(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ha(Object(n), !0).forEach(function(i) {
      Tp(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ha(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Ep(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rp(e) {
  var t = Ep(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const pa = () => {
};
let vo = {}, fd = {}, hd = null, pd = {
  mark: pa,
  measure: pa
};
try {
  typeof window < "u" && (vo = window), typeof document < "u" && (fd = document), typeof MutationObserver < "u" && (hd = MutationObserver), typeof performance < "u" && (pd = performance);
} catch {
}
const {
  userAgent: ga = ""
} = vo.navigator || {}, Ge = vo, St = fd, ma = hd, Di = pd;
Ge.document;
const ze = !!St.documentElement && !!St.head && typeof St.addEventListener == "function" && typeof St.createElement == "function", gd = ~ga.indexOf("MSIE") || ~ga.indexOf("Trident/");
var Lp = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, Fp = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, md = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, Np = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, bd = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], qt = "classic", Os = "duotone", zp = "sharp", Bp = "sharp-duotone", yd = [qt, Os, zp, Bp], Wp = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, jp = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, $p = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), Vp = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Hp = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], ba = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, Up = ["kit"], Yp = {
  kit: {
    "fa-kit": "fak"
  }
}, qp = ["fak", "fakd"], Xp = {
  kit: {
    fak: "fa-kit"
  }
}, ya = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Oi = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Gp = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Kp = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Qp = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Zp = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, Jp = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, _r = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, tg = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], wr = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...Gp, ...tg], eg = ["solid", "regular", "light", "thin", "duotone", "brands"], xd = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], ng = xd.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ig = [...Object.keys(Jp), ...eg, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Oi.GROUP, Oi.SWAP_OPACITY, Oi.PRIMARY, Oi.SECONDARY].concat(xd.map((e) => "".concat(e, "x"))).concat(ng.map((e) => "w-".concat(e))), sg = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Le = "___FONT_AWESOME___", Sr = 16, vd = "fa", _d = "svg-inline--fa", xn = "data-fa-i2svg", Cr = "data-fa-pseudo-element", rg = "data-fa-pseudo-element-pending", _o = "data-prefix", wo = "data-icon", xa = "fontawesome-i2svg", og = "async", ag = ["HTML", "HEAD", "STYLE", "SCRIPT"], wd = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function ki(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[qt];
    }
  });
}
const Sd = D({}, md);
Sd[qt] = D(D(D(D({}, {
  "fa-duotone": "duotone"
}), md[qt]), ba.kit), ba["kit-duotone"]);
const lg = ki(Sd), kr = D({}, Vp);
kr[qt] = D(D(D(D({}, {
  duotone: "fad"
}), kr[qt]), ya.kit), ya["kit-duotone"]);
const va = ki(kr), Pr = D({}, _r);
Pr[qt] = D(D({}, Pr[qt]), Xp.kit);
const So = ki(Pr), Ar = D({}, Zp);
Ar[qt] = D(D({}, Ar[qt]), Yp.kit);
ki(Ar);
const cg = Lp, Cd = "fa-layers-text", dg = Fp, ug = D({}, Wp);
ki(ug);
const fg = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Ys = Np, hg = [...Up, ...ig], ti = Ge.FontAwesomeConfig || {};
function pg(e) {
  var t = St.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function gg(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
St && typeof St.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, i] = t;
  const s = gg(pg(n));
  s != null && (ti[i] = s);
});
const kd = {
  styleDefault: "solid",
  familyDefault: qt,
  cssPrefix: vd,
  replacementClass: _d,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ti.familyPrefix && (ti.cssPrefix = ti.familyPrefix);
const En = D(D({}, kd), ti);
En.autoReplaceSvg || (En.observeMutations = !1);
const K = {};
Object.keys(kd).forEach((e) => {
  Object.defineProperty(K, e, {
    enumerable: !0,
    set: function(t) {
      En[e] = t, ei.forEach((n) => n(K));
    },
    get: function() {
      return En[e];
    }
  });
});
Object.defineProperty(K, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    En.cssPrefix = e, ei.forEach((t) => t(K));
  },
  get: function() {
    return En.cssPrefix;
  }
});
Ge.FontAwesomeConfig = K;
const ei = [];
function mg(e) {
  return ei.push(e), () => {
    ei.splice(ei.indexOf(e), 1);
  };
}
const $e = Sr, _e = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function bg(e) {
  if (!e || !ze)
    return;
  const t = St.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = St.head.childNodes;
  let i = null;
  for (let s = n.length - 1; s > -1; s--) {
    const r = n[s], o = (r.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(o) > -1 && (i = r);
  }
  return St.head.insertBefore(t, i), e;
}
const yg = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function di() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += yg[Math.random() * 62 | 0];
  return t;
}
function Bn(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Co(e) {
  return e.classList ? Bn(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function Pd(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function xg(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(Pd(e[n]), '" '), "").trim();
}
function Ts(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function ko(e) {
  return e.size !== _e.size || e.x !== _e.x || e.y !== _e.y || e.rotate !== _e.rotate || e.flipX || e.flipY;
}
function vg(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: i
  } = e;
  const s = {
    transform: "translate(".concat(n / 2, " 256)")
  }, r = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), a = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(r, " ").concat(o, " ").concat(a)
  }, c = {
    transform: "translate(".concat(i / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: l,
    path: c
  };
}
function _g(e) {
  let {
    transform: t,
    width: n = Sr,
    height: i = Sr,
    startCentered: s = !1
  } = e, r = "";
  return s && gd ? r += "translate(".concat(t.x / $e - n / 2, "em, ").concat(t.y / $e - i / 2, "em) ") : s ? r += "translate(calc(-50% + ".concat(t.x / $e, "em), calc(-50% + ").concat(t.y / $e, "em)) ") : r += "translate(".concat(t.x / $e, "em, ").concat(t.y / $e, "em) "), r += "scale(".concat(t.size / $e * (t.flipX ? -1 : 1), ", ").concat(t.size / $e * (t.flipY ? -1 : 1), ") "), r += "rotate(".concat(t.rotate, "deg) "), r;
}
var wg = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function Ad() {
  const e = vd, t = _d, n = K.cssPrefix, i = K.replacementClass;
  let s = wg;
  if (n !== e || i !== t) {
    const r = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), a = new RegExp("\\.".concat(t), "g");
    s = s.replace(r, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(a, ".".concat(i));
  }
  return s;
}
let _a = !1;
function qs() {
  K.autoAddCss && !_a && (bg(Ad()), _a = !0);
}
var Sg = {
  mixout() {
    return {
      dom: {
        css: Ad,
        insertCss: qs
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        qs();
      },
      beforeI2svg() {
        qs();
      }
    };
  }
};
const Fe = Ge || {};
Fe[Le] || (Fe[Le] = {});
Fe[Le].styles || (Fe[Le].styles = {});
Fe[Le].hooks || (Fe[Le].hooks = {});
Fe[Le].shims || (Fe[Le].shims = []);
var we = Fe[Le];
const Md = [], Id = function() {
  St.removeEventListener("DOMContentLoaded", Id), ps = 1, Md.map((e) => e());
};
let ps = !1;
ze && (ps = (St.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(St.readyState), ps || St.addEventListener("DOMContentLoaded", Id));
function Cg(e) {
  ze && (ps ? setTimeout(e, 0) : Md.push(e));
}
function Pi(e) {
  const {
    tag: t,
    attributes: n = {},
    children: i = []
  } = e;
  return typeof e == "string" ? Pd(e) : "<".concat(t, " ").concat(xg(n), ">").concat(i.map(Pi).join(""), "</").concat(t, ">");
}
function wa(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var Xs = function(t, n, i, s) {
  var r = Object.keys(t), o = r.length, a = n, l, c, d;
  for (i === void 0 ? (l = 1, d = t[r[0]]) : (l = 0, d = i); l < o; l++)
    c = r[l], d = a(d, t[c], c, t);
  return d;
};
function kg(e) {
  const t = [];
  let n = 0;
  const i = e.length;
  for (; n < i; ) {
    const s = e.charCodeAt(n++);
    if (s >= 55296 && s <= 56319 && n < i) {
      const r = e.charCodeAt(n++);
      (r & 64512) == 56320 ? t.push(((s & 1023) << 10) + (r & 1023) + 65536) : (t.push(s), n--);
    } else
      t.push(s);
  }
  return t;
}
function Mr(e) {
  const t = kg(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Pg(e, t) {
  const n = e.length;
  let i = e.charCodeAt(t), s;
  return i >= 55296 && i <= 56319 && n > t + 1 && (s = e.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (i - 55296) * 1024 + s - 56320 + 65536 : i;
}
function Sa(e) {
  return Object.keys(e).reduce((t, n) => {
    const i = e[n];
    return !!i.icon ? t[i.iconName] = i.icon : t[n] = i, t;
  }, {});
}
function Ir(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: i = !1
  } = n, s = Sa(t);
  typeof we.hooks.addPack == "function" && !i ? we.hooks.addPack(e, Sa(t)) : we.styles[e] = D(D({}, we.styles[e] || {}), s), e === "fas" && Ir("fa", t);
}
const {
  styles: ui,
  shims: Ag
} = we, Dd = Object.keys(So), Mg = Dd.reduce((e, t) => (e[t] = Object.keys(So[t]), e), {});
let Po = null, Od = {}, Td = {}, Ed = {}, Rd = {}, Ld = {};
function Ig(e) {
  return ~hg.indexOf(e);
}
function Dg(e, t) {
  const n = t.split("-"), i = n[0], s = n.slice(1).join("-");
  return i === e && s !== "" && !Ig(s) ? s : null;
}
const Fd = () => {
  const e = (i) => Xs(ui, (s, r, o) => (s[o] = Xs(r, i, {}), s), {});
  Od = e((i, s, r) => (s[3] && (i[s[3]] = r), s[2] && s[2].filter((a) => typeof a == "number").forEach((a) => {
    i[a.toString(16)] = r;
  }), i)), Td = e((i, s, r) => (i[r] = r, s[2] && s[2].filter((a) => typeof a == "string").forEach((a) => {
    i[a] = r;
  }), i)), Ld = e((i, s, r) => {
    const o = s[2];
    return i[r] = r, o.forEach((a) => {
      i[a] = r;
    }), i;
  });
  const t = "far" in ui || K.autoFetchSvg, n = Xs(Ag, (i, s) => {
    const r = s[0];
    let o = s[1];
    const a = s[2];
    return o === "far" && !t && (o = "fas"), typeof r == "string" && (i.names[r] = {
      prefix: o,
      iconName: a
    }), typeof r == "number" && (i.unicodes[r.toString(16)] = {
      prefix: o,
      iconName: a
    }), i;
  }, {
    names: {},
    unicodes: {}
  });
  Ed = n.names, Rd = n.unicodes, Po = Es(K.styleDefault, {
    family: K.familyDefault
  });
};
mg((e) => {
  Po = Es(e.styleDefault, {
    family: K.familyDefault
  });
});
Fd();
function Ao(e, t) {
  return (Od[e] || {})[t];
}
function Og(e, t) {
  return (Td[e] || {})[t];
}
function pn(e, t) {
  return (Ld[e] || {})[t];
}
function Nd(e) {
  return Ed[e] || {
    prefix: null,
    iconName: null
  };
}
function Tg(e) {
  const t = Rd[e], n = Ao("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Ke() {
  return Po;
}
const zd = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function Eg(e) {
  let t = qt;
  const n = Dd.reduce((i, s) => (i[s] = "".concat(K.cssPrefix, "-").concat(s), i), {});
  return yd.forEach((i) => {
    (e.includes(n[i]) || e.some((s) => Mg[i].includes(s))) && (t = i);
  }), t;
}
function Es(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = qt
  } = t, i = lg[n][e];
  if (n === Os && !e)
    return "fad";
  const s = va[n][e] || va[n][i], r = e in we.styles ? e : null;
  return s || r || null;
}
function Rg(e) {
  let t = [], n = null;
  return e.forEach((i) => {
    const s = Dg(K.cssPrefix, i);
    s ? n = s : i && t.push(i);
  }), {
    iconName: n,
    rest: t
  };
}
function Ca(e) {
  return e.sort().filter((t, n, i) => i.indexOf(t) === n);
}
function Rs(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let i = null;
  const s = wr.concat(Kp), r = Ca(e.filter((u) => s.includes(u))), o = Ca(e.filter((u) => !wr.includes(u))), a = r.filter((u) => (i = u, !bd.includes(u))), [l = null] = a, c = Eg(r), d = D(D({}, Rg(o)), {}, {
    prefix: Es(l, {
      family: c
    })
  });
  return D(D(D({}, d), zg({
    values: e,
    family: c,
    styles: ui,
    config: K,
    canonical: d,
    givenPrefix: i
  })), Lg(n, i, d));
}
function Lg(e, t, n) {
  let {
    prefix: i,
    iconName: s
  } = n;
  if (e || !i || !s)
    return {
      prefix: i,
      iconName: s
    };
  const r = t === "fa" ? Nd(s) : {}, o = pn(i, s);
  return s = r.iconName || o || s, i = r.prefix || i, i === "far" && !ui.far && ui.fas && !K.autoFetchSvg && (i = "fas"), {
    prefix: i,
    iconName: s
  };
}
const Fg = yd.filter((e) => e !== qt || e !== Os), Ng = Object.keys(_r).filter((e) => e !== qt).map((e) => Object.keys(_r[e])).flat();
function zg(e) {
  const {
    values: t,
    family: n,
    canonical: i,
    givenPrefix: s = "",
    styles: r = {},
    config: o = {}
  } = e, a = n === Os, l = t.includes("fa-duotone") || t.includes("fad"), c = o.familyDefault === "duotone", d = i.prefix === "fad" || i.prefix === "fa-duotone";
  if (!a && (l || c || d) && (i.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (i.prefix = "fab"), !i.prefix && Fg.includes(n) && (Object.keys(r).find((h) => Ng.includes(h)) || o.autoFetchSvg)) {
    const h = $p.get(n).defaultShortPrefixId;
    i.prefix = h, i.iconName = pn(i.prefix, i.iconName) || i.iconName;
  }
  return (i.prefix === "fa" || s === "fa") && (i.prefix = Ke() || "fas"), i;
}
class Bg {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
      n[i] = arguments[i];
    const s = n.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((r) => {
      this.definitions[r] = D(D({}, this.definitions[r] || {}), s[r]), Ir(r, s[r]);
      const o = So[qt][r];
      o && Ir(o, s[r]), Fd();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const i = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(i).map((s) => {
      const {
        prefix: r,
        iconName: o,
        icon: a
      } = i[s], l = a[2];
      t[r] || (t[r] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (t[r][c] = a);
      }), t[r][o] = a;
    }), t;
  }
}
let ka = [], Mn = {};
const Dn = {}, Wg = Object.keys(Dn);
function jg(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return ka = e, Mn = {}, Object.keys(Dn).forEach((i) => {
    Wg.indexOf(i) === -1 && delete Dn[i];
  }), ka.forEach((i) => {
    const s = i.mixout ? i.mixout() : {};
    if (Object.keys(s).forEach((r) => {
      typeof s[r] == "function" && (n[r] = s[r]), typeof s[r] == "object" && Object.keys(s[r]).forEach((o) => {
        n[r] || (n[r] = {}), n[r][o] = s[r][o];
      });
    }), i.hooks) {
      const r = i.hooks();
      Object.keys(r).forEach((o) => {
        Mn[o] || (Mn[o] = []), Mn[o].push(r[o]);
      });
    }
    i.provides && i.provides(Dn);
  }), n;
}
function Dr(e, t) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    i[s - 2] = arguments[s];
  return (Mn[e] || []).forEach((o) => {
    t = o.apply(null, [t, ...i]);
  }), t;
}
function vn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  (Mn[e] || []).forEach((r) => {
    r.apply(null, n);
  });
}
function Qe() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Dn[e] ? Dn[e].apply(null, t) : void 0;
}
function Or(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || Ke();
  if (t)
    return t = pn(n, t) || t, wa(Bd.definitions, n, t) || wa(we.styles, n, t);
}
const Bd = new Bg(), $g = () => {
  K.autoReplaceSvg = !1, K.observeMutations = !1, vn("noAuto");
}, Vg = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ze ? (vn("beforeI2svg", e), Qe("pseudoElements2svg", e), Qe("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    K.autoReplaceSvg === !1 && (K.autoReplaceSvg = !0), K.observeMutations = !0, Cg(() => {
      Ug({
        autoReplaceSvgRoot: t
      }), vn("watch", e);
    });
  }
}, Hg = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: pn(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Es(e[0]);
      return {
        prefix: n,
        iconName: pn(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(K.cssPrefix, "-")) > -1 || e.match(cg))) {
      const t = Rs(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || Ke(),
        iconName: pn(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = Ke();
      return {
        prefix: t,
        iconName: pn(t, e) || e
      };
    }
  }
}, ne = {
  noAuto: $g,
  config: K,
  dom: Vg,
  parse: Hg,
  library: Bd,
  findIconDefinition: Or,
  toHtml: Pi
}, Ug = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = St
  } = e;
  (Object.keys(we.styles).length > 0 || K.autoFetchSvg) && ze && K.autoReplaceSvg && ne.dom.i2svg({
    node: t
  });
};
function Ls(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Pi(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!ze) return;
      const n = St.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function Yg(e) {
  let {
    children: t,
    main: n,
    mask: i,
    attributes: s,
    styles: r,
    transform: o
  } = e;
  if (ko(o) && n.found && !i.found) {
    const {
      width: a,
      height: l
    } = n, c = {
      x: a / l / 2,
      y: 0.5
    };
    s.style = Ts(D(D({}, r), {}, {
      "transform-origin": "".concat(c.x + o.x / 16, "em ").concat(c.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function qg(e) {
  let {
    prefix: t,
    iconName: n,
    children: i,
    attributes: s,
    symbol: r
  } = e;
  const o = r === !0 ? "".concat(t, "-").concat(K.cssPrefix, "-").concat(n) : r;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: D(D({}, s), {}, {
        id: o
      }),
      children: i
    }]
  }];
}
function Mo(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: i,
    iconName: s,
    transform: r,
    symbol: o,
    title: a,
    maskId: l,
    titleId: c,
    extra: d,
    watchable: u = !1
  } = e, {
    width: h,
    height: p
  } = n.found ? n : t, m = qp.includes(i), g = [K.replacementClass, s ? "".concat(K.cssPrefix, "-").concat(s) : ""].filter((v) => d.classes.indexOf(v) === -1).filter((v) => v !== "" || !!v).concat(d.classes).join(" ");
  let b = {
    children: [],
    attributes: D(D({}, d.attributes), {}, {
      "data-prefix": i,
      "data-icon": s,
      class: g,
      role: d.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(h, " ").concat(p)
    })
  };
  const y = m && !~d.classes.indexOf("fa-fw") ? {
    width: "".concat(h / p * 16 * 0.0625, "em")
  } : {};
  u && (b.attributes[xn] = ""), a && (b.children.push({
    tag: "title",
    attributes: {
      id: b.attributes["aria-labelledby"] || "title-".concat(c || di())
    },
    children: [a]
  }), delete b.attributes.title);
  const x = D(D({}, b), {}, {
    prefix: i,
    iconName: s,
    main: t,
    mask: n,
    maskId: l,
    transform: r,
    symbol: o,
    styles: D(D({}, y), d.styles)
  }), {
    children: w,
    attributes: S
  } = n.found && t.found ? Qe("generateAbstractMask", x) || {
    children: [],
    attributes: {}
  } : Qe("generateAbstractIcon", x) || {
    children: [],
    attributes: {}
  };
  return x.children = w, x.attributes = S, o ? qg(x) : Yg(x);
}
function Pa(e) {
  const {
    content: t,
    width: n,
    height: i,
    transform: s,
    title: r,
    extra: o,
    watchable: a = !1
  } = e, l = D(D(D({}, o.attributes), r ? {
    title: r
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  a && (l[xn] = "");
  const c = D({}, o.styles);
  ko(s) && (c.transform = _g({
    transform: s,
    startCentered: !0,
    width: n,
    height: i
  }), c["-webkit-transform"] = c.transform);
  const d = Ts(c);
  d.length > 0 && (l.style = d);
  const u = [];
  return u.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), r && u.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), u;
}
function Xg(e) {
  const {
    content: t,
    title: n,
    extra: i
  } = e, s = D(D(D({}, i.attributes), n ? {
    title: n
  } : {}), {}, {
    class: i.classes.join(" ")
  }), r = Ts(i.styles);
  r.length > 0 && (s.style = r);
  const o = [];
  return o.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
const {
  styles: Gs
} = we;
function Tr(e) {
  const t = e[0], n = e[1], [i] = e.slice(4);
  let s = null;
  return Array.isArray(i) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(K.cssPrefix, "-").concat(Ys.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(K.cssPrefix, "-").concat(Ys.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(K.cssPrefix, "-").concat(Ys.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: s
  };
}
const Gg = {
  found: !1,
  width: 512,
  height: 512
};
function Kg(e, t) {
  !wd && !K.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Er(e, t) {
  let n = t;
  return t === "fa" && K.styleDefault !== null && (t = Ke()), new Promise((i, s) => {
    if (n === "fa") {
      const r = Nd(e) || {};
      e = r.iconName || e, t = r.prefix || t;
    }
    if (e && t && Gs[t] && Gs[t][e]) {
      const r = Gs[t][e];
      return i(Tr(r));
    }
    Kg(e, t), i(D(D({}, Gg), {}, {
      icon: K.showMissingIcons && e ? Qe("missingIconAbstract") || {} : {}
    }));
  });
}
const Aa = () => {
}, Rr = K.measurePerformance && Di && Di.mark && Di.measure ? Di : {
  mark: Aa,
  measure: Aa
}, qn = 'FA "6.7.2"', Qg = (e) => (Rr.mark("".concat(qn, " ").concat(e, " begins")), () => Wd(e)), Wd = (e) => {
  Rr.mark("".concat(qn, " ").concat(e, " ends")), Rr.measure("".concat(qn, " ").concat(e), "".concat(qn, " ").concat(e, " begins"), "".concat(qn, " ").concat(e, " ends"));
};
var Io = {
  begin: Qg,
  end: Wd
};
const Qi = () => {
};
function Ma(e) {
  return typeof (e.getAttribute ? e.getAttribute(xn) : null) == "string";
}
function Zg(e) {
  const t = e.getAttribute ? e.getAttribute(_o) : null, n = e.getAttribute ? e.getAttribute(wo) : null;
  return t && n;
}
function Jg(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(K.replacementClass);
}
function tm() {
  return K.autoReplaceSvg === !0 ? Zi.replace : Zi[K.autoReplaceSvg] || Zi.replace;
}
function em(e) {
  return St.createElementNS("http://www.w3.org/2000/svg", e);
}
function nm(e) {
  return St.createElement(e);
}
function jd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? em : nm
  } = t;
  if (typeof e == "string")
    return St.createTextNode(e);
  const i = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(r) {
    i.setAttribute(r, e.attributes[r]);
  }), (e.children || []).forEach(function(r) {
    i.appendChild(jd(r, {
      ceFn: n
    }));
  }), i;
}
function im(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const Zi = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(jd(n), t);
      }), t.getAttribute(xn) === null && K.keepOriginalSource) {
        let n = St.createComment(im(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Co(t).indexOf(K.replacementClass))
      return Zi.replace(e);
    const i = new RegExp("".concat(K.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const r = n[0].attributes.class.split(" ").reduce((o, a) => (a === K.replacementClass || a.match(i) ? o.toSvg.push(a) : o.toNode.push(a), o), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = r.toSvg.join(" "), r.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", r.toNode.join(" "));
    }
    const s = n.map((r) => Pi(r)).join(`
`);
    t.setAttribute(xn, ""), t.innerHTML = s;
  }
};
function Ia(e) {
  e();
}
function $d(e, t) {
  const n = typeof t == "function" ? t : Qi;
  if (e.length === 0)
    n();
  else {
    let i = Ia;
    K.mutateApproach === og && (i = Ge.requestAnimationFrame || Ia), i(() => {
      const s = tm(), r = Io.begin("mutate");
      e.map(s), r(), n();
    });
  }
}
let Do = !1;
function Vd() {
  Do = !0;
}
function Lr() {
  Do = !1;
}
let gs = null;
function Da(e) {
  if (!ma || !K.observeMutations)
    return;
  const {
    treeCallback: t = Qi,
    nodeCallback: n = Qi,
    pseudoElementsCallback: i = Qi,
    observeMutationsRoot: s = St
  } = e;
  gs = new ma((r) => {
    if (Do) return;
    const o = Ke();
    Bn(r).forEach((a) => {
      if (a.type === "childList" && a.addedNodes.length > 0 && !Ma(a.addedNodes[0]) && (K.searchPseudoElements && i(a.target), t(a.target)), a.type === "attributes" && a.target.parentNode && K.searchPseudoElements && i(a.target.parentNode), a.type === "attributes" && Ma(a.target) && ~fg.indexOf(a.attributeName))
        if (a.attributeName === "class" && Zg(a.target)) {
          const {
            prefix: l,
            iconName: c
          } = Rs(Co(a.target));
          a.target.setAttribute(_o, l || o), c && a.target.setAttribute(wo, c);
        } else Jg(a.target) && n(a.target);
    });
  }), ze && gs.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function sm() {
  gs && gs.disconnect();
}
function rm(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((i, s) => {
    const r = s.split(":"), o = r[0], a = r.slice(1);
    return o && a.length > 0 && (i[o] = a.join(":").trim()), i;
  }, {})), n;
}
function om(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), i = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = Rs(Co(e));
  return s.prefix || (s.prefix = Ke()), t && n && (s.prefix = t, s.iconName = n), s.iconName && s.prefix || (s.prefix && i.length > 0 && (s.iconName = Og(s.prefix, e.innerText) || Ao(s.prefix, Mr(e.innerText))), !s.iconName && K.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function am(e) {
  const t = Bn(e.attributes).reduce((s, r) => (s.name !== "class" && s.name !== "style" && (s[r.name] = r.value), s), {}), n = e.getAttribute("title"), i = e.getAttribute("data-fa-title-id");
  return K.autoA11y && (n ? t["aria-labelledby"] = "".concat(K.replacementClass, "-title-").concat(i || di()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function lm() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: _e,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Oa(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: i,
    rest: s
  } = om(e), r = am(e), o = Dr("parseNodeAttributes", {}, e);
  let a = t.styleParser ? rm(e) : [];
  return D({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: i,
    transform: _e,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: a,
      attributes: r
    }
  }, o);
}
const {
  styles: cm
} = we;
function Hd(e) {
  const t = K.autoReplaceSvg === "nest" ? Oa(e, {
    styleParser: !1
  }) : Oa(e);
  return ~t.extra.classes.indexOf(Cd) ? Qe("generateLayersText", e, t) : Qe("generateSvgReplacementMutation", e, t);
}
function dm() {
  return [...Hp, ...wr];
}
function Ta(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!ze) return Promise.resolve();
  const n = St.documentElement.classList, i = (d) => n.add("".concat(xa, "-").concat(d)), s = (d) => n.remove("".concat(xa, "-").concat(d)), r = K.autoFetchSvg ? dm() : bd.concat(Object.keys(cm));
  r.includes("fa") || r.push("fa");
  const o = [".".concat(Cd, ":not([").concat(xn, "])")].concat(r.map((d) => ".".concat(d, ":not([").concat(xn, "])"))).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  let a = [];
  try {
    a = Bn(e.querySelectorAll(o));
  } catch {
  }
  if (a.length > 0)
    i("pending"), s("complete");
  else
    return Promise.resolve();
  const l = Io.begin("onTree"), c = a.reduce((d, u) => {
    try {
      const h = Hd(u);
      h && d.push(h);
    } catch (h) {
      wd || h.name === "MissingIcon" && console.error(h);
    }
    return d;
  }, []);
  return new Promise((d, u) => {
    Promise.all(c).then((h) => {
      $d(h, () => {
        i("active"), i("complete"), s("pending"), typeof t == "function" && t(), l(), d();
      });
    }).catch((h) => {
      l(), u(h);
    });
  });
}
function um(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Hd(e).then((n) => {
    n && $d([n], t);
  });
}
function fm(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = (t || {}).icon ? t : Or(t || {});
    let {
      mask: s
    } = n;
    return s && (s = (s || {}).icon ? s : Or(s || {})), e(i, D(D({}, n), {}, {
      mask: s
    }));
  };
}
const hm = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = _e,
    symbol: i = !1,
    mask: s = null,
    maskId: r = null,
    title: o = null,
    titleId: a = null,
    classes: l = [],
    attributes: c = {},
    styles: d = {}
  } = t;
  if (!e) return;
  const {
    prefix: u,
    iconName: h,
    icon: p
  } = e;
  return Ls(D({
    type: "icon"
  }, e), () => (vn("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), K.autoA11y && (o ? c["aria-labelledby"] = "".concat(K.replacementClass, "-title-").concat(a || di()) : (c["aria-hidden"] = "true", c.focusable = "false")), Mo({
    icons: {
      main: Tr(p),
      mask: s ? Tr(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: u,
    iconName: h,
    transform: D(D({}, _e), n),
    symbol: i,
    title: o,
    maskId: r,
    titleId: a,
    extra: {
      attributes: c,
      styles: d,
      classes: l
    }
  })));
};
var pm = {
  mixout() {
    return {
      icon: fm(hm)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = Ta, e.nodeCallback = um, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = St,
        callback: i = () => {
        }
      } = t;
      return Ta(n, i);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: i,
        title: s,
        titleId: r,
        prefix: o,
        transform: a,
        symbol: l,
        mask: c,
        maskId: d,
        extra: u
      } = n;
      return new Promise((h, p) => {
        Promise.all([Er(i, o), c.iconName ? Er(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((m) => {
          let [g, b] = m;
          h([t, Mo({
            icons: {
              main: g,
              mask: b
            },
            prefix: o,
            iconName: i,
            transform: a,
            symbol: l,
            maskId: d,
            title: s,
            titleId: r,
            extra: u,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: i,
        main: s,
        transform: r,
        styles: o
      } = t;
      const a = Ts(o);
      a.length > 0 && (i.style = a);
      let l;
      return ko(r) && (l = Qe("generateAbstractTransformGrouping", {
        main: s,
        transform: r,
        containerWidth: s.width,
        iconWidth: s.width
      })), n.push(l || s.icon), {
        children: n,
        attributes: i
      };
    };
  }
}, gm = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Ls({
          type: "layer"
        }, () => {
          vn("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let i = [];
          return e((s) => {
            Array.isArray(s) ? s.map((r) => {
              i = i.concat(r.abstract);
            }) : i = i.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(K.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: i
          }];
        });
      }
    };
  }
}, mm = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: i = [],
          attributes: s = {},
          styles: r = {}
        } = t;
        return Ls({
          type: "counter",
          content: e
        }, () => (vn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Xg({
          content: e.toString(),
          title: n,
          extra: {
            attributes: s,
            styles: r,
            classes: ["".concat(K.cssPrefix, "-layers-counter"), ...i]
          }
        })));
      }
    };
  }
}, bm = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = _e,
          title: i = null,
          classes: s = [],
          attributes: r = {},
          styles: o = {}
        } = t;
        return Ls({
          type: "text",
          content: e
        }, () => (vn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Pa({
          content: e,
          transform: D(D({}, _e), n),
          title: i,
          extra: {
            attributes: r,
            styles: o,
            classes: ["".concat(K.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: i,
        transform: s,
        extra: r
      } = n;
      let o = null, a = null;
      if (gd) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        o = c.width / l, a = c.height / l;
      }
      return K.autoA11y && !i && (r.attributes["aria-hidden"] = "true"), Promise.resolve([t, Pa({
        content: t.innerHTML,
        width: o,
        height: a,
        transform: s,
        title: i,
        extra: r,
        watchable: !0
      })]);
    };
  }
};
const ym = new RegExp('"', "ug"), Ea = [1105920, 1112319], Ra = D(D(D(D({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), jp), sg), Qp), Fr = Object.keys(Ra).reduce((e, t) => (e[t.toLowerCase()] = Ra[t], e), {}), xm = Object.keys(Fr).reduce((e, t) => {
  const n = Fr[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function vm(e) {
  const t = e.replace(ym, ""), n = Pg(t, 0), i = n >= Ea[0] && n <= Ea[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Mr(s ? t[0] : t),
    isSecondary: i || s
  };
}
function _m(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), i = parseInt(t), s = isNaN(i) ? "normal" : i;
  return (Fr[n] || {})[s] || xm[n];
}
function La(e, t) {
  const n = "".concat(rg).concat(t.replace(":", "-"));
  return new Promise((i, s) => {
    if (e.getAttribute(n) !== null)
      return i();
    const o = Bn(e.children).filter((h) => h.getAttribute(Cr) === t)[0], a = Ge.getComputedStyle(e, t), l = a.getPropertyValue("font-family"), c = l.match(dg), d = a.getPropertyValue("font-weight"), u = a.getPropertyValue("content");
    if (o && !c)
      return e.removeChild(o), i();
    if (c && u !== "none" && u !== "") {
      const h = a.getPropertyValue("content");
      let p = _m(l, d);
      const {
        value: m,
        isSecondary: g
      } = vm(h), b = c[0].startsWith("FontAwesome");
      let y = Ao(p, m), x = y;
      if (b) {
        const w = Tg(m);
        w.iconName && w.prefix && (y = w.iconName, p = w.prefix);
      }
      if (y && !g && (!o || o.getAttribute(_o) !== p || o.getAttribute(wo) !== x)) {
        e.setAttribute(n, x), o && e.removeChild(o);
        const w = lm(), {
          extra: S
        } = w;
        S.attributes[Cr] = t, Er(y, p).then((v) => {
          const _ = Mo(D(D({}, w), {}, {
            icons: {
              main: v,
              mask: zd()
            },
            prefix: p,
            iconName: x,
            extra: S,
            watchable: !0
          })), C = St.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(C, e.firstChild) : e.appendChild(C), C.outerHTML = _.map((P) => Pi(P)).join(`
`), e.removeAttribute(n), i();
        }).catch(s);
      } else
        i();
    } else
      i();
  });
}
function wm(e) {
  return Promise.all([La(e, "::before"), La(e, "::after")]);
}
function Sm(e) {
  return e.parentNode !== document.head && !~ag.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Cr) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function Fa(e) {
  if (ze)
    return new Promise((t, n) => {
      const i = Bn(e.querySelectorAll("*")).filter(Sm).map(wm), s = Io.begin("searchPseudoElements");
      Vd(), Promise.all(i).then(() => {
        s(), Lr(), t();
      }).catch(() => {
        s(), Lr(), n();
      });
    });
}
var Cm = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = Fa, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = St
      } = t;
      K.searchPseudoElements && Fa(n);
    };
  }
};
let Na = !1;
var km = {
  mixout() {
    return {
      dom: {
        unwatch() {
          Vd(), Na = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        Da(Dr("mutationObserverCallbacks", {}));
      },
      noAuto() {
        sm();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        Na ? Lr() : Da(Dr("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const za = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, i) => {
    const s = i.toLowerCase().split("-"), r = s[0];
    let o = s.slice(1).join("-");
    if (r && o === "h")
      return n.flipX = !0, n;
    if (r && o === "v")
      return n.flipY = !0, n;
    if (o = parseFloat(o), isNaN(o))
      return n;
    switch (r) {
      case "grow":
        n.size = n.size + o;
        break;
      case "shrink":
        n.size = n.size - o;
        break;
      case "left":
        n.x = n.x - o;
        break;
      case "right":
        n.x = n.x + o;
        break;
      case "up":
        n.y = n.y - o;
        break;
      case "down":
        n.y = n.y + o;
        break;
      case "rotate":
        n.rotate = n.rotate + o;
        break;
    }
    return n;
  }, t);
};
var Pm = {
  mixout() {
    return {
      parse: {
        transform: (e) => za(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = za(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: i,
        containerWidth: s,
        iconWidth: r
      } = t;
      const o = {
        transform: "translate(".concat(s / 2, " 256)")
      }, a = "translate(".concat(i.x * 32, ", ").concat(i.y * 32, ") "), l = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), c = "rotate(".concat(i.rotate, " 0 0)"), d = {
        transform: "".concat(a, " ").concat(l, " ").concat(c)
      }, u = {
        transform: "translate(".concat(r / 2 * -1, " -256)")
      }, h = {
        outer: o,
        inner: d,
        path: u
      };
      return {
        tag: "g",
        attributes: D({}, h.outer),
        children: [{
          tag: "g",
          attributes: D({}, h.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: D(D({}, n.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
};
const Ks = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Ba(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function Am(e) {
  return e.tag === "g" ? e.children : [e];
}
var Mm = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), i = n ? Rs(n.split(" ").map((s) => s.trim())) : zd();
        return i.prefix || (i.prefix = Ke()), e.mask = i, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: i,
        main: s,
        mask: r,
        maskId: o,
        transform: a
      } = t;
      const {
        width: l,
        icon: c
      } = s, {
        width: d,
        icon: u
      } = r, h = vg({
        transform: a,
        containerWidth: d,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: D(D({}, Ks), {}, {
          fill: "white"
        })
      }, m = c.children ? {
        children: c.children.map(Ba)
      } : {}, g = {
        tag: "g",
        attributes: D({}, h.inner),
        children: [Ba(D({
          tag: c.tag,
          attributes: D(D({}, c.attributes), h.path)
        }, m))]
      }, b = {
        tag: "g",
        attributes: D({}, h.outer),
        children: [g]
      }, y = "mask-".concat(o || di()), x = "clip-".concat(o || di()), w = {
        tag: "mask",
        attributes: D(D({}, Ks), {}, {
          id: y,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, b]
      }, S = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: x
          },
          children: Am(u)
        }, w]
      };
      return n.push(S, {
        tag: "rect",
        attributes: D({
          fill: "currentColor",
          "clip-path": "url(#".concat(x, ")"),
          mask: "url(#".concat(y, ")")
        }, Ks)
      }), {
        children: n,
        attributes: i
      };
    };
  }
}, Im = {
  provides(e) {
    let t = !1;
    Ge.matchMedia && (t = Ge.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], i = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: D(D({}, i), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const r = D(D({}, s), {}, {
        attributeName: "opacity"
      }), o = {
        tag: "circle",
        attributes: D(D({}, i), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || o.children.push({
        tag: "animate",
        attributes: D(D({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: D(D({}, r), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(o), n.push({
        tag: "path",
        attributes: D(D({}, i), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: D(D({}, r), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: D(D({}, i), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: D(D({}, r), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, Dm = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), i = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = i, e;
      }
    };
  }
}, Om = [Sg, pm, gm, mm, bm, Cm, km, Pm, Mm, Im, Dm];
jg(Om, {
  mixoutsTo: ne
});
ne.noAuto;
ne.config;
ne.library;
ne.dom;
const Nr = ne.parse;
ne.findIconDefinition;
ne.toHtml;
const Tm = ne.icon;
ne.layer;
ne.text;
ne.counter;
var Ti = { exports: {} }, Ei = { exports: {} }, bt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wa;
function Em() {
  if (Wa) return bt;
  Wa = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(v) {
    if (typeof v == "object" && v !== null) {
      var _ = v.$$typeof;
      switch (_) {
        case t:
          switch (v = v.type, v) {
            case l:
            case c:
            case i:
            case r:
            case s:
            case u:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case a:
                case d:
                case m:
                case p:
                case o:
                  return v;
                default:
                  return _;
              }
          }
        case n:
          return _;
      }
    }
  }
  function S(v) {
    return w(v) === c;
  }
  return bt.AsyncMode = l, bt.ConcurrentMode = c, bt.ContextConsumer = a, bt.ContextProvider = o, bt.Element = t, bt.ForwardRef = d, bt.Fragment = i, bt.Lazy = m, bt.Memo = p, bt.Portal = n, bt.Profiler = r, bt.StrictMode = s, bt.Suspense = u, bt.isAsyncMode = function(v) {
    return S(v) || w(v) === l;
  }, bt.isConcurrentMode = S, bt.isContextConsumer = function(v) {
    return w(v) === a;
  }, bt.isContextProvider = function(v) {
    return w(v) === o;
  }, bt.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === t;
  }, bt.isForwardRef = function(v) {
    return w(v) === d;
  }, bt.isFragment = function(v) {
    return w(v) === i;
  }, bt.isLazy = function(v) {
    return w(v) === m;
  }, bt.isMemo = function(v) {
    return w(v) === p;
  }, bt.isPortal = function(v) {
    return w(v) === n;
  }, bt.isProfiler = function(v) {
    return w(v) === r;
  }, bt.isStrictMode = function(v) {
    return w(v) === s;
  }, bt.isSuspense = function(v) {
    return w(v) === u;
  }, bt.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === i || v === c || v === r || v === s || v === u || v === h || typeof v == "object" && v !== null && (v.$$typeof === m || v.$$typeof === p || v.$$typeof === o || v.$$typeof === a || v.$$typeof === d || v.$$typeof === b || v.$$typeof === y || v.$$typeof === x || v.$$typeof === g);
  }, bt.typeOf = w, bt;
}
var yt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ja;
function Rm() {
  return ja || (ja = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function w(O) {
      return typeof O == "string" || typeof O == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      O === i || O === c || O === r || O === s || O === u || O === h || typeof O == "object" && O !== null && (O.$$typeof === m || O.$$typeof === p || O.$$typeof === o || O.$$typeof === a || O.$$typeof === d || O.$$typeof === b || O.$$typeof === y || O.$$typeof === x || O.$$typeof === g);
    }
    function S(O) {
      if (typeof O == "object" && O !== null) {
        var vt = O.$$typeof;
        switch (vt) {
          case t:
            var _t = O.type;
            switch (_t) {
              case l:
              case c:
              case i:
              case r:
              case s:
              case u:
                return _t;
              default:
                var It = _t && _t.$$typeof;
                switch (It) {
                  case a:
                  case d:
                  case m:
                  case p:
                  case o:
                    return It;
                  default:
                    return vt;
                }
            }
          case n:
            return vt;
        }
      }
    }
    var v = l, _ = c, C = a, P = o, I = t, V = d, $ = i, T = m, j = p, q = n, B = r, X = s, G = u, st = !1;
    function rt(O) {
      return st || (st = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(O) || S(O) === l;
    }
    function M(O) {
      return S(O) === c;
    }
    function A(O) {
      return S(O) === a;
    }
    function L(O) {
      return S(O) === o;
    }
    function N(O) {
      return typeof O == "object" && O !== null && O.$$typeof === t;
    }
    function F(O) {
      return S(O) === d;
    }
    function W(O) {
      return S(O) === i;
    }
    function U(O) {
      return S(O) === m;
    }
    function Q(O) {
      return S(O) === p;
    }
    function et(O) {
      return S(O) === n;
    }
    function tt(O) {
      return S(O) === r;
    }
    function it(O) {
      return S(O) === s;
    }
    function z(O) {
      return S(O) === u;
    }
    yt.AsyncMode = v, yt.ConcurrentMode = _, yt.ContextConsumer = C, yt.ContextProvider = P, yt.Element = I, yt.ForwardRef = V, yt.Fragment = $, yt.Lazy = T, yt.Memo = j, yt.Portal = q, yt.Profiler = B, yt.StrictMode = X, yt.Suspense = G, yt.isAsyncMode = rt, yt.isConcurrentMode = M, yt.isContextConsumer = A, yt.isContextProvider = L, yt.isElement = N, yt.isForwardRef = F, yt.isFragment = W, yt.isLazy = U, yt.isMemo = Q, yt.isPortal = et, yt.isProfiler = tt, yt.isStrictMode = it, yt.isSuspense = z, yt.isValidElementType = w, yt.typeOf = S;
  }()), yt;
}
var $a;
function Ud() {
  return $a || ($a = 1, process.env.NODE_ENV === "production" ? Ei.exports = Em() : Ei.exports = Rm()), Ei.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Qs, Va;
function Lm() {
  if (Va) return Qs;
  Va = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function i(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Qs = s() ? Object.assign : function(r, o) {
    for (var a, l = i(r), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var u in a)
        t.call(a, u) && (l[u] = a[u]);
      if (e) {
        c = e(a);
        for (var h = 0; h < c.length; h++)
          n.call(a, c[h]) && (l[c[h]] = a[c[h]]);
      }
    }
    return l;
  }, Qs;
}
var Zs, Ha;
function Oo() {
  if (Ha) return Zs;
  Ha = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zs = e, Zs;
}
var Js, Ua;
function Yd() {
  return Ua || (Ua = 1, Js = Function.call.bind(Object.prototype.hasOwnProperty)), Js;
}
var tr, Ya;
function Fm() {
  if (Ya) return tr;
  Ya = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Oo(), n = {}, i = /* @__PURE__ */ Yd();
    e = function(r) {
      var o = "Warning: " + r;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function s(r, o, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in r)
        if (i(r, d)) {
          var u;
          try {
            if (typeof r[d] != "function") {
              var h = Error(
                (l || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            u = r[d](o, d, l, a, null, t);
          } catch (m) {
            u = m;
          }
          if (u && !(u instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + a + " type: " + u.message + (p ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, tr = s, tr;
}
var er, qa;
function Nm() {
  if (qa) return er;
  qa = 1;
  var e = Ud(), t = Lm(), n = /* @__PURE__ */ Oo(), i = /* @__PURE__ */ Yd(), s = /* @__PURE__ */ Fm(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return er = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function u(M) {
      var A = M && (c && M[c] || M[d]);
      if (typeof A == "function")
        return A;
    }
    var h = "<<anonymous>>", p = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: x(),
      arrayOf: w,
      element: S(),
      elementType: v(),
      instanceOf: _,
      node: V(),
      objectOf: P,
      oneOf: C,
      oneOfType: I,
      shape: T,
      exact: j
    };
    function m(M, A) {
      return M === A ? M !== 0 || 1 / M === 1 / A : M !== M && A !== A;
    }
    function g(M, A) {
      this.message = M, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function b(M) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, L = 0;
      function N(W, U, Q, et, tt, it, z) {
        if (et = et || h, it = it || Q, z !== n) {
          if (l) {
            var O = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw O.name = "Invariant Violation", O;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var vt = et + ":" + Q;
            !A[vt] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + it + "` prop on `" + et + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[vt] = !0, L++);
          }
        }
        return U[Q] == null ? W ? U[Q] === null ? new g("The " + tt + " `" + it + "` is marked as required " + ("in `" + et + "`, but its value is `null`.")) : new g("The " + tt + " `" + it + "` is marked as required in " + ("`" + et + "`, but its value is `undefined`.")) : null : M(U, Q, et, tt, it);
      }
      var F = N.bind(null, !1);
      return F.isRequired = N.bind(null, !0), F;
    }
    function y(M) {
      function A(L, N, F, W, U, Q) {
        var et = L[N], tt = X(et);
        if (tt !== M) {
          var it = G(et);
          return new g(
            "Invalid " + W + " `" + U + "` of type " + ("`" + it + "` supplied to `" + F + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return b(A);
    }
    function x() {
      return b(o);
    }
    function w(M) {
      function A(L, N, F, W, U) {
        if (typeof M != "function")
          return new g("Property `" + U + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var Q = L[N];
        if (!Array.isArray(Q)) {
          var et = X(Q);
          return new g("Invalid " + W + " `" + U + "` of type " + ("`" + et + "` supplied to `" + F + "`, expected an array."));
        }
        for (var tt = 0; tt < Q.length; tt++) {
          var it = M(Q, tt, F, W, U + "[" + tt + "]", n);
          if (it instanceof Error)
            return it;
        }
        return null;
      }
      return b(A);
    }
    function S() {
      function M(A, L, N, F, W) {
        var U = A[L];
        if (!a(U)) {
          var Q = X(U);
          return new g("Invalid " + F + " `" + W + "` of type " + ("`" + Q + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(M);
    }
    function v() {
      function M(A, L, N, F, W) {
        var U = A[L];
        if (!e.isValidElementType(U)) {
          var Q = X(U);
          return new g("Invalid " + F + " `" + W + "` of type " + ("`" + Q + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(M);
    }
    function _(M) {
      function A(L, N, F, W, U) {
        if (!(L[N] instanceof M)) {
          var Q = M.name || h, et = rt(L[N]);
          return new g("Invalid " + W + " `" + U + "` of type " + ("`" + et + "` supplied to `" + F + "`, expected ") + ("instance of `" + Q + "`."));
        }
        return null;
      }
      return b(A);
    }
    function C(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), o;
      function A(L, N, F, W, U) {
        for (var Q = L[N], et = 0; et < M.length; et++)
          if (m(Q, M[et]))
            return null;
        var tt = JSON.stringify(M, function(z, O) {
          var vt = G(O);
          return vt === "symbol" ? String(O) : O;
        });
        return new g("Invalid " + W + " `" + U + "` of value `" + String(Q) + "` " + ("supplied to `" + F + "`, expected one of " + tt + "."));
      }
      return b(A);
    }
    function P(M) {
      function A(L, N, F, W, U) {
        if (typeof M != "function")
          return new g("Property `" + U + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var Q = L[N], et = X(Q);
        if (et !== "object")
          return new g("Invalid " + W + " `" + U + "` of type " + ("`" + et + "` supplied to `" + F + "`, expected an object."));
        for (var tt in Q)
          if (i(Q, tt)) {
            var it = M(Q, tt, F, W, U + "." + tt, n);
            if (it instanceof Error)
              return it;
          }
        return null;
      }
      return b(A);
    }
    function I(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var A = 0; A < M.length; A++) {
        var L = M[A];
        if (typeof L != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + st(L) + " at index " + A + "."
          ), o;
      }
      function N(F, W, U, Q, et) {
        for (var tt = [], it = 0; it < M.length; it++) {
          var z = M[it], O = z(F, W, U, Q, et, n);
          if (O == null)
            return null;
          O.data && i(O.data, "expectedType") && tt.push(O.data.expectedType);
        }
        var vt = tt.length > 0 ? ", expected one of type [" + tt.join(", ") + "]" : "";
        return new g("Invalid " + Q + " `" + et + "` supplied to " + ("`" + U + "`" + vt + "."));
      }
      return b(N);
    }
    function V() {
      function M(A, L, N, F, W) {
        return q(A[L]) ? null : new g("Invalid " + F + " `" + W + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return b(M);
    }
    function $(M, A, L, N, F) {
      return new g(
        (M || "React class") + ": " + A + " type `" + L + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function T(M) {
      function A(L, N, F, W, U) {
        var Q = L[N], et = X(Q);
        if (et !== "object")
          return new g("Invalid " + W + " `" + U + "` of type `" + et + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var tt in M) {
          var it = M[tt];
          if (typeof it != "function")
            return $(F, W, U, tt, G(it));
          var z = it(Q, tt, F, W, U + "." + tt, n);
          if (z)
            return z;
        }
        return null;
      }
      return b(A);
    }
    function j(M) {
      function A(L, N, F, W, U) {
        var Q = L[N], et = X(Q);
        if (et !== "object")
          return new g("Invalid " + W + " `" + U + "` of type `" + et + "` " + ("supplied to `" + F + "`, expected `object`."));
        var tt = t({}, L[N], M);
        for (var it in tt) {
          var z = M[it];
          if (i(M, it) && typeof z != "function")
            return $(F, W, U, it, G(z));
          if (!z)
            return new g(
              "Invalid " + W + " `" + U + "` key `" + it + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(L[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var O = z(Q, it, F, W, U + "." + it, n);
          if (O)
            return O;
        }
        return null;
      }
      return b(A);
    }
    function q(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(q);
          if (M === null || a(M))
            return !0;
          var A = u(M);
          if (A) {
            var L = A.call(M), N;
            if (A !== M.entries) {
              for (; !(N = L.next()).done; )
                if (!q(N.value))
                  return !1;
            } else
              for (; !(N = L.next()).done; ) {
                var F = N.value;
                if (F && !q(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function B(M, A) {
      return M === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    function X(M) {
      var A = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : B(A, M) ? "symbol" : A;
    }
    function G(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var A = X(M);
      if (A === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    function st(M) {
      var A = G(M);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    function rt(M) {
      return !M.constructor || !M.constructor.name ? h : M.constructor.name;
    }
    return p.checkPropTypes = s, p.resetWarningCache = s.resetWarningCache, p.PropTypes = p, p;
  }, er;
}
var nr, Xa;
function zm() {
  if (Xa) return nr;
  Xa = 1;
  var e = /* @__PURE__ */ Oo();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, nr = function() {
    function i(o, a, l, c, d, u) {
      if (u !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    i.isRequired = i;
    function s() {
      return i;
    }
    var r = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: s,
      element: i,
      elementType: i,
      instanceOf: s,
      node: i,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, nr;
}
var Ga;
function Bm() {
  if (Ga) return Ti.exports;
  if (Ga = 1, process.env.NODE_ENV !== "production") {
    var e = Ud(), t = !0;
    Ti.exports = /* @__PURE__ */ Nm()(e.isElement, t);
  } else
    Ti.exports = /* @__PURE__ */ zm()();
  return Ti.exports;
}
var Wm = /* @__PURE__ */ Bm();
const lt = /* @__PURE__ */ ad(Wm);
function Ka(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ve(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ka(Object(n), !0).forEach(function(i) {
      In(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ka(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function In(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function jm(e, t) {
  if (e == null) return {};
  var n = {}, i = Object.keys(e), s, r;
  for (r = 0; r < i.length; r++)
    s = i[r], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
function $m(e, t) {
  if (e == null) return {};
  var n = jm(e, t), i, s;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (s = 0; s < r.length; s++)
      i = r[s], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
  }
  return n;
}
function zr(e) {
  return Vm(e) || Hm(e) || Um(e) || Ym();
}
function Vm(e) {
  if (Array.isArray(e)) return Br(e);
}
function Hm(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Um(e, t) {
  if (e) {
    if (typeof e == "string") return Br(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Br(e, t);
  }
}
function Br(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
  return i;
}
function Ym() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qm(e) {
  var t, n = e.beat, i = e.fade, s = e.beatFade, r = e.bounce, o = e.shake, a = e.flash, l = e.spin, c = e.spinPulse, d = e.spinReverse, u = e.pulse, h = e.fixedWidth, p = e.inverse, m = e.border, g = e.listItem, b = e.flip, y = e.size, x = e.rotation, w = e.pull, S = (t = {
    "fa-beat": n,
    "fa-fade": i,
    "fa-beat-fade": s,
    "fa-bounce": r,
    "fa-shake": o,
    "fa-flash": a,
    "fa-spin": l,
    "fa-spin-reverse": d,
    "fa-spin-pulse": c,
    "fa-pulse": u,
    "fa-fw": h,
    "fa-inverse": p,
    "fa-border": m,
    "fa-li": g,
    "fa-flip": b === !0,
    "fa-flip-horizontal": b === "horizontal" || b === "both",
    "fa-flip-vertical": b === "vertical" || b === "both"
  }, In(t, "fa-".concat(y), typeof y < "u" && y !== null), In(t, "fa-rotate-".concat(x), typeof x < "u" && x !== null && x !== 0), In(t, "fa-pull-".concat(w), typeof w < "u" && w !== null), In(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(S).map(function(v) {
    return S[v] ? v : null;
  }).filter(function(v) {
    return v;
  });
}
function Xm(e) {
  return e = e - 0, e === e;
}
function qd(e) {
  return Xm(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var Gm = ["style"];
function Km(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Qm(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var i = n.indexOf(":"), s = qd(n.slice(0, i)), r = n.slice(i + 1).trim();
    return s.startsWith("webkit") ? t[Km(s)] = r : t[s] = r, t;
  }, {});
}
function Xd(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var i = (t.children || []).map(function(l) {
    return Xd(e, l);
  }), s = Object.keys(t.attributes || {}).reduce(function(l, c) {
    var d = t.attributes[c];
    switch (c) {
      case "class":
        l.attrs.className = d, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = Qm(d);
        break;
      default:
        c.indexOf("aria-") === 0 || c.indexOf("data-") === 0 ? l.attrs[c.toLowerCase()] = d : l.attrs[qd(c)] = d;
    }
    return l;
  }, {
    attrs: {}
  }), r = n.style, o = r === void 0 ? {} : r, a = $m(n, Gm);
  return s.attrs.style = ve(ve({}, s.attrs.style), o), e.apply(void 0, [t.tag, ve(ve({}, s.attrs), a)].concat(zr(i)));
}
var Gd = !1;
try {
  Gd = process.env.NODE_ENV === "production";
} catch {
}
function Zm() {
  if (!Gd && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Qa(e) {
  if (e && ms(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (Nr.icon)
    return Nr.icon(e);
  if (e === null)
    return null;
  if (e && ms(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function ir(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? In({}, e, t) : {};
}
var Za = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, fe = /* @__PURE__ */ Rt.forwardRef(function(e, t) {
  var n = ve(ve({}, Za), e), i = n.icon, s = n.mask, r = n.symbol, o = n.className, a = n.title, l = n.titleId, c = n.maskId, d = Qa(i), u = ir("classes", [].concat(zr(qm(n)), zr((o || "").split(" ")))), h = ir("transform", typeof n.transform == "string" ? Nr.transform(n.transform) : n.transform), p = ir("mask", Qa(s)), m = Tm(d, ve(ve(ve(ve({}, u), h), p), {}, {
    symbol: r,
    title: a,
    titleId: l,
    maskId: c
  }));
  if (!m)
    return Zm("Could not find icon", d), null;
  var g = m.abstract, b = {
    ref: t
  };
  return Object.keys(n).forEach(function(y) {
    Za.hasOwnProperty(y) || (b[y] = n[y]);
  }), Jm(g[0], b);
});
fe.displayName = "FontAwesomeIcon";
fe.propTypes = {
  beat: lt.bool,
  border: lt.bool,
  beatFade: lt.bool,
  bounce: lt.bool,
  className: lt.string,
  fade: lt.bool,
  flash: lt.bool,
  mask: lt.oneOfType([lt.object, lt.array, lt.string]),
  maskId: lt.string,
  fixedWidth: lt.bool,
  inverse: lt.bool,
  flip: lt.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: lt.oneOfType([lt.object, lt.array, lt.string]),
  listItem: lt.bool,
  pull: lt.oneOf(["right", "left"]),
  pulse: lt.bool,
  rotation: lt.oneOf([0, 90, 180, 270]),
  shake: lt.bool,
  size: lt.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: lt.bool,
  spinPulse: lt.bool,
  spinReverse: lt.bool,
  symbol: lt.oneOfType([lt.bool, lt.string]),
  title: lt.string,
  titleId: lt.string,
  transform: lt.oneOfType([lt.string, lt.object]),
  swapOpacity: lt.bool
};
var Jm = Xd.bind(null, Rt.createElement);
const t0 = function({ contactId: e, studentId: t, staffId: n }) {
  const { isPending: i, error: s, data: r } = new Hc.contactImage({ contactId: e, studentId: t, staffId: n }).ToQuery(), [o, a] = Y(void 0);
  return mt(() => (r && a(URL.createObjectURL(r)), () => {
    o && URL.revokeObjectURL(o);
  }), [r]), { isPending: i, error: s, data: r, url: o };
}, Fs = function({ contactId: e, studentId: t, staffId: n, contactFullName: i, sx: s, ...r }) {
  const o = tn(), { error: a, url: l } = t0({ contactId: e, studentId: t, staffId: n });
  let c, d, u;
  return i && ({ initials: d, bgcolor: c } = Jh(i), u = o.palette.getContrastText(c)), a && console.warn("Error getting contact image", a), /* @__PURE__ */ f(Nn, { ...r, src: l, sx: { ...s, bgcolor: c, color: `${u} !important` }, children: d == null ? void 0 : d.toUpperCase() });
}, e0 = (e, t = {}) => {
  switch (e) {
    case ue.AdminPost:
      return { icon: /* @__PURE__ */ f(Xf, { ...t }), color: Hf[700] };
    case ue.Alert:
      return { icon: /* @__PURE__ */ f(Gc, { ...t }), color: Vf[700] };
    case ue.Absence:
      return { icon: /* @__PURE__ */ f(Gf, { ...t }), color: ds[700] };
    case ue.AbsenceInbound:
      return { icon: /* @__PURE__ */ f(Kc, { ...t }), color: ds[700] };
    case ue.Post:
    case ue.PostReply:
      return { icon: /* @__PURE__ */ f(Kf, { ...t }), color: $f[700] };
    case ue.Excursion:
      return { icon: /* @__PURE__ */ f(Qc, { ...t }), color: us[700] };
    case ue.Admin:
    case ue.AdminInbound:
    case ue.Peer:
    default:
      return { icon: /* @__PURE__ */ f(vr, { ...t }), color: re[700] };
  }
}, Ja = ({ eventType: e, calendarName: t }, n = {}) => {
  switch (e) {
    case ye.Unknown:
      return {
        color: na[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Calendar", ...n }),
        iconType: "Calendar"
        /* Calendar */
      };
    case ye.Note:
      return {
        color: qc[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Note", ...n }),
        iconType: "Note"
        /* Note */
      };
    case ye.Lesson:
      return {
        color: go.A700,
        icon: /* @__PURE__ */ f(Z, { iconType: "Class", ...n }),
        iconType: "Class"
        /* Class */
      };
    case ye.CalendarEvent:
      return t && t.toLocaleLowerCase().indexOf("excursion") > -1 ? {
        color: us[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Excursion", ...n }),
        iconType: "Excursion"
        /* Excursion */
      } : {
        color: re[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Calendar", ...n }),
        iconType: "Calendar"
        /* Calendar */
      };
    case ye.DailyOrganiserChange:
      return {
        color: us[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "DailyOrgChange", ...n }),
        iconType: "DailyOrgChange"
        /* DailyOrgChange */
      };
    case ye.Task:
      return {
        color: po[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Assessment", ...n }),
        iconType: "Assessment"
        /* Assessment */
      };
    case ye.Interview:
      return {
        color: Yc[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "ParentTeacherInterview", ...n }),
        iconType: "ParentTeacherInterview"
        /* ParentTeacherInterview */
      };
    case ye.StudentRecord:
      return {
        color: na[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Record", ...n }),
        iconType: "Record"
        /* Record */
      };
  }
}, n0 = (e, t = {}, n = "") => {
  const i = tn();
  switch (e) {
    case rn.Attendee:
      return { color: An[400], icon: /* @__PURE__ */ f(Jc, { ...t }) };
    case rn.Location:
      return { color: An[400], icon: /* @__PURE__ */ f(Z, { iconType: "Location", ...t }) };
    case rn.ApprovalStatus:
      let s = n == "Approved" ? /* @__PURE__ */ f(ra, { ...t }) : n == "Not Attending" ? /* @__PURE__ */ f(yo, { ...t }) : /* @__PURE__ */ f(Gh, { ...t });
      return { color: n == "Approved" ? i.palette.success.main : n == "Not Attending" ? i.palette.error.main : i.palette.info.main, icon: s };
    case rn.PaymentStatus:
      const o = n == "Paid" ? /* @__PURE__ */ f(ra, { ...t }) : n == "Failed" ? /* @__PURE__ */ f(od, { ...t }) : /* @__PURE__ */ f(sa, { ...t });
      return { color: n == "Paid" ? i.palette.success.main : n == "Failed" ? i.palette.error.main : i.palette.info.main, icon: o };
    case rn.PaymentAmount:
      return { color: An[400], icon: /* @__PURE__ */ f(sa, { ...t }) };
    case rn.LessonNote:
      return { color: us[400], icon: /* @__PURE__ */ f(Z, { iconType: "Note", ...t }) };
    case rn.LessonFileCount:
      return { color: re[400], icon: /* @__PURE__ */ f(Z, { iconType: "Attachment", ...t }) };
    default:
      return { color: An[400], icon: /* @__PURE__ */ f(td, { ...t }) };
  }
}, ok = (e) => {
  switch (e) {
    case "Class Note":
      return {
        color: go.A700,
        iconType: "Class"
        /* Class */
      };
    case "Assessment Note":
      return {
        color: re[500],
        iconType: "Assessment"
        /* Assessment */
      };
    case "Homework":
      return {
        color: po[700],
        iconType: "Home"
        /* Home */
      };
    default:
      return {
        color: qc[700],
        iconType: "Note"
        /* Note */
      };
  }
}, tl = (e, t = { icon: fa }) => {
  switch (e.toLowerCase()) {
    case "url":
      return { color: re[700], icon: /* @__PURE__ */ f(Z, {
        iconType: "Link"
        /* Link */
      }) };
    case "rbc":
      return { color: An[500], icon: /* @__PURE__ */ f(fe, { ...t, icon: Cp }) };
    case "pdf":
      return { color: jf[700], icon: /* @__PURE__ */ f(fe, { ...t, icon: Op }) };
    case "doc":
    case "docx":
      return { color: re[500], icon: /* @__PURE__ */ f(fe, { ...t, icon: Pp }) };
    case "csv":
    case "xls":
    case "xlsx":
      return { color: go[700], icon: /* @__PURE__ */ f(fe, { ...t, icon: Mp }) };
    case "png":
    case "jpg":
    case "gif":
    case "jpeg":
    case "bmp":
      return { color: po[700], icon: /* @__PURE__ */ f(fe, { ...t, icon: Ip }) };
    case "ppt":
    case "pptx":
    case "pptm":
      return { color: ds[600], icon: /* @__PURE__ */ f(fe, { ...t, icon: Ap }) };
    case "avi":
    case "mpg":
    case "gifv":
    case "flv":
    case "mpeg":
    case "mov":
    case "qt":
    case "wmv":
    case "mkv":
    case "ogg":
    case "mp4":
    case "m4v":
      return { color: Yc[700], icon: /* @__PURE__ */ f(fe, { ...t, icon: Dp }) };
    default:
      return { color: An[400], icon: /* @__PURE__ */ f(fe, { ...t, icon: fa }) };
  }
}, ak = (e, t = {}) => {
  let n, i;
  switch (e) {
    case je.UnapprovedAbsence:
      return {
        color: ds[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Absent", ...t }),
        iconType: "Absent"
        /* Absent */
      };
    case je.Excursion:
      return { color: n, iconType: i } = Ja({ eventType: ye.CalendarEvent, calendarName: "Excursion" }), { color: n, icon: /* @__PURE__ */ f(Z, { iconType: i, ...t }), iconType: i };
    case je.PeerToPeerMessage:
      return {
        color: re[700],
        icon: /* @__PURE__ */ f(Z, { iconType: "Message", ...t }),
        iconType: "Message"
        /* Message */
      };
    case je.PointsAdded:
      return {
        color: re[500],
        icon: /* @__PURE__ */ f(Z, { iconType: "Points", ...t }),
        iconType: "Points"
        /* Points */
      };
    case je.ParentTeacherInterview:
      return { color: n, iconType: i } = Ja({ eventType: ye.Interview }), { color: n, icon: /* @__PURE__ */ f(Z, { iconType: i, ...t }), iconType: i };
    case je.AssessmentPublished:
    case je.NewRecord:
    case je.RecordComment:
    default:
      return {
        color: re[500],
        icon: /* @__PURE__ */ f(Z, { iconType: "Notification", ...t }),
        iconType: "Notification"
        /* Notification */
      };
  }
};
var J = /* @__PURE__ */ ((e) => (e.Absent = "Absent", e.Annotations = "Annotations", e.Approved = "Approved", e.Attachment = "Attachment", e.Attendance = "Attendance", e.Assessment = "Assessment", e.Calendar = "Calendar", e.CalendarMonth = "CalendarMonth", e.Check = "Check", e.ChevronDown = "ChevronDown", e.ChevronLeft = "ChevronLeft", e.ChevronRight = "ChevronRight", e.ChevronUp = "ChevronUp", e.Class = "Class", e.Cross = "Cross", e.DailyOrgChange = "DailyOrgChange", e.DarkMode = "DarkMode", e.Delete = "Delete", e.Download = "Download", e.Edit = "Edit", e.Excursion = "Excursion", e.Expired = "Expired", e.File = "File", e.FileFind = "FileFind", e.FileTicked = "FileTicked", e.FullScreen = "FullScreen", e.Home = "Home", e.Info = "Info", e.Late = "Late", e.LightMode = "LightMode", e.Link = "Link", e.Location = "Location", e.Message = "Message", e.MessageAbsenceNotification = "MessageAbsenceNotification", e.MessagePeer = "MessagePeer", e.MessageSchoolMessage = "MessageSchoolMessage", e.MessageThread = "MessageThread", e.More = "More", e.New = "New", e.NewWindow = "NewWindow", e.Note = "Note", e.Notification = "Notification", e.OpenInNew = "OpenInNew", e.ParentTeacherInterview = "ParentTeacherInterview", e.PasswordReset = "PasswordReset", e.Payment = "Payment", e.Pending = "Pending", e.Points = "Points", e.Priority = "Priority", e.Profile = "Profile", e.Record = "Record", e.Report = "Report", e.Reply = "Reply", e.ReplyAll = "ReplyAll", e.Restore = "Restore", e.Return = "Return", e.RubricRatingMinus = "RubricRatingMinus", e.RubricRatingPlus = "RubricRatingPlus", e.Save = "Save", e.Schedule = "Schedule", e.Search = "Search", e.Send = "Send", e.Settings = "Settings", e.SignOut = "SignOut", e.Start = "Start", e.QuickAction = "QuickActoin", e.Upload = "Upload", e.User = "User", e.Visibility = "Visibility", e.VisibilityOff = "VisibilityOff", e.Warning = "Warning", e.ZoomIn = "ZoomIn", e.ZoomOut = "ZoomOut", e))(J || {}), i0 = /* @__PURE__ */ ((e) => (e.UserPen = "UserPen", e))(i0 || {});
const lk = ({ iconType: e, ...t }) => {
  switch (e) {
    case "UserPen":
      return /* @__PURE__ */ f(fe, { icon: kp, ...t });
  }
}, Z = ({ iconType: e, ...t }) => {
  switch (e) {
    case "Approved":
      return /* @__PURE__ */ f(gh, { ...t });
    case "Annotations":
      return /* @__PURE__ */ f(Ah, { ...t });
    case "Attachment":
      return /* @__PURE__ */ f(ed, { ...t });
    case "Attendance":
      return /* @__PURE__ */ f(dh, { ...t });
    case "Assessment":
      return /* @__PURE__ */ f(eh, { ...t });
    case "Calendar":
      return /* @__PURE__ */ f(Qf, { ...t });
    case "CalendarMonth":
      return /* @__PURE__ */ f(Zf, { ...t });
    case "Check":
      return /* @__PURE__ */ f(wh, { ...t });
    case "ChevronUp":
      return /* @__PURE__ */ f(Lh, { ...t });
    case "ChevronDown":
      return /* @__PURE__ */ f(id, { ...t });
    case "ChevronLeft":
      return /* @__PURE__ */ f(kh, { ...t });
    case "ChevronRight":
      return /* @__PURE__ */ f(Ch, { ...t });
    case "Class":
      return /* @__PURE__ */ f(Jf, { ...t });
    case "Absent":
    case "Cross":
      return /* @__PURE__ */ f(nd, { ...t });
    case "DailyOrgChange":
      return /* @__PURE__ */ f(Zc, { ...t });
    case "DarkMode":
      return /* @__PURE__ */ f(vh, { ...t });
    case "Delete":
      return /* @__PURE__ */ f(Ci, { ...t });
    case "Download":
      return /* @__PURE__ */ f(Mh, { ...t });
    case "Edit":
      return /* @__PURE__ */ f(Is, { ...t });
    case "Excursion":
      return /* @__PURE__ */ f(Qc, { ...t });
    case "Expired":
      return /* @__PURE__ */ f(Fh, { ...t });
    case "File":
      return /* @__PURE__ */ f(Eh, { ...t });
    case "FileFind":
      return /* @__PURE__ */ f(Rh, { ...t });
    case "FileTicked":
      return /* @__PURE__ */ f(Oh, { ...t });
    case "FullScreen":
      return /* @__PURE__ */ f(Nh, { ...t });
    case "Home":
      return /* @__PURE__ */ f(hh, { ...t });
    case "Info":
      return /* @__PURE__ */ f(td, { ...t });
    case "Late":
      return /* @__PURE__ */ f(Sh, { ...t });
    case "LightMode":
      return /* @__PURE__ */ f(xh, { ...t });
    case "Link":
      return /* @__PURE__ */ f(Vh, { ...t });
    case "Location":
      return /* @__PURE__ */ f(ih, { ...t });
    case "Message":
      return /* @__PURE__ */ f(vr, { ...t });
    case "MessageSchoolMessage":
      return /* @__PURE__ */ f(vr, { ...t });
    case "MessageAbsenceNotification":
      return /* @__PURE__ */ f(Gc, { ...t });
    case "MessagePeer":
      return /* @__PURE__ */ f(Kc, { ...t });
    case "MessageThread":
      return /* @__PURE__ */ f(rh, { ...t });
    case "More":
      return /* @__PURE__ */ f(ph, { ...t });
    case "New":
      return /* @__PURE__ */ f(mo, { ...t });
    case "NewWindow":
      return /* @__PURE__ */ f(ia, { ...t });
    case "Note":
      return /* @__PURE__ */ f(th, { ...t });
    case "Notification":
      return /* @__PURE__ */ f(lh, { ...t });
    case "OpenInNew":
      return /* @__PURE__ */ f(ia, { ...t });
    case "ParentTeacherInterview":
      return /* @__PURE__ */ f(nh, { ...t });
    case "PasswordReset":
      return /* @__PURE__ */ f(_h, { ...t });
    case "Payment":
      return /* @__PURE__ */ f(bh, { ...t });
    case "Pending":
      return /* @__PURE__ */ f(mh, { ...t });
    case "Points":
      return /* @__PURE__ */ f(ah, { ...t });
    case "Priority":
      return /* @__PURE__ */ f(od, { ...t });
    case "Profile":
      return /* @__PURE__ */ f(fh, { ...t });
    case "Record":
      return /* @__PURE__ */ f(sh, { ...t });
    case "Report":
      return /* @__PURE__ */ f(uh, { ...t });
    case "Reply":
      return /* @__PURE__ */ f(rd, { ...t });
    case "ReplyAll":
      return /* @__PURE__ */ f(Uh, { ...t });
    case "Restore":
      return /* @__PURE__ */ f(Yh, { ...t });
    case "Return":
      return /* @__PURE__ */ f(oh, { ...t });
    case "RubricRatingMinus":
      return /* @__PURE__ */ f(Bh, { ...t });
    case "RubricRatingPlus":
      return /* @__PURE__ */ f(zh, { ...t });
    case "Schedule":
      return /* @__PURE__ */ f(ch, { ...t });
    case "Search":
      return /* @__PURE__ */ f(jh, { ...t });
    case "Save":
      return /* @__PURE__ */ f(bo, { ...t });
    case "Send":
      return /* @__PURE__ */ f(sd, { ...t });
    case "Settings":
      return /* @__PURE__ */ f($h, { ...t });
    case "SignOut":
      return /* @__PURE__ */ f(yh, { ...t });
    case "Start":
      return /* @__PURE__ */ f(Wh, { ...t });
    case "QuickActoin":
      return /* @__PURE__ */ f(Ph, { ...t });
    case "Upload":
      return /* @__PURE__ */ f(Hh, { ...t });
    case "User":
      return /* @__PURE__ */ f(Jc, { ...t });
    case "Visibility":
      return /* @__PURE__ */ f(qh, { ...t });
    case "VisibilityOff":
      return /* @__PURE__ */ f(Xh, { ...t });
    case "Warning":
      return /* @__PURE__ */ f(Th, { ...t });
    case "ZoomIn":
      return /* @__PURE__ */ f(Ih, { ...t });
    case "ZoomOut":
      return /* @__PURE__ */ f(Dh, { ...t });
  }
}, ck = ({ studentId: e, contactId: t, icon: n, color: i }) => {
  const s = tn(), r = cd(e);
  return /* @__PURE__ */ f(
    ao,
    {
      sx: { "& .MuiBadge-badge": { backgroundColor: "transparent" } },
      overlap: "rectangular",
      anchorOrigin: { vertical: "bottom", horizontal: "right" },
      badgeContent: /* @__PURE__ */ f(Nn, { variant: "rounded", sx: {
        height: 21,
        width: 21,
        bgcolor: i,
        color: s.palette.getContrastText(i),
        bottom: "3px",
        right: "3px"
      }, children: n }),
      children: /* @__PURE__ */ f(Fs, { studentId: e, contactFullName: r == null ? void 0 : r.DisplaynameSurname, contactId: t, sx: { fontSize: "1rem", width: 33, height: 33 }, variant: "rounded" })
    }
  );
}, s0 = "_listItem_yr90q_1", r0 = "_main_yr90q_28", o0 = "_title_yr90q_35", a0 = "_unread_yr90q_48", jn = {
  listItem: s0,
  main: r0,
  title: o0,
  unread: a0
}, To = Ft(({
  title: e,
  description: t,
  avatar: n,
  chips: i,
  chipsRight: s,
  date: r,
  variant: o,
  onClick: a,
  selected: l,
  elevation: c = 1,
  bgcolor: d,
  unread: u,
  onUnreadClicked: h,
  category: p,
  loading: m,
  itemType: g
}, b) => {
  const y = kt(null), x = tn(), w = (C) => {
    C.stopPropagation(), h && h();
  }, S = o === "subdued";
  let v;
  r && (v = Zt(r));
  let _ = d;
  return l && (_ = Tn(x.palette.primary.main, 0.35)), /* @__PURE__ */ k(
    _i,
    {
      ref: b,
      "data-testid": "list-item",
      "data-item-type": g || void 0,
      onClick: a,
      component: "article",
      "aria-selected": l,
      elevation: c,
      sx: { "&:hover": { cursor: a ? "pointer" : "", boxShadow: a ? 3 : void 0 }, bgcolor: _, opacity: S ? ".6" : "1" },
      className: jn.listItem,
      onMouseDown: (C) => {
        var P;
        return (P = y.current) == null ? void 0 : P.start(C);
      },
      onMouseUp: (C) => {
        var P;
        return (P = y.current) == null ? void 0 : P.stop(C);
      },
      children: [
        m && /* @__PURE__ */ f(R, { sx: {
          position: "absolute",
          bgcolor: "var(--mui-palette-action-selected)",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }, children: /* @__PURE__ */ f(wi, {}) }),
        /* @__PURE__ */ f(Kh, { ref: y, center: !1 }),
        /* @__PURE__ */ f("div", { children: n }),
        /* @__PURE__ */ k("div", { className: jn.main, children: [
          e ? /* @__PURE__ */ k(ht, { children: [
            /* @__PURE__ */ k("div", { className: jn.title, children: [
              /* @__PURE__ */ f(H, { variant: "h3", sx: {
                fontSize: "1rem",
                fontWeight: S ? 300 : 500,
                color: "var(--mui-palette-text-primary)"
              }, children: e }),
              v && /* @__PURE__ */ f(H, { sx: {
                fontSize: ".75rem",
                fontWeight: 300,
                color: "var(--mui-palette-text-secondary)"
              }, children: v }),
              p && /* @__PURE__ */ f(R, { sx: {
                fontSize: ".75rem",
                fontWeight: 300,
                color: "var(--mui-palette-text-secondary)"
              }, children: p })
            ] }),
            /* @__PURE__ */ f(R, { sx: {
              fontWeight: 300,
              fontSize: ".9rem",
              color: "var(--mui-palette-text-primary)",
              pr: u ? 3 : void 0,
              whiteSpace: "pre-line"
            }, children: t })
          ] }) : /* @__PURE__ */ k("div", { className: jn.title, children: [
            /* @__PURE__ */ f(R, { sx: {
              fontWeight: 300,
              fontSize: ".9rem",
              color: "var(--mui-palette-text-primary)",
              pr: u ? 3 : void 0,
              whiteSpace: "pre-line",
              flex: 1
            }, children: t }),
            v && /* @__PURE__ */ f(H, { sx: {
              fontSize: ".75rem",
              fontWeight: 300,
              color: "var(--mui-palette-text-secondary)",
              flexShrink: 0
            }, children: v }),
            p && /* @__PURE__ */ f(R, { sx: {
              fontSize: ".75rem",
              fontWeight: 300,
              color: "var(--mui-palette-text-secondary)",
              flexShrink: 0
            }, children: p })
          ] }),
          (i || s) && /* @__PURE__ */ k(R, { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "space-between", children: [
            i && /* @__PURE__ */ f(R, { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", children: i }),
            s && /* @__PURE__ */ f(R, { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", children: s })
          ] })
        ] }),
        u && /* @__PURE__ */ f("div", { onClick: w, className: jn.unread, title: "Unread. Click to mark as read" })
      ]
    }
  );
}), bs = ({ children: e }) => /* @__PURE__ */ f(H, { sx: { color: "var(--mui-palette-text-disabled)", fontWeight: 300, fontSize: ".9rem", alignSelf: "center" }, children: e }), dk = ({
  Name: e,
  Status: t,
  SetDate: n,
  ClassName: i,
  Type: s,
  onClick: r,
  HasPublishedAnnotations: o,
  WorkReceived: a,
  Overdue: l
}) => {
  const c = tn();
  let d = J.Assessment, u = re[700];
  l && (u = c.palette.warning.main, d = J.File);
  const h = /* @__PURE__ */ f(Z, { iconType: d, sx: { width: 20, height: 20 } }), p = /* @__PURE__ */ k(Nn, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: Tn(u, 0.15), color: u }, children: [
    " ",
    h,
    " "
  ] }), m = n && new Date(n) > /* @__PURE__ */ new Date();
  let g = [];
  return g.push(/* @__PURE__ */ f(Dt, { size: "small", label: i, icon: /* @__PURE__ */ f(Z, { iconType: J.Class }) }, "classname")), g.push(/* @__PURE__ */ f(Dt, { size: "small", label: s, icon: /* @__PURE__ */ f(Z, { iconType: J.Assessment }) }, "tasktype")), o && g.push(/* @__PURE__ */ f(Dt, { size: "small", label: "Teacher feedback", icon: /* @__PURE__ */ f(Z, { iconType: J.Annotations }) }, "annotations")), a && g.push(/* @__PURE__ */ f(Dt, { size: "small", label: "Work received", icon: /* @__PURE__ */ f(Z, { iconType: J.FileTicked }) }, "studentwork")), m && g.push(/* @__PURE__ */ f(Dt, { size: "small", label: "Preview", icon: /* @__PURE__ */ f(Z, { iconType: J.Schedule }) }, "preview")), /* @__PURE__ */ f(To, { itemType: "assessmenttask", title: e, description: t, avatar: p, date: n, chips: g, onClick: r });
}, uk = ({ title: e, subTitle: t, meta: n, onClick: i }) => /* @__PURE__ */ k(
  R,
  {
    onClick: i,
    onKeyDown: (r) => {
      i && (r.key === "Enter" || r.key === " ") && (r.preventDefault(), i());
    },
    role: i ? "button" : void 0,
    tabIndex: i ? 0 : void 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.5,
    px: 2,
    py: 1,
    sx: {
      cursor: i ? "pointer" : "default",
      "&:not(:last-child)": {
        borderBottom: 1,
        borderColor: "divider"
      }
    },
    children: [
      /* @__PURE__ */ k(R, { display: "flex", gap: 2, rowGap: 0, alignItems: "center", flexWrap: "wrap", children: [
        e && /* @__PURE__ */ f(H, { variant: "subtitle1", fontSize: ".85rem", children: e }),
        t && /* @__PURE__ */ f(H, { variant: "caption", color: "text.secondary", children: t })
      ] }),
      n && /* @__PURE__ */ f(R, { display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end", flexGrow: 1, children: n })
    ]
  }
);
var sr = {}, el;
function l0() {
  return el || (el = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t = "fas", n = "file", i = 384, s = 512, r = [128196, 128459, 61462], o = "f15b", a = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z";
    e.definition = {
      prefix: t,
      iconName: n,
      icon: [
        i,
        s,
        r,
        o,
        a
      ]
    }, e.faFile = e.definition, e.prefix = t, e.iconName = n, e.width = i, e.height = s, e.ligatures = r, e.unicode = o, e.svgPathData = a, e.aliases = r;
  }(sr)), sr;
}
var c0 = /* @__PURE__ */ l0();
const d0 = /* @__PURE__ */ ad(c0), fk = ({
  block: e,
  message: t,
  title: n = "Are you sure you want to leave?",
  cancelText: i = "Cancel",
  leaveText: s = "Leave"
}) => {
  const r = tp(() => e);
  return /* @__PURE__ */ f(
    Se,
    {
      open: r.state === "blocked",
      title: n,
      children: /* @__PURE__ */ k(R, { paddingLeft: 3, paddingRight: 3, children: [
        /* @__PURE__ */ f(H, { children: t }),
        /* @__PURE__ */ k(R, { sx: { display: "flex", alignItems: "center", justifyContent: "right", gap: 1, flexWrap: "wrap", pt: 3, pb: 3 }, children: [
          /* @__PURE__ */ f(ot, { onClick: () => {
            r.reset && r.reset();
          }, children: i }),
          /* @__PURE__ */ f(ot, { variant: "contained", onClick: () => {
            r.proceed && r.proceed();
          }, children: s })
        ] })
      ] })
    }
  );
}, Se = Ft(({ title: e, children: t, actions: n, onClose: i, open: s = !1, sx: r, maxWidth: o, fullScreen: a, showFullScreenControls: l, allowEventPropagation: c }, d) => {
  const [u, h] = Y(s);
  return Wt(d, () => ({
    open: () => {
      h(!0);
    },
    close: () => {
      h(!1);
    }
  })), mt(() => {
    h(s);
  }, [s]), /* @__PURE__ */ f(
    lo,
    {
      fullScreen: a,
      maxWidth: o,
      sx: r,
      open: u,
      onClose: () => {
        h(!1), i && i();
      },
      onClick: (p) => {
        c || (p.stopPropagation(), p.preventDefault());
      },
      "aria-labelledby": "responsive-dialog-title",
      children: u && /* @__PURE__ */ k(ht, { children: [
        !l && e && /* @__PURE__ */ f(df, { id: "responsive-dialog-title", children: e }),
        /* @__PURE__ */ f(
          R,
          {
            padding: 1,
            children: l ? /* @__PURE__ */ f(u0, { title: e, onClose: () => {
              h(!1), i && i();
            }, children: t }) : t
          }
        ),
        n && /* @__PURE__ */ f(uf, { children: n })
      ] })
    }
  );
}), u0 = ({ title: e, onClose: t, children: n }) => {
  const i = kt(null), [s, r] = Y();
  return mt(() => {
    i.current && r(`calc(100vh - ${i.current.offsetHeight}px - env(safe-area-inset-bottom) - env(safe-area-inset-top))`);
  }, [i]), /* @__PURE__ */ k(gt, { children: [
    /* @__PURE__ */ f(ff, { sx: { position: "relative", marginTop: "env(safe-area-inset-top)" }, ref: i, children: /* @__PURE__ */ k(hf, { children: [
      /* @__PURE__ */ f(
        li,
        {
          edge: "start",
          color: "inherit",
          onClick: t,
          "aria-label": "close",
          children: /* @__PURE__ */ f(Z, { iconType: J.Cross })
        }
      ),
      /* @__PURE__ */ f(H, { sx: { ml: 2, flex: 1 }, variant: "h3", component: "div", children: e })
    ] }) }),
    /* @__PURE__ */ f(R, { flexGrow: 1, sx: { height: s }, children: n })
  ] });
}, f0 = ({ fileId: e, onDelete: t }) => {
  const { isPending: n, data: i } = new Si.FileInfo(e).ToQuery(), [s, r] = Y(null), { Post: o } = Ne(), { baseUrl: a } = me(), l = xo();
  mt(() => {
    r(i ?? null);
  }, [i]);
  const c = async () => {
    try {
      let u = await o(
        {
          url: a + `/lms/api/files/save/${e}`,
          config: null,
          data: s
        }
      );
      u && r(u), l && l.invalidateQueries({ queryKey: ["FileInfo", e] });
    } catch {
    }
  }, d = async () => {
    try {
      await o(
        {
          url: a + `/lms/api/files/delete/${e}`,
          config: null,
          data: null
        }
      ) && t && t(), l && l.invalidateQueries({ queryKey: ["FileInfo", e] });
    } catch {
    }
  };
  return n ? /* @__PURE__ */ f(R, { children: "Loading" }) : s ? /* @__PURE__ */ k(R, { p: 5, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, children: [
    /* @__PURE__ */ f(yn, { slotProps: { input: { readOnly: !0 } }, label: "File name", value: `${s.Name}.${s.Ext}` }),
    /* @__PURE__ */ f(
      yn,
      {
        label: "Description",
        value: s.Description,
        multiline: !0,
        rows: 4,
        fullWidth: !0,
        onChange: (u) => {
          let h = s;
          h.Description = u.target.value, r({ ...h });
        }
      }
    ),
    /* @__PURE__ */ k(Ec, { variant: "contained", children: [
      /* @__PURE__ */ f(ot, { onClick: d, startIcon: /* @__PURE__ */ f(Ci, {}), children: "Delete" }),
      /* @__PURE__ */ f(ot, { onClick: c, startIcon: /* @__PURE__ */ f(bo, {}), children: "Save" })
    ] })
  ] }) : /* @__PURE__ */ f(R, { children: "New attachment" });
}, hk = ({ type: e, parameters: t }) => {
  const [n, i] = Y(null), [s, r] = Y(null), o = kt(null), { settings: a } = xp(), l = (d) => {
    var u;
    i(d), (u = o.current) == null || u.openToast();
  }, c = (d) => {
    r(d);
  };
  return a && a.isAzure ? /* @__PURE__ */ k(R, { p: 5, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, children: [
    /* @__PURE__ */ f(hs, { ref: o, type: n ? n.type : "success", message: n ? n.message : "" }),
    /* @__PURE__ */ f(cp, { type: e, parameters: t, onStatus: l, onProgress: c }),
    s && /* @__PURE__ */ f(pf, { sx: { width: "100%" }, variant: "determinate", value: s ?? 0 })
  ] }) : /* @__PURE__ */ k(R, { p: 5, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, children: [
    /* @__PURE__ */ f(hs, { ref: o, type: n ? n.type : "success", message: n ? n.message : "" }),
    /* @__PURE__ */ f(h0, { type: e, parameters: t, onStatus: l, onProgress: c })
  ] });
}, h0 = ({ onProgress: e, parameters: t, onStatus: n }) => {
  const [i, s] = Y(null), { Post: r } = Ne(), { baseUrl: o } = me();
  return /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ f(
      Rc,
      {
        type: "file",
        inputProps: { accept: "image/*" },
        onChange: async (c) => {
          let d = c.target;
          if (!d.files)
            return;
          let u = d.files[0];
          s(u), e && e(null);
        },
        sx: {
          display: "block",
          flex: 1,
          marginTop: "10px",
          padding: "8px",
          border: "0",
          backgroundColor: "var(--mui-palette-primary-main)",
          color: "var(--mui-palette-primary-contrastText)",
          borderRadius: "var(--mui-shape-borderRadius)",
          "&:hover": {
            boxShadow: "var(--mui-shadows-4)"
          },
          "&::before": {
            border: "0 !important"
          },
          '& input[type="file"]': {
            cursor: "pointer"
          },
          '& input[type="file"]::file-selector-button': {
            border: "0",
            backgroundColor: "var(--mui-palette-primary-main)",
            color: "var(--mui-palette-primary-contrastText)"
          },
          '& input[type="file"]::file-upload-text': {
            color: "var(--mui-palette-primary-contrastText)"
          }
        }
      }
    ),
    /* @__PURE__ */ f(
      ot,
      {
        variant: "contained",
        onClick: async () => {
          const c = new FormData();
          c.append("file", i);
          let d = `/lms/api/files/upload/db/record?formId=${t.formId}&id=${t.id}`;
          t.rowId && (d += `&rowId=${t.rowId}`);
          try {
            await r({
              url: o + d,
              data: c,
              config: { headers: { a: "b" }, dontStringify: !0 }
            }), n && n({ type: "success", message: `Succesfully upload file ${i == null ? void 0 : i.name}` });
          } catch (u) {
            n && n({ type: "error", message: `${i == null ? void 0 : i.name} failed to upload: ${u.message}` });
            return;
          }
        },
        disabled: !i,
        startIcon: /* @__PURE__ */ f(Xc, {}),
        children: "Upload"
      }
    )
  ] });
}, pk = ({ fileId: e, name: t, canEdit: n, onDelete: i }) => {
  const { isPending: s, data: r } = new Si.FileDownLoadLink({ FileId: e ?? 0, ContentProvider: 0, enable: !0 }).ToQuery(), o = kt(null);
  return /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ k(R, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center" }, children: [
      /* @__PURE__ */ f(
        Lc,
        {
          target: "_blank",
          onClick: () => {
            s && alert("Loading");
          },
          href: s ? "#" : r,
          children: t
        }
      ),
      n && /* @__PURE__ */ f(ot, { onClick: () => {
        var c;
        (c = o.current) == null || c.open();
      }, startIcon: /* @__PURE__ */ f(Is, {}), children: "Edit" })
    ] }),
    /* @__PURE__ */ f(Se, { title: "Edit Attachment", ref: o, children: /* @__PURE__ */ f(f0, { fileId: e, onDelete: () => {
      var c;
      (c = o.current) == null || c.close(), i && i();
    } }) })
  ] });
}, p0 = () => {
  const { nativeDownload: e } = Uf(), [t, n] = Y(!1), [i, s] = Y(), { refetch: r } = new Si.FileDownLoadLink({ FileId: (i == null ? void 0 : i.fileId) ?? 0, Pdf: (i == null ? void 0 : i.pdf) ?? !1 }).ToQuery();
  mt(() => {
    i != null && i.fileId && o();
  }, [i]);
  const o = async () => {
    n(!0);
    const { data: a } = await r();
    if (!a) {
      n(!1);
      return;
    }
    if (e)
      console.log("gonna do native download", a), await e(a);
    else {
      const l = document.createElement("a");
      l.href = a, l.target = "_blank", l.click(), document.removeChild(l);
    }
  };
  return { downloadFile: s, isDownloading: t };
}, Eo = ({ fileId: e, extension: t, pdf: n, download: i, fileName: s, locationType: r, url: o, modifiedBy: a, modifiedDate: l, size: c = "small", ...d }) => {
  const { downloadFile: u } = p0(), h = () => {
    i && (r === oa.URL && o ? Yf.isNativePlatform() ? qf.open({ url: o }) : window.open(o, "_blank") : u({ fileId: e, pdf: !!n }));
  }, { color: p } = tl(t);
  let { icon: m } = tl(t, { color: p, icon: d0, size: c === "medium" ? "lg" : void 0 });
  r === oa.URL && (m = /* @__PURE__ */ f(Z, { fontSize: c, iconType: J.NewWindow }));
  let g = s;
  return (a || l) && (g = /* @__PURE__ */ k(gt, { pl: 1, children: [
    /* @__PURE__ */ f(H, { fontSize: "inherit", children: s }),
    /* @__PURE__ */ k(R, { display: "flex", gap: 1, children: [
      a && /* @__PURE__ */ f(H, { fontSize: "inherit", variant: "caption", sx: { color: d.color === "error" ? "inherit" : void 0 }, children: a }),
      l && /* @__PURE__ */ f(H, { fontSize: "inherit", variant: "caption", sx: { color: d.color === "error" ? "inherit" : void 0 }, children: Zt(l) })
    ] })
  ] })), /* @__PURE__ */ f(
    Dt,
    {
      ...d,
      label: g,
      onClick: h,
      icon: m,
      size: c
    }
  );
}, Ro = ({ studentId: e, size: t = "medium", ...n }) => {
  const i = cd(e);
  return i ? /* @__PURE__ */ f(
    Dt,
    {
      size: t,
      avatar: /* @__PURE__ */ f(Fs, { variant: "rounded", contactId: i.ContactID, contactFullName: i.DisplaynameSurname }),
      label: i.DisplaynameSurname,
      variant: "filled",
      ...n
    }
  ) : /* @__PURE__ */ f(at, { variant: "rounded", width: 10 });
}, gk = ({ contactId: e, staffId: t, size: n = "medium", label: i, showMessageIconButton: s, onContactMessageClick: r, ...o }) => /* @__PURE__ */ k(R, { children: [
  /* @__PURE__ */ f(
    Dt,
    {
      size: n,
      avatar: /* @__PURE__ */ f(Fs, { variant: "rounded", contactId: e, staffId: t, contactFullName: i }),
      label: i,
      variant: "filled",
      ...o
    }
  ),
  s && r && /* @__PURE__ */ f(
    li,
    {
      size: "small",
      onClick: () => {
        e && r(e);
      },
      "aria-label": "Send message",
      sx: { color: "primary.main" },
      children: /* @__PURE__ */ f(Z, { iconType: J.Message, fontSize: "small" })
    }
  )
] });
function g0(e, t) {
  let n = "info", i = t, s = J.Info;
  switch (e) {
    case on.NotSet:
      return null;
    case on.Present:
      n = "success", s = J.Check, i = "Present";
      break;
    case on.RollNotMarked:
      n = "info", s = J.Pending, i = "Unmarked Roll";
      break;
    case on.AbsentUnapproved:
      n = "error", s = J.Absent;
      break;
    case on.AbsentApproved:
      s = J.Absent, n = "warning";
      break;
    case on.Late:
      n = "error", s = J.Late;
      break;
    case on.LateApproved:
      n = "warning", s = J.Late;
      break;
    default:
      return null;
  }
  return { iconType: s, color: n, label: i };
}
const mk = ({ attendanceStatus: e, absentDescription: t, size: n, ...i }) => {
  const s = g0(e, t);
  if (!s) return null;
  const { iconType: r, color: o, label: a } = s;
  return /* @__PURE__ */ f(Dt, { variant: "outlined", size: n, icon: /* @__PURE__ */ f(Z, { iconType: r }), color: o, label: a, ...i });
}, bk = ({ Type: e, Value: t }) => {
  const { icon: n, color: i } = n0(e, { sx: { width: 10, height: 10 } }, t);
  return t = t ?? "", /* @__PURE__ */ f(
    Dt,
    {
      size: "small",
      sx: { margin: "2px" },
      label: t.length < 20 ? t : t.substring(0, 20) + "...",
      avatar: n ? /* @__PURE__ */ f(Nn, { variant: "rounded", sx: { height: 10, width: 30, bgcolor: Tn(i, 0.15), color: i }, children: n }) : /* @__PURE__ */ f(ht, {})
    }
  );
}, Kd = ({
  subject: e,
  messageType: t,
  sentFrom: n,
  date: i,
  read: s,
  onClick: r,
  selected: o,
  threadCount: a,
  attachments: l
}) => {
  let { icon: c, color: d } = e0(t, { sx: { width: 20, height: 20 } });
  const u = /* @__PURE__ */ f(Nn, { variant: "rounded", sx: {
    height: 30,
    width: 30,
    bgcolor: s ? "transparent" : Tn(d, 0.15),
    color: s ? Tn(d, 0.45) : d
  }, children: c }), h = [], p = (l == null ? void 0 : l.filter((m) => m.AttachmentType === fs.File)) || [];
  return p.length && h.push(/* @__PURE__ */ f(Dt, { icon: /* @__PURE__ */ f(Z, { iconType: J.Attachment }), size: "small", label: `${p.length} file${p.length > 1 ? "s" : ""}` }, "attachments")), l != null && l.some((m) => m.AttachmentType === fs.Record) && h.push(/* @__PURE__ */ f(Dt, { icon: /* @__PURE__ */ f(Z, { iconType: J.Record }), size: "small", label: "Record attached" }, "record")), a && a > 1 && h.push(/* @__PURE__ */ f(Dt, { icon: /* @__PURE__ */ f(Z, { iconType: J.MessageThread }), size: "small", label: `${a} messages in this thread` }, "threadcount")), /* @__PURE__ */ f(To, { itemType: "message", chips: h, title: n, description: e, avatar: u, date: i, variant: s ? "subdued" : void 0, onClick: r, selected: o });
}, m0 = [
  { id: "number", label: "Credit Card Number", required: !0, validateAndFormat: y0, placeholder: "•••• •••• •••• ••••", value: "" },
  { id: "expiry_month", label: "Exp Month", required: !0, validateAndFormat: x0, placeholder: "MM", value: "" },
  { id: "expiry_year", label: "Exp Year", required: !0, validateAndFormat: v0, placeholder: "YY", value: "" },
  { id: "cvc", label: "CVC", required: !0, validateAndFormat: _0, placeholder: "•••", value: "" },
  { id: "name", label: "Name", required: !0, value: "" },
  { id: "address_line1", label: "Address Line 1", required: !0, value: "" },
  { id: "address_line2", label: "", required: !1, value: "" },
  { id: "address_city", label: "City", required: !0, value: "" },
  { id: "address_postcode", label: "Post Code", required: !0, value: "" },
  { id: "address_state", label: "State", required: !0, value: "" },
  { id: "address_country", label: "Country", required: !0, value: "" },
  { id: "email", label: "Email", required: !0, validateAndFormat: w0, value: "" }
], b0 = ({ showErrors: e, onFormChanged: t, apiErrors: n, onUseCustomerTokenEmail: i, saveCard: s, saveCardChanged: r }) => {
  const { Get: o } = Ne(), { baseUrl: a } = me(), { data: l, isFetching: c, refetch: d } = new Uc.Customer().ToQuery(), [u, h] = Y(m0);
  mt(() => {
    console.log("customer", l), l != null && l.Comments ? i(l.Email) : i(null);
  }, [l]), mt(() => {
    h(u.map((y) => ({ ...y, error: p(y).error })));
  }, []), mt(() => {
    if (n != null && n.messages) {
      let y = u.map((x) => {
        var S;
        const w = (S = n.messages) == null ? void 0 : S.find((v) => v.param === x.id);
        return { ...x, apiError: w ? w.message : null };
      });
      h(y);
    }
  }, [n]);
  const p = ({ validateAndFormat: y, required: x, label: w, value: S }) => {
    let v = x && !S ? `${w} is required` : null;
    return !v && y && ({ value: S, error: v } = y(S)), { error: v, value: S };
  }, m = (y) => {
    let { id: x, value: w } = y.target;
    const { value: S, error: v } = p({ ...b(x), value: w }), _ = u.map((P) => P.id !== x ? P : { ...P, value: S, error: v });
    h(_);
    const C = {};
    _.forEach((P) => C[P.id] = { value: P.value, error: P.error }), t(C);
  }, g = async () => {
    const y = await o({
      url: `${a}/lms/api/payments/customer`,
      data: null,
      config: { method: "DELETE", asResponse: !0 }
    });
    y.ok ? d() : console.log(y);
  }, b = (y) => u.find((x) => x.id === y);
  return c ? /* @__PURE__ */ k(gt, { spacing: 1, children: [
    /* @__PURE__ */ f(at, { variant: "rounded", height: 20 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 20 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 20 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 20 })
  ] }) : l != null && l.Comments ? /* @__PURE__ */ k(gt, { spacing: 1, children: [
    /* @__PURE__ */ k(R, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Use this card" }),
      /* @__PURE__ */ f(H, { children: l.Comments })
    ] }),
    /* @__PURE__ */ f(R, { children: /* @__PURE__ */ f(ot, { onClick: g, startIcon: /* @__PURE__ */ f(Z, { iconType: J.Cross }), children: "Remove Card" }) })
  ] }) : /* @__PURE__ */ k(gt, { spacing: 4, children: [
    /* @__PURE__ */ k(gt, { spacing: 1, children: [
      /* @__PURE__ */ f(H, { variant: "h3", children: "Billing Address" }),
      /* @__PURE__ */ f(ie, { ...b("address_line1"), onChange: m, showError: e }),
      /* @__PURE__ */ f(ie, { ...b("address_line2"), onChange: m, showError: e }),
      /* @__PURE__ */ f(ie, { ...b("address_city"), onChange: m, showError: e }),
      /* @__PURE__ */ k(R, { display: "flex", gap: 1, flexGrow: 1, children: [
        /* @__PURE__ */ f(ie, { ...b("address_state"), onChange: m, showError: e }),
        /* @__PURE__ */ f(ie, { ...b("address_postcode"), onChange: m, showError: e })
      ] }),
      /* @__PURE__ */ f(ie, { ...b("address_country"), onChange: m, showError: e }),
      /* @__PURE__ */ f(ie, { ...b("email"), onChange: m, showError: e })
    ] }),
    /* @__PURE__ */ k(gt, { spacing: 1, children: [
      /* @__PURE__ */ f(H, { variant: "h3", children: "Credit card details" }),
      /* @__PURE__ */ f(ie, { ...b("name"), onChange: m, showError: e }),
      /* @__PURE__ */ f(ie, { ...b("number"), onChange: m, showError: e }),
      /* @__PURE__ */ k(R, { display: "flex", gap: 1, children: [
        /* @__PURE__ */ k(R, { display: "flex", gap: 1, children: [
          /* @__PURE__ */ f(ie, { ...b("expiry_month"), onChange: m, showError: e }),
          /* @__PURE__ */ f(ie, { ...b("expiry_year"), onChange: m, showError: e })
        ] }),
        /* @__PURE__ */ f(ie, { ...b("cvc"), onChange: m, showError: e })
      ] }),
      /* @__PURE__ */ f(zn, { control: /* @__PURE__ */ f(gf, { defaultChecked: !0, id: "storecard", checked: s, onChange: (y) => r(y.target.checked) }), label: "Store these credit card details for reuse" })
    ] })
  ] });
}, ie = ({ id: e, onChange: t, showError: n, label: i, placeholder: s, value: r, error: o, apiError: a }) => /* @__PURE__ */ f(
  yn,
  {
    id: e,
    value: r,
    onChange: t,
    label: i,
    placeholder: s,
    error: n && !!(a || o),
    helperText: n ? a || o : void 0,
    variant: "outlined",
    sx: { flexGrow: 1 }
  }
);
function y0(e) {
  const t = e.replace(/\D/g, "").slice(0, 16), n = t.replace(/(.{4})/g, "$1 ").trim();
  return t ? t.length < 16 ? { value: n, error: "Credit card number must be 16 digits" } : { value: n, error: null } : { value: "", error: "Credit card number is required" };
}
function x0(e) {
  const t = e.replace(/\D/g, "").slice(0, 2), n = parseInt(t, 10);
  return t ? n >= 1 && n <= 12 ? { value: t, error: null } : { value: t, error: "Invalid month (01-12)" } : { value: "", error: "Expiry month is required" };
}
function v0(e) {
  const t = e.replace(/\D/g, "").slice(0, 2);
  return t ? t.length === 2 ? { value: t, error: null } : { value: t, error: "Year must be 2 digits" } : { value: "", error: "Expiry year is required" };
}
function _0(e) {
  const t = e.replace(/\D/g, "").slice(0, 3);
  return t ? t.length === 3 ? { value: t, error: null } : { value: t, error: "CVC must be 3 digits" } : { value: "", error: "CVC is required" };
}
function w0(e) {
  const t = e.trim(), n = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return t ? n.test(t) ? { value: t, error: null } : { value: t, error: "Invalid email address format" } : { value: "", error: "Email address is required" };
}
const Qd = ({ Comment: e, onClose: t, StudentID: n, FormID: i, RowID: s }) => {
  const { schoolName: r } = me(), { isFetching: o, data: a, refetch: l } = new Uc.PaymentAmountAndFees({ studentId: n, formId: i, rowId: s }).ToQuery(), c = kt(null), [d, u] = Y(), [h, p] = Y(!0), [m, g] = Y(), [b, y] = Y(), [x, w] = Y(!1), [S, v] = Y(!1), [_, C] = Y(), P = ({ success: $, payment: T, error: j }) => {
    w(!0), u(void 0), $ ? y(T) : (console.log("pay error", j), C({
      error_description: j.title
    }));
  }, I = () => {
    y(void 0), l();
  }, V = async () => {
    if (C(void 0), v(!0), m)
      u({ useStoredCustomer: !0 });
    else if (!Object.keys(c.current).some(($) => !!c.current[$].error)) {
      const $ = new fp({ publicKey: "pk_xQvSFhZu16tLd4eQEHB_Bw" }), T = Object.fromEntries(Object.entries(c.current).map(([q, B]) => [q, B.value])), j = await $.createCard({
        ...T
      });
      j.success ? u({ token: j.data.response.token, ip: j.data.ip_address }) : C(j.error);
    }
  };
  return o ? /* @__PURE__ */ f(Se, { open: !0, onClose: () => t && t(x), children: /* @__PURE__ */ k(gt, { gap: 2, p: 3, children: [
    /* @__PURE__ */ f(at, { variant: "rounded", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rounded", height: 50 })
  ] }) }) : a.PayStatus === te.Paid ? /* @__PURE__ */ f(Se, { open: !0, onClose: () => t && t(x), children: /* @__PURE__ */ f(pp, { ...a }) }) : b && b.PayStatus === te.Paid ? /* @__PURE__ */ f(Se, { open: !0, onClose: () => t && t(x), children: /* @__PURE__ */ f(ke, { variant: "filled", severity: "success", action: /* @__PURE__ */ f(ot, { variant: "outlined", color: "inherit", size: "small", onClick: I, children: "View Invoice" }), children: "Your payment has been processed" }) }) : /* @__PURE__ */ k(Se, { open: !0, onClose: () => t && t(x), children: [
    /* @__PURE__ */ k(gt, { spacing: 4, p: 3, children: [
      /* @__PURE__ */ k(gt, { spacing: 3, children: [
        /* @__PURE__ */ k(gt, { spacing: 1, children: [
          /* @__PURE__ */ f(H, { variant: "h3", children: "Payment to" }),
          /* @__PURE__ */ f(H, { variant: "body2", children: r })
        ] }),
        /* @__PURE__ */ k(gt, { spacing: 1, children: [
          /* @__PURE__ */ f(H, { variant: "h3", children: "For" }),
          /* @__PURE__ */ f(H, { variant: "body2", children: e }),
          /* @__PURE__ */ f(Ro, { studentId: n, sx: { alignSelf: "flex-start" } })
        ] })
      ] }),
      /* @__PURE__ */ f(b0, { showErrors: S, onFormChanged: ($) => c.current = $, apiErrors: _, onUseCustomerTokenEmail: g, saveCard: h, saveCardChanged: p }),
      /* @__PURE__ */ f(dp, { ...a }),
      _ && /* @__PURE__ */ f(ke, { variant: "filled", severity: "error", children: _.error_description }),
      /* @__PURE__ */ f(ot, { onClick: V, variant: "contained", children: "Pay Now" })
    ] }),
    d && /* @__PURE__ */ f(
      hp,
      {
        SaveCard: h,
        CardToken: d.token,
        IPAddress: d.ip,
        UseStoredCard: d.useStoredCustomer,
        AgreedTotal: a.Amount + (a.Fee || 0),
        FormID: i,
        StudentID: n,
        RowID: s,
        Email: d.useStoredCustomer ? m : c.current.email.value,
        onPaymentComplete: P
      }
    )
  ] });
}, S0 = ({ AuthorName: e, ModifiedName: t, Record: n, onPaymentChanged: i }) => {
  const { StudentId: s, Created: r, Modified: o, ExpireDate: a } = n;
  let l;
  return a != null && (new Date(a) > /* @__PURE__ */ new Date() ? l = /* @__PURE__ */ f(Dt, { size: "small", label: `Expires: ${Zt(a)}`, icon: /* @__PURE__ */ f(Z, { iconType: J.Expired }), color: "warning" }) : l = /* @__PURE__ */ f(ls, { title: `Expired: ${Zt(a)}`, children: /* @__PURE__ */ f(Dt, { size: "small", color: "error", label: "Expired", icon: /* @__PURE__ */ f(Z, { iconType: J.Expired }) }) })), /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ f(Ro, { size: "small", studentId: s }),
    /* @__PURE__ */ f(Dt, { size: "small", icon: /* @__PURE__ */ f(Z, { iconType: J.New }), label: `Created by ${e}, ${Zt(r)}` }),
    /* @__PURE__ */ f(Dt, { size: "small", icon: /* @__PURE__ */ f(Z, { iconType: J.Edit }), label: `Modified by ${t}, ${Zt(o)}` }),
    l,
    /* @__PURE__ */ f(C0, { onPaymentChanged: i, ...n })
  ] });
}, C0 = ({ StatusCaption: e, StatusType: t, StatusFlags: n, MobilePayment: i, onPaymentChanged: s }) => /* @__PURE__ */ k(ht, { children: [
  /* @__PURE__ */ f(Zd, { size: "small", statusCaption: e, statusType: t, statusFlags: n }),
  /* @__PURE__ */ f(k0, { onPaymentChanged: s, size: "small", payment: i })
] }), Zd = ({ statusCaption: e, statusType: t, statusFlags: n, ...i }) => {
  if (!e && !t || (n ?? 0) > 0)
    return null;
  let s = {
    color: "info",
    iconType: J.Info,
    label: e
  };
  t && (s = A0(t, e));
  const { color: r, iconType: o, label: a } = s;
  return /* @__PURE__ */ f(Dt, { ...i, color: r, icon: /* @__PURE__ */ f(Z, { fontSize: "small", iconType: o }), label: a });
}, k0 = ({ payment: e, onPaymentChanged: t, ...n }) => {
  const [i, s] = Y(null), [r, o] = Y(!1), a = (m) => {
    m.persist(), m.stopPropagation(), m.nativeEvent.stopImmediatePropagation(), m.nativeEvent.stopPropagation(), m.preventDefault(), s(m.currentTarget);
  }, l = () => {
    s(null);
  };
  if (!e || e.PayStatus === te.None)
    return null;
  const { color: c, iconType: d, label: u, tooltip: h } = P0(e), p = !!i;
  return /* @__PURE__ */ k(ht, { children: [
    r && /* @__PURE__ */ f(Qd, { ...e, onClose: (m) => {
      o(!1), m && t && t();
    } }),
    /* @__PURE__ */ f(Dt, { ...n, color: c, icon: /* @__PURE__ */ f(Z, { fontSize: "small", iconType: d }), label: u, onClick: a, "aria-describedby": "status-type-popover" }),
    /* @__PURE__ */ f(Fc, { onClick: (m) => {
      m.stopPropagation(), m.preventDefault();
    }, id: "status-type-popover", open: p, onClose: l, anchorEl: i, anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }, children: /* @__PURE__ */ k(gt, { p: 2, spacing: 2, alignItems: "flex-start", children: [
      /* @__PURE__ */ f(H, { children: h }),
      e.PayStatus === te.Due && /* @__PURE__ */ f(ot, { onClick: () => o(!0), children: "Pay Now" }),
      e.PayStatus === te.Paid && /* @__PURE__ */ f(ot, { onClick: () => o(!0), children: "View Invoice" })
    ] }) })
  ] });
}, P0 = (e) => {
  const { total: t } = up(e);
  switch (e.PayStatus) {
    case te.Due:
      const n = /* @__PURE__ */ k(ht, { children: [
        /* @__PURE__ */ f("strong", { children: t }),
        " payment due"
      ] });
      return { iconType: J.Payment, color: "warning", label: n, tooltip: `This record requires a ${t} payment.` };
    case te.Failed:
      return { iconType: J.Payment, color: "error", label: "Payment failed", tooltip: "Payment failed. Please try again or contact the school." };
    case te.Paid:
      return { iconType: J.Payment, color: "success", label: "Paid", tooltip: "Payment complete." };
    case te.Processing:
      return { iconType: J.Payment, color: "info", label: "Payment processing", tooltip: "Payment is processing. Please check again later or contact the school." };
    case te.Refund:
      return { iconType: J.Payment, color: "info", label: "Payment refunded", tooltip: "Payment has been refunded." };
    default:
      return { iconType: J.Payment, color: "info", label: "No payment info", tooltip: "There is no payment information for this record." };
  }
}, A0 = (e, t) => {
  switch (e) {
    case an.Absent:
      return { iconType: J.Cross, color: "error", label: t === "Absent" ? "Absent" : `Absent - ${t}` };
    case an.Approved:
      return { iconType: J.Approved, color: "success", label: t === "Approved" ? "Approved" : `Approved - ${t}` };
    case an.Attended:
      return { iconType: J.Check, color: "success", label: t === "Attended" ? "Attended" : `Attended - ${t}` };
    case an.Awaiting:
      return { iconType: J.Pending, color: "warning", label: t === "Awaiting" ? "Awaiting" : `Awaiting - ${t}` };
    case an.Closed:
      return { iconType: J.Warning, color: "error", label: t === "Closed" ? "Closed" : `Closed - ${t}` };
    case an.Declined:
      return { iconType: J.Cross, color: "error", label: t === "Declined" ? "Declined" : `Declined - ${t}` };
    case an.None:
    default:
      return { iconType: J.Info, color: "info", label: "None" };
  }
}, Jd = ({ created: e, status: t, statusType: n, statusFlags: i, summary: s, title: r, colour: o, modifiedByName: a, modified: l, expireDate: c, onClick: d }) => {
  let u = [];
  return l && u.push(/* @__PURE__ */ f(Dt, { size: "small", label: `Modified ${a ? `by ${a}` : ""} ${Qh(l) ? "" : "at "}${Zt(l)}`, icon: /* @__PURE__ */ f(Is, {}) })), c != null && (new Date(c) > /* @__PURE__ */ new Date() ? u.push(/* @__PURE__ */ f(Dt, { size: "small", label: `Expires: ${Zt(c)}`, icon: /* @__PURE__ */ f(Z, { iconType: J.Expired }), color: "warning" })) : u.push(/* @__PURE__ */ f(ls, { title: `Expired: ${Zt(c)}`, children: /* @__PURE__ */ f(Dt, { size: "small", color: "error", label: "Expired", icon: /* @__PURE__ */ f(Z, { iconType: J.Expired }) }) }))), u.push(/* @__PURE__ */ f(Zd, { size: "small", statusCaption: t, statusType: n, statusFlags: i })), /* @__PURE__ */ f(
    To,
    {
      itemType: "record",
      title: r ?? t,
      description: s,
      date: e,
      avatar: /* @__PURE__ */ f(Nn, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: Tn(o || re[700], 0.85), colour: o || re[700] }, children: /* @__PURE__ */ f(np, {}) }),
      chips: u,
      onClick: d
    }
  );
}, M0 = sp(ot)({
  display: "flex",
  justifyContent: "left",
  paddingLeft: 2
}), yk = ({ disabled: e }) => {
  const { schoolName: t, schoolCode: n, ClearSchool: i, schoolList: s, UpdateSchool: r, RemoveSchoolFromList: o } = me(), a = kt(null);
  return /* @__PURE__ */ k(ht, { children: [
    e ? /* @__PURE__ */ k(H, { children: [
      /* @__PURE__ */ f(ca, { fontSize: "inherit", style: { verticalAlign: "middle", marginRight: 4 } }),
      " ",
      t
    ] }) : /* @__PURE__ */ f(ot, { size: "small", variant: "text", onClick: () => {
      var l;
      return (l = a.current) == null ? void 0 : l.open();
    }, startIcon: /* @__PURE__ */ f(ca, {}), children: t }),
    /* @__PURE__ */ f(Se, { title: "Switch Schools", ref: a, children: /* @__PURE__ */ k(R, { sx: { display: "flex", flexFlow: "column", gap: 1, p: 1 }, children: [
      /* @__PURE__ */ f(ot, { size: "small", variant: "text", onClick: i, endIcon: /* @__PURE__ */ f(mo, {}), children: "Add School" }),
      s && s.map(
        (l) => /* @__PURE__ */ k(R, { sx: { display: "flex", justifyContent: "space-between" }, children: [
          /* @__PURE__ */ f(M0, { size: "small", variant: "text", onClick: () => r(l), disabled: n == l.schoolCode, children: l.schoolName }),
          /* @__PURE__ */ f(ip, { sx: { float: "right" }, "aria-label": "delete", disabled: n == l.schoolCode, onClick: () => o(l), children: /* @__PURE__ */ f(Ci, {}) })
        ] }, l.schoolCode)
      )
    ] }) })
  ] });
};
Mt.extend(lp);
const xk = ({
  weekStart: e,
  events: t = [],
  startHour: n = 8,
  endHour: i = 17,
  hourHeight: s = 60,
  onEventClick: r,
  showWeekends: o = !0,
  loading: a = !1,
  dateDecorators: l = []
}) => {
  const c = tn(), [d, u] = Y(null), [h, p] = Y(null), m = () => {
    u(null), p(null);
  }, g = (_) => (C) => {
    C.stopPropagation(), h === _ ? (p(null), u(null)) : (p(_), u(_));
  }, b = (_) => () => {
    (h !== _ || d !== null) && u(_);
  }, y = () => {
    h || u(null);
  }, x = Ki(() => {
    const _ = e ? Mt(e).startOf("isoWeek") : Mt().startOf("isoWeek"), C = [];
    for (let P = 0; P < (o ? 7 : 5); P++)
      C.push(_.add(P, "day"));
    return C;
  }, [e, o]), w = Ki(() => {
    const _ = [];
    for (let C = n; C <= i; C++)
      _.push(C);
    return _;
  }, [n, i]), S = Ki(() => {
    const _ = [];
    return x.forEach((C, P) => {
      const I = t.map((T) => {
        const j = Mt(T.start), q = Mt(T.end);
        if (!j.isSame(C, "day"))
          return null;
        const B = j.hour() * 60 + j.minute(), X = q.hour() * 60 + q.minute(), G = n * 60, st = (i + 1) * 60;
        if (X < G || B > st)
          return null;
        const rt = Math.max(B, G), M = Math.min(X, st), A = (rt - G) / 60 * s, L = (M - rt) / 60 * s;
        return {
          ...T,
          top: A,
          height: L,
          left: 0,
          // Will be calculated with overlap
          width: 100,
          // Will be calculated with overlap
          columnIndex: P,
          _start: rt,
          _end: M
        };
      }).filter(Boolean);
      I.sort((T, j) => T._start !== j._start ? T._start - j._start : j._end - j._start - (T._end - T._start));
      const V = [];
      let $ = /* @__PURE__ */ new Set();
      I.forEach((T) => {
        if ($.has(T.id))
          return;
        const j = I.filter((q) => !(T._end <= q._start || T._start >= q._end));
        j.length > 0 && (V.push(j), j.forEach((q) => $.add(q.id)));
      }), V.forEach((T) => {
        const j = [];
        T.sort((q, B) => q._start !== B._start ? q._start - B._start : B._end - B._start - (q._end - q._start)), T.forEach((q) => {
          let B = !1;
          for (let X of j)
            if (!X.some(
              (st) => !(q._end <= st._start || q._start >= st._end)
            )) {
              X.push(q), B = !0;
              break;
            }
          B || j.push([q]);
        }), T.forEach((q) => {
          let B = 0;
          for (let X = 0; X < j.length; X++)
            if (j[X].includes(q)) {
              B = X;
              break;
            }
          q.width = 100 / j.length, q.left = B * 100 / j.length;
        });
      }), I.forEach((T) => {
        delete T._start, delete T._end, _.push(T);
      });
    }), _;
  }, [t, x, n, i, s]), v = w.length * s;
  return /* @__PURE__ */ k(R, { sx: { position: "relative" }, children: [
    a && /* @__PURE__ */ f(
      R,
      {
        sx: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1001
        },
        children: /* @__PURE__ */ f(wi, { size: 60, sx: { color: c.palette.primary.main } })
      }
    ),
    /* @__PURE__ */ k(R, { sx: {
      display: "grid",
      gridTemplateColumns: `60px repeat(${o ? 7 : 5}, 1fr)`,
      borderBottom: "1px solid var(--mui-palette-divider)",
      position: "sticky",
      top: 0,
      backgroundColor: "var(--mui-palette-background-paper)",
      zIndex: 1e3
    }, children: [
      /* @__PURE__ */ f(R, {}),
      " ",
      x.map((_) => {
        const C = _.isSame(Mt(), "day"), P = l.find((I) => Mt(I.date).isSame(_, "day"));
        return /* @__PURE__ */ k(
          R,
          {
            sx: {
              p: 1,
              textAlign: "center",
              borderLeft: "1px solid var(--mui-palette-divider)",
              backgroundColor: C ? "var(--mui-palette-action-selected)" : "transparent"
            },
            children: [
              /* @__PURE__ */ f(H, { variant: "caption", sx: { color: "var(--mui-palette-text-secondary)" }, children: _.format("ddd") }),
              /* @__PURE__ */ k(R, { sx: { display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }, children: [
                /* @__PURE__ */ f(H, { variant: "body2", fontWeight: C ? 600 : 400, sx: { color: "var(--mui-palette-text-primary)" }, children: _.format("D") }),
                P && /* @__PURE__ */ f(ls, { title: P.tooltip || "", arrow: !0, children: /* @__PURE__ */ f(
                  R,
                  {
                    onClick: (I) => {
                      I.stopPropagation(), P.onClick(_.toDate());
                    },
                    sx: {
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        opacity: 0.7
                      }
                    },
                    children: /* @__PURE__ */ f(
                      Z,
                      {
                        iconType: P.iconType,
                        sx: {
                          fontSize: 16,
                          color: "var(--mui-palette-primary-main)"
                        }
                      }
                    )
                  }
                ) })
              ] })
            ]
          },
          _.format("YYYY-MM-DD")
        );
      })
    ] }),
    /* @__PURE__ */ k(R, { sx: {
      display: "grid",
      gridTemplateColumns: `60px repeat(${o ? 7 : 5}, 1fr)`,
      position: "relative",
      minHeight: `${v}px`
    }, children: [
      w.map((_, C) => /* @__PURE__ */ f(
        R,
        {
          sx: {
            gridColumn: "1",
            gridRow: `${C + 1}`,
            height: `${s}px`,
            pr: 1,
            pt: 0.5,
            borderTop: C === 0 ? "none" : "1px solid var(--mui-palette-divider)",
            textAlign: "right"
          },
          children: /* @__PURE__ */ f(H, { variant: "caption", sx: { color: "var(--mui-palette-text-secondary)" }, children: `${_.toString().padStart(2, "0")}:00` })
        },
        _
      )),
      x.map((_, C) => {
        const P = S.filter((I) => I.columnIndex === C);
        return /* @__PURE__ */ k(
          R,
          {
            sx: {
              gridColumn: `${C + 2}`,
              gridRow: `1 / ${w.length + 1}`,
              borderLeft: "1px solid var(--mui-palette-divider)",
              position: "relative"
            },
            children: [
              w.slice(1).map((I) => {
                const V = (I - n) * s;
                return /* @__PURE__ */ f(
                  R,
                  {
                    sx: {
                      position: "absolute",
                      top: `${V}px`,
                      left: 0,
                      right: 0,
                      borderTop: "1px solid var(--mui-palette-divider)"
                    }
                  },
                  I
                );
              }),
              P.map((I) => {
                const V = I.color || c.palette.primary.main, $ = I.textColor || c.palette.getContrastText(V), T = Mt(I.end).diff(Mt(I.start), "minute") < 20;
                return /* @__PURE__ */ k(
                  _i,
                  {
                    elevation: 2,
                    onClick: () => r == null ? void 0 : r(I),
                    sx: {
                      position: "absolute",
                      top: `${I.top}px`,
                      height: `${I.height}px`,
                      left: `calc(${I.left}% + 1px)`,
                      width: `calc(${I.width}% - 2px)`,
                      backgroundColor: V,
                      color: $,
                      p: T ? 0 : 0.5,
                      pl: 0.5,
                      cursor: r ? "pointer" : "default",
                      overflow: "hidden",
                      zIndex: 1,
                      "&:hover": r ? {
                        boxShadow: c.shadows[4]
                      } : {}
                    },
                    children: [
                      /* @__PURE__ */ f(H, { variant: "caption", fontWeight: T ? 400 : 600, sx: {
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: "inherit",
                        fontSize: T ? "0.7rem" : void 0
                      }, children: I.title }),
                      /* @__PURE__ */ k(H, { variant: "caption", sx: { fontSize: "0.65rem", opacity: 0.9, color: "inherit" }, children: [
                        Mt(I.start).format("HH:mm"),
                        " - ",
                        Mt(I.end).format("HH:mm")
                      ] }),
                      I.staff && I.staff.length > 0 && /* @__PURE__ */ f(H, { variant: "caption", sx: {
                        fontSize: "0.65rem",
                        opacity: 0.9,
                        color: "inherit",
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }, children: I.staff.join(", ") }),
                      I.Code && /* @__PURE__ */ f(
                        R,
                        {
                          sx: {
                            position: "absolute",
                            bottom: 4,
                            right: 4,
                            backgroundColor: $,
                            color: V,
                            px: 0.5,
                            py: 0.25,
                            borderRadius: 0.5,
                            fontSize: "0.65rem",
                            fontWeight: 500,
                            lineHeight: 1
                          },
                          children: I.Code
                        }
                      ),
                      I.badges && I.badges.length > 0 && /* @__PURE__ */ f(
                        R,
                        {
                          sx: {
                            position: "absolute",
                            top: 4,
                            right: 4,
                            display: "flex",
                            gap: 0.25,
                            flexDirection: "row"
                          },
                          children: I.badges.map((j, q) => {
                            const B = `${I.id}-badge-${q}`;
                            return /* @__PURE__ */ f(mf, { onClickAway: m, children: /* @__PURE__ */ f(
                              ls,
                              {
                                title: j.title || "",
                                arrow: !0,
                                open: d === B,
                                onOpen: b(B),
                                onClose: y,
                                children: /* @__PURE__ */ f(
                                  R,
                                  {
                                    onClick: g(B),
                                    sx: {
                                      backgroundColor: j.backgroundColor,
                                      borderRadius: "50%",
                                      width: 18,
                                      height: 18,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer"
                                    },
                                    children: /* @__PURE__ */ f(
                                      Z,
                                      {
                                        iconType: j.iconType,
                                        sx: {
                                          fontSize: 12,
                                          color: c.palette.getContrastText(j.backgroundColor)
                                        }
                                      }
                                    )
                                  }
                                )
                              }
                            ) }, q);
                          })
                        }
                      )
                    ]
                  },
                  `${I.id}`
                );
              })
            ]
          },
          _.format("YYYY-MM-DD")
        );
      })
    ] })
  ] });
}, vk = Ft(({ studentId: e, formId: t, canAdd: n, onClick: i, includeExpired: s, year: r, filter: o }, a) => {
  var h;
  const { isPending: l, data: c, refetch: d } = new ho.RecordListStudent({ studentId: e, formId: t, includeExpired: s ? 1 : 0, year: r }).ToQuery();
  if (Wt(a, () => ({
    refetch: d
  })), t == 0)
    return /* @__PURE__ */ f(bs, { children: /* @__PURE__ */ f(ht, {}) });
  if (l)
    return /* @__PURE__ */ k(R, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: [
      /* @__PURE__ */ f(at, { variant: "rounded", height: 65 }),
      /* @__PURE__ */ f(at, { variant: "rounded", height: 65 }),
      /* @__PURE__ */ f(at, { variant: "rounded", height: 65 }),
      /* @__PURE__ */ f(at, { variant: "rounded", height: 65 }),
      /* @__PURE__ */ f(at, { variant: "rounded", height: 65 })
    ] });
  if (c.Records.length == 0)
    return /* @__PURE__ */ k(ke, { severity: "info", children: [
      "No records for the selected form.",
      /* @__PURE__ */ f("br", {}),
      n ? /* @__PURE__ */ f(ht, { children: "Click new to create one" }) : /* @__PURE__ */ f(ht, {})
    ] });
  let u = null;
  return t && (c != null && c.Form.SummaryFieldID) && (u = ((h = c.Form.Items.find((p) => p.FieldID == c.Form.SummaryFieldID)) == null ? void 0 : h.FieldName) ?? null), /* @__PURE__ */ f(R, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: c.Records.sort((p, m) => m._created.getTime() - p._created.getTime()).filter(o ?? (() => !0)).map((p) => /* @__PURE__ */ f(
    Jd,
    {
      title: p._StatusCaption ? p._StatusCaption : c.Form.Caption,
      status: p._StatusCaption,
      statusType: p._statusType,
      statusFlags: p._statusFlags,
      summary: u && u in p ? p[u].toString() : void 0,
      created: p._created,
      colour: c == null ? void 0 : c.Form.Colour,
      modifiedByName: p._modifiedBy.Name,
      modified: p._modified,
      expireDate: p.ExpireDate,
      onClick: () => {
        i && i(`./${t}?mode=0${p._rowId ? "&row=" + p._rowId : ""}`);
      }
    },
    p._rowId
  )) });
}), I0 = ({ maxWidth: e, children: t }) => {
  const n = kt(null), [i, s] = Y([]), [r, o] = Y([]), [a, l] = Y(null);
  mt(() => {
    const u = () => {
      if (!n.current) return;
      let p = Math.min(n.current.offsetWidth, e ?? 1e5);
      const m = 100, g = Rt.Children.toArray(t).filter((x) => Rt.isValidElement(x)), b = [], y = [];
      g.forEach((x) => {
        p >= m ? (b.push(x), p -= m) : y.push(x);
      }), y.length > 0 && p < 60 && y.unshift(b.pop()), s(b), o(y);
    };
    return u(), window.addEventListener("resize", u), () => window.removeEventListener("resize", u);
  }, [t, e]);
  const c = (u) => l(u.currentTarget), d = () => l(null);
  return /* @__PURE__ */ f(R, { ref: n, style: { display: "flex", maxWidth: `${e}px` }, children: /* @__PURE__ */ k(Ec, { variant: "contained", children: [
    i,
    r.length > 0 && /* @__PURE__ */ k(ht, { children: [
      /* @__PURE__ */ f(ot, { onClick: c, children: /* @__PURE__ */ f(Z, { iconType: J.More }) }),
      /* @__PURE__ */ f(bf, { anchorEl: a, open: !!a, onClose: d, children: r.map((u, h) => {
        if (!Rt.isValidElement(u)) return null;
        const p = u;
        return /* @__PURE__ */ f(cs, { onClick: p.props.onClick, children: p.props.children }, h);
      }) })
    ] })
  ] }) });
};
var ct = /* @__PURE__ */ ((e) => (e[e.Read = 0] = "Read", e[e.Edit = 1] = "Edit", e[e.New = 2] = "New", e))(ct || {});
const D0 = ({ editMode: e, canEdit: t, canDelete: n, actions: i, canAddNew: s, canAttach: r, templateId: o, canMessage: a, discussion: l, fileCount: c, HandleAction: d }) => {
  var x;
  const [u, h] = Y(null), [p, m] = Y({ type: "success", message: "" }), g = kt(null), b = kt(null), y = async (w) => {
    var v;
    h(w);
    let S = await d(w);
    h(null), S && (m(S), (v = g.current) == null || v.openToast());
  };
  return /* @__PURE__ */ k(R, { ref: b, children: [
    /* @__PURE__ */ f(hs, { ref: g, type: p.type, message: p.message }),
    /* @__PURE__ */ k(I0, { maxWidth: (x = b.current) == null ? void 0 : x.clientWidth, children: [
      t && e == 0 && /* @__PURE__ */ f(ot, { disabled: !!u, variant: "contained", startIcon: /* @__PURE__ */ f(Is, {}), onClick: () => y("edit"), children: "Edit" }, "edit"),
      (t && e != 0 || e == 0 && c > 0) && /* @__PURE__ */ f(ot, { disabled: !!u && u != "save", loading: u == "save", variant: "contained", startIcon: /* @__PURE__ */ f(bo, {}), loadingPosition: "start", onClick: () => y("save"), children: "Save" }, "save"),
      e == 1 && /* @__PURE__ */ f(ot, { disabled: !!u && u != "cancel", loading: u == "cancel", variant: "contained", startIcon: /* @__PURE__ */ f(yo, {}), loadingPosition: "start", onClick: () => y("cancel"), children: "Cancel" }, "cancel"),
      n && e != 2 && /* @__PURE__ */ f(ot, { disabled: !!u && u != "delete", loading: u == "delete", variant: "contained", startIcon: /* @__PURE__ */ f(Ci, {}), onClick: () => y("delete"), children: "Delete" }, "delete"),
      s && e == 0 && /* @__PURE__ */ f(ot, { disabled: !!u && u != "add", loading: u == "add", variant: "contained", startIcon: /* @__PURE__ */ f(mo, {}), onClick: () => y("add"), children: "Add" }, "add"),
      (r && t && e == 0 || r && t && e == 2) && /* @__PURE__ */ f(ao, { color: "success", anchorOrigin: { horizontal: "right" }, badgeContent: c > 0 ? c : void 0, children: /* @__PURE__ */ f(ot, { disabled: !!u && u != "attach", loading: u == "attach", variant: "contained", startIcon: /* @__PURE__ */ f(ed, {}), onClick: () => y("attach"), children: "Attach" }, "attach") }),
      o && o != 0 && e == 0 && /* @__PURE__ */ f(ot, { disabled: !0, loading: u == "print", variant: "contained", startIcon: /* @__PURE__ */ f(gp, {}), onClick: () => y("print"), children: "Print" }, ""),
      a && e == 0 && /* @__PURE__ */ f(ot, { disabled: !0, loading: u == "message", variant: "contained", startIcon: /* @__PURE__ */ f(sd, {}), onClick: () => y("message"), children: "Send as message" }, "message"),
      l && e == 0 && /* @__PURE__ */ f(ot, { disabled: !0, loading: u == "reply", variant: "contained", startIcon: /* @__PURE__ */ f(rd, {}), onClick: () => y("reply"), children: "Reply" }, "reply"),
      i && i.map((w) => /* @__PURE__ */ f(ot, { disabled: !!u && u != String(w.ActionId), loading: u == String(w.ActionId), variant: "contained", onClick: () => y(String(w.ActionId)), children: w.Text }, w.ActionId))
    ] })
  ] });
}, O0 = Ft(({ field: e, editMode: t, value: n, onChange: i }, s) => {
  Wt(s, () => ({}));
  const r = (o) => {
    i && i(e.Required && !o ? "" : o.toString());
  };
  return /* @__PURE__ */ f(zn, { control: /* @__PURE__ */ f(co, { checked: n == "1" || n == "true", onChange: (o) => r(o.target.checked), disabled: t == ct.Read }), label: /* @__PURE__ */ k(ht, { children: [
    (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
    e.Required ? " *" : ""
  ] }) });
}), T0 = Ft(({ field: e, editMode: t, value: n, onChange: i }, s) => {
  let r = n ? n.split(",") : [];
  const [o, a] = Y([]);
  Wt(s, () => ({}));
  const l = (d) => (u) => {
    let h = [...r];
    if (u)
      h.includes(d) || (h.push(d), h = o.filter((m) => m.ItemID !== -1).map((m) => la(m.Value)).filter((m) => h.includes(m)));
    else {
      const p = h.indexOf(d);
      p !== -1 && h.splice(p, 1);
    }
    i && i(h.join(","));
  };
  mt(() => {
    let d = null, u = [];
    e.ListItems.sort((h, p) => h.Category.localeCompare(p.Category)).forEach((h) => {
      h.Category != "" && h.Category != d && (u.push({
        ItemID: -1,
        FieldID: -1,
        Name: h.Category,
        Value: "",
        Category: ""
      }), d = h.Category), h.Value != "" && u.push(h);
    }), a([...u]);
  }, [e]);
  const c = r.filter((d) => d !== "").map((d) => aa(d));
  return /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ k(H, { variant: t == ct.Read ? "disabled" : "caption", sx: { fontSize: "large" }, children: [
      (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      e.Required ? " *" : ""
    ] }),
    /* @__PURE__ */ f(R, { sx: { display: "flex", flexFlow: "column", gap: 0, paddingLeft: 3 }, children: o.map((d) => {
      if (d.ItemID == -1)
        return /* @__PURE__ */ f(uo, { children: d.Name }, d.Name);
      {
        const u = aa(d.Value);
        return /* @__PURE__ */ f(
          zn,
          {
            control: /* @__PURE__ */ f(
              co,
              {
                checked: c.includes(u),
                onChange: (h) => l(la(d.Value))(h.target.checked),
                disabled: t == ct.Read
              }
            ),
            label: d.Name
          },
          d.Name
        );
      }
    }) })
  ] });
}), E0 = Ft(({ field: e, editMode: t, value: n, onChange: i, onBlur: s, showValidation: r }, o) => {
  let a = n && typeof n == "string" ? Mt(n) : null;
  a == null && n && (a = Mt(n)), t == ct.New && ((e.Flags & 1) > 0 ? a = null : a = Mt()), Wt(o, () => ({}));
  const l = (d) => {
    i && i((d == null ? void 0 : d.toString()) ?? "");
  }, c = () => {
    a = n && typeof n == "string" ? Mt(n) : null, s && s((a == null ? void 0 : a.toString()) ?? "");
  };
  return /* @__PURE__ */ f(
    rp,
    {
      label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      disabled: t == ct.Read,
      value: a,
      onChange: (d) => l(d),
      slotProps: {
        textField: {
          error: r,
          onBlur: c,
          required: e.Required
        }
      }
    }
  );
}), R0 = Ft(({ field: e, editMode: t, value: n, onChange: i, onBlur: s, showValidation: r }, o) => {
  let a = n && typeof n == "string" ? Mt(n) : null;
  t == ct.New && ((e.Flags & 1) > 0 ? a = null : a = Mt()), Wt(o, () => ({}));
  const l = (d) => {
    i && i((d == null ? void 0 : d.toString()) ?? "");
  }, c = () => {
    a = n && typeof n == "string" ? Mt(n) : null, s && s((a == null ? void 0 : a.toString()) ?? "");
  };
  return /* @__PURE__ */ f(
    op,
    {
      label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      disabled: t == ct.Read,
      value: a,
      onChange: (d) => l(d),
      slotProps: {
        textField: {
          error: r,
          onBlur: c,
          required: e.Required
        }
      }
    }
  );
}), L0 = Ft(({ field: e, editMode: t, value: n, onChange: i, showValidation: s, onBlur: r }, o) => {
  Wt(o, () => ({}));
  const a = (c) => {
    c = c.replace(/[^\d.-]/g, ""), i && i(c.toString());
  }, l = () => {
    r && r((n == null ? void 0 : n.toString()) ?? "");
  };
  return /* @__PURE__ */ f(
    yn,
    {
      id: e.FieldName,
      label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      disabled: t == ct.Read,
      type: "number",
      multiline: !0,
      rows: e.Height,
      value: n ?? "",
      onChange: (c) => {
        a(c.target.value);
      },
      onBlur: () => l(),
      error: s,
      required: e.Required
    }
  );
}), F0 = Ft(({ field: e, editMode: t, value: n, onChange: i, showValidation: s, onBlur: r }, o) => {
  Wt(o, () => ({}));
  const a = (c) => {
    i && i(c);
  }, l = () => {
    r && r((n == null ? void 0 : n.toString()) ?? "");
  };
  return /* @__PURE__ */ f(
    yn,
    {
      id: e.FieldName,
      label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      disabled: t == ct.Read,
      multiline: !0,
      rows: e.Height,
      value: n ?? "",
      onChange: (c) => {
        a(c.target.value);
      },
      required: e.Required,
      onBlur: l,
      error: s
    },
    e.FieldName
  );
}), N0 = Ft(({ field: e, editMode: t, value: n, onChange: i, showValidation: s, onBlur: r }, o) => {
  const [a, l] = Y([]);
  Wt(o, () => ({}));
  const c = (u, h) => {
    i && i(u.toString(), h);
  }, d = (u) => {
    r && r(u.toString());
  };
  return mt(() => {
    let u = null;
    const h = [];
    let p = !1;
    (e.Flags & 1) > 0 && (typeof n > "u" || n == "") && h.push({
      ItemID: -2,
      FieldID: -2,
      Name: "-- Please Select --",
      Value: "",
      Category: ""
    }), e.ListItems && e.ListItems.sort((m, g) => m.Category.localeCompare(g.Category)).forEach((m) => {
      m.Category != "" && m.Category != u && (h.push({
        ItemID: -1,
        FieldID: -1,
        Name: m.Category,
        Value: "",
        Category: ""
      }), u = m.Category), m.Value != "" && !p && m.Value == n && (p = !0), h.push(m);
    }), !p && h.find((m) => m.ItemID != -1) != null && [...h].find((m) => m.ItemID != -1).Value != "" && c([...h].find((m) => m.ItemID != -1).Value, !1), l([...h]);
  }, [e, n]), /* @__PURE__ */ k(Ms, { error: s, children: [
    /* @__PURE__ */ k(fo, { htmlFor: "grouped-native-select", shrink: !0, children: [
      (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      e.Required ? " *" : ""
    ] }),
    /* @__PURE__ */ f(
      yf,
      {
        id: "grouped-native-select",
        label: e.Caption,
        value: n || "",
        onChange: (u) => c(u.target.value ?? "", !0),
        onBlur: (u) => d(u.target.value ?? ""),
        disabled: t == ct.Read,
        displayEmpty: !0,
        children: a.map((u) => u.ItemID == -1 ? /* @__PURE__ */ f(xf, { children: u.Name }, u.Name) : /* @__PURE__ */ f(
          cs,
          {
            sx: { minHeight: 1 },
            value: u.Value,
            disabled: u.ItemID == -2,
            children: u.Name
          },
          u.ItemID
        ))
      }
    )
  ] }, e.FieldName);
}), z0 = Ft(({ field: e, editMode: t, value: n, onChange: i }, s) => {
  const [r, o] = Y([]);
  Wt(s, () => ({}));
  const a = (l) => {
    i && i(l);
  };
  return mt(() => {
    let l = null;
    const c = [];
    e.ListItems.sort((d, u) => d.Category.localeCompare(u.Category)).forEach((d) => {
      d.Category != "" && d.Category != l && (c.push({
        ItemID: -1,
        FieldID: -1,
        Name: d.Category,
        Value: "",
        Category: ""
      }), l = d.Category), c.push(d);
    }), o([...c]), (n === "" || n === void 0 || n === null) && (e.Flags & ee.DatePickerNotDefaultToNow) === 0 && i && i(c[0].Value, !1);
  }, [e]), /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ k(H, { variant: t == ct.Read ? "disabled" : "caption", sx: { fontSize: "large" }, children: [
      (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      e.Required ? " *" : ""
    ] }),
    /* @__PURE__ */ f(R, { sx: { paddingLeft: 3 }, children: /* @__PURE__ */ f(
      Nc,
      {
        id: "grouped-native-select",
        value: n !== void 0 ? n : (e.Flags & 1) > 0 ? void 0 : r.length > 0 ? r[0].Value : "",
        onChange: (l) => a(l.target.value ?? ""),
        children: r.map((l) => l.ItemID == -1 ? /* @__PURE__ */ f(uo, { children: l.Name }, l.Name) : /* @__PURE__ */ f(zn, { value: l.Value, control: /* @__PURE__ */ f(zc, { disabled: t == ct.Read }), label: l.Name }, l.Name))
      }
    ) })
  ] });
}), B0 = Ft(({ field: e, editMode: t, value: n, onChange: i, onBlur: s, showValidation: r }, o) => {
  let a = n && typeof n == "string" ? Mt(n) : null;
  t == ct.New && ((e.Flags & 1) > 0 ? a = null : a = Mt()), Wt(o, () => ({}));
  const l = (d) => {
    i && i((d == null ? void 0 : d.toString()) ?? "");
  }, c = () => {
    a = n && typeof n == "string" ? Mt(n) : null, s && s((a == null ? void 0 : a.toString()) ?? "");
  };
  return /* @__PURE__ */ f(
    ap,
    {
      label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }),
      disabled: t == ct.Read,
      value: a,
      onChange: (d) => l(d),
      slotProps: {
        textField: {
          error: r,
          onBlur: c,
          required: e.Required
        }
      }
    }
  );
}), W0 = Ft(({ field: e, editMode: t, value: n, onChange: i, showValidation: s }, r) => {
  const [o, a] = Y(!1);
  mt(() => {
    e.Required && a((s && (!n || n == "")) ?? !1);
  }, []);
  const [l, c] = Y(!1);
  Wt(r, () => ({}));
  const d = (u) => {
    i && i(u);
  };
  return /* @__PURE__ */ k(Ms, { children: [
    /* @__PURE__ */ f(fo, { htmlFor: e.FieldName, children: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }) }),
    /* @__PURE__ */ f(
      Bc,
      {
        id: e.FieldName,
        label: e.Caption,
        disabled: t == ct.Read,
        type: l ? "text" : "password",
        value: n ?? "",
        onChange: (u) => {
          d(u.target.value);
        },
        required: e.Required,
        onBlur: () => a(e.Required && n == ""),
        error: o,
        endAdornment: /* @__PURE__ */ f(Wc, { position: "end", children: /* @__PURE__ */ f(li, { "aria-label": l ? "hide the password" : "display the password", onClick: () => c(!l), children: l ? /* @__PURE__ */ f(Z, { iconType: J.VisibilityOff }) : /* @__PURE__ */ f(Z, { iconType: J.Visibility }) }) })
      }
    )
  ] });
});
function Ns() {
  return (Ns = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }).apply(this, arguments);
}
function tu(e, t) {
  if (e == null) return {};
  var n, i, s = {}, r = Object.keys(e);
  for (i = 0; i < r.length; i++) t.indexOf(n = r[i]) >= 0 || (s[n] = e[n]);
  return s;
}
function Wr(e) {
  var t = kt(e), n = kt(function(i) {
    t.current && t.current(i);
  });
  return t.current = e, n.current;
}
var fi = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, ni = function(e) {
  return "touches" in e;
}, jr = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, nl = function(e, t, n) {
  var i = e.getBoundingClientRect(), s = ni(t) ? function(r, o) {
    for (var a = 0; a < r.length; a++) if (r[a].identifier === o) return r[a];
    return r[0];
  }(t.touches, n) : t;
  return { left: fi((s.pageX - (i.left + jr(e).pageXOffset)) / i.width), top: fi((s.pageY - (i.top + jr(e).pageYOffset)) / i.height) };
}, il = function(e) {
  !ni(e) && e.preventDefault();
}, eu = Rt.memo(function(e) {
  var t = e.onMove, n = e.onKey, i = tu(e, ["onMove", "onKey"]), s = kt(null), r = Wr(t), o = Wr(n), a = kt(null), l = kt(!1), c = Ki(function() {
    var p = function(b) {
      il(b), (ni(b) ? b.touches.length > 0 : b.buttons > 0) && s.current ? r(nl(s.current, b, a.current)) : g(!1);
    }, m = function() {
      return g(!1);
    };
    function g(b) {
      var y = l.current, x = jr(s.current), w = b ? x.addEventListener : x.removeEventListener;
      w(y ? "touchmove" : "mousemove", p), w(y ? "touchend" : "mouseup", m);
    }
    return [function(b) {
      var y = b.nativeEvent, x = s.current;
      if (x && (il(y), !function(S, v) {
        return v && !ni(S);
      }(y, l.current) && x)) {
        if (ni(y)) {
          l.current = !0;
          var w = y.changedTouches || [];
          w.length && (a.current = w[0].identifier);
        }
        x.focus(), r(nl(x, y, a.current)), g(!0);
      }
    }, function(b) {
      var y = b.which || b.keyCode;
      y < 37 || y > 40 || (b.preventDefault(), o({ left: y === 39 ? 0.05 : y === 37 ? -0.05 : 0, top: y === 40 ? 0.05 : y === 38 ? -0.05 : 0 }));
    }, g];
  }, [o, r]), d = c[0], u = c[1], h = c[2];
  return mt(function() {
    return h;
  }, [h]), Rt.createElement("div", Ns({}, i, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: s, onKeyDown: u, tabIndex: 0, role: "slider" }));
}), Lo = function(e) {
  return e.filter(Boolean).join(" ");
}, nu = function(e) {
  var t = e.color, n = e.left, i = e.top, s = i === void 0 ? 0.5 : i, r = Lo(["react-colorful__pointer", e.className]);
  return Rt.createElement("div", { className: r, style: { top: 100 * s + "%", left: 100 * n + "%" } }, Rt.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, $t = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, j0 = function(e) {
  return Y0($r(e));
}, $r = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? $t(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? $t(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, $0 = function(e) {
  return U0(H0(e));
}, V0 = function(e) {
  var t = e.s, n = e.v, i = e.a, s = (200 - t) * n / 100;
  return { h: $t(e.h), s: $t(s > 0 && s < 200 ? t * n / 100 / (s <= 100 ? s : 200 - s) * 100 : 0), l: $t(s / 2), a: $t(i, 2) };
}, Vr = function(e) {
  var t = V0(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, H0 = function(e) {
  var t = e.h, n = e.s, i = e.v, s = e.a;
  t = t / 360 * 6, n /= 100, i /= 100;
  var r = Math.floor(t), o = i * (1 - n), a = i * (1 - (t - r) * n), l = i * (1 - (1 - t + r) * n), c = r % 6;
  return { r: $t(255 * [i, a, o, o, l, i][c]), g: $t(255 * [l, i, i, a, o, o][c]), b: $t(255 * [o, o, l, i, i, a][c]), a: $t(s, 2) };
}, Ri = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, U0 = function(e) {
  var t = e.r, n = e.g, i = e.b, s = e.a, r = s < 1 ? Ri($t(255 * s)) : "";
  return "#" + Ri(t) + Ri(n) + Ri(i) + r;
}, Y0 = function(e) {
  var t = e.r, n = e.g, i = e.b, s = e.a, r = Math.max(t, n, i), o = r - Math.min(t, n, i), a = o ? r === t ? (n - i) / o : r === n ? 2 + (i - t) / o : 4 + (t - n) / o : 0;
  return { h: $t(60 * (a < 0 ? a + 6 : a)), s: $t(r ? o / r * 100 : 0), v: $t(r / 255 * 100), a: s };
}, q0 = Rt.memo(function(e) {
  var t = e.hue, n = e.onChange, i = Lo(["react-colorful__hue", e.className]);
  return Rt.createElement("div", { className: i }, Rt.createElement(eu, { onMove: function(s) {
    n({ h: 360 * s.left });
  }, onKey: function(s) {
    n({ h: fi(t + 360 * s.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": $t(t), "aria-valuemax": "360", "aria-valuemin": "0" }, Rt.createElement(nu, { className: "react-colorful__hue-pointer", left: t / 360, color: Vr({ h: t, s: 100, v: 100, a: 1 }) })));
}), X0 = Rt.memo(function(e) {
  var t = e.hsva, n = e.onChange, i = { backgroundColor: Vr({ h: t.h, s: 100, v: 100, a: 1 }) };
  return Rt.createElement("div", { className: "react-colorful__saturation", style: i }, Rt.createElement(eu, { onMove: function(s) {
    n({ s: 100 * s.left, v: 100 - 100 * s.top });
  }, onKey: function(s) {
    n({ s: fi(t.s + 100 * s.left, 0, 100), v: fi(t.v - 100 * s.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + $t(t.s) + "%, Brightness " + $t(t.v) + "%" }, Rt.createElement(nu, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Vr(t) })));
}), iu = function(e, t) {
  if (e === t) return !0;
  for (var n in e) if (e[n] !== t[n]) return !1;
  return !0;
}, G0 = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || iu($r(e), $r(t));
};
function K0(e, t, n) {
  var i = Wr(n), s = Y(function() {
    return e.toHsva(t);
  }), r = s[0], o = s[1], a = kt({ color: t, hsva: r });
  mt(function() {
    if (!e.equal(t, a.current.color)) {
      var c = e.toHsva(t);
      a.current = { hsva: c, color: t }, o(c);
    }
  }, [t, e]), mt(function() {
    var c;
    iu(r, a.current.hsva) || e.equal(c = e.fromHsva(r), a.current.color) || (a.current = { hsva: r, color: c }, i(c));
  }, [r, e, i]);
  var l = Tc(function(c) {
    o(function(d) {
      return Object.assign({}, d, c);
    });
  }, []);
  return [r, l];
}
var Q0 = typeof window < "u" ? af : mt, Z0 = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, sl = /* @__PURE__ */ new Map(), J0 = function(e) {
  Q0(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !sl.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, sl.set(t, n);
      var i = Z0();
      i && n.setAttribute("nonce", i), t.head.appendChild(n);
    }
  }, []);
}, tb = function(e) {
  var t = e.className, n = e.colorModel, i = e.color, s = i === void 0 ? n.defaultColor : i, r = e.onChange, o = tu(e, ["className", "colorModel", "color", "onChange"]), a = kt(null);
  J0(a);
  var l = K0(n, s, r), c = l[0], d = l[1], u = Lo(["react-colorful", t]);
  return Rt.createElement("div", Ns({}, o, { ref: a, className: u }), Rt.createElement(X0, { hsva: c, onChange: d }), Rt.createElement(q0, { hue: c.h, onChange: d, className: "react-colorful__last-control" }));
}, eb = { defaultColor: "000", toHsva: j0, fromHsva: function(e) {
  return $0({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: G0 }, nb = function(e) {
  return Rt.createElement(tb, Ns({}, e, { colorModel: eb }));
};
const ib = Ft(({ field: e, editMode: t, value: n, onChange: i }, s) => {
  let r = n && n !== "" ? n : "#FFFFFF";
  const [o, a] = Y(null);
  Wt(s, () => ({}));
  const l = (u) => {
    a(u.currentTarget);
  }, c = () => {
    a(null);
  }, d = (u) => {
    i && i(u);
  };
  return /* @__PURE__ */ k(R, { display: "flex", alignItems: "center", gap: 1, children: [
    /* @__PURE__ */ f(
      yn,
      {
        id: e.FieldName,
        label: e.Caption,
        disabled: t == ct.Read,
        value: r,
        onChange: (u) => d(u.target.value),
        sx: { borderRadius: "var(--mui-shape-borderRadius)", backgroundColor: t == ct.Read ? ab(r, 0.8) : r, input: { color: sb(r) } },
        onClick: l
      }
    ),
    /* @__PURE__ */ f(
      Fc,
      {
        open: !!o,
        anchorEl: o,
        onClose: c,
        disableAutoFocus: !0,
        disableEnforceFocus: !0,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        transformOrigin: { vertical: "top", horizontal: "center" },
        children: /* @__PURE__ */ f(R, { p: 2, children: /* @__PURE__ */ f(nb, { color: r, onChange: d }) })
      }
    )
  ] });
});
function sb(e) {
  if (!e)
    return "#000000";
  e = e.replace("#", ""), e.length === 3 && (e = e.split("").map((r) => r + r).join(""));
  const t = parseInt(e.substring(0, 2), 16), n = parseInt(e.substring(2, 4), 16), i = parseInt(e.substring(4, 6), 16);
  return (t * 299 + n * 587 + i * 114) / 1e3 > 128 ? "#000000" : "#FFFFFF";
}
function rb(e) {
  let t = parseInt(e.slice(1, 3), 16) / 255, n = parseInt(e.slice(3, 5), 16) / 255, i = parseInt(e.slice(5, 7), 16) / 255, s = Math.max(t, n, i), r = Math.min(t, n, i), o = 0, a = 0, l = (s + r) / 2;
  if (s !== r) {
    let c = s - r;
    a = l > 0.5 ? c / (2 - s - r) : c / (s + r), o = s === t ? (n - i) / c + (n < i ? 6 : 0) : s === n ? (i - t) / c + 2 : (t - n) / c + 4, o /= 6;
  }
  return { h: Math.round(o * 360), s: Math.round(a * 100), l: Math.round(l * 100) };
}
function ob(e, t, n) {
  t /= 100, n /= 100;
  let i = (1 - Math.abs(2 * n - 1)) * t, s = i * (1 - Math.abs(e / 60 % 2 - 1)), r = n - i / 2, o = 0, a = 0, l = 0;
  return e < 60 ? [o, a, l] = [i, s, 0] : e < 120 ? [o, a, l] = [s, i, 0] : e < 180 ? [o, a, l] = [0, i, s] : e < 240 ? [o, a, l] = [0, s, i] : e < 300 ? [o, a, l] = [s, 0, i] : [o, a, l] = [i, 0, s], `#${((1 << 24) + (Math.round((o + r) * 255) << 16 | Math.round((a + r) * 255) << 8 | Math.round((l + r) * 255))).toString(16).slice(1).toUpperCase()}`;
}
function ab(e, t) {
  let { h: n, s: i, l: s } = rb(e);
  return i = Math.max(0, i - t * 100), ob(n, i, s);
}
const lb = Ft(({ field: e, value: t, payment: n, onChange: i, reload: s }, r) => {
  Wt(r, () => ({}));
  const [o, a] = Y(!1), l = (u) => {
    i && i(u);
  };
  let c, d;
  switch (n == null ? void 0 : n.PayStatus) {
    case te.Due:
      d = "warning", c = "Pay Now";
      break;
    case te.Paid:
      d = "success", c = "View Invoice";
      break;
    case te.Failed:
      d = "error", c = "Pay Now";
      break;
  }
  return /* @__PURE__ */ k(R, { display: "flex", gap: 1, children: [
    /* @__PURE__ */ k(Ms, { focused: !0, color: d, sx: { flexGrow: 1 }, children: [
      /* @__PURE__ */ f(fo, { htmlFor: e.FieldName, children: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(oe, { unwrapDisallowed: !0, disallowedElements: ["p"], children: e.Caption }) : /* @__PURE__ */ f(ae, { text: e.Caption }) }),
      /* @__PURE__ */ f(
        Bc,
        {
          id: e.FieldName,
          label: e.Caption,
          value: t ?? "",
          required: e.Required,
          startAdornment: /* @__PURE__ */ f(Wc, { position: "start", children: "$" }),
          color: d,
          onChange: (u) => {
            l(u.target.value);
          }
        }
      )
    ] }),
    c && /* @__PURE__ */ f(ot, { variant: "contained", sx: { flexShrink: 1 }, onClick: () => a(!0), children: c }),
    n && o && /* @__PURE__ */ f(Qd, { ...n, onClose: (u) => {
      u && s && s(), a(!1);
    } })
  ] });
});
/*!
 * Signature Pad v5.0.9 | https://github.com/szimek/signature_pad
 * (c) 2025 Szymon Nowak | Released under the MIT license
 */
class ys {
  constructor(t, n, i, s) {
    if (isNaN(t) || isNaN(n))
      throw new Error(`Point is invalid: (${t}, ${n})`);
    this.x = +t, this.y = +n, this.pressure = i || 0, this.time = s || Date.now();
  }
  distanceTo(t) {
    return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2));
  }
  equals(t) {
    return this.x === t.x && this.y === t.y && this.pressure === t.pressure && this.time === t.time;
  }
  velocityFrom(t) {
    return this.time !== t.time ? this.distanceTo(t) / (this.time - t.time) : 0;
  }
}
class Fo {
  static fromPoints(t, n) {
    const i = this.calculateControlPoints(t[0], t[1], t[2]).c2, s = this.calculateControlPoints(t[1], t[2], t[3]).c1;
    return new Fo(t[1], i, s, t[2], n.start, n.end);
  }
  static calculateControlPoints(t, n, i) {
    const s = t.x - n.x, r = t.y - n.y, o = n.x - i.x, a = n.y - i.y, l = { x: (t.x + n.x) / 2, y: (t.y + n.y) / 2 }, c = { x: (n.x + i.x) / 2, y: (n.y + i.y) / 2 }, d = Math.sqrt(s * s + r * r), u = Math.sqrt(o * o + a * a), h = l.x - c.x, p = l.y - c.y, m = d + u == 0 ? 0 : u / (d + u), g = { x: c.x + h * m, y: c.y + p * m }, b = n.x - g.x, y = n.y - g.y;
    return {
      c1: new ys(l.x + b, l.y + y),
      c2: new ys(c.x + b, c.y + y)
    };
  }
  constructor(t, n, i, s, r, o) {
    this.startPoint = t, this.control2 = n, this.control1 = i, this.endPoint = s, this.startWidth = r, this.endWidth = o;
  }
  length() {
    let n = 0, i, s;
    for (let r = 0; r <= 10; r += 1) {
      const o = r / 10, a = this.point(o, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), l = this.point(o, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (r > 0) {
        const c = a - i, d = l - s;
        n += Math.sqrt(c * c + d * d);
      }
      i = a, s = l;
    }
    return n;
  }
  point(t, n, i, s, r) {
    return n * (1 - t) * (1 - t) * (1 - t) + 3 * i * (1 - t) * (1 - t) * t + 3 * s * (1 - t) * t * t + r * t * t * t;
  }
}
class cb {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch {
      this._et = document;
    }
  }
  addEventListener(t, n, i) {
    this._et.addEventListener(t, n, i);
  }
  dispatchEvent(t) {
    return this._et.dispatchEvent(t);
  }
  removeEventListener(t, n, i) {
    this._et.removeEventListener(t, n, i);
  }
}
function db(e, t = 250) {
  let n = 0, i = null, s, r, o;
  const a = () => {
    n = Date.now(), i = null, s = e.apply(r, o), i || (r = null, o = []);
  };
  return function(...c) {
    const d = Date.now(), u = t - (d - n);
    return r = this, o = c, u <= 0 || u > t ? (i && (clearTimeout(i), i = null), n = d, s = e.apply(r, o), i || (r = null, o = [])) : i || (i = window.setTimeout(a, u)), s;
  };
}
class xs extends cb {
  constructor(t, n = {}) {
    var i, s, r;
    super(), this.canvas = t, this._drawingStroke = !1, this._isEmpty = !0, this._lastPoints = [], this._data = [], this._lastVelocity = 0, this._lastWidth = 0, this._handleMouseDown = (o) => {
      !this._isLeftButtonPressed(o, !0) || this._drawingStroke || this._strokeBegin(this._pointerEventToSignatureEvent(o));
    }, this._handleMouseMove = (o) => {
      if (!this._isLeftButtonPressed(o, !0) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(o), !1);
        return;
      }
      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(o));
    }, this._handleMouseUp = (o) => {
      this._isLeftButtonPressed(o) || this._strokeEnd(this._pointerEventToSignatureEvent(o));
    }, this._handleTouchStart = (o) => {
      o.targetTouches.length !== 1 || this._drawingStroke || (o.cancelable && o.preventDefault(), this._strokeBegin(this._touchEventToSignatureEvent(o)));
    }, this._handleTouchMove = (o) => {
      if (o.targetTouches.length === 1) {
        if (o.cancelable && o.preventDefault(), !this._drawingStroke) {
          this._strokeEnd(this._touchEventToSignatureEvent(o), !1);
          return;
        }
        this._strokeMoveUpdate(this._touchEventToSignatureEvent(o));
      }
    }, this._handleTouchEnd = (o) => {
      o.targetTouches.length === 0 && (o.cancelable && o.preventDefault(), this._strokeEnd(this._touchEventToSignatureEvent(o)));
    }, this._handlePointerDown = (o) => {
      !o.isPrimary || !this._isLeftButtonPressed(o) || this._drawingStroke || typeof this._strokePointerId < "u" && this._strokePointerId !== this._getPointerId(o) || (this._strokePointerId = this._getPointerId(o), o.preventDefault(), this._strokeBegin(this._pointerEventToSignatureEvent(o)));
    }, this._handlePointerMove = (o) => {
      if (!(!o.isPrimary || this._strokePointerId !== this._getPointerId(o))) {
        if (!this._isLeftButtonPressed(o, !0) || !this._drawingStroke) {
          this._strokeEnd(this._pointerEventToSignatureEvent(o), !1);
          return;
        }
        o.preventDefault(), this._strokeMoveUpdate(this._pointerEventToSignatureEvent(o));
      }
    }, this._handlePointerUp = (o) => {
      !o.isPrimary || this._isLeftButtonPressed(o) || this._strokePointerId !== this._getPointerId(o) || (this._strokePointerId = void 0, o.preventDefault(), this._strokeEnd(this._pointerEventToSignatureEvent(o)));
    }, this.velocityFilterWeight = n.velocityFilterWeight || 0.7, this.minWidth = n.minWidth || 0.5, this.maxWidth = n.maxWidth || 2.5, this.throttle = (i = n.throttle) !== null && i !== void 0 ? i : 16, this.minDistance = (s = n.minDistance) !== null && s !== void 0 ? s : 5, this.dotSize = n.dotSize || 0, this.penColor = n.penColor || "black", this.backgroundColor = n.backgroundColor || "rgba(0,0,0,0)", this.compositeOperation = n.compositeOperation || "source-over", this.canvasContextOptions = (r = n.canvasContextOptions) !== null && r !== void 0 ? r : {}, this._strokeMoveUpdate = this.throttle ? db(xs.prototype._strokeUpdate, this.throttle) : xs.prototype._strokeUpdate, this._ctx = t.getContext("2d", this.canvasContextOptions), this.clear(), this.on();
  }
  clear() {
    const { _ctx: t, canvas: n } = this;
    t.fillStyle = this.backgroundColor, t.clearRect(0, 0, n.width, n.height), t.fillRect(0, 0, n.width, n.height), this._data = [], this._reset(this._getPointGroupOptions()), this._isEmpty = !0;
  }
  fromDataURL(t, n = {}) {
    return new Promise((i, s) => {
      const r = new Image(), o = n.ratio || window.devicePixelRatio || 1, a = n.width || this.canvas.width / o, l = n.height || this.canvas.height / o, c = n.xOffset || 0, d = n.yOffset || 0;
      this._reset(this._getPointGroupOptions()), r.onload = () => {
        this._ctx.drawImage(r, c, d, a, l), i();
      }, r.onerror = (u) => {
        s(u);
      }, r.crossOrigin = "anonymous", r.src = t, this._isEmpty = !1;
    });
  }
  toDataURL(t = "image/png", n) {
    switch (t) {
      case "image/svg+xml":
        return typeof n != "object" && (n = void 0), `data:image/svg+xml;base64,${btoa(this.toSVG(n))}`;
      default:
        return typeof n != "number" && (n = void 0), this.canvas.toDataURL(t, n);
    }
  }
  on() {
    this.canvas.style.touchAction = "none", this.canvas.style.msTouchAction = "none", this.canvas.style.userSelect = "none";
    const t = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    window.PointerEvent && !t ? this._handlePointerEvents() : (this._handleMouseEvents(), "ontouchstart" in window && this._handleTouchEvents());
  }
  off() {
    this.canvas.style.touchAction = "auto", this.canvas.style.msTouchAction = "auto", this.canvas.style.userSelect = "auto", this.canvas.removeEventListener("pointerdown", this._handlePointerDown), this.canvas.removeEventListener("mousedown", this._handleMouseDown), this.canvas.removeEventListener("touchstart", this._handleTouchStart), this._removeMoveUpEventListeners();
  }
  _getListenerFunctions() {
    var t;
    const n = window.document === this.canvas.ownerDocument ? window : (t = this.canvas.ownerDocument.defaultView) !== null && t !== void 0 ? t : this.canvas.ownerDocument;
    return {
      addEventListener: n.addEventListener.bind(n),
      removeEventListener: n.removeEventListener.bind(n)
    };
  }
  _removeMoveUpEventListeners() {
    const { removeEventListener: t } = this._getListenerFunctions();
    t("pointermove", this._handlePointerMove), t("pointerup", this._handlePointerUp), t("mousemove", this._handleMouseMove), t("mouseup", this._handleMouseUp), t("touchmove", this._handleTouchMove), t("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(t, { clear: n = !0 } = {}) {
    n && this.clear(), this._fromData(t, this._drawCurve.bind(this), this._drawDot.bind(this)), this._data = this._data.concat(t);
  }
  toData() {
    return this._data;
  }
  _isLeftButtonPressed(t, n) {
    return n ? t.buttons === 1 : (t.buttons & 1) === 1;
  }
  _pointerEventToSignatureEvent(t) {
    return {
      event: t,
      type: t.type,
      x: t.clientX,
      y: t.clientY,
      pressure: "pressure" in t ? t.pressure : 0
    };
  }
  _touchEventToSignatureEvent(t) {
    const n = t.changedTouches[0];
    return {
      event: t,
      type: t.type,
      x: n.clientX,
      y: n.clientY,
      pressure: n.force
    };
  }
  _getPointerId(t) {
    return t.persistentDeviceId || t.pointerId;
  }
  _getPointGroupOptions(t) {
    return {
      penColor: t && "penColor" in t ? t.penColor : this.penColor,
      dotSize: t && "dotSize" in t ? t.dotSize : this.dotSize,
      minWidth: t && "minWidth" in t ? t.minWidth : this.minWidth,
      maxWidth: t && "maxWidth" in t ? t.maxWidth : this.maxWidth,
      velocityFilterWeight: t && "velocityFilterWeight" in t ? t.velocityFilterWeight : this.velocityFilterWeight,
      compositeOperation: t && "compositeOperation" in t ? t.compositeOperation : this.compositeOperation
    };
  }
  _strokeBegin(t) {
    if (!this.dispatchEvent(new CustomEvent("beginStroke", { detail: t, cancelable: !0 })))
      return;
    const { addEventListener: i } = this._getListenerFunctions();
    switch (t.event.type) {
      case "mousedown":
        i("mousemove", this._handleMouseMove, {
          passive: !1
        }), i("mouseup", this._handleMouseUp, { passive: !1 });
        break;
      case "touchstart":
        i("touchmove", this._handleTouchMove, {
          passive: !1
        }), i("touchend", this._handleTouchEnd, { passive: !1 });
        break;
      case "pointerdown":
        i("pointermove", this._handlePointerMove, {
          passive: !1
        }), i("pointerup", this._handlePointerUp, {
          passive: !1
        });
        break;
    }
    this._drawingStroke = !0;
    const s = this._getPointGroupOptions(), r = Object.assign(Object.assign({}, s), { points: [] });
    this._data.push(r), this._reset(s), this._strokeUpdate(t);
  }
  _strokeUpdate(t) {
    if (!this._drawingStroke)
      return;
    if (this._data.length === 0) {
      this._strokeBegin(t);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: t }));
    const n = this._createPoint(t.x, t.y, t.pressure), i = this._data[this._data.length - 1], s = i.points, r = s.length > 0 && s[s.length - 1], o = r ? n.distanceTo(r) <= this.minDistance : !1, a = this._getPointGroupOptions(i);
    if (!r || !(r && o)) {
      const l = this._addPoint(n, a);
      r ? l && this._drawCurve(l, a) : this._drawDot(n, a), s.push({
        time: n.time,
        x: n.x,
        y: n.y,
        pressure: n.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: t }));
  }
  _strokeEnd(t, n = !0) {
    this._removeMoveUpEventListeners(), this._drawingStroke && (n && this._strokeUpdate(t), this._drawingStroke = !1, this.dispatchEvent(new CustomEvent("endStroke", { detail: t })));
  }
  _handlePointerEvents() {
    this._drawingStroke = !1, this.canvas.addEventListener("pointerdown", this._handlePointerDown, {
      passive: !1
    });
  }
  _handleMouseEvents() {
    this._drawingStroke = !1, this.canvas.addEventListener("mousedown", this._handleMouseDown, {
      passive: !1
    });
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart, {
      passive: !1
    });
  }
  _reset(t) {
    this._lastPoints = [], this._lastVelocity = 0, this._lastWidth = (t.minWidth + t.maxWidth) / 2, this._ctx.fillStyle = t.penColor, this._ctx.globalCompositeOperation = t.compositeOperation;
  }
  _createPoint(t, n, i) {
    const s = this.canvas.getBoundingClientRect();
    return new ys(t - s.left, n - s.top, i, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(t, n) {
    const { _lastPoints: i } = this;
    if (i.push(t), i.length > 2) {
      i.length === 3 && i.unshift(i[0]);
      const s = this._calculateCurveWidths(i[1], i[2], n), r = Fo.fromPoints(i, s);
      return i.shift(), r;
    }
    return null;
  }
  _calculateCurveWidths(t, n, i) {
    const s = i.velocityFilterWeight * n.velocityFrom(t) + (1 - i.velocityFilterWeight) * this._lastVelocity, r = this._strokeWidth(s, i), o = {
      end: r,
      start: this._lastWidth
    };
    return this._lastVelocity = s, this._lastWidth = r, o;
  }
  _strokeWidth(t, n) {
    return Math.max(n.maxWidth / (t + 1), n.minWidth);
  }
  _drawCurveSegment(t, n, i) {
    const s = this._ctx;
    s.moveTo(t, n), s.arc(t, n, i, 0, 2 * Math.PI, !1), this._isEmpty = !1;
  }
  _drawCurve(t, n) {
    const i = this._ctx, s = t.endWidth - t.startWidth, r = Math.ceil(t.length()) * 2;
    i.beginPath(), i.fillStyle = n.penColor;
    for (let o = 0; o < r; o += 1) {
      const a = o / r, l = a * a, c = l * a, d = 1 - a, u = d * d, h = u * d;
      let p = h * t.startPoint.x;
      p += 3 * u * a * t.control1.x, p += 3 * d * l * t.control2.x, p += c * t.endPoint.x;
      let m = h * t.startPoint.y;
      m += 3 * u * a * t.control1.y, m += 3 * d * l * t.control2.y, m += c * t.endPoint.y;
      const g = Math.min(t.startWidth + c * s, n.maxWidth);
      this._drawCurveSegment(p, m, g);
    }
    i.closePath(), i.fill();
  }
  _drawDot(t, n) {
    const i = this._ctx, s = n.dotSize > 0 ? n.dotSize : (n.minWidth + n.maxWidth) / 2;
    i.beginPath(), this._drawCurveSegment(t.x, t.y, s), i.closePath(), i.fillStyle = n.penColor, i.fill();
  }
  _fromData(t, n, i) {
    for (const s of t) {
      const { points: r } = s, o = this._getPointGroupOptions(s);
      if (r.length > 1)
        for (let a = 0; a < r.length; a += 1) {
          const l = r[a], c = new ys(l.x, l.y, l.pressure, l.time);
          a === 0 && this._reset(o);
          const d = this._addPoint(c, o);
          d && n(d, o);
        }
      else
        this._reset(o), i(r[0], o);
    }
  }
  toSVG({ includeBackgroundColor: t = !1 } = {}) {
    const n = this._data, i = Math.max(window.devicePixelRatio || 1, 1), s = 0, r = 0, o = this.canvas.width / i, a = this.canvas.height / i, l = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (l.setAttribute("xmlns", "http://www.w3.org/2000/svg"), l.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), l.setAttribute("viewBox", `${s} ${r} ${o} ${a}`), l.setAttribute("width", o.toString()), l.setAttribute("height", a.toString()), t && this.backgroundColor) {
      const c = document.createElement("rect");
      c.setAttribute("width", "100%"), c.setAttribute("height", "100%"), c.setAttribute("fill", this.backgroundColor), l.appendChild(c);
    }
    return this._fromData(n, (c, { penColor: d }) => {
      const u = document.createElement("path");
      if (!isNaN(c.control1.x) && !isNaN(c.control1.y) && !isNaN(c.control2.x) && !isNaN(c.control2.y)) {
        const h = `M ${c.startPoint.x.toFixed(3)},${c.startPoint.y.toFixed(3)} C ${c.control1.x.toFixed(3)},${c.control1.y.toFixed(3)} ${c.control2.x.toFixed(3)},${c.control2.y.toFixed(3)} ${c.endPoint.x.toFixed(3)},${c.endPoint.y.toFixed(3)}`;
        u.setAttribute("d", h), u.setAttribute("stroke-width", (c.endWidth * 2.25).toFixed(3)), u.setAttribute("stroke", d), u.setAttribute("fill", "none"), u.setAttribute("stroke-linecap", "round"), l.appendChild(u);
      }
    }, (c, { penColor: d, dotSize: u, minWidth: h, maxWidth: p }) => {
      const m = document.createElement("circle"), g = u > 0 ? u : (h + p) / 2;
      m.setAttribute("r", g.toString()), m.setAttribute("cx", c.x.toString()), m.setAttribute("cy", c.y.toString()), m.setAttribute("fill", d), l.appendChild(m);
    }), l.outerHTML;
  }
}
const ub = Ft(({ field: e, editMode: t, value: n, onChange: i }, s) => {
  const r = kt(null), o = kt(null);
  Wt(s, () => ({}));
  const a = (u, h) => {
    i && i(u, h);
  };
  mt(() => {
    t == 1 && l(!1);
  }, [t]), mt(() => {
    o.current = new xs(r.current), n && n !== "" && o.current.fromDataURL(n), t === ct.Read && o.current.off(), o.current.addEventListener("endStroke", () => {
      var u;
      t === ct.Edit && a(((u = o.current) == null ? void 0 : u.toDataURL()) ?? "", !0);
    });
  }, [n, t]);
  const l = (u) => {
    var h;
    t !== ct.Read && ((h = o.current) == null || h.clear(), a("", u));
  }, c = async (u) => {
    var p;
    const h = (p = u.target.files) == null ? void 0 : p[0];
    h && a(await d(h), !0);
  }, d = (u) => new Promise((h, p) => {
    const m = new FileReader();
    m.onload = () => {
      h(m.result);
    }, m.onerror = () => {
      p(m.error);
    }, m.readAsDataURL(u);
  });
  return /* @__PURE__ */ k(R, { children: [
    t !== ct.Read && /* @__PURE__ */ k(H, { children: [
      e.Required ? "*" : "",
      " Touch to draw in the space provided"
    ] }),
    /* @__PURE__ */ f(
      "canvas",
      {
        style: { border: "1px solid black", borderRadius: "var(--mui-shape-borderRadius)", backgroundColor: "#FFF" },
        ref: r
      }
    ),
    t !== ct.Read && /* @__PURE__ */ k(R, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
      /* @__PURE__ */ f(ot, { variant: "contained", onClick: () => l(!0), style: { marginTop: "0px" }, startIcon: /* @__PURE__ */ f(nd, {}), children: "Clear" }),
      /* @__PURE__ */ k(ot, { variant: "contained", component: "label", style: { marginTop: "0px" }, startIcon: /* @__PURE__ */ f(Xc, {}), children: [
        /* @__PURE__ */ f(
          Rc,
          {
            type: "file",
            inputProps: { accept: "image/*" },
            onChange: c,
            hidden: !0,
            sx: { display: "none" }
          }
        ),
        "Upload Signature"
      ] })
    ] })
  ] });
}), fb = Ft(
  ({ field: e, editMode: t, recordId: n, value: i, onChange: s, showValidation: r }, o) => {
    const { Get: a, Post: l } = Ne(), { baseUrl: c } = me(), { data: d } = new Hc.currentUser().ToQuery(), u = kt(null), h = i || (d == null ? void 0 : d.ContactID), p = t === ct.Read, [m, g] = Y(!0), [b, y] = Y(p), [x, w] = Y({}), [S, v] = Y({}), [_, C] = Y(!1), [P, I] = Y({ type: "", message: "" }), [V, $] = Y(!1);
    mt(() => {
      y(p);
    }, [t]);
    const T = (e.Parameters ?? JSON.parse('{"Items":[]}')).Items.reduce(
      (A, { Name: L, Value: N }) => (A[L] = N, A),
      {}
    ), j = T.ShowEmergency == "true", q = {
      firstname: ["First Name", "name"],
      surname: ["Surname", "family-name"],
      phonenumber: ["Phone Number", "tel"],
      worknumber: ["Work Number", ""],
      alternatenumber: ["Alternate Number", ""],
      email: ["Email", "email"],
      address1: ["Address 1", "address-line1"],
      address2: ["Address 2", "address-line2"],
      town: ["Town", "address-level2"],
      state: ["State", "address-level1"],
      postcode: ["Postcode", "postal-code"],
      country: ["Country", "country-name"]
    }, B = Tc(async () => {
      if (!(h == 0 || h == null)) {
        g(!0);
        try {
          let A = c + `/lms/api/contact/profile/${h}/information?type=0`;
          n && (A += `&recordId=${n}`);
          const L = await a({ url: A, data: null, config: null });
          if (w(L), $(!1), j) {
            let N = c + `/lms/api/contact/profile/${h}/information?type=1`;
            n && (N += `&recordId=${n}`);
            const F = await a({ url: N, data: null, config: null });
            v(F ?? {}), Object.keys(L).every(
              (U) => U === "Type" || U === "ContactId" || U === "RecordId" || L[U] === F[U]
            ) && C(!0);
          }
        } catch (A) {
          A.status == 403 && ($(!0), y(!0), w({}));
        } finally {
          g(!1);
        }
      }
    }, [d, h, n, j]);
    mt(() => {
      B(), h && (s == null || s(String(h), !1));
    }, [B]);
    const X = (A) => {
      C(A), h && (s == null || s(String(h), !1));
    }, G = (A, L, N = !1) => {
      const F = Object.keys(N ? S ?? {} : x ?? {}).find((W) => W.toLowerCase() === A.toLowerCase()) ?? "";
      N ? v((W) => ({ ...W, [F]: L })) : w((W) => ({ ...W, [F]: L })), h && (s == null || s(String(h)));
    }, st = () => {
      var N;
      const A = Object.entries(T).filter(([F, W]) => F.endsWith("_required") && W === "true").map(([F]) => F), L = [];
      return Object.keys(q).forEach((F) => {
        const W = F.toLowerCase(), U = A.map((Q) => Q.toLowerCase());
        U.includes(`${W}_required`) && !Object.keys(x).some((Q) => Q.toLowerCase() === W && x[Q]) && !T[`${W}_hidden`] && L.push(F), j && U.includes(`${W}_emergency_required`) && !_ && !Object.keys(S).some((Q) => Q.toLowerCase() === W && S[Q]) && !T[`${W}_hidden`] && L.push(`emergency ${F}`);
      }), L.length > 0 ? (I({
        type: "warning",
        message: `Some required fields are missing: ${L.join(", ")}`
      }), (N = u.current) == null || N.openToast(), !1) : !0;
    }, rt = async (A, L = !1, N = 0) => {
      var Q, et;
      const F = c + `/lms/api/contact/profile/${h}/information?type=${A}`, W = {
        ContactId: h,
        Type: A,
        RecordId: n
      };
      Object.entries((N === 1 ? S : x) ?? {}).forEach(([tt, it]) => {
        tt == "ContactId" || tt == "Type" || tt == "RecordId" || (W[tt] = it);
      });
      try {
        await l({ url: F, data: W, config: { asResponse: !0 } }), L && (I({
          type: "success",
          message: "The contact profile has been saved, but you still need to save the record to include the details."
        }), (Q = u.current) == null || Q.openToast());
      } catch (tt) {
        console.log(tt), I({ type: "error", message: "Failed to save contact profile." }), (et = u.current) == null || et.openToast();
      }
    };
    Wt(o, () => ({
      save: async (A = !1) => st() ? (await rt(0, A), j && await rt(1, !1, _ ? 0 : 1), !0) : !1
    }));
    const M = (A, [L, N], F = !1) => {
      const W = F ? "emergency_" : "";
      if (T[`${A}_${W}hidden`] === "true") return null;
      const U = T[`${A}_${W}caption`] ?? L, Q = T[`${A}_${W}required`] === "true", et = Object.keys(F ? S ?? {} : x ?? {}).find((it) => it.toLowerCase() === A.toLowerCase()) ?? "";
      let tt = et ? (F ? S[et] : x[et]) ?? "" : "";
      return V && (tt = "****************"), /* @__PURE__ */ f(Us, { sx: { xs: 12, sm: A.startsWith("address") ? 12 : 6 }, children: /* @__PURE__ */ f(
        yn,
        {
          id: `${W}${A}`,
          name: A,
          fullWidth: !0,
          variant: "outlined",
          label: (e.Flags & ee.Markdown) > 0 ? /* @__PURE__ */ f(
            oe,
            {
              unwrapDisallowed: !0,
              disallowedElements: ["p"],
              children: U
            }
          ) : /* @__PURE__ */ f(ae, { text: U }),
          value: tt,
          onChange: (it) => G(A, it.target.value, F),
          disabled: b || V,
          required: Q,
          autoComplete: N || void 0,
          error: r && Q && tt == ""
        }
      ) }, A);
    };
    return m ? /* @__PURE__ */ f(ht, { children: /* @__PURE__ */ f(wi, {}) }) : /* @__PURE__ */ k(ht, { children: [
      /* @__PURE__ */ f(hs, { ref: u, type: P.type, message: P.message }),
      /* @__PURE__ */ f(
        R,
        {
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: "700px",
          children: /* @__PURE__ */ f(jc, { variant: "outlined", sx: { backgroundColor: "transparent", boxShadow: "none" }, children: /* @__PURE__ */ k(vf, { children: [
            /* @__PURE__ */ f(H, { variant: "h6", fontWeight: "600", marginBottom: 3, children: "Contact Details" }),
            /* @__PURE__ */ f(Us, { container: !0, spacing: 2, children: Object.entries(q).map(([A, L]) => M(A, L, !1)) }),
            j && /* @__PURE__ */ k(ht, { children: [
              /* @__PURE__ */ f($c, { sx: { my: 3 } }),
              /* @__PURE__ */ f(H, { variant: "h6", fontWeight: "600", children: "Emergency Contact" }),
              /* @__PURE__ */ f(
                zn,
                {
                  control: /* @__PURE__ */ f(
                    co,
                    {
                      checked: _,
                      onChange: (A) => X(A.target.checked),
                      disabled: b
                    }
                  ),
                  label: "Same as above"
                }
              ),
              !_ && /* @__PURE__ */ f(Us, { container: !0, spacing: 2, children: Object.entries(q).map(
                ([A, L]) => M(A, L, !0)
              ) })
            ] })
          ] }) })
        }
      )
    ] });
  }
);
var Ae = /* @__PURE__ */ ((e) => (e[e.Label = 0] = "Label", e[e.Textbox = 1] = "Textbox", e[e.NumericTextbox = 2] = "NumericTextbox", e[e.EmailTextbox = 3] = "EmailTextbox", e[e.DatePicker = 4] = "DatePicker", e[e.DropDownList = 5] = "DropDownList", e[e.Checkbox = 6] = "Checkbox", e[e.DynamicClassList = 7] = "DynamicClassList", e[e.DynamicTeacherList = 8] = "DynamicTeacherList", e[e.DynamicAllTeacherList = 9] = "DynamicAllTeacherList", e[e.DynamicSubjectList = 10] = "DynamicSubjectList", e[e.DynamicContactList = 11] = "DynamicContactList", e[e.CustomSqlList = 12] = "CustomSqlList", e[e.ContactLookup = 13] = "ContactLookup", e[e.EventList = 14] = "EventList", e[e.Radio = 16] = "Radio", e[e.CheckboxList = 17] = "CheckboxList", e[e.ColourPicker = 18] = "ColourPicker", e[e.Password = 19] = "Password", e[e.PaymentField_DONOTUSE = 20] = "PaymentField_DONOTUSE", e[e.DateAndTimePicker = 21] = "DateAndTimePicker", e[e.Hidden = 22] = "Hidden", e[e.PaymentField = 23] = "PaymentField", e[e.AssignedPeople_DONOTUSE = 24] = "AssignedPeople_DONOTUSE", e[e.DynamicAllStaffList = 25] = "DynamicAllStaffList", e[e.TimePicker = 26] = "TimePicker", e[e.AssignedStaffList = 27] = "AssignedStaffList", e[e.Signature = 28] = "Signature", e[e.EventPlanning = 29] = "EventPlanning", e[e.EventPicker = 30] = "EventPicker", e[e.ContactProfile = 31] = "ContactProfile", e))(Ae || {}), hb = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.String = 1] = "String", e[e.Number = 2] = "Number", e[e.DateTime = 3] = "DateTime", e[e.Boolean = 4] = "Boolean", e[e.Integer = 5] = "Integer", e))(hb || {});
const pb = Ft(({ ...e }, t) => {
  switch (e.field.ControlType) {
    case 0:
      return /* @__PURE__ */ f(da, { ...e });
    case 3:
    //Need to make it handle a required format
    case 1:
      return /* @__PURE__ */ f(F0, { ref: t, ...e });
    case 2:
      return /* @__PURE__ */ f(L0, { ref: t, ...e });
    case 21:
      return /* @__PURE__ */ f(E0, { ref: t, ...e });
    case 4:
      return /* @__PURE__ */ f(R0, { ref: t, ...e });
    case 17:
      return /* @__PURE__ */ f(T0, { ref: t, ...e });
    case 6:
      return /* @__PURE__ */ f(O0, { ref: t, ...e });
    case 7:
    case 11:
    case 10:
    case 8:
    case 25:
    case 9:
    case 5:
    case 12:
      return /* @__PURE__ */ f(N0, { ref: t, ...e });
    case 16:
      return /* @__PURE__ */ f(z0, { ref: t, ...e });
    case 22:
      return /* @__PURE__ */ f(mp, { ref: t, ...e });
    case 26:
      return /* @__PURE__ */ f(B0, { ref: t, ...e });
    case 19:
      return /* @__PURE__ */ f(W0, { ref: t, ...e });
    case 18:
      return /* @__PURE__ */ f(ib, { ref: t, ...e });
    case 23:
    case 20:
      return /* @__PURE__ */ f(lb, { ref: t, ...e });
    case 28:
      return /* @__PURE__ */ f(ub, { ref: t, ...e });
    case 31:
      return /* @__PURE__ */ f(fb, { ref: t, ...e });
  }
  return /* @__PURE__ */ f(da, { ...e });
}), gb = Ft(({ studentId: e, formId: t, rowId: n, editMode: i, onHasAttachmentsChange: s }, r) => {
  const { isPending: o, data: a, refetch: l } = new ho.RecordAttachments({ studentId: e, formId: t, rowId: n }).ToQuery(), [c, d] = Y([]), { Post: u } = Ne(), { baseUrl: h } = me();
  let p = /* @__PURE__ */ f(Ci, { sx: { "&:hover": { transform: "scale(1.3)", cursor: "pointer" } } }), m = /* @__PURE__ */ f(bp, { sx: { "&:hover": { transform: "scale(1.3)", cursor: "pointer" } } });
  mt(() => {
    const y = !!(!o && a && a.length > 0);
    s == null || s(y);
  }, [o, a]);
  const g = async () => {
    await u({
      url: h + "/lms/api/files/delete",
      config: null,
      data: c
    }), d([]), l();
  };
  if (Wt(r, () => ({
    refetch: l,
    hasAttachments: !!(!o && a && a.length > 0),
    deletedFileIds: i == 1 ? c : [],
    deleteAllFiles: g
  }), [o, a, c]), o || (a == null ? void 0 : a.length) == 0)
    return null;
  const b = (y) => {
    c.includes(y) ? d(c.filter((x) => x !== y)) : d([...c, y]);
  };
  return /* @__PURE__ */ f(R, { display: "flex", gap: 1, flexWrap: "wrap", children: a == null ? void 0 : a.sort((y, x) => y.CanEdit == x.CanEdit ? 0 : y.CanEdit ? -1 : 1).map(
    (y) => /* @__PURE__ */ f(R, { children: /* @__PURE__ */ f(Eo, { extension: y.Ext, fileId: y.Id, fileName: y.Name, locationType: y.LocationType, url: y.URL, download: !0, modifiedBy: y.ModifiedBy, modifiedDate: y.Modified, color: c.includes(y.Id) && i == 1 ? "error" : "default", onDelete: i == 1 ? () => b(y.Id) : void 0, deleteIcon: i == 1 && !c.includes(y.Id) ? p : i == 1 && c.includes(y.Id) ? m : void 0 }, y.Id) })
  ) });
}), mb = "_inputEl_wzgfu_1", bb = {
  inputEl: mb
}, su = ({ onClose: e, onDone: t, type: n, files: i, addFiles: s, removeFile: r }) => {
  const o = () => {
    const l = document.createElement("input");
    document.body.appendChild(l), l.type = "file", l.multiple = !0, l.classList.add(bb.inputEl), l.onchange = a, l.click();
  }, a = (l) => {
    const c = l.target;
    if (!c.files)
      return;
    console.log(c.files);
    const d = [];
    for (let u = 0; u < c.files.length; u++)
      console.log(u, c.files.item(u)), d.push(c.files.item(u));
    s(d, n);
  };
  return /* @__PURE__ */ f(lo, { open: !0, onClose: e, disableEnforceFocus: !0, children: /* @__PURE__ */ f(_f, { children: /* @__PURE__ */ k(gt, { spacing: 2, p: 2, children: [
    /* @__PURE__ */ f(H, { variant: "h6", children: "Attachments" }),
    /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Files" }),
      i.length === 0 && /* @__PURE__ */ f(H, { children: "No files selected" }),
      i.map((l) => /* @__PURE__ */ k(gt, { direction: "row", alignItems: "center", children: [
        /* @__PURE__ */ f(H, { children: l.file.name }),
        /* @__PURE__ */ f(ot, { onClick: () => r(l.file), children: "Delete" })
      ] }, `${l.file.name} ${l.file.size}`))
    ] }),
    /* @__PURE__ */ k(R, { display: "flex", gap: 2, children: [
      /* @__PURE__ */ f(
        ot,
        {
          component: "label",
          role: void 0,
          variant: "text",
          tabIndex: -1,
          onClick: o,
          startIcon: /* @__PURE__ */ f(Z, { iconType: J.New }),
          children: "Add files"
        }
      ),
      /* @__PURE__ */ f(ot, { variant: "contained", onClick: t ?? e, startIcon: /* @__PURE__ */ f(Z, { iconType: J.Check }), children: "Done" })
    ] })
  ] }) }) });
}, yb = ({ formId: e, studentId: t, rowId: n, editMode: i, updateRowId: s, back: r, add: o, setDirty: a }) => {
  const [l, c] = Y({}), [d, u] = Y([]), [h, p] = Y([]), { isPending: m, data: g, error: b, refetch: y } = new ho.RecordDetails({ formId: e, studentId: t, rowId: n, editMode: i }).ToQuery(), [x, w] = Y(null), [S, v] = Y(i), { User: _, Post: C, IsImpersonating: P } = Ne(), { baseUrl: I } = me(), V = xo(), [$, T] = Y(!1), { files: j, addFiles: q, removeFile: B, uploadAll: X, clearFiles: G } = dd(), st = kt(null), [rt, M] = Y(!1), [A, L] = Y(!1), [N, F] = Y(null), W = (z) => {
    F(z);
  }, U = (z, O = !1) => (vt, _t = !0) => {
    c((It) => {
      const le = { ...It };
      return le[z].value = vt, le;
    }), Q(z, O || h.some((It) => It == z) || d.some((It) => It == z))(vt), a && _t && a(!0), _t && L(!0);
  }, Q = (z, O) => (vt) => {
    O && (vt && vt.length > 0 ? p((_t) => _t.filter((It) => It != z)) : h.includes(z) || p((_t) => [..._t, z]));
  };
  mt(() => {
    a && a(S != ct.Read && A);
    const z = (O) => {
      if (!(!A || S == ct.Read))
        return O.preventDefault(), O.returnValue = "Are you sure you want to leave this record?", "Are you sure you want to leave this record?";
    };
    return window.addEventListener("beforeunload", z), () => window.removeEventListener("beforeunload", z);
  }, [A, S]), mt(() => {
    v(i);
  }, [i]), mt(() => {
    g && (n == 0 && g.Record.RowId != 0 && s && s(g.Record.RowId), i == ct.Read && (g == null ? void 0 : g.Record.StatusType) == 1 && v(ct.Edit));
  }, [g]), mt(() => {
    c({});
  }, [n, g]);
  const et = async (z) => {
    switch (V.invalidateQueries({ queryKey: ["recordliststudent", t, e] }), V.invalidateQueries({ queryKey: ["studentsummary", t] }), u([]), z.toLowerCase()) {
      case "save":
        return await tt();
      case "edit":
        return v(ct.Edit), null;
      case "cancel":
        return v(ct.Read), null;
      case "delete":
        return await it(), r && r(), null;
      case "attach":
        return T(!0), null;
      case "print":
        return { type: "warning", message: "Record print functionality not enabled for parents" };
      case "reply":
        return { type: "warning", message: "Record discussion functionality not enabled for parents" };
      case "add":
        return o && o(), null;
      default:
        return await tt(z);
    }
  }, tt = async (z) => {
    var O, vt;
    if (S != ct.Read || z) {
      let _t = [], It = [], le = g.Form.Items;
      g.Form.Items.forEach((ft) => {
        var Be, We, Gt;
        if (!((Be = ft.Parameters) != null && Be.Items))
          return;
        let Tt = ft.Parameters.Items;
        if (Tt.length <= 0 || !Tt.some((Vt) => Vt.Name == "SourceFieldName"))
          return;
        const Nt = g.Form.Items.find((Vt) => {
          var zt;
          return Vt.FieldName == ((zt = Tt == null ? void 0 : Tt.find((de) => de.Name == "SourceFieldName")) == null ? void 0 : zt.Value);
        });
        if (!Nt)
          return;
        const Et = ((We = l[Nt.FieldID]) == null ? void 0 : We.value) ?? "", ce = (Gt = Tt == null ? void 0 : Tt.find((Vt) => Vt.Name == "SourceFieldValue")) == null ? void 0 : Gt.Value;
        Et && Et == ce || Et && Nt.ControlType == Ae.CheckboxList && Et && Et.split(",").includes(ce ?? "") || Et && Nt.ControlType == Ae.Checkbox && (Et ? "True" : "False") == ce || (le = le.filter((Vt) => Vt.FieldID != ft.FieldID));
      });
      let nn = await Promise.all(le.map(async (ft) => {
        var Nt, Et, ce, Be, We, Gt;
        let Tt = ((Nt = l[ft.FieldID]) == null ? void 0 : Nt.value) ?? "";
        return (Tt && ft.ControlType == Ae.DateAndTimePicker || ft.ControlType == Ae.DatePicker) && (Tt = Mt(Tt).isValid() ? Mt(Tt).toString() : ""), ft.ControlType == Ae.ContactProfile && (await ((Be = (ce = (Et = l[ft.FieldID]) == null ? void 0 : Et.controls) == null ? void 0 : ce.save) == null ? void 0 : Be.call(ce)) || (_t.push(ft.Caption), It.push(ft.FieldID))), ft.Required && ft.ControlType != Ae.Label && Tt == "" && rl(
          ft.HasPermissions,
          (We = ft.Permissions) == null ? void 0 : We.find((zt) => zt.StatusId == g.Record.StatusId),
          (Gt = g.Form.States) == null ? void 0 : Gt.find((zt) => zt.StatusId == g.Record.StatusId),
          _.GroupMask,
          g.Form.EditMask
        ) && (_t.push(ft.Caption), It.push(ft.FieldID)), { FieldID: ft.FieldID, Value: encodeURIComponent(Tt.toString()) };
      }));
      if (_t.length > 0)
        return p(It), null;
      a && a(!1);
      try {
        let ft = await C(
          {
            url: I + `/lms/api/forms/record/save?formId=${e}&id=${t}${n && n != 0 ? "&rowid=" + n : ""}${z && z != "" ? "&actionId=" + z : ""}&async=false`,
            config: null,
            data: nn
          }
        );
        if ((n === 0 || n === void 0) && s && s(ft.Record.RowId), j.length > 0 && ft && (M(!0), await X({ rowId: `${ft.Record.RowId}`, id: `${t}`, formId: `${e}` }), M(!1), G()), (O = st.current) != null && O.deletedFileIds && st.current.deletedFileIds.length > 0 && ((vt = st.current) == null || vt.deleteAllFiles()), z) {
          if (ft.ActionResults && ft.ActionResults.length > 0 && ft.ActionResults.some((Tt) => !Tt.Success))
            return ft.ActionResults.forEach((Nt) => {
              Nt.CheckType == 2 && (u((Et) => (Et.includes(Nt.FieldId) || Et.push(Nt.FieldId), [...Et])), p((Et) => (Et.includes(Nt.FieldId) || Et.push(Nt.FieldId), [...Et])));
            }), { type: "warning", message: ft.ActionResults.map((Nt) => {
              if (Nt.Message != "<a href='#' onclick='InfoForms.CurrentRecord.Edit();'>Click here to return</a>")
                return /* @__PURE__ */ k(ht, { children: [
                  Nt.Message,
                  /* @__PURE__ */ f("br", {})
                ] });
            }) };
          y();
        }
      } catch (ft) {
        return ft instanceof Error ? { type: "error", message: ft.message } : ft.title ? { type: "error", message: ft.title } : { type: "error", message: "Unknown error occured" };
      }
    } else
      j.length > 0 && n && n != 0 && (M(!0), await X({ rowId: `${n}`, id: `${t}`, formId: `${e}` }, W), M(!1), G());
    return w(null), v(ct.Read), { type: "success", message: "Record has been saved" };
  }, it = async () => {
    try {
      await C(
        {
          url: I + `/lms/api/forms/record/delete?formId=${e}&id=${t}&rowID=${n}`,
          config: null,
          data: null
        }
      );
    } catch (z) {
      return z instanceof Error ? { type: "error", message: z.message } : z.title ? { type: "error", message: z.title } : { type: "error", message: "Unknown error occured" };
    }
    return { type: "success", message: "Record has been deleted" };
  };
  return m ? /* @__PURE__ */ f(R, { p: 2, children: "Loading..." }) : !g || b ? /* @__PURE__ */ k(ke, { severity: "error", children: [
    /* @__PURE__ */ f(wf, { children: "Error loading record" }),
    b.title && b.title.replace("<br/>", "")
  ] }) : /* @__PURE__ */ k(gt, { spacing: 2, children: [
    N && /* @__PURE__ */ f(ke, { severity: N.type, onClose: () => F(null), children: N.message }),
    $ && /* @__PURE__ */ f(su, { files: j, addFiles: q, removeFile: B, type: ud.RecordAttachment, onClose: () => T(!1) }),
    x,
    S != ct.New && /* @__PURE__ */ f(gt, { spacing: 1, children: /* @__PURE__ */ f(R, { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", children: /* @__PURE__ */ f(S0, { ...g, onPaymentChanged: y }) }) }),
    !P && /* @__PURE__ */ f(
      D0,
      {
        editMode: S,
        canDelete: g.CanDelete,
        canEdit: function() {
          var O;
          let z = (O = g.Form.States) == null ? void 0 : O.find((vt) => vt.StatusId == g.Record.StatusId);
          return z && z.Edit ? (z.Edit & _.GroupMask) > 0 : (g.Form.EditMask & _.GroupMask) > 0;
        }(),
        HandleAction: et,
        canAddNew: g.CanAddNew,
        canAttach: g.Form.CanAttach,
        templateId: g.Form.DefaultTemplateID ?? 0,
        canMessage: g.Form.CanMessage,
        actions: g.Actions,
        discussion: g.Form.DiscussionForm,
        fileCount: j.length
      }
    ),
    !rt && S != ct.New && /* @__PURE__ */ f(xb, { studentId: t, rowId: n, formId: e, editMode: S, attachmentsRef: st }),
    rt && /* @__PURE__ */ f(H, { color: "text.secondary", children: "Uploading attachments…" }),
    /* @__PURE__ */ f(R, { sx: { display: "flex", flexFlow: "column", gap: 1.5, marginTop: 2 }, children: [...g.Form.Items.sort((z, O) => z.Index - O.Index)].map((z) => {
      var ft, Tt, Nt, Et, ce, Be, We;
      let O = g.Record.StatusId, vt = !1, _t = (ft = g.Form.States) == null ? void 0 : ft.find((Gt) => Gt.StatusId == O);
      if (vt = rl(z.HasPermissions, (Tt = z.Permissions) == null ? void 0 : Tt.find((Gt) => Gt.StatusId == O), _t, _.GroupMask, g.Form.EditMask), ((Et = (Nt = z.Parameters) == null ? void 0 : Nt.Items) == null ? void 0 : Et.length) > 0) {
        const Gt = z.Parameters.Items;
        if (Gt.some((Vt) => Vt.Name == "SourceFieldName")) {
          const Vt = g.Form.Items.find((zt) => {
            var de;
            return zt.FieldName == ((de = Gt.find((sn) => sn.Name == "SourceFieldName")) == null ? void 0 : de.Value);
          });
          if (Vt) {
            const zt = l ? l[Vt.FieldID] : null;
            if (!zt)
              return /* @__PURE__ */ f(ht, {});
            let de = !0;
            const sn = ((ce = Gt.find((sf) => sf.Name == "SourceFieldValue")) == null ? void 0 : ce.Value) ?? null;
            if ((zt == null ? void 0 : zt.value) == sn && (de = !1), de && Vt.ControlType == Ae.CheckboxList && (de = !((Be = zt == null ? void 0 : zt.value) != null && Be.split(",").includes(sn ?? ""))), de && Vt.ControlType == Ae.Checkbox && (de = ((We = zt == null ? void 0 : zt.value) == null ? void 0 : We.toString().toLowerCase()) != (sn == null ? void 0 : sn.toLowerCase())), de)
              return /* @__PURE__ */ f(ht, {});
          }
        }
      }
      const It = g.Record.Results;
      let le = null;
      S != ct.New && Object.keys(It).length > 0 && It[String(z.FieldID)] && !l[z.FieldID] && (le = It[String(z.FieldID)].Value ?? void 0), l[z.FieldID] && (le = l[z.FieldID].value);
      let nn = z.Required;
      return nn = nn && vt, d.includes(z.FieldID) && (nn = !0), /* @__PURE__ */ k(Ms, { sx: { m: 1, minWidth: 250 }, error: h.includes(z.FieldID), children: [
        /* @__PURE__ */ f(
          pb,
          {
            ref: (Gt) => {
              l[z.FieldID] = { controls: Gt, value: le ?? null };
            },
            field: { ...z },
            editMode: vt ? S : ct.Read,
            value: le ?? void 0,
            onChange: U(z.FieldID, nn),
            onBlur: Q(z.FieldID, nn),
            showValidation: h.includes(z.FieldID),
            payment: g.Record.MobilePayment,
            reload: y,
            recordId: g.Record.RecordId
          },
          n + "_" + z.FieldID
        ),
        /* @__PURE__ */ f(Sf, { color: "error", children: h.includes(z.FieldID) ? `${z.Caption} is required` : "" })
      ] }, z.FieldName);
    }) })
  ] });
}, xb = ({ formId: e, rowId: t, studentId: n, editMode: i, attachmentsRef: s }) => {
  const [r, o] = Y(!1);
  return /* @__PURE__ */ k(gt, { gap: 1, children: [
    r && /* @__PURE__ */ f(H, { children: "Attachments" }),
    /* @__PURE__ */ f(gb, { formId: e, studentId: n, rowId: t, ref: s, editMode: i, onHasAttachmentsChange: o })
  ] });
}, rl = (e, t, n, i, s) => {
  if (e && t) {
    if (t.Read != null) {
      if (!((t.Read & i) > 0))
        return !1;
    } else if (n != null && n.Read && !(((n == null ? void 0 : n.Read) & i) > 0))
      return !1;
    if (t.Edit != null) {
      if ((t.Edit & i) > 0)
        return !0;
    } else if (n != null && n.Edit) {
      if (((n == null ? void 0 : n.Edit) & i) > 0)
        return !0;
    } else
      return !0;
  } else
    return n && n.Edit ? (n.Edit & i) > 0 : (s & i) > 0;
  return !1;
}, ol = ({ refresh: e, status: t, text: n, span: i, locked: s, groupId: r, slotId: o, student: a, staffId: l, classId: c, selectedStudent: d }) => {
  const u = kt(null), h = !s && (t == "Booking" || t == "Available");
  if ((n == null ? void 0 : n.length) == 0)
    switch (t) {
      case "Available":
        n = "Available";
        break;
      case "Unavailable":
        n = "Unavailable";
        break;
      default:
        n = "";
    }
  const p = "var(--mui-palette-background-paper)";
  let m = "var(--mui-palette-background-paper)";
  switch (t) {
    case "Available":
      m = s ? "#97b9ff" : "#00ff00";
      break;
    case "Unavailable":
      m = s ? "#97b9ff" : "#ff0000";
      break;
    case "Booked":
      m = s && d ? "#0000aa" : s && !d ? "#ebd89b" : "#0000aa";
      break;
    case "Booking":
      m = s && d ? "#3e46f3" : s && !d ? "#ffecb1" : "#3e46f3";
      break;
  }
  return /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ f(Se, { ref: u, children: /* @__PURE__ */ f(vb, { refresh: () => {
      var g;
      e(), (g = u.current) == null || g.close();
    }, status: t, groupId: r, slotId: o, student: a, staffId: l, classId: c }) }),
    /* @__PURE__ */ f(
      Pn,
      {
        onClick: () => {
          var g;
          h && ((g = u.current) == null || g.open());
        },
        sx: {
          backgroundColor: `color-mix(in srgb, ${p} 60%, ${m} 40%)`,
          cursor: h ? "pointer" : "default",
          "&:hover": h ? {
            backgroundColor: `color-mix(in srgb, ${p} 40%, ${m} 60%)`
          } : {}
        },
        colSpan: i,
        align: "center",
        children: `${s && (t === "Available" || t === "Unavailable") ? "" : n}`
      }
    )
  ] });
}, vb = ({ refresh: e, status: t, groupId: n, slotId: i, student: s, staffId: r, classId: o }) => {
  var v, _;
  const { data: a, isPending: l, refetch: c } = new ci.InterviewSlotDetails({ groupId: n, slotId: i, studentId: s.ID, staffId: r, classId: o }).ToQuery(), { data: d, isPending: u } = new ci.InterviewGroup(Number(n)).ToQuery(), { Post: h } = Ne(), { baseUrl: p } = me(), m = tn(), [g, b] = Y(), [y, x] = Y((d == null ? void 0 : d.ParentOptions.length) == 1 ? d == null ? void 0 : d.ParentOptions[0] : ""), w = async () => {
    if (y == null || y == "") {
      b("Please select a method for the interview");
      return;
    }
    try {
      let C = `${p}/lms/api/interviews/${n}/slot/${i}/book?staffId=${r}&studentId=${s.ID}&classId=${o ?? 0}&method=${y}`;
      await h({
        url: C,
        config: null,
        data: null
      }) && (e(), c());
    } catch (C) {
      if (typeof C == "object" && C != null) {
        if ("message" in C && typeof C.message == "string") {
          b(C.message);
          return;
        }
        if ("detail" in C && typeof C.detail == "string")
          try {
            const P = JSON.parse(C.detail);
            if (P.message) {
              b(P.message);
              return;
            }
          } catch {
            b(C.detail);
            return;
          }
      }
      b("Something went wrong when booking the interview");
    }
  }, S = async () => {
    try {
      await h({
        url: `${p}/lms/api/interviews/${n}/slot/${i}/cancel?staffId=${r}`,
        config: null,
        data: null
      }) && (e(), c());
    } catch (C) {
      if (typeof C == "object" && C != null) {
        if ("message" in C && typeof C.message == "string") {
          b(C.message);
          return;
        }
        if ("detail" in C && typeof C.detail == "string")
          try {
            const P = JSON.parse(C.detail);
            if (P.message) {
              b(P.message);
              return;
            }
          } catch {
            b(C.detail);
            return;
          }
      }
      b("Something went wrong when cancelling the interview");
    }
  };
  return l || u ? /* @__PURE__ */ k(R, { padding: 5, sx: { display: "flex", flexFlow: "column", boxSizing: "border-box", gap: 1.1, width: 315 }, children: [
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "3rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } }),
    /* @__PURE__ */ f(at, { variant: "text", sx: { fontSize: "1.5rem" } })
  ] }) : /* @__PURE__ */ k(R, { padding: 5, sx: { display: "flex", flexFlow: "column", gap: 1 }, children: [
    /* @__PURE__ */ f(H, { variant: "h1", children: (v = a == null ? void 0 : a.Teacher) == null ? void 0 : v.DisplaynameSurname }),
    (a == null ? void 0 : a.InterviewClass) && /* @__PURE__ */ f(H, { variant: "caption", children: a == null ? void 0 : a.InterviewClass.Name }),
    /* @__PURE__ */ f(H, { color: m.palette.primary.main, children: ld(a.TimeSlot.From, a.TimeSlot.To) }),
    /* @__PURE__ */ k(H, { children: [
      "Student: ",
      t === "Booking" ? (_ = a == null ? void 0 : a.Student) == null ? void 0 : _.DisplaynameSurname : s.Name
    ] }),
    (d == null ? void 0 : d.ParentOptions) && /* @__PURE__ */ f(ht, { children: a != null && a.SelectedParentOption ? /* @__PURE__ */ k(H, { fontSize: "1rem", variant: "caption", children: [
      "Method: ",
      a == null ? void 0 : a.SelectedParentOption
    ] }) : /* @__PURE__ */ k(ht, { children: [
      /* @__PURE__ */ f(uo, { id: "method-dropdown", children: "Method" }),
      /* @__PURE__ */ f(
        Nc,
        {
          "aria-labelledby": "method-dropdown",
          value: (d == null ? void 0 : d.ParentOptions.length) == 1 ? d == null ? void 0 : d.ParentOptions[0] : y,
          onClick: (C) => x(C.target.value),
          name: "radio-buttons-group",
          children: d == null ? void 0 : d.ParentOptions.map((C) => /* @__PURE__ */ f(zn, { value: C, control: /* @__PURE__ */ f(zc, { disabled: t == "Booked" || t == "Booking" }), label: C }, C))
        }
      )
    ] }) }),
    a != null && a.SelectedParentOption ? /* @__PURE__ */ f(ot, { onClick: S, startIcon: /* @__PURE__ */ f(yo, {}), variant: "contained", children: "Cancel" }) : /* @__PURE__ */ f(ot, { onClick: w, startIcon: /* @__PURE__ */ f(Zc, {}), variant: "contained", children: "Book" }),
    g && /* @__PURE__ */ f(ke, { severity: "error", children: g })
  ] });
}, _k = ({ slotId: e, groupId: t = 0, studentId: n, staffId: i, classId: s }) => {
  var a, l;
  const { data: r, isPending: o } = new ci.InterviewSlotDetails({
    groupId: t,
    slotId: e,
    studentId: n ?? 0,
    staffId: i ?? 0,
    classId: s ?? 0
  }).ToQuery();
  return o ? /* @__PURE__ */ k(gt, { spacing: 2, children: [
    /* @__PURE__ */ f(at, { variant: "text", width: 100 }),
    /* @__PURE__ */ f(at, { variant: "text", width: 100 }),
    /* @__PURE__ */ f(at, { variant: "text", width: 100 }),
    /* @__PURE__ */ f(at, { variant: "text", width: 100 })
  ] }) : /* @__PURE__ */ k(gt, { spacing: 2, children: [
    /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Teacher" }),
      /* @__PURE__ */ f(H, { children: r == null ? void 0 : r.Teacher.DisplaynameSurname })
    ] }),
    /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Student" }),
      /* @__PURE__ */ f(H, { children: /* @__PURE__ */ f(Ro, { studentId: r.Student.ID }) })
    ] }),
    /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Time" }),
      /* @__PURE__ */ f(H, { children: ld(r.TimeSlot.From, r.TimeSlot.To) })
    ] }),
    ((a = r == null ? void 0 : r.InterviewClass) == null ? void 0 : a.Name) && /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Class" }),
      /* @__PURE__ */ f(H, { children: r == null ? void 0 : r.InterviewClass.Name })
    ] }),
    !((l = r == null ? void 0 : r.InterviewClass) != null && l.Name) && (r == null ? void 0 : r.Classes) && /* @__PURE__ */ k(gt, { children: [
      /* @__PURE__ */ f(H, { variant: "caption", children: "Classes" }),
      /* @__PURE__ */ f(H, { children: r == null ? void 0 : r.Classes.split("</br>").join(", ").trim().replace(/,$/, "") })
    ] })
  ] });
}, _b = (e) => /^https?:\/\//i.test(e), wb = ({ url: e }) => {
  const t = e.length > 20 ? e.slice(0, 17) + "..." : e;
  return /* @__PURE__ */ f(
    ot,
    {
      variant: "text",
      onClick: () => Zh(e),
      sx: {
        fontSize: "0.7rem",
        padding: 0,
        minWidth: "auto",
        textTransform: "none",
        color: "inherit",
        textDecoration: "underline",
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: "transparent"
        }
      },
      children: t
    }
  );
}, Sb = Vc(Cf)(({ theme: e }) => ({
  backgroundColor: e.palette.primary.main,
  "& .MuiTableCell-root": {
    color: e.palette.primary.contrastText,
    fontWeight: "bold"
  }
})), Cb = Vc(Pn)(({ theme: e }) => ({
  backgroundColor: e.palette.primary.main,
  color: e.palette.primary.contrastText,
  textAlign: "center",
  width: "100px"
})), wk = ({ groupId: e, classes: t = !1, student: n = null, isLocked: i, deadline: s, maxBookings: r }) => {
  const { isPending: o, data: a } = new ci.InterviewSlots(Number(e)).ToQuery(), { isPending: l, data: c, refetch: d } = new ci.InterviewTeachers(Number(e)).ToQuery();
  if (o || l || !n)
    return /* @__PURE__ */ f(at, { variant: "rounded", height: 400 });
  let u = {};
  a == null || a.forEach((p) => {
    u[Zt(p.From, { showTime: !1 })] ? u[Zt(p.From, { showTime: !1 })].push(p) : u[Zt(p.From, { showTime: !1 })] = [p];
  });
  let h = !1;
  return r && (h = ((c == null ? void 0 : c.reduce((m, g) => {
    const b = Object.values(g.Bookings).filter((y) => {
      var x;
      return ((x = y.Student) == null ? void 0 : x.ID) == n.ID;
    }).length ?? 0;
    return m + b;
  }, 0)) ?? 0) >= r), /* @__PURE__ */ k(ht, { children: [
    h && /* @__PURE__ */ f(ke, { severity: "warning", children: `${n.DisplaynameSurname} has reached  the limit of ${r} booking${r > 1 ? "s" : ""} per student, to book another time slot please cancel an existing interview booking` }),
    Object.keys(u).map((p) => {
      const m = (c == null ? void 0 : c.filter((g) => g.Classes.some((b) => b.Students && b.Students.some((y) => y.ID == (n == null ? void 0 : n.ID))))) ?? [];
      return /* @__PURE__ */ k(kf, { defaultExpanded: !0, sx: { boxShadow: "none" }, children: [
        /* @__PURE__ */ f(Pf, { expandIcon: /* @__PURE__ */ f(id, {}), children: p }),
        /* @__PURE__ */ f(Af, { sx: { padding: 0 }, children: /* @__PURE__ */ f(Mf, { component: _i, children: /* @__PURE__ */ k(If, { sx: { fontSize: "0.75rem", borderCollapse: "collapse" }, children: [
          /* @__PURE__ */ f(kb, { teachers: m, showClasses: t, studentID: n.ID }),
          /* @__PURE__ */ f(Df, { children: u[p].map((g) => {
            var w, S, v;
            const b = (c == null ? void 0 : c.some((_) => {
              var C;
              return ((C = _.Bookings[g.ID]) == null ? void 0 : C.Student) != null;
            })) ?? !1, y = (S = (w = c == null ? void 0 : c.find((_) => {
              var C;
              return ((C = _.Bookings[g.ID]) == null ? void 0 : C.Student) != null;
            })) == null ? void 0 : w.Bookings[g.ID]) == null ? void 0 : S.Student;
            let x = null;
            return b && (x = ((v = c.find((_) => {
              var C;
              return ((C = _.Bookings[g.ID]) == null ? void 0 : C.Student) != null;
            })) == null ? void 0 : v.Bookings[g.ID]) ?? null), /* @__PURE__ */ k(xr, { children: [
              /* @__PURE__ */ f(Cb, { sx: { position: "sticky", left: 0 }, children: Zt(g.From, { showDate: !1 }) }),
              m.map((_, C, P) => {
                var V, $, T, j, q, B, X;
                let I = t ? _.Classes.filter((G) => G.Students && G.Students.some((st) => st.ID == (n == null ? void 0 : n.ID))).length : 1;
                if (t)
                  return _.Classes.filter((G) => G.Students && G.Students.some((st) => st.ID == (n == null ? void 0 : n.ID))).map((G, st) => {
                    var U, Q, et, tt, it, z, O, vt;
                    const rt = !(((U = _.Bookings[g.ID]) == null ? void 0 : U.Available) ?? !0);
                    let M = b && (((Q = _.Bookings[g.ID]) == null ? void 0 : Q.InterviewClassId) ?? 0) == G.Id && (((et = _.Bookings[g.ID]) == null ? void 0 : et.Student) ?? null) != null, A = P.some((_t) => _t.ID == (x == null ? void 0 : x.StaffId));
                    b && (!P.some((_t) => _t.ID == (x == null ? void 0 : x.StaffId)) || !P.some((_t) => _t.Classes && _t.Classes.some((It) => It.Id == (x == null ? void 0 : x.InterviewClassId)))) && C == 0 && st == 0 && (M = !0);
                    let L = (tt = _.Bookings[g.ID]) != null && tt.Student ? { ID: (it = _.Bookings[g.ID]) == null ? void 0 : it.Student.ID, Name: (z = _.Bookings[g.ID]) == null ? void 0 : z.Student.DisplaynameSurname } : n ? { ID: n.ID, Name: n.DisplaynameSurname } : { ID: 0, Name: "" };
                    if (b && (M ? L = x != null && x.Student ? { ID: x == null ? void 0 : x.Student.ID, Name: x == null ? void 0 : x.Student.DisplaynameSurname } : { ID: 0, Name: "" } : L = { ID: 0, Name: "" }), rt && st != 0)
                      return;
                    const N = new Date(g.From);
                    N.setMinutes(N.getMinutes() - s);
                    const F = /* @__PURE__ */ new Date() >= N;
                    let W = "Available";
                    if (!G.Available && !b || !b && (F || !(((O = _.Bookings[g.ID]) == null ? void 0 : O.Available) ?? !0)))
                      W = "Unavailable", G.Available || (I = 1);
                    else if (M)
                      W = "Booking", A || (I = P.reduce((_t, It) => _t + It.Classes.length, 0));
                    else if (b && !M) {
                      if (!A)
                        return /* @__PURE__ */ f(ht, {});
                      W = "Booked", I = 1;
                    }
                    return /* @__PURE__ */ f(
                      ol,
                      {
                        groupId: e,
                        status: W,
                        text: W == "Booking" ? L.Name + (A ? "" : " - " + ((vt = c == null ? void 0 : c.find((_t) => _t.ID == (x == null ? void 0 : x.StaffId))) == null ? void 0 : vt.DisplaynameSurname)) : "",
                        span: W != "Available" ? I : 1,
                        slotId: g.ID,
                        student: L,
                        selectedStudent: (n == null ? void 0 : n.ID) === (y == null ? void 0 : y.ID),
                        staffId: (x == null ? void 0 : x.StaffId) ?? _.ID,
                        classId: G.Id,
                        locked: F || i || h && !M,
                        refresh: d
                      },
                      g.ID + _.ID
                    );
                  });
                {
                  let G = b && (((V = _.Bookings[g.ID]) == null ? void 0 : V.StaffId) ?? 0) == _.ID && ((($ = _.Bookings[g.ID]) == null ? void 0 : $.Student) ?? null) != null, st = P.some((N) => N.ID == (x == null ? void 0 : x.StaffId));
                  b && !P.some((N) => N.ID == (x == null ? void 0 : x.StaffId)) && C == 0 && (G = !0, I = P.length);
                  let rt = (T = _.Bookings[g.ID]) != null && T.Student ? { ID: (j = _.Bookings[g.ID]) == null ? void 0 : j.Student.ID, Name: (q = _.Bookings[g.ID]) == null ? void 0 : q.Student.DisplaynameSurname } : n ? { ID: n.ID, Name: n.DisplaynameSurname } : { ID: 0, Name: "" };
                  b && (G ? rt = x != null && x.Student ? { ID: x == null ? void 0 : x.Student.ID, Name: x == null ? void 0 : x.Student.DisplaynameSurname } : { ID: 0, Name: "" } : rt = { ID: 0, Name: "" });
                  const M = new Date(g.From);
                  M.setMinutes(M.getMinutes() - s);
                  const A = /* @__PURE__ */ new Date() >= M;
                  let L = "Available";
                  if (!b && (A || !(((B = _.Bookings[g.ID]) == null ? void 0 : B.Available) ?? !0)))
                    L = "Unavailable";
                  else if (G)
                    L = "Booking";
                  else if (b && !G) {
                    if (!st)
                      return /* @__PURE__ */ f(ht, {});
                    L = "Booked";
                  } else _.Classes.some((N) => !N.Available) && Object.values(_.Bookings).some((N) => N.StudentId == rt.ID) && (L = "Unavailable");
                  return /* @__PURE__ */ f(
                    ol,
                    {
                      groupId: e,
                      status: L,
                      text: L == "Booking" ? rt.Name + (st ? "" : " - " + ((X = c == null ? void 0 : c.find((N) => N.ID == (x == null ? void 0 : x.StaffId))) == null ? void 0 : X.DisplaynameSurname)) : "",
                      span: I,
                      slotId: g.ID,
                      student: rt,
                      selectedStudent: (n == null ? void 0 : n.ID) === (y == null ? void 0 : y.ID),
                      staffId: (x == null ? void 0 : x.StaffId) ?? _.ID,
                      classId: 0,
                      locked: A || i || h && !G,
                      refresh: d
                    },
                    g.ID + _.ID
                  );
                }
              })
            ] }, g.ID);
          }) })
        ] }) }) })
      ] }, p);
    })
  ] });
}, kb = ({ teachers: e, showClasses: t, studentID: n }) => /* @__PURE__ */ k(Sb, { children: [
  /* @__PURE__ */ k(xr, { children: [
    /* @__PURE__ */ f(Pn, { sx: { borderRight: "2px solid var(--mui-palette-TableCell-border)" } }, "buffer_cell"),
    e.map((i) => {
      var o;
      const s = t ? i.Classes.filter((a) => a.Students && a.Students.some((l) => l.ID == n)).length : 1, r = i.Classes.length > 0 ? (o = i.Classes.find((a) => a.Students && a.Students.some((l) => l.ID == n))) == null ? void 0 : o.Name : "";
      return /* @__PURE__ */ k(
        Pn,
        {
          sx: { borderRight: "2px solid var(--mui-palette-TableCell-border)" },
          colSpan: s,
          children: [
            /* @__PURE__ */ f(H, { sx: { overflow: "hidden", whiteSpace: "nowrap" }, children: i.DisplaynameSurname }),
            /* @__PURE__ */ f(
              H,
              {
                sx: { overflow: "hidden", whiteSpace: "nowrap", fontStyle: "italic" },
                fontSize: "0.7rem",
                children: i.Location !== "" ? _b(i.Location) ? /* @__PURE__ */ f(wb, { url: i.Location }) : i.Location.length > 20 ? i.Location.slice(0, 17) + "..." : i.Location : /* @__PURE__ */ f("br", {})
              }
            ),
            /* @__PURE__ */ f("br", {}),
            /* @__PURE__ */ f(
              H,
              {
                sx: { overflow: "hidden", whiteSpace: "nowrap" },
                fontSize: "0.7rem",
                children: r !== "" ? r : /* @__PURE__ */ f("br", {})
              }
            )
          ]
        },
        i.DisplaynameSurname
      );
    })
  ] }),
  t && /* @__PURE__ */ k(xr, { children: [
    /* @__PURE__ */ f(Pn, { sx: { borderRight: "2px solid var(--mui-palette-TableCell-border)" } }, "buffer_cell"),
    e.map((i) => i.Classes.filter((s) => s.Students && s.Students.some((r) => r.ID == n)).map((s, r) => /* @__PURE__ */ f(
      Pn,
      {
        sx: { borderRight: r == i.Classes.length - 1 ? "2px solid var(--mui-palette-TableCell-border)" : "none" },
        children: s.Name
      },
      s.Name
    )))
  ] })
] });
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Ai(e) {
  return e + 0.5 | 0;
}
const Ve = (e, t, n) => Math.max(Math.min(e, n), t);
function Xn(e) {
  return Ve(Ai(e * 2.55), 0, 255);
}
function Xe(e) {
  return Ve(Ai(e * 255), 0, 255);
}
function De(e) {
  return Ve(Ai(e / 2.55) / 100, 0, 1);
}
function al(e) {
  return Ve(Ai(e * 100), 0, 100);
}
const se = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Hr = [..."0123456789ABCDEF"], Pb = (e) => Hr[e & 15], Ab = (e) => Hr[(e & 240) >> 4] + Hr[e & 15], Li = (e) => (e & 240) >> 4 === (e & 15), Mb = (e) => Li(e.r) && Li(e.g) && Li(e.b) && Li(e.a);
function Ib(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & se[e[1]] * 17,
    g: 255 & se[e[2]] * 17,
    b: 255 & se[e[3]] * 17,
    a: t === 5 ? se[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: se[e[1]] << 4 | se[e[2]],
    g: se[e[3]] << 4 | se[e[4]],
    b: se[e[5]] << 4 | se[e[6]],
    a: t === 9 ? se[e[7]] << 4 | se[e[8]] : 255
  })), n;
}
const Db = (e, t) => e < 255 ? t(e) : "";
function Ob(e) {
  var t = Mb(e) ? Pb : Ab;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + Db(e.a, t) : void 0;
}
const Tb = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function ru(e, t, n) {
  const i = t * Math.min(n, 1 - n), s = (r, o = (r + e / 30) % 12) => n - i * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [s(0), s(8), s(4)];
}
function Eb(e, t, n) {
  const i = (s, r = (s + e / 60) % 6) => n - n * t * Math.max(Math.min(r, 4 - r, 1), 0);
  return [i(5), i(3), i(1)];
}
function Rb(e, t, n) {
  const i = ru(e, 1, 0.5);
  let s;
  for (t + n > 1 && (s = 1 / (t + n), t *= s, n *= s), s = 0; s < 3; s++)
    i[s] *= 1 - t - n, i[s] += t;
  return i;
}
function Lb(e, t, n, i, s) {
  return e === s ? (t - n) / i + (t < n ? 6 : 0) : t === s ? (n - e) / i + 2 : (e - t) / i + 4;
}
function No(e) {
  const n = e.r / 255, i = e.g / 255, s = e.b / 255, r = Math.max(n, i, s), o = Math.min(n, i, s), a = (r + o) / 2;
  let l, c, d;
  return r !== o && (d = r - o, c = a > 0.5 ? d / (2 - r - o) : d / (r + o), l = Lb(n, i, s, d, r), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function zo(e, t, n, i) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, i)).map(Xe);
}
function Bo(e, t, n) {
  return zo(ru, e, t, n);
}
function Fb(e, t, n) {
  return zo(Rb, e, t, n);
}
function Nb(e, t, n) {
  return zo(Eb, e, t, n);
}
function ou(e) {
  return (e % 360 + 360) % 360;
}
function zb(e) {
  const t = Tb.exec(e);
  let n = 255, i;
  if (!t)
    return;
  t[5] !== i && (n = t[6] ? Xn(+t[5]) : Xe(+t[5]));
  const s = ou(+t[2]), r = +t[3] / 100, o = +t[4] / 100;
  return t[1] === "hwb" ? i = Fb(s, r, o) : t[1] === "hsv" ? i = Nb(s, r, o) : i = Bo(s, r, o), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: n
  };
}
function Bb(e, t) {
  var n = No(e);
  n[0] = ou(n[0] + t), n = Bo(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function Wb(e) {
  if (!e)
    return;
  const t = No(e), n = t[0], i = al(t[1]), s = al(t[2]);
  return e.a < 255 ? `hsla(${n}, ${i}%, ${s}%, ${De(e.a)})` : `hsl(${n}, ${i}%, ${s}%)`;
}
const ll = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, cl = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function jb() {
  const e = {}, t = Object.keys(cl), n = Object.keys(ll);
  let i, s, r, o, a;
  for (i = 0; i < t.length; i++) {
    for (o = a = t[i], s = 0; s < n.length; s++)
      r = n[s], a = a.replace(r, ll[r]);
    r = parseInt(cl[o], 16), e[a] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return e;
}
let Fi;
function $b(e) {
  Fi || (Fi = jb(), Fi.transparent = [0, 0, 0, 0]);
  const t = Fi[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const Vb = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Hb(e) {
  const t = Vb.exec(e);
  let n = 255, i, s, r;
  if (t) {
    if (t[7] !== i) {
      const o = +t[7];
      n = t[8] ? Xn(o) : Ve(o * 255, 0, 255);
    }
    return i = +t[1], s = +t[3], r = +t[5], i = 255 & (t[2] ? Xn(i) : Ve(i, 0, 255)), s = 255 & (t[4] ? Xn(s) : Ve(s, 0, 255)), r = 255 & (t[6] ? Xn(r) : Ve(r, 0, 255)), {
      r: i,
      g: s,
      b: r,
      a: n
    };
  }
}
function Ub(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${De(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const rr = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Cn = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function Yb(e, t, n) {
  const i = Cn(De(e.r)), s = Cn(De(e.g)), r = Cn(De(e.b));
  return {
    r: Xe(rr(i + n * (Cn(De(t.r)) - i))),
    g: Xe(rr(s + n * (Cn(De(t.g)) - s))),
    b: Xe(rr(r + n * (Cn(De(t.b)) - r))),
    a: e.a + n * (t.a - e.a)
  };
}
function Ni(e, t, n) {
  if (e) {
    let i = No(e);
    i[t] = Math.max(0, Math.min(i[t] + i[t] * n, t === 0 ? 360 : 1)), i = Bo(i), e.r = i[0], e.g = i[1], e.b = i[2];
  }
}
function au(e, t) {
  return e && Object.assign(t || {}, e);
}
function dl(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Xe(e[3]))) : (t = au(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Xe(t.a)), t;
}
function qb(e) {
  return e.charAt(0) === "r" ? Hb(e) : zb(e);
}
class hi {
  constructor(t) {
    if (t instanceof hi)
      return t;
    const n = typeof t;
    let i;
    n === "object" ? i = dl(t) : n === "string" && (i = Ib(t) || $b(t) || qb(t)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = au(this._rgb);
    return t && (t.a = De(t.a)), t;
  }
  set rgb(t) {
    this._rgb = dl(t);
  }
  rgbString() {
    return this._valid ? Ub(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Ob(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Wb(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const i = this.rgb, s = t.rgb;
      let r;
      const o = n === r ? 0.5 : n, a = 2 * o - 1, l = i.a - s.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      r = 1 - c, i.r = 255 & c * i.r + r * s.r + 0.5, i.g = 255 & c * i.g + r * s.g + 0.5, i.b = 255 & c * i.b + r * s.b + 0.5, i.a = o * i.a + (1 - o) * s.a, this.rgb = i;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = Yb(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new hi(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Xe(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = Ai(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Ni(this._rgb, 2, t), this;
  }
  darken(t) {
    return Ni(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Ni(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Ni(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Bb(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function Pe() {
}
const Xb = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function dt(e) {
  return e == null;
}
function Pt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function ut(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ot(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Jt(e, t) {
  return Ot(e) ? e : t;
}
function nt(e, t) {
  return typeof e > "u" ? t : e;
}
const Gb = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, lu = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function wt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function xt(e, t, n, i) {
  let s, r, o;
  if (Pt(e))
    for (r = e.length, s = 0; s < r; s++)
      t.call(n, e[s], s);
  else if (ut(e))
    for (o = Object.keys(e), r = o.length, s = 0; s < r; s++)
      t.call(n, e[o[s]], o[s]);
}
function vs(e, t) {
  let n, i, s, r;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, i = e.length; n < i; ++n)
    if (s = e[n], r = t[n], s.datasetIndex !== r.datasetIndex || s.index !== r.index)
      return !1;
  return !0;
}
function _s(e) {
  if (Pt(e))
    return e.map(_s);
  if (ut(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), i = n.length;
    let s = 0;
    for (; s < i; ++s)
      t[n[s]] = _s(e[n[s]]);
    return t;
  }
  return e;
}
function cu(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function Kb(e, t, n, i) {
  if (!cu(e))
    return;
  const s = t[e], r = n[e];
  ut(s) && ut(r) ? pi(s, r, i) : t[e] = _s(r);
}
function pi(e, t, n) {
  const i = Pt(t) ? t : [
    t
  ], s = i.length;
  if (!ut(e))
    return e;
  n = n || {};
  const r = n.merger || Kb;
  let o;
  for (let a = 0; a < s; ++a) {
    if (o = i[a], !ut(o))
      continue;
    const l = Object.keys(o);
    for (let c = 0, d = l.length; c < d; ++c)
      r(l[c], e, o, n);
  }
  return e;
}
function ii(e, t) {
  return pi(e, t, {
    merger: Qb
  });
}
function Qb(e, t, n) {
  if (!cu(e))
    return;
  const i = t[e], s = n[e];
  ut(i) && ut(s) ? ii(i, s) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = _s(s));
}
const ul = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function Zb(e) {
  const t = e.split("."), n = [];
  let i = "";
  for (const s of t)
    i += s, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (n.push(i), i = "");
  return n;
}
function Jb(e) {
  const t = Zb(e);
  return (n) => {
    for (const i of t) {
      if (i === "")
        break;
      n = n && n[i];
    }
    return n;
  };
}
function Ze(e, t) {
  return (ul[t] || (ul[t] = Jb(t)))(e);
}
function Wo(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const gi = (e) => typeof e < "u", Je = (e) => typeof e == "function", fl = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function ty(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const pt = Math.PI, Ct = 2 * pt, ey = Ct + pt, ws = Number.POSITIVE_INFINITY, ny = pt / 180, Lt = pt / 2, ln = pt / 4, hl = pt * 2 / 3, He = Math.log10, Ce = Math.sign;
function si(e, t, n) {
  return Math.abs(e - t) < n;
}
function pl(e) {
  const t = Math.round(e);
  e = si(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(He(e))), i = e / n;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n;
}
function iy(e) {
  const t = [], n = Math.sqrt(e);
  let i;
  for (i = 1; i < n; i++)
    e % i === 0 && (t.push(i), t.push(e / i));
  return n === (n | 0) && t.push(n), t.sort((s, r) => s - r).pop(), t;
}
function sy(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function Rn(e) {
  return !sy(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function ry(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function du(e, t, n) {
  let i, s, r;
  for (i = 0, s = e.length; i < s; i++)
    r = e[i][n], isNaN(r) || (t.min = Math.min(t.min, r), t.max = Math.max(t.max, r));
}
function he(e) {
  return e * (pt / 180);
}
function jo(e) {
  return e * (180 / pt);
}
function gl(e) {
  if (!Ot(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function uu(e, t) {
  const n = t.x - e.x, i = t.y - e.y, s = Math.sqrt(n * n + i * i);
  let r = Math.atan2(i, n);
  return r < -0.5 * pt && (r += Ct), {
    angle: r,
    distance: s
  };
}
function Ur(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function oy(e, t) {
  return (e - t + ey) % Ct - pt;
}
function Ut(e) {
  return (e % Ct + Ct) % Ct;
}
function mi(e, t, n, i) {
  const s = Ut(e), r = Ut(t), o = Ut(n), a = Ut(r - s), l = Ut(o - s), c = Ut(s - r), d = Ut(s - o);
  return s === r || s === o || i && r === o || a > l && c < d;
}
function jt(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function ay(e) {
  return jt(e, -32768, 32767);
}
function Te(e, t, n, i = 1e-6) {
  return e >= Math.min(t, n) - i && e <= Math.max(t, n) + i;
}
function $o(e, t, n) {
  n = n || ((o) => e[o] < t);
  let i = e.length - 1, s = 0, r;
  for (; i - s > 1; )
    r = s + i >> 1, n(r) ? s = r : i = r;
  return {
    lo: s,
    hi: i
  };
}
const Ee = (e, t, n, i) => $o(e, n, i ? (s) => {
  const r = e[s][t];
  return r < n || r === n && e[s + 1][t] === n;
} : (s) => e[s][t] < n), ly = (e, t, n) => $o(e, n, (i) => e[i][t] >= n);
function cy(e, t, n) {
  let i = 0, s = e.length;
  for (; i < s && e[i] < t; )
    i++;
  for (; s > i && e[s - 1] > n; )
    s--;
  return i > 0 || s < e.length ? e.slice(i, s) : e;
}
const fu = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function dy(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), fu.forEach((n) => {
    const i = "_onData" + Wo(n), s = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const o = s.apply(this, r);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[i] == "function" && a[i](...r);
        }), o;
      }
    });
  });
}
function ml(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const i = n.listeners, s = i.indexOf(t);
  s !== -1 && i.splice(s, 1), !(i.length > 0) && (fu.forEach((r) => {
    delete e[r];
  }), delete e._chartjs);
}
function hu(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const pu = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function gu(e, t) {
  let n = [], i = !1;
  return function(...s) {
    n = s, i || (i = !0, pu.call(window, () => {
      i = !1, e.apply(t, n);
    }));
  };
}
function uy(e, t) {
  let n;
  return function(...i) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, i)) : e.apply(this, i), t;
  };
}
const Vo = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Ht = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, fy = (e, t, n, i) => e === (i ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function mu(e, t, n) {
  const i = t.length;
  let s = 0, r = i;
  if (e._sorted) {
    const { iScale: o, vScale: a, _parsed: l } = e, c = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, d = o.axis, { min: u, max: h, minDefined: p, maxDefined: m } = o.getUserBounds();
    if (p) {
      if (s = Math.min(
        // @ts-expect-error Need to type _parsed
        Ee(l, d, u).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? i : Ee(t, d, o.getPixelForValue(u)).lo
      ), c) {
        const g = l.slice(0, s + 1).reverse().findIndex((b) => !dt(b[a.axis]));
        s -= Math.max(0, g);
      }
      s = jt(s, 0, i - 1);
    }
    if (m) {
      let g = Math.max(
        // @ts-expect-error Need to type _parsed
        Ee(l, o.axis, h, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : Ee(t, d, o.getPixelForValue(h), !0).hi + 1
      );
      if (c) {
        const b = l.slice(g - 1).findIndex((y) => !dt(y[a.axis]));
        g += Math.max(0, b);
      }
      r = jt(g, s, i) - s;
    } else
      r = i - s;
  }
  return {
    start: s,
    count: r
  };
}
function bu(e) {
  const { xScale: t, yScale: n, _scaleRanges: i } = e, s = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!i)
    return e._scaleRanges = s, !0;
  const r = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== n.min || i.ymax !== n.max;
  return Object.assign(i, s), r;
}
const zi = (e) => e === 0 || e === 1, bl = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * Ct / n)), yl = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * Ct / n) + 1, ri = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Lt) + 1,
  easeOutSine: (e) => Math.sin(e * Lt),
  easeInOutSine: (e) => -0.5 * (Math.cos(pt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => zi(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => zi(e) ? e : bl(e, 0.075, 0.3),
  easeOutElastic: (e) => zi(e) ? e : yl(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return zi(e) ? e : e < 0.5 ? 0.5 * bl(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * yl(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - ri.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? ri.easeInBounce(e * 2) * 0.5 : ri.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Ho(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function xl(e) {
  return Ho(e) ? e : new hi(e);
}
function or(e) {
  return Ho(e) ? e : new hi(e).saturate(0.5).darken(0.1).hexString();
}
const hy = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], py = [
  "color",
  "borderColor",
  "backgroundColor"
];
function gy(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: py
    },
    numbers: {
      type: "number",
      properties: hy
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function my(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const vl = /* @__PURE__ */ new Map();
function by(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let i = vl.get(n);
  return i || (i = new Intl.NumberFormat(e, t), vl.set(n, i)), i;
}
function Mi(e, t, n) {
  return by(t, n).format(e);
}
const yu = {
  values(e) {
    return Pt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const i = this.chart.options.locale;
    let s, r = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (s = "scientific"), r = yy(e, n);
    }
    const o = He(Math.abs(r)), a = isNaN(o) ? 1 : Math.max(Math.min(-1 * Math.floor(o), 20), 0), l = {
      notation: s,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), Mi(e, i, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const i = n[t].significand || e / Math.pow(10, Math.floor(He(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || t > 0.8 * n.length ? yu.numeric.call(this, e, t, n) : "";
  }
};
function yy(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var zs = {
  formatters: yu
};
function xy(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: zs.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const _n = /* @__PURE__ */ Object.create(null), Yr = /* @__PURE__ */ Object.create(null);
function oi(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let i = 0, s = n.length; i < s; ++i) {
    const r = n[i];
    e = e[r] || (e[r] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function ar(e, t, n) {
  return typeof t == "string" ? pi(oi(e, t), n) : pi(oi(e, ""), t);
}
class vy {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, s) => or(s.backgroundColor), this.hoverBorderColor = (i, s) => or(s.borderColor), this.hoverColor = (i, s) => or(s.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return ar(this, t, n);
  }
  get(t) {
    return oi(this, t);
  }
  describe(t, n) {
    return ar(Yr, t, n);
  }
  override(t, n) {
    return ar(_n, t, n);
  }
  route(t, n, i, s) {
    const r = oi(this, t), o = oi(this, i), a = "_" + n;
    Object.defineProperties(r, {
      [a]: {
        value: r[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = o[s];
          return ut(l) ? Object.assign({}, c, l) : nt(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var At = /* @__PURE__ */ new vy({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  gy,
  my,
  xy
]);
function _y(e) {
  return !e || dt(e.size) || dt(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Ss(e, t, n, i, s) {
  let r = t[s];
  return r || (r = t[s] = e.measureText(s).width, n.push(s)), r > i && (i = r), i;
}
function wy(e, t, n, i) {
  i = i || {};
  let s = i.data = i.data || {}, r = i.garbageCollect = i.garbageCollect || [];
  i.font !== t && (s = i.data = {}, r = i.garbageCollect = [], i.font = t), e.save(), e.font = t;
  let o = 0;
  const a = n.length;
  let l, c, d, u, h;
  for (l = 0; l < a; l++)
    if (u = n[l], u != null && !Pt(u))
      o = Ss(e, s, r, o, u);
    else if (Pt(u))
      for (c = 0, d = u.length; c < d; c++)
        h = u[c], h != null && !Pt(h) && (o = Ss(e, s, r, o, h));
  e.restore();
  const p = r.length / 2;
  if (p > n.length) {
    for (l = 0; l < p; l++)
      delete s[r[l]];
    r.splice(0, p);
  }
  return o;
}
function cn(e, t, n) {
  const i = e.currentDevicePixelRatio, s = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - s) * i) / i + s;
}
function _l(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function qr(e, t, n, i) {
  xu(e, t, n, i, null);
}
function xu(e, t, n, i, s) {
  let r, o, a, l, c, d, u, h;
  const p = t.pointStyle, m = t.rotation, g = t.radius;
  let b = (m || 0) * ny;
  if (p && typeof p == "object" && (r = p.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, i), e.rotate(b), e.drawImage(p, -p.width / 2, -p.height / 2, p.width, p.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), p) {
      // Default includes circle
      default:
        s ? e.ellipse(n, i, s / 2, g, 0, 0, Ct) : e.arc(n, i, g, 0, Ct), e.closePath();
        break;
      case "triangle":
        d = s ? s / 2 : g, e.moveTo(n + Math.sin(b) * d, i - Math.cos(b) * g), b += hl, e.lineTo(n + Math.sin(b) * d, i - Math.cos(b) * g), b += hl, e.lineTo(n + Math.sin(b) * d, i - Math.cos(b) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, o = Math.cos(b + ln) * l, u = Math.cos(b + ln) * (s ? s / 2 - c : l), a = Math.sin(b + ln) * l, h = Math.sin(b + ln) * (s ? s / 2 - c : l), e.arc(n - u, i - a, c, b - pt, b - Lt), e.arc(n + h, i - o, c, b - Lt, b), e.arc(n + u, i + a, c, b, b + Lt), e.arc(n - h, i + o, c, b + Lt, b + pt), e.closePath();
        break;
      case "rect":
        if (!m) {
          l = Math.SQRT1_2 * g, d = s ? s / 2 : l, e.rect(n - d, i - l, 2 * d, 2 * l);
          break;
        }
        b += ln;
      /* falls through */
      case "rectRot":
        u = Math.cos(b) * (s ? s / 2 : g), o = Math.cos(b) * g, a = Math.sin(b) * g, h = Math.sin(b) * (s ? s / 2 : g), e.moveTo(n - u, i - a), e.lineTo(n + h, i - o), e.lineTo(n + u, i + a), e.lineTo(n - h, i + o), e.closePath();
        break;
      case "crossRot":
        b += ln;
      /* falls through */
      case "cross":
        u = Math.cos(b) * (s ? s / 2 : g), o = Math.cos(b) * g, a = Math.sin(b) * g, h = Math.sin(b) * (s ? s / 2 : g), e.moveTo(n - u, i - a), e.lineTo(n + u, i + a), e.moveTo(n + h, i - o), e.lineTo(n - h, i + o);
        break;
      case "star":
        u = Math.cos(b) * (s ? s / 2 : g), o = Math.cos(b) * g, a = Math.sin(b) * g, h = Math.sin(b) * (s ? s / 2 : g), e.moveTo(n - u, i - a), e.lineTo(n + u, i + a), e.moveTo(n + h, i - o), e.lineTo(n - h, i + o), b += ln, u = Math.cos(b) * (s ? s / 2 : g), o = Math.cos(b) * g, a = Math.sin(b) * g, h = Math.sin(b) * (s ? s / 2 : g), e.moveTo(n - u, i - a), e.lineTo(n + u, i + a), e.moveTo(n + h, i - o), e.lineTo(n - h, i + o);
        break;
      case "line":
        o = s ? s / 2 : Math.cos(b) * g, a = Math.sin(b) * g, e.moveTo(n - o, i - a), e.lineTo(n + o, i + a);
        break;
      case "dash":
        e.moveTo(n, i), e.lineTo(n + Math.cos(b) * (s ? s / 2 : g), i + Math.sin(b) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Re(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function Bs(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Ws(e) {
  e.restore();
}
function Sy(e, t, n, i, s) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (s === "middle") {
    const r = (t.x + n.x) / 2;
    e.lineTo(r, t.y), e.lineTo(r, n.y);
  } else s === "after" != !!i ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function Cy(e, t, n, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? n.cp2x : n.cp1x, i ? n.cp2y : n.cp1y, n.x, n.y);
}
function ky(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), dt(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function Py(e, t, n, i, s) {
  if (s.strikethrough || s.underline) {
    const r = e.measureText(i), o = t - r.actualBoundingBoxLeft, a = t + r.actualBoundingBoxRight, l = n - r.actualBoundingBoxAscent, c = n + r.actualBoundingBoxDescent, d = s.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = s.decorationWidth || 2, e.moveTo(o, d), e.lineTo(a, d), e.stroke();
  }
}
function Ay(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function wn(e, t, n, i, s, r = {}) {
  const o = Pt(t) ? t : [
    t
  ], a = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = s.string, ky(e, r), l = 0; l < o.length; ++l)
    c = o[l], r.backdrop && Ay(e, r.backdrop), a && (r.strokeColor && (e.strokeStyle = r.strokeColor), dt(r.strokeWidth) || (e.lineWidth = r.strokeWidth), e.strokeText(c, n, i, r.maxWidth)), e.fillText(c, n, i, r.maxWidth), Py(e, n, i, c, r), i += Number(s.lineHeight);
  e.restore();
}
function bi(e, t) {
  const { x: n, y: i, w: s, h: r, radius: o } = t;
  e.arc(n + o.topLeft, i + o.topLeft, o.topLeft, 1.5 * pt, pt, !0), e.lineTo(n, i + r - o.bottomLeft), e.arc(n + o.bottomLeft, i + r - o.bottomLeft, o.bottomLeft, pt, Lt, !0), e.lineTo(n + s - o.bottomRight, i + r), e.arc(n + s - o.bottomRight, i + r - o.bottomRight, o.bottomRight, Lt, 0, !0), e.lineTo(n + s, i + o.topRight), e.arc(n + s - o.topRight, i + o.topRight, o.topRight, 0, -Lt, !0), e.lineTo(n + o.topLeft, i);
}
const My = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Iy = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Dy(e, t) {
  const n = ("" + e).match(My);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Oy = (e) => +e || 0;
function Uo(e, t) {
  const n = {}, i = ut(t), s = i ? Object.keys(t) : t, r = ut(e) ? i ? (o) => nt(e[o], e[t[o]]) : (o) => e[o] : () => e;
  for (const o of s)
    n[o] = Oy(r(o));
  return n;
}
function vu(e) {
  return Uo(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function mn(e) {
  return Uo(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Xt(e) {
  const t = vu(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Bt(e, t) {
  e = e || {}, t = t || At.font;
  let n = nt(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let i = nt(e.style, t.style);
  i && !("" + i).match(Iy) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const s = {
    family: nt(e.family, t.family),
    lineHeight: Dy(nt(e.lineHeight, t.lineHeight), n),
    size: n,
    style: i,
    weight: nt(e.weight, t.weight),
    string: ""
  };
  return s.string = _y(s), s;
}
function Gn(e, t, n, i) {
  let s, r, o;
  for (s = 0, r = e.length; s < r; ++s)
    if (o = e[s], o !== void 0 && o !== void 0)
      return o;
}
function Ty(e, t, n) {
  const { min: i, max: s } = e, r = lu(t, (s - i) / 2), o = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: o(i, -Math.abs(r)),
    max: o(s, r)
  };
}
function en(e, t) {
  return Object.assign(Object.create(e), t);
}
function Yo(e, t = [
  ""
], n, i, s = () => e[0]) {
  const r = n || e;
  typeof i > "u" && (i = Cu("_fallback", e));
  const o = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: r,
    _fallback: i,
    _getTarget: s,
    override: (a) => Yo([
      a,
      ...e
    ], t, r, i)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return wu(a, l, () => Wy(l, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return Sl(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Sl(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const d = a._storage || (a._storage = s());
      return a[l] = d[l] = c, delete a._keys, !0;
    }
  });
}
function Ln(e, t, n, i) {
  const s = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _u(e, i),
    setContext: (r) => Ln(e, r, n, i),
    override: (r) => Ln(e.override(r), t, n, i)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, o) {
      return delete r[o], delete e[o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, o, a) {
      return wu(r, o, () => Ry(r, o, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, o) {
      return r._descriptors.allKeys ? Reflect.has(e, o) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(r, o) {
      return Reflect.has(e, o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(r, o, a) {
      return e[o] = a, delete r[o], !0;
    }
  });
}
function _u(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: i = t.indexable, _allKeys: s = t.allKeys } = e;
  return {
    allKeys: s,
    scriptable: n,
    indexable: i,
    isScriptable: Je(n) ? n : () => n,
    isIndexable: Je(i) ? i : () => i
  };
}
const Ey = (e, t) => e ? e + Wo(t) : t, qo = (e, t) => ut(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function wu(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const i = n();
  return e[t] = i, i;
}
function Ry(e, t, n) {
  const { _proxy: i, _context: s, _subProxy: r, _descriptors: o } = e;
  let a = i[t];
  return Je(a) && o.isScriptable(t) && (a = Ly(t, a, e, n)), Pt(a) && a.length && (a = Fy(t, a, e, o.isIndexable)), qo(t, a) && (a = Ln(a, s, r && r[t], o)), a;
}
function Ly(e, t, n, i) {
  const { _proxy: s, _context: r, _subProxy: o, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let l = t(r, o || i);
  return a.delete(e), qo(e, l) && (l = Xo(s._scopes, s, e, l)), l;
}
function Fy(e, t, n, i) {
  const { _proxy: s, _context: r, _subProxy: o, _descriptors: a } = n;
  if (typeof r.index < "u" && i(e))
    return t[r.index % t.length];
  if (ut(t[0])) {
    const l = t, c = s._scopes.filter((d) => d !== l);
    t = [];
    for (const d of l) {
      const u = Xo(c, s, e, d);
      t.push(Ln(u, r, o && o[e], a));
    }
  }
  return t;
}
function Su(e, t, n) {
  return Je(e) ? e(t, n) : e;
}
const Ny = (e, t) => e === !0 ? t : typeof e == "string" ? Ze(t, e) : void 0;
function zy(e, t, n, i, s) {
  for (const r of t) {
    const o = Ny(n, r);
    if (o) {
      e.add(o);
      const a = Su(o._fallback, n, s);
      if (typeof a < "u" && a !== n && a !== i)
        return a;
    } else if (o === !1 && typeof i < "u" && n !== i)
      return null;
  }
  return !1;
}
function Xo(e, t, n, i) {
  const s = t._rootScopes, r = Su(t._fallback, n, i), o = [
    ...e,
    ...s
  ], a = /* @__PURE__ */ new Set();
  a.add(i);
  let l = wl(a, o, n, r || n, i);
  return l === null || typeof r < "u" && r !== n && (l = wl(a, o, r, l, i), l === null) ? !1 : Yo(Array.from(a), [
    ""
  ], s, r, () => By(t, n, i));
}
function wl(e, t, n, i, s) {
  for (; n; )
    n = zy(e, t, n, i, s);
  return n;
}
function By(e, t, n) {
  const i = e._getTarget();
  t in i || (i[t] = {});
  const s = i[t];
  return Pt(s) && ut(n) ? n : s || {};
}
function Wy(e, t, n, i) {
  let s;
  for (const r of t)
    if (s = Cu(Ey(r, e), n), typeof s < "u")
      return qo(e, s) ? Xo(n, i, e, s) : s;
}
function Cu(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const i = n[e];
    if (typeof i < "u")
      return i;
  }
}
function Sl(e) {
  let t = e._keys;
  return t || (t = e._keys = jy(e._scopes)), t;
}
function jy(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const i of Object.keys(n).filter((s) => !s.startsWith("_")))
      t.add(i);
  return Array.from(t);
}
function ku(e, t, n, i) {
  const { iScale: s } = e, { key: r = "r" } = this._parsing, o = new Array(i);
  let a, l, c, d;
  for (a = 0, l = i; a < l; ++a)
    c = a + n, d = t[c], o[a] = {
      r: s.parse(Ze(d, r), c)
    };
  return o;
}
const $y = Number.EPSILON || 1e-14, Fn = (e, t) => t < e.length && !e[t].skip && e[t], Pu = (e) => e === "x" ? "y" : "x";
function Vy(e, t, n, i) {
  const s = e.skip ? t : e, r = t, o = n.skip ? t : n, a = Ur(r, s), l = Ur(o, r);
  let c = a / (a + l), d = l / (a + l);
  c = isNaN(c) ? 0 : c, d = isNaN(d) ? 0 : d;
  const u = i * c, h = i * d;
  return {
    previous: {
      x: r.x - u * (o.x - s.x),
      y: r.y - u * (o.y - s.y)
    },
    next: {
      x: r.x + h * (o.x - s.x),
      y: r.y + h * (o.y - s.y)
    }
  };
}
function Hy(e, t, n) {
  const i = e.length;
  let s, r, o, a, l, c = Fn(e, 0);
  for (let d = 0; d < i - 1; ++d)
    if (l = c, c = Fn(e, d + 1), !(!l || !c)) {
      if (si(t[d], 0, $y)) {
        n[d] = n[d + 1] = 0;
        continue;
      }
      s = n[d] / t[d], r = n[d + 1] / t[d], a = Math.pow(s, 2) + Math.pow(r, 2), !(a <= 9) && (o = 3 / Math.sqrt(a), n[d] = s * o * t[d], n[d + 1] = r * o * t[d]);
    }
}
function Uy(e, t, n = "x") {
  const i = Pu(n), s = e.length;
  let r, o, a, l = Fn(e, 0);
  for (let c = 0; c < s; ++c) {
    if (o = a, a = l, l = Fn(e, c + 1), !a)
      continue;
    const d = a[n], u = a[i];
    o && (r = (d - o[n]) / 3, a[`cp1${n}`] = d - r, a[`cp1${i}`] = u - r * t[c]), l && (r = (l[n] - d) / 3, a[`cp2${n}`] = d + r, a[`cp2${i}`] = u + r * t[c]);
  }
}
function Yy(e, t = "x") {
  const n = Pu(t), i = e.length, s = Array(i).fill(0), r = Array(i);
  let o, a, l, c = Fn(e, 0);
  for (o = 0; o < i; ++o)
    if (a = l, l = c, c = Fn(e, o + 1), !!l) {
      if (c) {
        const d = c[t] - l[t];
        s[o] = d !== 0 ? (c[n] - l[n]) / d : 0;
      }
      r[o] = a ? c ? Ce(s[o - 1]) !== Ce(s[o]) ? 0 : (s[o - 1] + s[o]) / 2 : s[o - 1] : s[o];
    }
  Hy(e, s, r), Uy(e, r, t);
}
function Bi(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function qy(e, t) {
  let n, i, s, r, o, a = Re(e[0], t);
  for (n = 0, i = e.length; n < i; ++n)
    o = r, r = a, a = n < i - 1 && Re(e[n + 1], t), r && (s = e[n], o && (s.cp1x = Bi(s.cp1x, t.left, t.right), s.cp1y = Bi(s.cp1y, t.top, t.bottom)), a && (s.cp2x = Bi(s.cp2x, t.left, t.right), s.cp2y = Bi(s.cp2y, t.top, t.bottom)));
}
function Xy(e, t, n, i, s) {
  let r, o, a, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Yy(e, s);
  else {
    let c = i ? e[e.length - 1] : e[0];
    for (r = 0, o = e.length; r < o; ++r)
      a = e[r], l = Vy(c, a, e[Math.min(r + 1, o - (i ? 0 : 1)) % o], t.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  t.capBezierPoints && qy(e, n);
}
function Go() {
  return typeof window < "u" && typeof document < "u";
}
function Ko(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Cs(e, t, n) {
  let i;
  return typeof e == "string" ? (i = parseInt(e, 10), e.indexOf("%") !== -1 && (i = i / 100 * t.parentNode[n])) : i = e, i;
}
const js = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Gy(e, t) {
  return js(e).getPropertyValue(t);
}
const Ky = [
  "top",
  "right",
  "bottom",
  "left"
];
function bn(e, t, n) {
  const i = {};
  n = n ? "-" + n : "";
  for (let s = 0; s < 4; s++) {
    const r = Ky[s];
    i[r] = parseFloat(e[t + "-" + r + n]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const Qy = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function Zy(e, t) {
  const n = e.touches, i = n && n.length ? n[0] : e, { offsetX: s, offsetY: r } = i;
  let o = !1, a, l;
  if (Qy(s, r, e.target))
    a = s, l = r;
  else {
    const c = t.getBoundingClientRect();
    a = i.clientX - c.left, l = i.clientY - c.top, o = !0;
  }
  return {
    x: a,
    y: l,
    box: o
  };
}
function fn(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: i } = t, s = js(n), r = s.boxSizing === "border-box", o = bn(s, "padding"), a = bn(s, "border", "width"), { x: l, y: c, box: d } = Zy(e, n), u = o.left + (d && a.left), h = o.top + (d && a.top);
  let { width: p, height: m } = t;
  return r && (p -= o.width + a.width, m -= o.height + a.height), {
    x: Math.round((l - u) / p * n.width / i),
    y: Math.round((c - h) / m * n.height / i)
  };
}
function Jy(e, t, n) {
  let i, s;
  if (t === void 0 || n === void 0) {
    const r = e && Ko(e);
    if (!r)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const o = r.getBoundingClientRect(), a = js(r), l = bn(a, "border", "width"), c = bn(a, "padding");
      t = o.width - c.width - l.width, n = o.height - c.height - l.height, i = Cs(a.maxWidth, r, "clientWidth"), s = Cs(a.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: i || ws,
    maxHeight: s || ws
  };
}
const Ue = (e) => Math.round(e * 10) / 10;
function tx(e, t, n, i) {
  const s = js(e), r = bn(s, "margin"), o = Cs(s.maxWidth, e, "clientWidth") || ws, a = Cs(s.maxHeight, e, "clientHeight") || ws, l = Jy(e, t, n);
  let { width: c, height: d } = l;
  if (s.boxSizing === "content-box") {
    const h = bn(s, "border", "width"), p = bn(s, "padding");
    c -= p.width + h.width, d -= p.height + h.height;
  }
  return c = Math.max(0, c - r.width), d = Math.max(0, i ? c / i : d - r.height), c = Ue(Math.min(c, o, l.maxWidth)), d = Ue(Math.min(d, a, l.maxHeight)), c && !d && (d = Ue(c / 2)), (t !== void 0 || n !== void 0) && i && l.height && d > l.height && (d = l.height, c = Ue(Math.floor(d * i))), {
    width: c,
    height: d
  };
}
function Cl(e, t, n) {
  const i = t || 1, s = Ue(e.height * i), r = Ue(e.width * i);
  e.height = Ue(e.height), e.width = Ue(e.width);
  const o = e.canvas;
  return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${e.height}px`, o.style.width = `${e.width}px`), e.currentDevicePixelRatio !== i || o.height !== s || o.width !== r ? (e.currentDevicePixelRatio = i, o.height = s, o.width = r, e.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const ex = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    Go() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function kl(e, t) {
  const n = Gy(e, t), i = n && n.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function hn(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function nx(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: i === "middle" ? n < 0.5 ? e.y : t.y : i === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function ix(e, t, n, i) {
  const s = {
    x: e.cp2x,
    y: e.cp2y
  }, r = {
    x: t.cp1x,
    y: t.cp1y
  }, o = hn(e, s, n), a = hn(s, r, n), l = hn(r, t, n), c = hn(o, a, n), d = hn(a, l, n);
  return hn(c, d, n);
}
const sx = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, i) {
      return n - i;
    },
    leftForLtr(n, i) {
      return n - i;
    }
  };
}, rx = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function On(e, t, n) {
  return e ? sx(t, n) : rx();
}
function Au(e, t) {
  let n, i;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, i = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = i);
}
function Mu(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Iu(e) {
  return e === "angle" ? {
    between: mi,
    compare: oy,
    normalize: Ut
  } : {
    between: Te,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Pl({ start: e, end: t, count: n, loop: i, style: s }) {
  return {
    start: e % n,
    end: t % n,
    loop: i && (t - e + 1) % n === 0,
    style: s
  };
}
function ox(e, t, n) {
  const { property: i, start: s, end: r } = n, { between: o, normalize: a } = Iu(i), l = t.length;
  let { start: c, end: d, loop: u } = e, h, p;
  if (u) {
    for (c += l, d += l, h = 0, p = l; h < p && o(a(t[c % l][i]), s, r); ++h)
      c--, d--;
    c %= l, d %= l;
  }
  return d < c && (d += l), {
    start: c,
    end: d,
    loop: u,
    style: e.style
  };
}
function Du(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: i, start: s, end: r } = n, o = t.length, { compare: a, between: l, normalize: c } = Iu(i), { start: d, end: u, loop: h, style: p } = ox(e, t, n), m = [];
  let g = !1, b = null, y, x, w;
  const S = () => l(s, w, y) && a(s, w) !== 0, v = () => a(r, y) === 0 || l(r, w, y), _ = () => g || S(), C = () => !g || v();
  for (let P = d, I = d; P <= u; ++P)
    x = t[P % o], !x.skip && (y = c(x[i]), y !== w && (g = l(y, s, r), b === null && _() && (b = a(y, s) === 0 ? P : I), b !== null && C() && (m.push(Pl({
      start: b,
      end: P,
      loop: h,
      count: o,
      style: p
    })), b = null), I = P, w = y));
  return b !== null && m.push(Pl({
    start: b,
    end: u,
    loop: h,
    count: o,
    style: p
  })), m;
}
function Ou(e, t) {
  const n = [], i = e.segments;
  for (let s = 0; s < i.length; s++) {
    const r = Du(i[s], e.points, t);
    r.length && n.push(...r);
  }
  return n;
}
function ax(e, t, n, i) {
  let s = 0, r = t - 1;
  if (n && !i)
    for (; s < t && !e[s].skip; )
      s++;
  for (; s < t && e[s].skip; )
    s++;
  for (s %= t, n && (r += s); r > s && e[r % t].skip; )
    r--;
  return r %= t, {
    start: s,
    end: r
  };
}
function lx(e, t, n, i) {
  const s = e.length, r = [];
  let o = t, a = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % s];
    c.skip || c.stop ? a.skip || (i = !1, r.push({
      start: t % s,
      end: (l - 1) % s,
      loop: i
    }), t = o = c.stop ? l : null) : (o = l, a.skip && (t = l)), a = c;
  }
  return o !== null && r.push({
    start: t % s,
    end: o % s,
    loop: i
  }), r;
}
function cx(e, t) {
  const n = e.points, i = e.options.spanGaps, s = n.length;
  if (!s)
    return [];
  const r = !!e._loop, { start: o, end: a } = ax(n, s, r, i);
  if (i === !0)
    return Al(e, [
      {
        start: o,
        end: a,
        loop: r
      }
    ], n, t);
  const l = a < o ? a + s : a, c = !!e._fullLoop && o === 0 && a === s - 1;
  return Al(e, lx(n, o, l, c), n, t);
}
function Al(e, t, n, i) {
  return !i || !i.setContext || !n ? t : dx(e, t, n, i);
}
function dx(e, t, n, i) {
  const s = e._chart.getContext(), r = Ml(e.options), { _datasetIndex: o, options: { spanGaps: a } } = e, l = n.length, c = [];
  let d = r, u = t[0].start, h = u;
  function p(m, g, b, y) {
    const x = a ? -1 : 1;
    if (m !== g) {
      for (m += l; n[m % l].skip; )
        m -= x;
      for (; n[g % l].skip; )
        g += x;
      m % l !== g % l && (c.push({
        start: m % l,
        end: g % l,
        loop: b,
        style: y
      }), d = y, u = g % l);
    }
  }
  for (const m of t) {
    u = a ? u : m.start;
    let g = n[u % l], b;
    for (h = u + 1; h <= m.end; h++) {
      const y = n[h % l];
      b = Ml(i.setContext(en(s, {
        type: "segment",
        p0: g,
        p1: y,
        p0DataIndex: (h - 1) % l,
        p1DataIndex: h % l,
        datasetIndex: o
      }))), ux(b, d) && p(u, h - 1, m.loop, d), g = y, d = b;
    }
    u < h - 1 && p(u, h - 1, m.loop, d);
  }
  return c;
}
function Ml(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function ux(e, t) {
  if (!t)
    return !1;
  const n = [], i = function(s, r) {
    return Ho(r) ? (n.includes(r) || n.push(r), n.indexOf(r)) : r;
  };
  return JSON.stringify(e, i) !== JSON.stringify(t, i);
}
function Wi(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function fx(e, t) {
  const { xScale: n, yScale: i } = e;
  return n && i ? {
    left: Wi(n, t, "left"),
    right: Wi(n, t, "right"),
    top: Wi(i, t, "top"),
    bottom: Wi(i, t, "bottom")
  } : t;
}
function Tu(e, t) {
  const n = t._clip;
  if (n.disabled)
    return !1;
  const i = fx(t, e.chartArea);
  return {
    left: n.left === !1 ? 0 : i.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? e.width : i.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : i.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? e.height : i.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class hx {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, i, s) {
    const r = n.listeners[s], o = n.duration;
    r.forEach((a) => a({
      chart: t,
      initial: n.initial,
      numSteps: o,
      currentStep: Math.min(i - n.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = pu.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((i, s) => {
      if (!i.running || !i.items.length)
        return;
      const r = i.items;
      let o = r.length - 1, a = !1, l;
      for (; o >= 0; --o)
        l = r[o], l._active ? (l._total > i.duration && (i.duration = l._total), l.tick(t), a = !0) : (r[o] = r[r.length - 1], r.pop());
      a && (s.draw(), this._notify(s, i, t, "progress")), r.length || (i.running = !1, this._notify(s, i, t, "complete"), i.initial = !1), n += r.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let i = n.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, i)), i;
  }
  listen(t, n, i) {
    this._getAnims(t).listeners[n].push(i);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((i, s) => Math.max(i, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const i = n.items;
    let s = i.length - 1;
    for (; s >= 0; --s)
      i[s].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var Me = /* @__PURE__ */ new hx();
const Il = "transparent", px = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const i = xl(e || Il), s = i.valid && xl(t || Il);
    return s && s.valid ? s.mix(i, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class gx {
  constructor(t, n, i, s) {
    const r = n[i];
    s = Gn([
      t.to,
      s,
      r,
      t.from
    ]);
    const o = Gn([
      t.from,
      r,
      s
    ]);
    this._active = !0, this._fn = t.fn || px[t.type || typeof o], this._easing = ri[t.easing] || ri.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = i, this._from = o, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, i) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], r = i - this._start, o = this._duration - r;
      this._start = i, this._duration = Math.floor(Math.max(o, t.duration)), this._total += r, this._loop = !!t.loop, this._to = Gn([
        t.to,
        n,
        s,
        t.from
      ]), this._from = Gn([
        t.from,
        s,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, i = this._duration, s = this._prop, r = this._from, o = this._loop, a = this._to;
    let l;
    if (this._active = r !== a && (o || n < i), !this._active) {
      this._target[s] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[s] = r;
      return;
    }
    l = n / i % 2, l = o && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[s] = this._fn(r, a, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, i) => {
      t.push({
        res: n,
        rej: i
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", i = this._promises || [];
    for (let s = 0; s < i.length; s++)
      i[s][n]();
  }
}
class Eu {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!ut(t))
      return;
    const n = Object.keys(At.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((s) => {
      const r = t[s];
      if (!ut(r))
        return;
      const o = {};
      for (const a of n)
        o[a] = r[a];
      (Pt(r.properties) && r.properties || [
        s
      ]).forEach((a) => {
        (a === s || !i.has(a)) && i.set(a, o);
      });
    });
  }
  _animateOptions(t, n) {
    const i = n.options, s = bx(t, i);
    if (!s)
      return [];
    const r = this._createAnimations(s, i);
    return i.$shared && mx(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), r;
  }
  _createAnimations(t, n) {
    const i = this._properties, s = [], r = t.$animations || (t.$animations = {}), o = Object.keys(n), a = Date.now();
    let l;
    for (l = o.length - 1; l >= 0; --l) {
      const c = o[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        s.push(...this._animateOptions(t, n));
        continue;
      }
      const d = n[c];
      let u = r[c];
      const h = i.get(c);
      if (u)
        if (h && u.active()) {
          u.update(h, d, a);
          continue;
        } else
          u.cancel();
      if (!h || !h.duration) {
        t[c] = d;
        continue;
      }
      r[c] = u = new gx(h, t, c, d), s.push(u);
    }
    return s;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const i = this._createAnimations(t, n);
    if (i.length)
      return Me.add(this._chart, i), !0;
  }
}
function mx(e, t) {
  const n = [], i = Object.keys(t);
  for (let s = 0; s < i.length; s++) {
    const r = e[i[s]];
    r && r.active() && n.push(r.wait());
  }
  return Promise.all(n);
}
function bx(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Dl(e, t) {
  const n = e && e.options || {}, i = n.reverse, s = n.min === void 0 ? t : 0, r = n.max === void 0 ? t : 0;
  return {
    start: i ? r : s,
    end: i ? s : r
  };
}
function yx(e, t, n) {
  if (n === !1)
    return !1;
  const i = Dl(e, n), s = Dl(t, n);
  return {
    top: s.end,
    right: i.end,
    bottom: s.start,
    left: i.start
  };
}
function xx(e) {
  let t, n, i, s;
  return ut(e) ? (t = e.top, n = e.right, i = e.bottom, s = e.left) : t = n = i = s = e, {
    top: t,
    right: n,
    bottom: i,
    left: s,
    disabled: e === !1
  };
}
function Ru(e, t) {
  const n = [], i = e._getSortedDatasetMetas(t);
  let s, r;
  for (s = 0, r = i.length; s < r; ++s)
    n.push(i[s].index);
  return n;
}
function Ol(e, t, n, i = {}) {
  const s = e.keys, r = i.mode === "single";
  let o, a, l, c;
  if (t === null)
    return;
  let d = !1;
  for (o = 0, a = s.length; o < a; ++o) {
    if (l = +s[o], l === n) {
      if (d = !0, i.all)
        continue;
      break;
    }
    c = e.values[l], Ot(c) && (r || t === 0 || Ce(t) === Ce(c)) && (t += c);
  }
  return !d && !i.all ? 0 : t;
}
function vx(e, t) {
  const { iScale: n, vScale: i } = t, s = n.axis === "x" ? "x" : "y", r = i.axis === "x" ? "x" : "y", o = Object.keys(e), a = new Array(o.length);
  let l, c, d;
  for (l = 0, c = o.length; l < c; ++l)
    d = o[l], a[l] = {
      [s]: d,
      [r]: e[d]
    };
  return a;
}
function lr(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function _x(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function wx(e) {
  const { min: t, max: n, minDefined: i, maxDefined: s } = e.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: s ? n : Number.POSITIVE_INFINITY
  };
}
function Sx(e, t, n) {
  const i = e[t] || (e[t] = {});
  return i[n] || (i[n] = {});
}
function Tl(e, t, n, i) {
  for (const s of t.getMatchingVisibleMetas(i).reverse()) {
    const r = e[s.index];
    if (n && r > 0 || !n && r < 0)
      return s.index;
  }
  return null;
}
function El(e, t) {
  const { chart: n, _cachedMeta: i } = e, s = n._stacks || (n._stacks = {}), { iScale: r, vScale: o, index: a } = i, l = r.axis, c = o.axis, d = _x(r, o, i), u = t.length;
  let h;
  for (let p = 0; p < u; ++p) {
    const m = t[p], { [l]: g, [c]: b } = m, y = m._stacks || (m._stacks = {});
    h = y[c] = Sx(s, d, g), h[a] = b, h._top = Tl(h, o, !0, i.type), h._bottom = Tl(h, o, !1, i.type);
    const x = h._visualValues || (h._visualValues = {});
    x[a] = b;
  }
}
function cr(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((i) => n[i].axis === t).shift();
}
function Cx(e, t) {
  return en(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function kx(e, t, n) {
  return en(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function $n(e, t) {
  const n = e.controller.index, i = e.vScale && e.vScale.axis;
  if (i) {
    t = t || e._parsed;
    for (const s of t) {
      const r = s._stacks;
      if (!r || r[i] === void 0 || r[i][n] === void 0)
        return;
      delete r[i][n], r[i]._visualValues !== void 0 && r[i]._visualValues[n] !== void 0 && delete r[i]._visualValues[n];
    }
  }
}
const dr = (e) => e === "reset" || e === "none", Rl = (e, t) => t ? e : Object.assign({}, e), Px = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: Ru(n, !0),
  values: null
};
class pe {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = lr(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && $n(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, i = this.getDataset(), s = (u, h, p, m) => u === "x" ? h : u === "r" ? m : p, r = n.xAxisID = nt(i.xAxisID, cr(t, "x")), o = n.yAxisID = nt(i.yAxisID, cr(t, "y")), a = n.rAxisID = nt(i.rAxisID, cr(t, "r")), l = n.indexAxis, c = n.iAxisID = s(l, r, o, a), d = n.vAxisID = s(l, o, r, a);
    n.xScale = this.getScaleForId(r), n.yScale = this.getScaleForId(o), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ml(this._data, this), t._stacked && $n(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), i = this._data;
    if (ut(n)) {
      const s = this._cachedMeta;
      this._data = vx(n, s);
    } else if (i !== n) {
      if (i) {
        ml(i, this);
        const s = this._cachedMeta;
        $n(s), s._parsed = [];
      }
      n && Object.isExtensible(n) && dy(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, i = this.getDataset();
    let s = !1;
    this._dataCheck();
    const r = n._stacked;
    n._stacked = lr(n.vScale, n), n.stack !== i.stack && (s = !0, $n(n), n.stack = i.stack), this._resyncElements(t), (s || r !== n._stacked) && (El(this, n._parsed), n._stacked = lr(n.vScale, n));
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: i, _data: s } = this, { iScale: r, _stacked: o } = i, a = r.axis;
    let l = t === 0 && n === s.length ? !0 : i._sorted, c = t > 0 && i._parsed[t - 1], d, u, h;
    if (this._parsing === !1)
      i._parsed = s, i._sorted = !0, h = s;
    else {
      Pt(s[t]) ? h = this.parseArrayData(i, s, t, n) : ut(s[t]) ? h = this.parseObjectData(i, s, t, n) : h = this.parsePrimitiveData(i, s, t, n);
      const p = () => u[a] === null || c && u[a] < c[a];
      for (d = 0; d < n; ++d)
        i._parsed[d + t] = u = h[d], l && (p() && (l = !1), c = u);
      i._sorted = l;
    }
    o && El(this, h);
  }
  parsePrimitiveData(t, n, i, s) {
    const { iScale: r, vScale: o } = t, a = r.axis, l = o.axis, c = r.getLabels(), d = r === o, u = new Array(s);
    let h, p, m;
    for (h = 0, p = s; h < p; ++h)
      m = h + i, u[h] = {
        [a]: d || r.parse(c[m], m),
        [l]: o.parse(n[m], m)
      };
    return u;
  }
  parseArrayData(t, n, i, s) {
    const { xScale: r, yScale: o } = t, a = new Array(s);
    let l, c, d, u;
    for (l = 0, c = s; l < c; ++l)
      d = l + i, u = n[d], a[l] = {
        x: r.parse(u[0], d),
        y: o.parse(u[1], d)
      };
    return a;
  }
  parseObjectData(t, n, i, s) {
    const { xScale: r, yScale: o } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(s);
    let d, u, h, p;
    for (d = 0, u = s; d < u; ++d)
      h = d + i, p = n[h], c[d] = {
        x: r.parse(Ze(p, a), h),
        y: o.parse(Ze(p, l), h)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, i) {
    const s = this.chart, r = this._cachedMeta, o = n[t.axis], a = {
      keys: Ru(s, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return Ol(a, o, r.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, n, i, s) {
    const r = i[n.axis];
    let o = r === null ? NaN : r;
    const a = s && i._stacks[n.axis];
    s && a && (s.values = a, o = Ol(s, r, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, n) {
    const i = this._cachedMeta, s = i._parsed, r = i._sorted && t === i.iScale, o = s.length, a = this._getOtherScale(t), l = Px(n, i, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: u } = wx(a);
    let h, p;
    function m() {
      p = s[h];
      const g = p[a.axis];
      return !Ot(p[t.axis]) || d > g || u < g;
    }
    for (h = 0; h < o && !(!m() && (this.updateRangeFromParsed(c, t, p, l), r)); ++h)
      ;
    if (r) {
      for (h = o - 1; h >= 0; --h)
        if (!m()) {
          this.updateRangeFromParsed(c, t, p, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, i = [];
    let s, r, o;
    for (s = 0, r = n.length; s < r; ++s)
      o = n[s][t.axis], Ot(o) && i.push(o);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = n.iScale, s = n.vScale, r = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(r[i.axis]) : "",
      value: s ? "" + s.getLabelForValue(r[s.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = xx(nt(this.options.clip, yx(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, i = this._cachedMeta, s = i.data || [], r = n.chartArea, o = [], a = this._drawStart || 0, l = this._drawCount || s.length - a, c = this.options.drawActiveElementsOnTop;
    let d;
    for (i.dataset && i.dataset.draw(t, r, a, l), d = a; d < a + l; ++d) {
      const u = s[d];
      u.hidden || (u.active && c ? o.push(u) : u.draw(t, r));
    }
    for (d = 0; d < o.length; ++d)
      o[d].draw(t, r);
  }
  getStyle(t, n) {
    const i = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, n, i) {
    const s = this.getDataset();
    let r;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      r = o.$context || (o.$context = kx(this.getContext(), t, o)), r.parsed = this.getParsed(t), r.raw = s.data[t], r.index = r.dataIndex = t;
    } else
      r = this.$context || (this.$context = Cx(this.chart.getContext(), this.index)), r.dataset = s, r.index = r.datasetIndex = this.index;
    return r.active = !!n, r.mode = i, r;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", i) {
    const s = n === "active", r = this._cachedDataOpts, o = t + "-" + n, a = r[o], l = this.enableOptionSharing && gi(i);
    if (a)
      return Rl(a, l);
    const c = this.chart.config, d = c.datasetElementScopeKeys(this._type, t), u = s ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], h = c.getOptionScopes(this.getDataset(), d), p = Object.keys(At.elements[t]), m = () => this.getContext(i, s, n), g = c.resolveNamedOptions(h, p, m, u);
    return g.$shared && (g.$shared = l, r[o] = Object.freeze(Rl(g, l))), g;
  }
  _resolveAnimations(t, n, i) {
    const s = this.chart, r = this._cachedDataOpts, o = `animation-${n}`, a = r[o];
    if (a)
      return a;
    let l;
    if (s.options.animation !== !1) {
      const d = this.chart.config, u = d.datasetAnimationScopeKeys(this._type, n), h = d.getOptionScopes(this.getDataset(), u);
      l = d.createResolver(h, this.getContext(t, i, n));
    }
    const c = new Eu(s, l && l.animations);
    return l && l._cacheable && (r[o] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || dr(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const i = this.resolveDataElementOptions(t, n), s = this._sharedOptions, r = this.getSharedOptions(i), o = this.includeOptions(n, r) || r !== s;
    return this.updateSharedOptions(r, n, i), {
      sharedOptions: r,
      includeOptions: o
    };
  }
  updateElement(t, n, i, s) {
    dr(s) ? Object.assign(t, i) : this._resolveAnimations(n, s).update(t, i);
  }
  updateSharedOptions(t, n, i) {
    t && !dr(n) && this._resolveAnimations(void 0, n).update(t, i);
  }
  _setStyle(t, n, i, s) {
    t.active = s;
    const r = this.getStyle(n, s);
    this._resolveAnimations(n, i, s).update(t, {
      options: !s && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, i = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const s = i.length, r = n.length, o = Math.min(r, s);
    o && this.parse(0, o), r > s ? this._insertElements(s, r - s, t) : r < s && this._removeElements(r, s - r);
  }
  _insertElements(t, n, i = !0) {
    const s = this._cachedMeta, r = s.data, o = t + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= o; a--)
        c[a] = c[a - n];
    };
    for (l(r), a = t; a < o; ++a)
      r[a] = new this.dataElementType();
    this._parsing && l(s._parsed), this.parse(t, n), i && this.updateElements(r, t, n, "reset");
  }
  updateElements(t, n, i, s) {
  }
  _removeElements(t, n) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const s = i._parsed.splice(t, n);
      i._stacked && $n(i, s);
    }
    i.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, i, s] = t;
      this[n](i, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
E(pe, "defaults", {}), E(pe, "datasetElementType", null), E(pe, "dataElementType", null);
function Ax(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let i = [];
    for (let s = 0, r = n.length; s < r; s++)
      i = i.concat(n[s].controller.getAllParsedValues(e));
    e._cache.$bar = hu(i.sort((s, r) => s - r));
  }
  return e._cache.$bar;
}
function Mx(e) {
  const t = e.iScale, n = Ax(t, e.type);
  let i = t._length, s, r, o, a;
  const l = () => {
    o === 32767 || o === -32768 || (gi(a) && (i = Math.min(i, Math.abs(o - a) || i)), a = o);
  };
  for (s = 0, r = n.length; s < r; ++s)
    o = t.getPixelForValue(n[s]), l();
  for (a = void 0, s = 0, r = t.ticks.length; s < r; ++s)
    o = t.getPixelForTick(s), l();
  return i;
}
function Ix(e, t, n, i) {
  const s = n.barThickness;
  let r, o;
  return dt(s) ? (r = t.min * n.categoryPercentage, o = n.barPercentage) : (r = s * i, o = 1), {
    chunk: r / i,
    ratio: o,
    start: t.pixels[e] - r / 2
  };
}
function Dx(e, t, n, i) {
  const s = t.pixels, r = s[e];
  let o = e > 0 ? s[e - 1] : null, a = e < s.length - 1 ? s[e + 1] : null;
  const l = n.categoryPercentage;
  o === null && (o = r - (a === null ? t.end - t.start : a - r)), a === null && (a = r + r - o);
  const c = r - (r - Math.min(o, a)) / 2 * l;
  return {
    chunk: Math.abs(a - o) / 2 * l / i,
    ratio: n.barPercentage,
    start: c
  };
}
function Ox(e, t, n, i) {
  const s = n.parse(e[0], i), r = n.parse(e[1], i), o = Math.min(s, r), a = Math.max(s, r);
  let l = o, c = a;
  Math.abs(o) > Math.abs(a) && (l = a, c = o), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: s,
    end: r,
    min: o,
    max: a
  };
}
function Lu(e, t, n, i) {
  return Pt(e) ? Ox(e, t, n, i) : t[n.axis] = n.parse(e, i), t;
}
function Ll(e, t, n, i) {
  const s = e.iScale, r = e.vScale, o = s.getLabels(), a = s === r, l = [];
  let c, d, u, h;
  for (c = n, d = n + i; c < d; ++c)
    h = t[c], u = {}, u[s.axis] = a || s.parse(o[c], c), l.push(Lu(h, u, r, c));
  return l;
}
function ur(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function Tx(e, t, n) {
  return e !== 0 ? Ce(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function Ex(e) {
  let t, n, i, s, r;
  return e.horizontal ? (t = e.base > e.x, n = "left", i = "right") : (t = e.base < e.y, n = "bottom", i = "top"), t ? (s = "end", r = "start") : (s = "start", r = "end"), {
    start: n,
    end: i,
    reverse: t,
    top: s,
    bottom: r
  };
}
function Rx(e, t, n, i) {
  let s = t.borderSkipped;
  const r = {};
  if (!s) {
    e.borderSkipped = r;
    return;
  }
  if (s === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: o, end: a, reverse: l, top: c, bottom: d } = Ex(e);
  s === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === i ? s = c : (n._bottom || 0) === i ? s = d : (r[Fl(d, o, a, l)] = !0, s = c)), r[Fl(s, o, a, l)] = !0, e.borderSkipped = r;
}
function Fl(e, t, n, i) {
  return i ? (e = Lx(e, t, n), e = Nl(e, n, t)) : e = Nl(e, t, n), e;
}
function Lx(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function Nl(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function Fx(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class Ji extends pe {
  parsePrimitiveData(t, n, i, s) {
    return Ll(t, n, i, s);
  }
  parseArrayData(t, n, i, s) {
    return Ll(t, n, i, s);
  }
  parseObjectData(t, n, i, s) {
    const { iScale: r, vScale: o } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = r.axis === "x" ? a : l, d = o.axis === "x" ? a : l, u = [];
    let h, p, m, g;
    for (h = i, p = i + s; h < p; ++h)
      g = n[h], m = {}, m[r.axis] = r.parse(Ze(g, c), h), u.push(Lu(Ze(g, d), m, o, h));
    return u;
  }
  updateRangeFromParsed(t, n, i, s) {
    super.updateRangeFromParsed(t, n, i, s);
    const r = i._custom;
    r && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, r.min), t.max = Math.max(t.max, r.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: i, vScale: s } = n, r = this.getParsed(t), o = r._custom, a = ur(o) ? "[" + o.start + ", " + o.end + "]" : "" + s.getLabelForValue(r[s.axis]);
    return {
      label: "" + i.getLabelForValue(r[i.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", { index: o, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), d = this._getRuler(), { sharedOptions: u, includeOptions: h } = this._getSharedOptions(n, s);
    for (let p = n; p < n + i; p++) {
      const m = this.getParsed(p), g = r || dt(m[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(p), b = this._calculateBarIndexPixels(p, d), y = (m._stacks || {})[a.axis], x = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !y || ur(m._custom) || o === y._top || o === y._bottom,
        x: c ? g.head : b.center,
        y: c ? b.center : g.head,
        height: c ? b.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : b.size
      };
      h && (x.options = u || this.resolveDataElementOptions(p, t[p].active ? "active" : s));
      const w = x.options || t[p].options;
      Rx(x, w, y, o), Fx(x, w, d.ratio), this.updateElement(t[p], p, x, s);
    }
  }
  _getStacks(t, n) {
    const { iScale: i } = this._cachedMeta, s = i.getMatchingVisibleMetas(this._type).filter((d) => d.controller.options.grouped), r = i.options.stacked, o = [], a = this._cachedMeta.controller.getParsed(n), l = a && a[i.axis], c = (d) => {
      const u = d._parsed.find((p) => p[i.axis] === l), h = u && u[d.vScale.axis];
      if (dt(h) || isNaN(h))
        return !0;
    };
    for (const d of s)
      if (!(n !== void 0 && c(d)) && ((r === !1 || o.indexOf(d.stack) === -1 || r === void 0 && d.stack === void 0) && o.push(d.stack), d.index === t))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getAxisCount() {
    return this._getAxis().length;
  }
  getFirstScaleIdForIndexAxis() {
    const t = this.chart.scales, n = this.chart.options.indexAxis;
    return Object.keys(t).filter((i) => t[i].axis === n).shift();
  }
  _getAxis() {
    const t = {}, n = this.getFirstScaleIdForIndexAxis();
    for (const i of this.chart.data.datasets)
      t[nt(this.chart.options.indexAxis === "x" ? i.xAxisID : i.yAxisID, n)] = !0;
    return Object.keys(t);
  }
  _getStackIndex(t, n, i) {
    const s = this._getStacks(t, i), r = n !== void 0 ? s.indexOf(n) : -1;
    return r === -1 ? s.length - 1 : r;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, i = n.iScale, s = [];
    let r, o;
    for (r = 0, o = n.data.length; r < o; ++r)
      s.push(i.getPixelForValue(this.getParsed(r)[i.axis], r));
    const a = t.barThickness;
    return {
      min: a || Mx(n),
      pixels: s,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: i, index: s }, options: { base: r, minBarLength: o } } = this, a = r || 0, l = this.getParsed(t), c = l._custom, d = ur(c);
    let u = l[n.axis], h = 0, p = i ? this.applyStack(n, l, i) : u, m, g;
    p !== u && (h = p - u, p = u), d && (u = c.barStart, p = c.barEnd - c.barStart, u !== 0 && Ce(u) !== Ce(c.barEnd) && (h = 0), h += u);
    const b = !dt(r) && !d ? r : h;
    let y = n.getPixelForValue(b);
    if (this.chart.getDataVisibility(t) ? m = n.getPixelForValue(h + p) : m = y, g = m - y, Math.abs(g) < o) {
      g = Tx(g, n, a) * o, u === a && (y -= g / 2);
      const x = n.getPixelForDecimal(0), w = n.getPixelForDecimal(1), S = Math.min(x, w), v = Math.max(x, w);
      y = Math.max(Math.min(y, v), S), m = y + g, i && !d && (l._stacks[n.axis]._visualValues[s] = n.getValueForPixel(m) - n.getValueForPixel(y));
    }
    if (y === n.getPixelForValue(a)) {
      const x = Ce(g) * n.getLineWidthForValue(a) / 2;
      y += x, g -= x;
    }
    return {
      size: g,
      base: y,
      head: m,
      center: m + g / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const i = n.scale, s = this.options, r = s.skipNull, o = nt(s.maxBarThickness, 1 / 0);
    let a, l;
    const c = this._getAxisCount();
    if (n.grouped) {
      const d = r ? this._getStackCount(t) : n.stackCount, u = s.barThickness === "flex" ? Dx(t, n, s, d * c) : Ix(t, n, s, d * c), h = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, p = this._getAxis().indexOf(nt(h, this.getFirstScaleIdForIndexAxis())), m = this._getStackIndex(this.index, this._cachedMeta.stack, r ? t : void 0) + p;
      a = u.start + u.chunk * m + u.chunk / 2, l = Math.min(o, u.chunk * u.ratio);
    } else
      a = i.getPixelForValue(this.getParsed(t)[i.axis], t), l = Math.min(o, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, i = t.data, s = i.length;
    let r = 0;
    for (; r < s; ++r)
      this.getParsed(r)[n.axis] !== null && !i[r].hidden && i[r].draw(this._ctx);
  }
}
E(Ji, "id", "bar"), E(Ji, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), E(Ji, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class ts extends pe {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, i, s) {
    const r = super.parsePrimitiveData(t, n, i, s);
    for (let o = 0; o < r.length; o++)
      r[o]._custom = this.resolveDataElementOptions(o + i).radius;
    return r;
  }
  parseArrayData(t, n, i, s) {
    const r = super.parseArrayData(t, n, i, s);
    for (let o = 0; o < r.length; o++) {
      const a = n[i + o];
      r[o]._custom = nt(a[2], this.resolveDataElementOptions(o + i).radius);
    }
    return r;
  }
  parseObjectData(t, n, i, s) {
    const r = super.parseObjectData(t, n, i, s);
    for (let o = 0; o < r.length; o++) {
      const a = n[i + o];
      r[o]._custom = nt(a && a.r && +a.r, this.resolveDataElementOptions(o + i).radius);
    }
    return r;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let i = t.length - 1; i >= 0; --i)
      n = Math.max(n, t[i].size(this.resolveDataElementOptions(i)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart.data.labels || [], { xScale: s, yScale: r } = n, o = this.getParsed(t), a = s.getLabelForValue(o.x), l = r.getLabelForValue(o.y), c = o._custom;
    return {
      label: i[t] || "",
      value: "(" + a + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", { iScale: o, vScale: a } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(n, s), d = o.axis, u = a.axis;
    for (let h = n; h < n + i; h++) {
      const p = t[h], m = !r && this.getParsed(h), g = {}, b = g[d] = r ? o.getPixelForDecimal(0.5) : o.getPixelForValue(m[d]), y = g[u] = r ? a.getBasePixel() : a.getPixelForValue(m[u]);
      g.skip = isNaN(b) || isNaN(y), c && (g.options = l || this.resolveDataElementOptions(h, p.active ? "active" : s), r && (g.options.radius = 0)), this.updateElement(p, h, g, s);
    }
  }
  resolveDataElementOptions(t, n) {
    const i = this.getParsed(t);
    let s = super.resolveDataElementOptions(t, n);
    s.$shared && (s = Object.assign({}, s, {
      $shared: !1
    }));
    const r = s.radius;
    return n !== "active" && (s.radius = 0), s.radius += nt(i && i._custom, r), s;
  }
}
E(ts, "id", "bubble"), E(ts, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), E(ts, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function Nx(e, t, n) {
  let i = 1, s = 1, r = 0, o = 0;
  if (t < Ct) {
    const a = e, l = a + t, c = Math.cos(a), d = Math.sin(a), u = Math.cos(l), h = Math.sin(l), p = (w, S, v) => mi(w, a, l, !0) ? 1 : Math.max(S, S * n, v, v * n), m = (w, S, v) => mi(w, a, l, !0) ? -1 : Math.min(S, S * n, v, v * n), g = p(0, c, u), b = p(Lt, d, h), y = m(pt, c, u), x = m(pt + Lt, d, h);
    i = (g - y) / 2, s = (b - x) / 2, r = -(g + y) / 2, o = -(b + x) / 2;
  }
  return {
    ratioX: i,
    ratioY: s,
    offsetX: r,
    offsetY: o
  };
}
class gn extends pe {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const i = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = i;
    else {
      let r = (l) => +i[l];
      if (ut(i[t])) {
        const { key: l = "value" } = this._parsing;
        r = (c) => +Ze(i[c], l);
      }
      let o, a;
      for (o = t, a = t + n; o < a; ++o)
        s._parsed[o] = r(o);
    }
  }
  _getRotation() {
    return he(this.options.rotation - 90);
  }
  _getCircumference() {
    return he(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Ct, n = -Ct;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const s = this.chart.getDatasetMeta(i).controller, r = s._getRotation(), o = s._getCircumference();
        t = Math.min(t, r), n = Math.max(n, r + o);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: i } = n, s = this._cachedMeta, r = s.data, o = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, a = Math.max((Math.min(i.width, i.height) - o) / 2, 0), l = Math.min(Gb(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: u } = this._getRotationExtents(), { ratioX: h, ratioY: p, offsetX: m, offsetY: g } = Nx(u, d, l), b = (i.width - o) / h, y = (i.height - o) / p, x = Math.max(Math.min(b, y) / 2, 0), w = lu(this.options.radius, x), S = Math.max(w * l, 0), v = (w - S) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * w, this.offsetY = g * w, s.total = this.calculateTotal(), this.outerRadius = w - v * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - v * c, 0), this.updateElements(r, 0, r.length, t);
  }
  _circumference(t, n) {
    const i = this.options, s = this._cachedMeta, r = this._getCircumference();
    return n && i.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * r / Ct);
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", o = this.chart, a = o.chartArea, c = o.options.animation, d = (a.left + a.right) / 2, u = (a.top + a.bottom) / 2, h = r && c.animateScale, p = h ? 0 : this.innerRadius, m = h ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: b } = this._getSharedOptions(n, s);
    let y = this._getRotation(), x;
    for (x = 0; x < n; ++x)
      y += this._circumference(x, r);
    for (x = n; x < n + i; ++x) {
      const w = this._circumference(x, r), S = t[x], v = {
        x: d + this.offsetX,
        y: u + this.offsetY,
        startAngle: y,
        endAngle: y + w,
        circumference: w,
        outerRadius: m,
        innerRadius: p
      };
      b && (v.options = g || this.resolveDataElementOptions(x, S.active ? "active" : s)), y += w, this.updateElement(S, x, v, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let i = 0, s;
    for (s = 0; s < n.length; s++) {
      const r = t._parsed[s];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(s) && !n[s].hidden && (i += Math.abs(r));
    }
    return i;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? Ct * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart, s = i.data.labels || [], r = Mi(n._parsed[t], i.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const i = this.chart;
    let s, r, o, a, l;
    if (!t) {
      for (s = 0, r = i.data.datasets.length; s < r; ++s)
        if (i.isDatasetVisible(s)) {
          o = i.getDatasetMeta(s), t = o.data, a = o.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, r = t.length; s < r; ++s)
      l = a.resolveDataElementOptions(s), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let i = 0, s = t.length; i < s; ++i) {
      const r = this.resolveDataElementOptions(i);
      n = Math.max(n, r.offset || 0, r.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (n += this._getRingWeight(i));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(nt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
E(gn, "id", "doughnut"), E(gn, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), E(gn, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), E(gn, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data, { labels: { pointStyle: i, textAlign: s, color: r, useBorderRadius: o, borderRadius: a } } = t.legend.options;
          return n.labels.length && n.datasets.length ? n.labels.map((l, c) => {
            const u = t.getDatasetMeta(0).controller.getStyle(c);
            return {
              text: l,
              fillStyle: u.backgroundColor,
              fontColor: r,
              hidden: !t.getDataVisibility(c),
              lineDash: u.borderDash,
              lineDashOffset: u.borderDashOffset,
              lineJoin: u.borderJoinStyle,
              lineWidth: u.borderWidth,
              strokeStyle: u.borderColor,
              textAlign: s,
              pointStyle: i,
              borderRadius: o && (a || u.borderRadius),
              index: c
            };
          }) : [];
        }
      },
      onClick(t, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  }
});
class es extends pe {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: i, data: s = [], _dataset: r } = n, o = this.chart._animationsDisabled;
    let { start: a, count: l } = mu(n, s, o);
    this._drawStart = a, this._drawCount = l, bu(n) && (a = 0, l = s.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!r._decimated, i.points = s;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !o,
      options: c
    }, t), this.updateElements(s, a, l, t);
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", { iScale: o, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: d, includeOptions: u } = this._getSharedOptions(n, s), h = o.axis, p = a.axis, { spanGaps: m, segment: g } = this.options, b = Rn(m) ? m : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || r || s === "none", x = n + i, w = t.length;
    let S = n > 0 && this.getParsed(n - 1);
    for (let v = 0; v < w; ++v) {
      const _ = t[v], C = y ? _ : {};
      if (v < n || v >= x) {
        C.skip = !0;
        continue;
      }
      const P = this.getParsed(v), I = dt(P[p]), V = C[h] = o.getPixelForValue(P[h], v), $ = C[p] = r || I ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, P, l) : P[p], v);
      C.skip = isNaN(V) || isNaN($) || I, C.stop = v > 0 && Math.abs(P[h] - S[h]) > b, g && (C.parsed = P, C.raw = c.data[v]), u && (C.options = d || this.resolveDataElementOptions(v, _.active ? "active" : s)), y || this.updateElement(_, v, C, s), S = P;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, i = n.options && n.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return i;
    const r = s[0].size(this.resolveDataElementOptions(0)), o = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(i, r, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
E(es, "id", "line"), E(es, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), E(es, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class ai extends pe {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart, s = i.data.labels || [], r = Mi(n._parsed[t].r, i.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  parseObjectData(t, n, i, s) {
    return ku.bind(this)(t, n, i, s);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((i, s) => {
      const r = this.getParsed(s).r;
      !isNaN(r) && this.chart.getDataVisibility(s) && (r < n.min && (n.min = r), r > n.max && (n.max = r));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, i = t.options, s = Math.min(n.right - n.left, n.bottom - n.top), r = Math.max(s / 2, 0), o = Math.max(i.cutoutPercentage ? r / 100 * i.cutoutPercentage : 1, 0), a = (r - o) / t.getVisibleDatasetCount();
    this.outerRadius = r - a * this.index, this.innerRadius = this.outerRadius - a;
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", o = this.chart, l = o.options.animation, c = this._cachedMeta.rScale, d = c.xCenter, u = c.yCenter, h = c.getIndexAngle(0) - 0.5 * pt;
    let p = h, m;
    const g = 360 / this.countVisibleElements();
    for (m = 0; m < n; ++m)
      p += this._computeAngle(m, s, g);
    for (m = n; m < n + i; m++) {
      const b = t[m];
      let y = p, x = p + this._computeAngle(m, s, g), w = o.getDataVisibility(m) ? c.getDistanceFromCenterForValue(this.getParsed(m).r) : 0;
      p = x, r && (l.animateScale && (w = 0), l.animateRotate && (y = x = h));
      const S = {
        x: d,
        y: u,
        innerRadius: 0,
        outerRadius: w,
        startAngle: y,
        endAngle: x,
        options: this.resolveDataElementOptions(m, b.active ? "active" : s)
      };
      this.updateElement(b, m, S, s);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((i, s) => {
      !isNaN(this.getParsed(s).r) && this.chart.getDataVisibility(s) && n++;
    }), n;
  }
  _computeAngle(t, n, i) {
    return this.chart.getDataVisibility(t) ? he(this.resolveDataElementOptions(t, n).angle || i) : 0;
  }
}
E(ai, "id", "polarArea"), E(ai, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), E(ai, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: i, color: s } } = t.legend.options;
            return n.labels.map((r, o) => {
              const l = t.getDatasetMeta(0).controller.getStyle(o);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: s,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !t.getDataVisibility(o),
                index: o
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Xr extends gn {
}
E(Xr, "id", "pie"), E(Xr, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class ns extends pe {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, i = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(i[n.axis])
    };
  }
  parseObjectData(t, n, i, s) {
    return ku.bind(this)(t, n, i, s);
  }
  update(t) {
    const n = this._cachedMeta, i = n.dataset, s = n.data || [], r = n.iScale.getLabels();
    if (i.points = s, t !== "resize") {
      const o = this.resolveDatasetElementOptions(t);
      this.options.showLine || (o.borderWidth = 0);
      const a = {
        _loop: !0,
        _fullLoop: r.length === s.length,
        options: o
      };
      this.updateElement(i, void 0, a, t);
    }
    this.updateElements(s, 0, s.length, t);
  }
  updateElements(t, n, i, s) {
    const r = this._cachedMeta.rScale, o = s === "reset";
    for (let a = n; a < n + i; a++) {
      const l = t[a], c = this.resolveDataElementOptions(a, l.active ? "active" : s), d = r.getPointPositionForValue(a, this.getParsed(a).r), u = o ? r.xCenter : d.x, h = o ? r.yCenter : d.y, p = {
        x: u,
        y: h,
        angle: d.angle,
        skip: isNaN(u) || isNaN(h),
        options: c
      };
      this.updateElement(l, a, p, s);
    }
  }
}
E(ns, "id", "radar"), E(ns, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), E(ns, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class is extends pe {
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart.data.labels || [], { xScale: s, yScale: r } = n, o = this.getParsed(t), a = s.getLabelForValue(o.x), l = r.getLabelForValue(o.y);
    return {
      label: i[t] || "",
      value: "(" + a + ", " + l + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta, { data: i = [] } = n, s = this.chart._animationsDisabled;
    let { start: r, count: o } = mu(n, i, s);
    if (this._drawStart = r, this._drawCount = o, bu(n) && (r = 0, o = i.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: a, _dataset: l } = n;
      a._chart = this.chart, a._datasetIndex = this.index, a._decimated = !!l._decimated, a.points = i;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(a, void 0, {
        animated: !s,
        options: c
      }, t);
    } else this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(i, r, o, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, n, i, s) {
    const r = s === "reset", { iScale: o, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, d = this.resolveDataElementOptions(n, s), u = this.getSharedOptions(d), h = this.includeOptions(s, u), p = o.axis, m = a.axis, { spanGaps: g, segment: b } = this.options, y = Rn(g) ? g : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || r || s === "none";
    let w = n > 0 && this.getParsed(n - 1);
    for (let S = n; S < n + i; ++S) {
      const v = t[S], _ = this.getParsed(S), C = x ? v : {}, P = dt(_[m]), I = C[p] = o.getPixelForValue(_[p], S), V = C[m] = r || P ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, _, l) : _[m], S);
      C.skip = isNaN(I) || isNaN(V) || P, C.stop = S > 0 && Math.abs(_[p] - w[p]) > y, b && (C.parsed = _, C.raw = c.data[S]), h && (C.options = u || this.resolveDataElementOptions(S, v.active ? "active" : s)), x || this.updateElement(v, S, C, s), w = _;
    }
    this.updateSharedOptions(u, s, d);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let a = 0;
      for (let l = n.length - 1; l >= 0; --l)
        a = Math.max(a, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return a > 0 && a;
    }
    const i = t.dataset, s = i.options && i.options.borderWidth || 0;
    if (!n.length)
      return s;
    const r = n[0].size(this.resolveDataElementOptions(0)), o = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(s, r, o) / 2;
  }
}
E(is, "id", "scatter"), E(is, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), E(is, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var zx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Ji,
  BubbleController: ts,
  DoughnutController: gn,
  LineController: es,
  PieController: Xr,
  PolarAreaController: ai,
  RadarController: ns,
  ScatterController: is
});
function dn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Qo {
  constructor(t) {
    E(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Qo.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return dn();
  }
  parse() {
    return dn();
  }
  format() {
    return dn();
  }
  add() {
    return dn();
  }
  diff() {
    return dn();
  }
  startOf() {
    return dn();
  }
  endOf() {
    return dn();
  }
}
var Bx = {
  _date: Qo
};
function Wx(e, t, n, i) {
  const { controller: s, data: r, _sorted: o } = e, a = s._cachedMeta.iScale, l = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
  if (a && t === a.axis && t !== "r" && o && r.length) {
    const c = a._reversePixels ? ly : Ee;
    if (i) {
      if (s._sharedOptions) {
        const d = r[0], u = typeof d.getRange == "function" && d.getRange(t);
        if (u) {
          const h = c(r, t, n - u), p = c(r, t, n + u);
          return {
            lo: h.lo,
            hi: p.hi
          };
        }
      }
    } else {
      const d = c(r, t, n);
      if (l) {
        const { vScale: u } = s._cachedMeta, { _parsed: h } = e, p = h.slice(0, d.lo + 1).reverse().findIndex((g) => !dt(g[u.axis]));
        d.lo -= Math.max(0, p);
        const m = h.slice(d.hi).findIndex((g) => !dt(g[u.axis]));
        d.hi += Math.max(0, m);
      }
      return d;
    }
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function $s(e, t, n, i, s) {
  const r = e.getSortedVisibleDatasetMetas(), o = n[t];
  for (let a = 0, l = r.length; a < l; ++a) {
    const { index: c, data: d } = r[a], { lo: u, hi: h } = Wx(r[a], t, o, s);
    for (let p = u; p <= h; ++p) {
      const m = d[p];
      m.skip || i(m, c, p);
    }
  }
}
function jx(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(i, s) {
    const r = t ? Math.abs(i.x - s.x) : 0, o = n ? Math.abs(i.y - s.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2));
  };
}
function fr(e, t, n, i, s) {
  const r = [];
  return !s && !e.isPointInArea(t) || $s(e, n, t, function(a, l, c) {
    !s && !Re(a, e.chartArea, 0) || a.inRange(t.x, t.y, i) && r.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), r;
}
function $x(e, t, n, i) {
  let s = [];
  function r(o, a, l) {
    const { startAngle: c, endAngle: d } = o.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: u } = uu(o, {
      x: t.x,
      y: t.y
    });
    mi(u, c, d) && s.push({
      element: o,
      datasetIndex: a,
      index: l
    });
  }
  return $s(e, n, t, r), s;
}
function Vx(e, t, n, i, s, r) {
  let o = [];
  const a = jx(n);
  let l = Number.POSITIVE_INFINITY;
  function c(d, u, h) {
    const p = d.inRange(t.x, t.y, s);
    if (i && !p)
      return;
    const m = d.getCenterPoint(s);
    if (!(!!r || e.isPointInArea(m)) && !p)
      return;
    const b = a(t, m);
    b < l ? (o = [
      {
        element: d,
        datasetIndex: u,
        index: h
      }
    ], l = b) : b === l && o.push({
      element: d,
      datasetIndex: u,
      index: h
    });
  }
  return $s(e, n, t, c), o;
}
function hr(e, t, n, i, s, r) {
  return !r && !e.isPointInArea(t) ? [] : n === "r" && !i ? $x(e, t, n, s) : Vx(e, t, n, i, s, r);
}
function zl(e, t, n, i, s) {
  const r = [], o = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return $s(e, n, t, (l, c, d) => {
    l[o] && l[o](t[n], s) && (r.push({
      element: l,
      datasetIndex: c,
      index: d
    }), a = a || l.inRange(t.x, t.y, s));
  }), i && !a ? [] : r;
}
var Hx = {
  modes: {
    index(e, t, n, i) {
      const s = fn(t, e), r = n.axis || "x", o = n.includeInvisible || !1, a = n.intersect ? fr(e, s, r, i, o) : hr(e, s, r, !1, i, o), l = [];
      return a.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const d = a[0].index, u = c.data[d];
        u && !u.skip && l.push({
          element: u,
          datasetIndex: c.index,
          index: d
        });
      }), l) : [];
    },
    dataset(e, t, n, i) {
      const s = fn(t, e), r = n.axis || "xy", o = n.includeInvisible || !1;
      let a = n.intersect ? fr(e, s, r, i, o) : hr(e, s, r, !1, i, o);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = e.getDatasetMeta(l).data;
        a = [];
        for (let d = 0; d < c.length; ++d)
          a.push({
            element: c[d],
            datasetIndex: l,
            index: d
          });
      }
      return a;
    },
    point(e, t, n, i) {
      const s = fn(t, e), r = n.axis || "xy", o = n.includeInvisible || !1;
      return fr(e, s, r, i, o);
    },
    nearest(e, t, n, i) {
      const s = fn(t, e), r = n.axis || "xy", o = n.includeInvisible || !1;
      return hr(e, s, r, n.intersect, i, o);
    },
    x(e, t, n, i) {
      const s = fn(t, e);
      return zl(e, s, "x", n.intersect, i);
    },
    y(e, t, n, i) {
      const s = fn(t, e);
      return zl(e, s, "y", n.intersect, i);
    }
  }
};
const Fu = [
  "left",
  "top",
  "right",
  "bottom"
];
function Vn(e, t) {
  return e.filter((n) => n.pos === t);
}
function Bl(e, t) {
  return e.filter((n) => Fu.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Hn(e, t) {
  return e.sort((n, i) => {
    const s = t ? i : n, r = t ? n : i;
    return s.weight === r.weight ? s.index - r.index : s.weight - r.weight;
  });
}
function Ux(e) {
  const t = [];
  let n, i, s, r, o, a;
  for (n = 0, i = (e || []).length; n < i; ++n)
    s = e[n], { position: r, options: { stack: o, stackWeight: a = 1 } } = s, t.push({
      index: n,
      box: s,
      pos: r,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: o && r + o,
      stackWeight: a
    });
  return t;
}
function Yx(e) {
  const t = {};
  for (const n of e) {
    const { stack: i, pos: s, stackWeight: r } = n;
    if (!i || !Fu.includes(s))
      continue;
    const o = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    o.count++, o.weight += r;
  }
  return t;
}
function qx(e, t) {
  const n = Yx(e), { vBoxMaxWidth: i, hBoxMaxHeight: s } = t;
  let r, o, a;
  for (r = 0, o = e.length; r < o; ++r) {
    a = e[r];
    const { fullSize: l } = a.box, c = n[a.stack], d = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = d ? d * i : l && t.availableWidth, a.height = s) : (a.width = i, a.height = d ? d * s : l && t.availableHeight);
  }
  return n;
}
function Xx(e) {
  const t = Ux(e), n = Hn(t.filter((c) => c.box.fullSize), !0), i = Hn(Vn(t, "left"), !0), s = Hn(Vn(t, "right")), r = Hn(Vn(t, "top"), !0), o = Hn(Vn(t, "bottom")), a = Bl(t, "x"), l = Bl(t, "y");
  return {
    fullSize: n,
    leftAndTop: i.concat(r),
    rightAndBottom: s.concat(l).concat(o).concat(a),
    chartArea: Vn(t, "chartArea"),
    vertical: i.concat(s).concat(l),
    horizontal: r.concat(o).concat(a)
  };
}
function Wl(e, t, n, i) {
  return Math.max(e[n], t[n]) + Math.max(e[i], t[i]);
}
function Nu(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function Gx(e, t, n, i) {
  const { pos: s, box: r } = n, o = e.maxPadding;
  if (!ut(s)) {
    n.size && (e[s] -= n.size);
    const u = i[n.stack] || {
      size: 0,
      count: 1
    };
    u.size = Math.max(u.size, n.horizontal ? r.height : r.width), n.size = u.size / u.count, e[s] += n.size;
  }
  r.getPadding && Nu(o, r.getPadding());
  const a = Math.max(0, t.outerWidth - Wl(o, e, "left", "right")), l = Math.max(0, t.outerHeight - Wl(o, e, "top", "bottom")), c = a !== e.w, d = l !== e.h;
  return e.w = a, e.h = l, n.horizontal ? {
    same: c,
    other: d
  } : {
    same: d,
    other: c
  };
}
function Kx(e) {
  const t = e.maxPadding;
  function n(i) {
    const s = Math.max(t[i] - e[i], 0);
    return e[i] += s, s;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function Qx(e, t) {
  const n = t.maxPadding;
  function i(s) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((o) => {
      r[o] = Math.max(t[o], n[o]);
    }), r;
  }
  return i(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Kn(e, t, n, i) {
  const s = [];
  let r, o, a, l, c, d;
  for (r = 0, o = e.length, c = 0; r < o; ++r) {
    a = e[r], l = a.box, l.update(a.width || t.w, a.height || t.h, Qx(a.horizontal, t));
    const { same: u, other: h } = Gx(t, n, a, i);
    c |= u && s.length, d = d || h, l.fullSize || s.push(a);
  }
  return c && Kn(s, t, n, i) || d;
}
function ji(e, t, n, i, s) {
  e.top = n, e.left = t, e.right = t + i, e.bottom = n + s, e.width = i, e.height = s;
}
function jl(e, t, n, i) {
  const s = n.padding;
  let { x: r, y: o } = t;
  for (const a of e) {
    const l = a.box, c = i[a.stack] || {
      placed: 0,
      weight: 1
    }, d = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const u = t.w * d, h = c.size || l.height;
      gi(c.start) && (o = c.start), l.fullSize ? ji(l, s.left, o, n.outerWidth - s.right - s.left, h) : ji(l, t.left + c.placed, o, u, h), c.start = o, c.placed += u, o = l.bottom;
    } else {
      const u = t.h * d, h = c.size || l.width;
      gi(c.start) && (r = c.start), l.fullSize ? ji(l, r, s.top, h, n.outerHeight - s.bottom - s.top) : ji(l, r, t.top + c.placed, h, u), c.start = r, c.placed += u, r = l.right;
    }
  }
  t.x = r, t.y = o;
}
var Yt = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, i) {
    if (!e)
      return;
    const s = Xt(e.options.layout.padding), r = Math.max(t - s.width, 0), o = Math.max(n - s.height, 0), a = Xx(e.boxes), l = a.vertical, c = a.horizontal;
    xt(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const d = l.reduce((g, b) => b.box.options && b.box.options.display === !1 ? g : g + 1, 0) || 1, u = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: s,
      availableWidth: r,
      availableHeight: o,
      vBoxMaxWidth: r / 2 / d,
      hBoxMaxHeight: o / 2
    }), h = Object.assign({}, s);
    Nu(h, Xt(i));
    const p = Object.assign({
      maxPadding: h,
      w: r,
      h: o,
      x: s.left,
      y: s.top
    }, s), m = qx(l.concat(c), u);
    Kn(a.fullSize, p, u, m), Kn(l, p, u, m), Kn(c, p, u, m) && Kn(l, p, u, m), Kx(p), jl(a.leftAndTop, p, u, m), p.x += p.w, p.y += p.h, jl(a.rightAndBottom, p, u, m), e.chartArea = {
      left: p.left,
      top: p.top,
      right: p.left + p.w,
      bottom: p.top + p.h,
      height: p.h,
      width: p.w
    }, xt(a.chartArea, (g) => {
      const b = g.box;
      Object.assign(b, e.chartArea), b.update(p.w, p.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class zu {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, i) {
  }
  removeEventListener(t, n, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, i, s) {
    return n = Math.max(0, n || t.width), i = i || t.height, {
      width: n,
      height: Math.max(0, s ? Math.floor(n / s) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Zx extends zu {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const ss = "$chartjs", Jx = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, $l = (e) => e === null || e === "";
function tv(e, t) {
  const n = e.style, i = e.getAttribute("height"), s = e.getAttribute("width");
  if (e[ss] = {
    initial: {
      height: i,
      width: s,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", $l(s)) {
    const r = kl(e, "width");
    r !== void 0 && (e.width = r);
  }
  if ($l(i))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const r = kl(e, "height");
      r !== void 0 && (e.height = r);
    }
  return e;
}
const Bu = ex ? {
  passive: !0
} : !1;
function ev(e, t, n) {
  e && e.addEventListener(t, n, Bu);
}
function nv(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, Bu);
}
function iv(e, t) {
  const n = Jx[e.type] || e.type, { x: i, y: s } = fn(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: i !== void 0 ? i : null,
    y: s !== void 0 ? s : null
  };
}
function ks(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function sv(e, t, n) {
  const i = e.canvas, s = new MutationObserver((r) => {
    let o = !1;
    for (const a of r)
      o = o || ks(a.addedNodes, i), o = o && !ks(a.removedNodes, i);
    o && n();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function rv(e, t, n) {
  const i = e.canvas, s = new MutationObserver((r) => {
    let o = !1;
    for (const a of r)
      o = o || ks(a.removedNodes, i), o = o && !ks(a.addedNodes, i);
    o && n();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const yi = /* @__PURE__ */ new Map();
let Vl = 0;
function Wu() {
  const e = window.devicePixelRatio;
  e !== Vl && (Vl = e, yi.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function ov(e, t) {
  yi.size || window.addEventListener("resize", Wu), yi.set(e, t);
}
function av(e) {
  yi.delete(e), yi.size || window.removeEventListener("resize", Wu);
}
function lv(e, t, n) {
  const i = e.canvas, s = i && Ko(i);
  if (!s)
    return;
  const r = gu((a, l) => {
    const c = s.clientWidth;
    n(a, l), c < s.clientWidth && n();
  }, window), o = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, d = l.contentRect.height;
    c === 0 && d === 0 || r(c, d);
  });
  return o.observe(s), ov(e, r), o;
}
function pr(e, t, n) {
  n && n.disconnect(), t === "resize" && av(e);
}
function cv(e, t, n) {
  const i = e.canvas, s = gu((r) => {
    e.ctx !== null && n(iv(r, e));
  }, e);
  return ev(i, t, s), s;
}
class dv extends zu {
  acquireContext(t, n) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (tv(t, n), i) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[ss])
      return !1;
    const i = n[ss].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const o = i[r];
      dt(o) ? n.removeAttribute(r) : n.setAttribute(r, o);
    });
    const s = i.style || {};
    return Object.keys(s).forEach((r) => {
      n.style[r] = s[r];
    }), n.width = n.width, delete n[ss], !0;
  }
  addEventListener(t, n, i) {
    this.removeEventListener(t, n);
    const s = t.$proxies || (t.$proxies = {}), o = {
      attach: sv,
      detach: rv,
      resize: lv
    }[n] || cv;
    s[n] = o(t, n, i);
  }
  removeEventListener(t, n) {
    const i = t.$proxies || (t.$proxies = {}), s = i[n];
    if (!s)
      return;
    ({
      attach: pr,
      detach: pr,
      resize: pr
    }[n] || nv)(t, n, s), i[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, i, s) {
    return tx(t, n, i, s);
  }
  isAttached(t) {
    const n = t && Ko(t);
    return !!(n && n.isConnected);
  }
}
function uv(e) {
  return !Go() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? Zx : dv;
}
class ge {
  constructor() {
    E(this, "x");
    E(this, "y");
    E(this, "active", !1);
    E(this, "options");
    E(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: i
    };
  }
  hasValue() {
    return Rn(this.x) && Rn(this.y);
  }
  getProps(t, n) {
    const i = this.$animations;
    if (!n || !i)
      return this;
    const s = {};
    return t.forEach((r) => {
      s[r] = i[r] && i[r].active() ? i[r]._to : this[r];
    }), s;
  }
}
E(ge, "defaults", {}), E(ge, "defaultRoutes");
function fv(e, t) {
  const n = e.options.ticks, i = hv(e), s = Math.min(n.maxTicksLimit || i, i), r = n.major.enabled ? gv(t) : [], o = r.length, a = r[0], l = r[o - 1], c = [];
  if (o > s)
    return mv(t, c, r, o / s), c;
  const d = pv(r, t, s);
  if (o > 0) {
    let u, h;
    const p = o > 1 ? Math.round((l - a) / (o - 1)) : null;
    for ($i(t, c, d, dt(p) ? 0 : a - p, a), u = 0, h = o - 1; u < h; u++)
      $i(t, c, d, r[u], r[u + 1]);
    return $i(t, c, d, l, dt(p) ? t.length : l + p), c;
  }
  return $i(t, c, d), c;
}
function hv(e) {
  const t = e.options.offset, n = e._tickSize(), i = e._length / n + (t ? 0 : 1), s = e._maxLength / n;
  return Math.floor(Math.min(i, s));
}
function pv(e, t, n) {
  const i = bv(e), s = t.length / n;
  if (!i)
    return Math.max(s, 1);
  const r = iy(i);
  for (let o = 0, a = r.length - 1; o < a; o++) {
    const l = r[o];
    if (l > s)
      return l;
  }
  return Math.max(s, 1);
}
function gv(e) {
  const t = [];
  let n, i;
  for (n = 0, i = e.length; n < i; n++)
    e[n].major && t.push(n);
  return t;
}
function mv(e, t, n, i) {
  let s = 0, r = n[0], o;
  for (i = Math.ceil(i), o = 0; o < e.length; o++)
    o === r && (t.push(e[o]), s++, r = n[s * i]);
}
function $i(e, t, n, i, s) {
  const r = nt(i, 0), o = Math.min(nt(s, e.length), e.length);
  let a = 0, l, c, d;
  for (n = Math.ceil(n), s && (l = s - i, n = l / Math.floor(l / n)), d = r; d < 0; )
    a++, d = Math.round(r + a * n);
  for (c = Math.max(r, 0); c < o; c++)
    c === d && (t.push(e[c]), a++, d = Math.round(r + a * n));
}
function bv(e) {
  const t = e.length;
  let n, i;
  if (t < 2)
    return !1;
  for (i = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== i)
      return !1;
  return i;
}
const yv = (e) => e === "left" ? "right" : e === "right" ? "left" : e, Hl = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, Ul = (e, t) => Math.min(t || e, e);
function Yl(e, t) {
  const n = [], i = e.length / t, s = e.length;
  let r = 0;
  for (; r < s; r += i)
    n.push(e[Math.floor(r)]);
  return n;
}
function xv(e, t, n) {
  const i = e.ticks.length, s = Math.min(t, i - 1), r = e._startPixel, o = e._endPixel, a = 1e-6;
  let l = e.getPixelForTick(s), c;
  if (!(n && (i === 1 ? c = Math.max(l - r, o - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(s - 1)) / 2, l += s < t ? c : -c, l < r - a || l > o + a)))
    return l;
}
function vv(e, t) {
  xt(e, (n) => {
    const i = n.gc, s = i.length / 2;
    let r;
    if (s > t) {
      for (r = 0; r < s; ++r)
        delete n.data[i[r]];
      i.splice(0, s);
    }
  });
}
function Un(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function ql(e, t) {
  if (!e.display)
    return 0;
  const n = Bt(e.font, t), i = Xt(e.padding);
  return (Pt(e.text) ? e.text.length : 1) * n.lineHeight + i.height;
}
function _v(e, t) {
  return en(e, {
    scale: t,
    type: "scale"
  });
}
function wv(e, t, n) {
  return en(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function Sv(e, t, n) {
  let i = Vo(e);
  return (n && t !== "right" || !n && t === "right") && (i = yv(i)), i;
}
function Cv(e, t, n, i) {
  const { top: s, left: r, bottom: o, right: a, chart: l } = e, { chartArea: c, scales: d } = l;
  let u = 0, h, p, m;
  const g = o - s, b = a - r;
  if (e.isHorizontal()) {
    if (p = Ht(i, r, a), ut(n)) {
      const y = Object.keys(n)[0], x = n[y];
      m = d[y].getPixelForValue(x) + g - t;
    } else n === "center" ? m = (c.bottom + c.top) / 2 + g - t : m = Hl(e, n, t);
    h = a - r;
  } else {
    if (ut(n)) {
      const y = Object.keys(n)[0], x = n[y];
      p = d[y].getPixelForValue(x) - b + t;
    } else n === "center" ? p = (c.left + c.right) / 2 - b + t : p = Hl(e, n, t);
    m = Ht(i, o, s), u = n === "left" ? -Lt : Lt;
  }
  return {
    titleX: p,
    titleY: m,
    maxWidth: h,
    rotation: u
  };
}
class Sn extends ge {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: i, _suggestedMax: s } = this;
    return t = Jt(t, Number.POSITIVE_INFINITY), n = Jt(n, Number.NEGATIVE_INFINITY), i = Jt(i, Number.POSITIVE_INFINITY), s = Jt(s, Number.NEGATIVE_INFINITY), {
      min: Jt(t, i),
      max: Jt(n, s),
      minDefined: Ot(t),
      maxDefined: Ot(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: i, minDefined: s, maxDefined: r } = this.getUserBounds(), o;
    if (s && r)
      return {
        min: n,
        max: i
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      o = a[l].controller.getMinMax(this, t), s || (n = Math.min(n, o.min)), r || (i = Math.max(i, o.max));
    return n = r && n > i ? i : n, i = s && n > i ? n : i, {
      min: Jt(n, Jt(i, n)),
      max: Jt(i, Jt(n, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    wt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, i) {
    const { beginAtZero: s, grace: r, ticks: o } = this.options, a = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Ty(this, r, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? Yl(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = fv(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, i;
    this.isHorizontal() ? (n = this.left, i = this.right) : (n = this.top, i = this.bottom, t = !t), this._startPixel = n, this._endPixel = i, this._reversePixels = t, this._length = i - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    wt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    wt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    wt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), wt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    wt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let i, s, r;
    for (i = 0, s = t.length; i < s; i++)
      r = t[i], r.label = wt(n.callback, [
        r.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    wt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    wt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, i = Ul(this.ticks.length, t.ticks.maxTicksLimit), s = n.minRotation || 0, r = n.maxRotation;
    let o = s, a, l, c;
    if (!this._isVisible() || !n.display || s >= r || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const d = this._getLabelSizes(), u = d.widest.width, h = d.highest.height, p = jt(this.chart.width - u, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / i : p / (i - 1), u + 6 > a && (a = p / (i - (t.offset ? 0.5 : 1)), l = this.maxHeight - Un(t.grid) - n.padding - ql(t.title, this.chart.options.font), c = Math.sqrt(u * u + h * h), o = jo(Math.min(Math.asin(jt((d.highest.height + 6) / a, -1, 1)), Math.asin(jt(l / c, -1, 1)) - Math.asin(jt(h / c, -1, 1)))), o = Math.max(s, Math.min(r, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    wt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    wt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: i, title: s, grid: r } } = this, o = this._isVisible(), a = this.isHorizontal();
    if (o) {
      const l = ql(s, n.options.font);
      if (a ? (t.width = this.maxWidth, t.height = Un(r) + l) : (t.height = this.maxHeight, t.width = Un(r) + l), i.display && this.ticks.length) {
        const { first: c, last: d, widest: u, highest: h } = this._getLabelSizes(), p = i.padding * 2, m = he(this.labelRotation), g = Math.cos(m), b = Math.sin(m);
        if (a) {
          const y = i.mirror ? 0 : b * u.width + g * h.height;
          t.height = Math.min(this.maxHeight, t.height + y + p);
        } else {
          const y = i.mirror ? 0 : g * u.width + b * h.height;
          t.width = Math.min(this.maxWidth, t.width + y + p);
        }
        this._calculatePadding(c, d, b, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, i, s) {
    const { ticks: { align: r, padding: o }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, u = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, p = 0;
      l ? c ? (h = s * t.width, p = i * n.height) : (h = i * t.height, p = s * n.width) : r === "start" ? p = n.width : r === "end" ? h = t.width : r !== "inner" && (h = t.width / 2, p = n.width / 2), this.paddingLeft = Math.max((h - d + o) * this.width / (this.width - d), 0), this.paddingRight = Math.max((p - u + o) * this.width / (this.width - u), 0);
    } else {
      let d = n.height / 2, u = t.height / 2;
      r === "start" ? (d = 0, u = t.height) : r === "end" && (d = n.height, u = 0), this.paddingTop = d + o, this.paddingBottom = u + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    wt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, i;
    for (n = 0, i = t.length; n < i; n++)
      dt(t[n].label) && (t.splice(n, 1), i--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let i = this.ticks;
      n < i.length && (i = Yl(i, n)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, i) {
    const { ctx: s, _longestTextCache: r } = this, o = [], a = [], l = Math.floor(n / Ul(n, i));
    let c = 0, d = 0, u, h, p, m, g, b, y, x, w, S, v;
    for (u = 0; u < n; u += l) {
      if (m = t[u].label, g = this._resolveTickFontOptions(u), s.font = b = g.string, y = r[b] = r[b] || {
        data: {},
        gc: []
      }, x = g.lineHeight, w = S = 0, !dt(m) && !Pt(m))
        w = Ss(s, y.data, y.gc, w, m), S = x;
      else if (Pt(m))
        for (h = 0, p = m.length; h < p; ++h)
          v = m[h], !dt(v) && !Pt(v) && (w = Ss(s, y.data, y.gc, w, v), S += x);
      o.push(w), a.push(S), c = Math.max(w, c), d = Math.max(S, d);
    }
    vv(r, n);
    const _ = o.indexOf(c), C = a.indexOf(d), P = (I) => ({
      width: o[I] || 0,
      height: a[I] || 0
    });
    return {
      first: P(0),
      last: P(n - 1),
      widest: P(_),
      highest: P(C),
      widths: o,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return ay(this._alignToPixels ? cn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return i.$context || (i.$context = wv(this.getContext(), t, i));
    }
    return this.$context || (this.$context = _v(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = he(this.labelRotation), i = Math.abs(Math.cos(n)), s = Math.abs(Math.sin(n)), r = this._getLabelSizes(), o = t.autoSkipPadding || 0, a = r ? r.widest.width + o : 0, l = r ? r.highest.height + o : 0;
    return this.isHorizontal() ? l * i > a * s ? a / i : l / s : l * s < a * i ? l / i : a / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, i = this.chart, s = this.options, { grid: r, position: o, border: a } = s, l = r.offset, c = this.isHorizontal(), u = this.ticks.length + (l ? 1 : 0), h = Un(r), p = [], m = a.setContext(this.getContext()), g = m.display ? m.width : 0, b = g / 2, y = function(X) {
      return cn(i, X, g);
    };
    let x, w, S, v, _, C, P, I, V, $, T, j;
    if (o === "top")
      x = y(this.bottom), C = this.bottom - h, I = x - b, $ = y(t.top) + b, j = t.bottom;
    else if (o === "bottom")
      x = y(this.top), $ = t.top, j = y(t.bottom) - b, C = x + b, I = this.top + h;
    else if (o === "left")
      x = y(this.right), _ = this.right - h, P = x - b, V = y(t.left) + b, T = t.right;
    else if (o === "right")
      x = y(this.left), V = t.left, T = y(t.right) - b, _ = x + b, P = this.left + h;
    else if (n === "x") {
      if (o === "center")
        x = y((t.top + t.bottom) / 2 + 0.5);
      else if (ut(o)) {
        const X = Object.keys(o)[0], G = o[X];
        x = y(this.chart.scales[X].getPixelForValue(G));
      }
      $ = t.top, j = t.bottom, C = x + b, I = C + h;
    } else if (n === "y") {
      if (o === "center")
        x = y((t.left + t.right) / 2);
      else if (ut(o)) {
        const X = Object.keys(o)[0], G = o[X];
        x = y(this.chart.scales[X].getPixelForValue(G));
      }
      _ = x - b, P = _ - h, V = t.left, T = t.right;
    }
    const q = nt(s.ticks.maxTicksLimit, u), B = Math.max(1, Math.ceil(u / q));
    for (w = 0; w < u; w += B) {
      const X = this.getContext(w), G = r.setContext(X), st = a.setContext(X), rt = G.lineWidth, M = G.color, A = st.dash || [], L = st.dashOffset, N = G.tickWidth, F = G.tickColor, W = G.tickBorderDash || [], U = G.tickBorderDashOffset;
      S = xv(this, w, l), S !== void 0 && (v = cn(i, S, rt), c ? _ = P = V = T = v : C = I = $ = j = v, p.push({
        tx1: _,
        ty1: C,
        tx2: P,
        ty2: I,
        x1: V,
        y1: $,
        x2: T,
        y2: j,
        width: rt,
        color: M,
        borderDash: A,
        borderDashOffset: L,
        tickWidth: N,
        tickColor: F,
        tickBorderDash: W,
        tickBorderDashOffset: U
      }));
    }
    return this._ticksLength = u, this._borderValue = x, p;
  }
  _computeLabelItems(t) {
    const n = this.axis, i = this.options, { position: s, ticks: r } = i, o = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: d, mirror: u } = r, h = Un(i.grid), p = h + d, m = u ? -d : p, g = -he(this.labelRotation), b = [];
    let y, x, w, S, v, _, C, P, I, V, $, T, j = "middle";
    if (s === "top")
      _ = this.bottom - m, C = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      _ = this.top + m, C = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const B = this._getYAxisLabelAlignment(h);
      C = B.textAlign, v = B.x;
    } else if (s === "right") {
      const B = this._getYAxisLabelAlignment(h);
      C = B.textAlign, v = B.x;
    } else if (n === "x") {
      if (s === "center")
        _ = (t.top + t.bottom) / 2 + p;
      else if (ut(s)) {
        const B = Object.keys(s)[0], X = s[B];
        _ = this.chart.scales[B].getPixelForValue(X) + p;
      }
      C = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (s === "center")
        v = (t.left + t.right) / 2 - p;
      else if (ut(s)) {
        const B = Object.keys(s)[0], X = s[B];
        v = this.chart.scales[B].getPixelForValue(X);
      }
      C = this._getYAxisLabelAlignment(h).textAlign;
    }
    n === "y" && (l === "start" ? j = "top" : l === "end" && (j = "bottom"));
    const q = this._getLabelSizes();
    for (y = 0, x = a.length; y < x; ++y) {
      w = a[y], S = w.label;
      const B = r.setContext(this.getContext(y));
      P = this.getPixelForTick(y) + r.labelOffset, I = this._resolveTickFontOptions(y), V = I.lineHeight, $ = Pt(S) ? S.length : 1;
      const X = $ / 2, G = B.color, st = B.textStrokeColor, rt = B.textStrokeWidth;
      let M = C;
      o ? (v = P, C === "inner" && (y === x - 1 ? M = this.options.reverse ? "left" : "right" : y === 0 ? M = this.options.reverse ? "right" : "left" : M = "center"), s === "top" ? c === "near" || g !== 0 ? T = -$ * V + V / 2 : c === "center" ? T = -q.highest.height / 2 - X * V + V : T = -q.highest.height + V / 2 : c === "near" || g !== 0 ? T = V / 2 : c === "center" ? T = q.highest.height / 2 - X * V : T = q.highest.height - $ * V, u && (T *= -1), g !== 0 && !B.showLabelBackdrop && (v += V / 2 * Math.sin(g))) : (_ = P, T = (1 - $) * V / 2);
      let A;
      if (B.showLabelBackdrop) {
        const L = Xt(B.backdropPadding), N = q.heights[y], F = q.widths[y];
        let W = T - L.top, U = 0 - L.left;
        switch (j) {
          case "middle":
            W -= N / 2;
            break;
          case "bottom":
            W -= N;
            break;
        }
        switch (C) {
          case "center":
            U -= F / 2;
            break;
          case "right":
            U -= F;
            break;
          case "inner":
            y === x - 1 ? U -= F : y > 0 && (U -= F / 2);
            break;
        }
        A = {
          left: U,
          top: W,
          width: F + L.width,
          height: N + L.height,
          color: B.backdropColor
        };
      }
      b.push({
        label: S,
        font: I,
        textOffset: T,
        options: {
          rotation: g,
          color: G,
          strokeColor: st,
          strokeWidth: rt,
          textAlign: M,
          textBaseline: j,
          translation: [
            v,
            _
          ],
          backdrop: A
        }
      });
    }
    return b;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-he(this.labelRotation))
      return t === "top" ? "left" : "right";
    let s = "center";
    return n.align === "start" ? s = "left" : n.align === "end" ? s = "right" : n.align === "inner" && (s = "inner"), s;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: i, mirror: s, padding: r } } = this.options, o = this._getLabelSizes(), a = t + r, l = o.widest.width;
    let c, d;
    return n === "left" ? s ? (d = this.right + r, i === "near" ? c = "left" : i === "center" ? (c = "center", d += l / 2) : (c = "right", d += l)) : (d = this.right - a, i === "near" ? c = "right" : i === "center" ? (c = "center", d -= l / 2) : (c = "left", d = this.left)) : n === "right" ? s ? (d = this.left + r, i === "near" ? c = "right" : i === "center" ? (c = "center", d -= l / 2) : (c = "left", d -= l)) : (d = this.left + a, i === "near" ? c = "left" : i === "center" ? (c = "center", d += l / 2) : (c = "right", d = this.right)) : c = "right", {
      textAlign: c,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: i, top: s, width: r, height: o } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(i, s, r, o), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const s = this.ticks.findIndex((r) => r.value === t);
    return s >= 0 ? n.setContext(this.getContext(s)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, i = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let r, o;
    const a = (l, c, d) => {
      !d.width || !d.color || (i.save(), i.lineWidth = d.width, i.strokeStyle = d.color, i.setLineDash(d.borderDash || []), i.lineDashOffset = d.borderDashOffset, i.beginPath(), i.moveTo(l.x, l.y), i.lineTo(c.x, c.y), i.stroke(), i.restore());
    };
    if (n.display)
      for (r = 0, o = s.length; r < o; ++r) {
        const l = s[r];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: i, grid: s } } = this, r = i.setContext(this.getContext()), o = i.display ? r.width : 0;
    if (!o)
      return;
    const a = s.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, d, u, h;
    this.isHorizontal() ? (c = cn(t, this.left, o) - o / 2, d = cn(t, this.right, a) + a / 2, u = h = l) : (u = cn(t, this.top, o) - o / 2, h = cn(t, this.bottom, a) + a / 2, c = d = l), n.save(), n.lineWidth = r.width, n.strokeStyle = r.color, n.beginPath(), n.moveTo(c, u), n.lineTo(d, h), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, s = this._computeLabelArea();
    s && Bs(i, s);
    const r = this.getLabelItems(t);
    for (const o of r) {
      const a = o.options, l = o.font, c = o.label, d = o.textOffset;
      wn(i, c, 0, d, l, a);
    }
    s && Ws(i);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: i, reverse: s } } = this;
    if (!i.display)
      return;
    const r = Bt(i.font), o = Xt(i.padding), a = i.align;
    let l = r.lineHeight / 2;
    n === "bottom" || n === "center" || ut(n) ? (l += o.bottom, Pt(i.text) && (l += r.lineHeight * (i.text.length - 1))) : l += o.top;
    const { titleX: c, titleY: d, maxWidth: u, rotation: h } = Cv(this, l, n, a);
    wn(t, i.text, 0, 0, r, {
      color: i.color,
      maxWidth: u,
      rotation: h,
      textAlign: Sv(a, n, s),
      textBaseline: "middle",
      translation: [
        c,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, i = nt(t.grid && t.grid.z, -1), s = nt(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Sn.prototype.draw ? [
      {
        z: n,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: i,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", s = [];
    let r, o;
    for (r = 0, o = n.length; r < o; ++r) {
      const a = n[r];
      a[i] === this.id && (!t || a.type === t) && s.push(a);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return Bt(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Vi {
  constructor(t, n, i) {
    this.type = t, this.scope = n, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let i;
    Av(n) && (i = this.register(n));
    const s = this.items, r = t.id, o = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + t);
    return r in s || (s[r] = t, kv(t, o, i), this.override && At.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, i = t.id, s = this.scope;
    i in n && delete n[i], s && i in At[s] && (delete At[s][i], this.override && delete _n[i]);
  }
}
function kv(e, t, n) {
  const i = pi(/* @__PURE__ */ Object.create(null), [
    n ? At.get(n) : {},
    At.get(t),
    e.defaults
  ]);
  At.set(t, i), e.defaultRoutes && Pv(t, e.defaultRoutes), e.descriptors && At.describe(t, e.descriptors);
}
function Pv(e, t) {
  Object.keys(t).forEach((n) => {
    const i = n.split("."), s = i.pop(), r = [
      e
    ].concat(i).join("."), o = t[n].split("."), a = o.pop(), l = o.join(".");
    At.route(r, s, l, a);
  });
}
function Av(e) {
  return "id" in e && "defaults" in e;
}
class Mv {
  constructor() {
    this.controllers = new Vi(pe, "datasets", !0), this.elements = new Vi(ge, "elements"), this.plugins = new Vi(Object, "plugins"), this.scales = new Vi(Sn, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, i) {
    [
      ...n
    ].forEach((s) => {
      const r = i || this._getRegistryForType(s);
      i || r.isForType(s) || r === this.plugins && s.id ? this._exec(t, r, s) : xt(s, (o) => {
        const a = i || this._getRegistryForType(o);
        this._exec(t, a, o);
      });
    });
  }
  _exec(t, n, i) {
    const s = Wo(t);
    wt(i["before" + s], [], i), n[t](i), wt(i["after" + s], [], i);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const i = this._typedRegistries[n];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, n, i) {
    const s = n.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return s;
  }
}
var xe = /* @__PURE__ */ new Mv();
class Iv {
  constructor() {
    this._init = void 0;
  }
  notify(t, n, i, s) {
    if (n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install")), this._init === void 0)
      return;
    const r = s ? this._descriptors(t).filter(s) : this._descriptors(t), o = this._notify(r, t, n, i);
    return n === "afterDestroy" && (this._notify(r, t, "stop"), this._notify(this._init, t, "uninstall"), this._init = void 0), o;
  }
  _notify(t, n, i, s) {
    s = s || {};
    for (const r of t) {
      const o = r.plugin, a = o[i], l = [
        n,
        s,
        r.options
      ];
      if (wt(a, l, o) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    dt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const i = t && t.config, s = nt(i.options && i.options.plugins, {}), r = Dv(i);
    return s === !1 && !n ? [] : Tv(t, r, s, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], i = this._cache, s = (r, o) => r.filter((a) => !o.some((l) => a.plugin.id === l.plugin.id));
    this._notify(s(n, i), t, "stop"), this._notify(s(i, n), t, "start");
  }
}
function Dv(e) {
  const t = {}, n = [], i = Object.keys(xe.plugins.items);
  for (let r = 0; r < i.length; r++)
    n.push(xe.getPlugin(i[r]));
  const s = e.plugins || [];
  for (let r = 0; r < s.length; r++) {
    const o = s[r];
    n.indexOf(o) === -1 && (n.push(o), t[o.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function Ov(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Tv(e, { plugins: t, localIds: n }, i, s) {
  const r = [], o = e.getContext();
  for (const a of t) {
    const l = a.id, c = Ov(i[l], s);
    c !== null && r.push({
      plugin: a,
      options: Ev(e.config, {
        plugin: a,
        local: n[l]
      }, c, o)
    });
  }
  return r;
}
function Ev(e, { plugin: t, local: n }, i, s) {
  const r = e.pluginScopeKeys(t), o = e.getOptionScopes(i, r);
  return n && t.defaults && o.push(t.defaults), e.createResolver(o, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Gr(e, t) {
  const n = At.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function Rv(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function Lv(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Xl(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function Fv(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Kr(e, ...t) {
  if (Xl(e))
    return e;
  for (const n of t) {
    const i = n.axis || Fv(n.position) || e.length > 1 && Xl(e[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Gl(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function Nv(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((i) => i.xAxisID === e || i.yAxisID === e);
    if (n.length)
      return Gl(e, "x", n[0]) || Gl(e, "y", n[0]);
  }
  return {};
}
function zv(e, t) {
  const n = _n[e.type] || {
    scales: {}
  }, i = t.scales || {}, s = Gr(e.type, t), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((o) => {
    const a = i[o];
    if (!ut(a))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const l = Kr(o, a, Nv(o, e), At.scales[a.type]), c = Lv(l, s), d = n.scales || {};
    r[o] = ii(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      d[l],
      d[c]
    ]);
  }), e.data.datasets.forEach((o) => {
    const a = o.type || e.type, l = o.indexAxis || Gr(a, t), d = (_n[a] || {}).scales || {};
    Object.keys(d).forEach((u) => {
      const h = Rv(u, l), p = o[h + "AxisID"] || h;
      r[p] = r[p] || /* @__PURE__ */ Object.create(null), ii(r[p], [
        {
          axis: h
        },
        i[p],
        d[u]
      ]);
    });
  }), Object.keys(r).forEach((o) => {
    const a = r[o];
    ii(a, [
      At.scales[a.type],
      At.scale
    ]);
  }), r;
}
function ju(e) {
  const t = e.options || (e.options = {});
  t.plugins = nt(t.plugins, {}), t.scales = zv(e, t);
}
function $u(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function Bv(e) {
  return e = e || {}, e.data = $u(e.data), ju(e), e;
}
const Kl = /* @__PURE__ */ new Map(), Vu = /* @__PURE__ */ new Set();
function Hi(e, t) {
  let n = Kl.get(e);
  return n || (n = t(), Kl.set(e, n), Vu.add(n)), n;
}
const Yn = (e, t, n) => {
  const i = Ze(t, n);
  i !== void 0 && e.add(i);
};
class Wv {
  constructor(t) {
    this._config = Bv(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = $u(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), ju(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Hi(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return Hi(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return Hi(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, i = this.type;
    return Hi(`${i}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const i = this._scopeCache;
    let s = i.get(t);
    return (!s || n) && (s = /* @__PURE__ */ new Map(), i.set(t, s)), s;
  }
  getOptionScopes(t, n, i) {
    const { options: s, type: r } = this, o = this._cachedScopes(t, i), a = o.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((d) => {
      t && (l.add(t), d.forEach((u) => Yn(l, t, u))), d.forEach((u) => Yn(l, s, u)), d.forEach((u) => Yn(l, _n[r] || {}, u)), d.forEach((u) => Yn(l, At, u)), d.forEach((u) => Yn(l, Yr, u));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Vu.has(n) && o.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      _n[n] || {},
      At.datasets[n] || {},
      {
        type: n
      },
      At,
      Yr
    ];
  }
  resolveNamedOptions(t, n, i, s = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: o, subPrefixes: a } = Ql(this._resolverCache, t, s);
    let l = o;
    if ($v(o, n)) {
      r.$shared = !1, i = Je(i) ? i() : i;
      const c = this.createResolver(t, i, a);
      l = Ln(o, i, c);
    }
    for (const c of n)
      r[c] = l[c];
    return r;
  }
  createResolver(t, n, i = [
    ""
  ], s) {
    const { resolver: r } = Ql(this._resolverCache, t, i);
    return ut(n) ? Ln(r, n, void 0, s) : r;
  }
}
function Ql(e, t, n) {
  let i = e.get(t);
  i || (i = /* @__PURE__ */ new Map(), e.set(t, i));
  const s = n.join();
  let r = i.get(s);
  return r || (r = {
    resolver: Yo(t, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, i.set(s, r)), r;
}
const jv = (e) => ut(e) && Object.getOwnPropertyNames(e).some((t) => Je(e[t]));
function $v(e, t) {
  const { isScriptable: n, isIndexable: i } = _u(e);
  for (const s of t) {
    const r = n(s), o = i(s), a = (o || r) && e[s];
    if (r && (Je(a) || jv(a)) || o && Pt(a))
      return !0;
  }
  return !1;
}
var Vv = "4.5.1";
const Hv = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Zl(e, t) {
  return e === "top" || e === "bottom" || Hv.indexOf(e) === -1 && t === "x";
}
function Jl(e, t) {
  return function(n, i) {
    return n[e] === i[e] ? n[t] - i[t] : n[e] - i[e];
  };
}
function tc(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), wt(n && n.onComplete, [
    e
  ], t);
}
function Uv(e) {
  const t = e.chart, n = t.options.animation;
  wt(n && n.onProgress, [
    e
  ], t);
}
function Hu(e) {
  return Go() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const rs = {}, ec = (e) => {
  const t = Hu(e);
  return Object.values(rs).filter((n) => n.canvas === t).pop();
};
function Yv(e, t, n) {
  const i = Object.keys(e);
  for (const s of i) {
    const r = +s;
    if (r >= t) {
      const o = e[s];
      delete e[s], (n > 0 || r > t) && (e[r + n] = o);
    }
  }
}
function qv(e, t, n, i) {
  return !n || e.type === "mouseout" ? null : i ? t : e;
}
class Oe {
  static register(...t) {
    xe.add(...t), nc();
  }
  static unregister(...t) {
    xe.remove(...t), nc();
  }
  constructor(t, n) {
    const i = this.config = new Wv(n), s = Hu(t), r = ec(s);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const o = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || uv(s))(), this.platform.updateConfig(i);
    const a = this.platform.acquireContext(s, o.aspectRatio), l = a && a.canvas, c = l && l.height, d = l && l.width;
    if (this.id = Xb(), this.ctx = a, this.canvas = l, this.width = d, this.height = c, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Iv(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = uy((u) => this.update(u), o.resizeDelay || 0), this._dataChanges = [], rs[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Me.listen(this, "complete", tc), Me.listen(this, "progress", Uv), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: i, height: s, _aspectRatio: r } = this;
    return dt(t) ? n && r ? r : s ? i / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return xe;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Cl(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return _l(this.canvas, this.ctx), this;
  }
  stop() {
    return Me.stop(this), this;
  }
  resize(t, n) {
    Me.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const i = this.options, s = this.canvas, r = i.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(s, t, n, r), a = i.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, Cl(this, a, !0) && (this.notifyPlugins("resize", {
      size: o
    }), wt(i.onResize, [
      this,
      o
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    xt(n, (i, s) => {
      i.id = s;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, i = this.scales, s = Object.keys(i).reduce((o, a) => (o[a] = !1, o), {});
    let r = [];
    n && (r = r.concat(Object.keys(n).map((o) => {
      const a = n[o], l = Kr(o, a), c = l === "r", d = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : d ? "bottom" : "left",
        dtype: c ? "radialLinear" : d ? "category" : "linear"
      };
    }))), xt(r, (o) => {
      const a = o.options, l = a.id, c = Kr(l, a), d = nt(a.type, o.dtype);
      (a.position === void 0 || Zl(a.position, c) !== Zl(o.dposition)) && (a.position = o.dposition), s[l] = !0;
      let u = null;
      if (l in i && i[l].type === d)
        u = i[l];
      else {
        const h = xe.getScale(d);
        u = new h({
          id: l,
          type: d,
          ctx: this.ctx,
          chart: this
        }), i[u.id] = u;
      }
      u.init(a, t);
    }), xt(s, (o, a) => {
      o || delete i[a];
    }), xt(i, (o) => {
      Yt.configure(this, o, o.options), Yt.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, i = t.length;
    if (t.sort((s, r) => s.index - r.index), i > n) {
      for (let s = n; s < i; ++s)
        this._destroyDatasetMeta(s);
      t.splice(n, i - n);
    }
    this._sortedMetasets = t.slice(0).sort(Jl("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((i, s) => {
      n.filter((r) => r === i._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let i, s;
    for (this._removeUnreferencedMetasets(), i = 0, s = n.length; i < s; i++) {
      const r = n[i];
      let o = this.getDatasetMeta(i);
      const a = r.type || this.config.type;
      if (o.type && o.type !== a && (this._destroyDatasetMeta(i), o = this.getDatasetMeta(i)), o.type = a, o.indexAxis = r.indexAxis || Gr(a, this.options), o.order = r.order || 0, o.index = i, o.label = "" + r.label, o.visible = this.isDatasetVisible(i), o.controller)
        o.controller.updateIndex(i), o.controller.linkScales();
      else {
        const l = xe.getController(a), { datasetElementType: c, dataElementType: d } = At.datasets[a];
        Object.assign(l, {
          dataElementType: xe.getElement(d),
          datasetElementType: c && xe.getElement(c)
        }), o.controller = new l(this, i), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    xt(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const i = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let c = 0, d = this.data.datasets.length; c < d; c++) {
      const { controller: u } = this.getDatasetMeta(c), h = !s && r.indexOf(u) === -1;
      u.buildOrUpdateElements(h), o = Math.max(+u.getMaxOverflow(), o);
    }
    o = this._minPadding = i.layout.autoPadding ? o : 0, this._updateLayout(o), s || xt(r, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Jl("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    xt(this.scales, (t) => {
      Yt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!fl(n, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: i, start: s, count: r } of n) {
      const o = i === "_removeElements" ? -r : r;
      Yv(t, s, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, i = (r) => new Set(t.filter((o) => o[0] === r).map((o, a) => a + "," + o.splice(1).join(","))), s = i(0);
    for (let r = 1; r < n; r++)
      if (!fl(s, i(r)))
        return;
    return Array.from(s).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Yt.update(this, this.width, this.height, t);
    const n = this.chartArea, i = n.width <= 0 || n.height <= 0;
    this._layers = [], xt(this.boxes, (s) => {
      i && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, r) => {
      s._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this._updateDataset(n, Je(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const i = this.getDatasetMeta(t), s = {
      meta: i,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (i.controller._update(n), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Me.has(this) ? this.attached && !Me.running(this) && Me.start(this) : (this.draw(), tc({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: s } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(i, s);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, i = [];
    let s, r;
    for (s = 0, r = n.length; s < r; ++s) {
      const o = n[s];
      (!t || o.visible) && i.push(o);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, i = {
      meta: t,
      index: t.index,
      cancelable: !0
    }, s = Tu(this, t);
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (s && Bs(n, s), t.controller.draw(), s && Ws(n), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return Re(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, i, s) {
    const r = Hx.modes[n];
    return typeof r == "function" ? r(this, t, i, s) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], i = this._metasets;
    let s = i.filter((r) => r && r._dataset === n).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, i.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = en(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const i = this.getDatasetMeta(t);
    i.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, i) {
    const s = i ? "show" : "hide", r = this.getDatasetMeta(t), o = r.controller._resolveAnimations(void 0, s);
    gi(n) ? (r.data[n].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), o.update(r, {
      visible: i
    }), this.update((a) => a.datasetIndex === t ? s : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), Me.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), _l(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete rs[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, i = (r, o) => {
      n.addEventListener(this, r, o), t[r] = o;
    }, s = (r, o, a) => {
      r.offsetX = o, r.offsetY = a, this._eventHandler(r);
    };
    xt(this.options.events, (r) => i(r, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, i = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, s = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, r = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let o;
    const a = () => {
      s("attach", a), this.attached = !0, this.resize(), i("resize", r), i("detach", o);
    };
    o = () => {
      this.attached = !1, s("resize", r), this._stop(), this._resize(0, 0), i("attach", a);
    }, n.isAttached(this.canvas) ? a() : o();
  }
  unbindEvents() {
    xt(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, xt(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, i) {
    const s = i ? "set" : "remove";
    let r, o, a, l;
    for (n === "dataset" && (r = this.getDatasetMeta(t[0].datasetIndex), r.controller["_" + s + "DatasetHoverStyle"]()), a = 0, l = t.length; a < l; ++a) {
      o = t[a];
      const c = o && this.getDatasetMeta(o.datasetIndex).controller;
      c && c[s + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], i = t.map(({ datasetIndex: r, index: o }) => {
      const a = this.getDatasetMeta(r);
      if (!a)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: a.data[o],
        index: o
      };
    });
    !vs(i, n) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, n));
  }
  notifyPlugins(t, n, i) {
    return this._plugins.notify(this, t, n, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, i) {
    const s = this.options.hover, r = (l, c) => l.filter((d) => !c.some((u) => d.datasetIndex === u.datasetIndex && d.index === u.index)), o = r(n, t), a = i ? t : r(t, n);
    o.length && this.updateHoverStyle(o, s.mode, !1), a.length && s.mode && this.updateHoverStyle(a, s.mode, !0);
  }
  _eventHandler(t, n) {
    const i = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, s) === !1)
      return;
    const r = this._handleEvent(t, n, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, s), (r || i.changed) && this.render(), this;
  }
  _handleEvent(t, n, i) {
    const { _active: s = [], options: r } = this, o = n, a = this._getActiveElements(t, s, i, o), l = ty(t), c = qv(t, this._lastEvent, i, l);
    i && (this._lastEvent = null, wt(r.onHover, [
      t,
      a,
      this
    ], this), l && wt(r.onClick, [
      t,
      a,
      this
    ], this));
    const d = !vs(a, s);
    return (d || n) && (this._active = a, this._updateHoverStyles(a, s, n)), this._lastEvent = c, d;
  }
  _getActiveElements(t, n, i, s) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(t, r.mode, r, s);
  }
}
E(Oe, "defaults", At), E(Oe, "instances", rs), E(Oe, "overrides", _n), E(Oe, "registry", xe), E(Oe, "version", Vv), E(Oe, "getChart", ec);
function nc() {
  return xt(Oe.instances, (e) => e._plugins.invalidate());
}
function Xv(e, t, n) {
  const { startAngle: i, x: s, y: r, outerRadius: o, innerRadius: a, options: l } = t, { borderWidth: c, borderJoinStyle: d } = l, u = Math.min(c / o, Ut(i - n));
  if (e.beginPath(), e.arc(s, r, o - c / 2, i + u / 2, n - u / 2), a > 0) {
    const h = Math.min(c / a, Ut(i - n));
    e.arc(s, r, a + c / 2, n - h / 2, i + h / 2, !0);
  } else {
    const h = Math.min(c / 2, o * Ut(i - n));
    if (d === "round")
      e.arc(s, r, h, n - pt / 2, i + pt / 2, !0);
    else if (d === "bevel") {
      const p = 2 * h * h, m = -p * Math.cos(n + pt / 2) + s, g = -p * Math.sin(n + pt / 2) + r, b = p * Math.cos(i + pt / 2) + s, y = p * Math.sin(i + pt / 2) + r;
      e.lineTo(m, g), e.lineTo(b, y);
    }
  }
  e.closePath(), e.moveTo(0, 0), e.rect(0, 0, e.canvas.width, e.canvas.height), e.clip("evenodd");
}
function Gv(e, t, n) {
  const { startAngle: i, pixelMargin: s, x: r, y: o, outerRadius: a, innerRadius: l } = t;
  let c = s / a;
  e.beginPath(), e.arc(r, o, a, i - c, n + c), l > s ? (c = s / l, e.arc(r, o, l, n + c, i - c, !0)) : e.arc(r, o, s, n + Lt, i - Lt), e.closePath(), e.clip();
}
function Kv(e) {
  return Uo(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Qv(e, t, n, i) {
  const s = Kv(e.options.borderRadius), r = (n - t) / 2, o = Math.min(r, i * t / 2), a = (l) => {
    const c = (n - Math.min(r, l)) * i / 2;
    return jt(l, 0, Math.min(r, c));
  };
  return {
    outerStart: a(s.outerStart),
    outerEnd: a(s.outerEnd),
    innerStart: jt(s.innerStart, 0, o),
    innerEnd: jt(s.innerEnd, 0, o)
  };
}
function kn(e, t, n, i) {
  return {
    x: n + e * Math.cos(t),
    y: i + e * Math.sin(t)
  };
}
function Ps(e, t, n, i, s, r) {
  const { x: o, y: a, startAngle: l, pixelMargin: c, innerRadius: d } = t, u = Math.max(t.outerRadius + i + n - c, 0), h = d > 0 ? d + i + n + c : 0;
  let p = 0;
  const m = s - l;
  if (i) {
    const B = d > 0 ? d - i : 0, X = u > 0 ? u - i : 0, G = (B + X) / 2, st = G !== 0 ? m * G / (G + i) : m;
    p = (m - st) / 2;
  }
  const g = Math.max(1e-3, m * u - n / pt) / u, b = (m - g) / 2, y = l + b + p, x = s - b - p, { outerStart: w, outerEnd: S, innerStart: v, innerEnd: _ } = Qv(t, h, u, x - y), C = u - w, P = u - S, I = y + w / C, V = x - S / P, $ = h + v, T = h + _, j = y + v / $, q = x - _ / T;
  if (e.beginPath(), r) {
    const B = (I + V) / 2;
    if (e.arc(o, a, u, I, B), e.arc(o, a, u, B, V), S > 0) {
      const rt = kn(P, V, o, a);
      e.arc(rt.x, rt.y, S, V, x + Lt);
    }
    const X = kn(T, x, o, a);
    if (e.lineTo(X.x, X.y), _ > 0) {
      const rt = kn(T, q, o, a);
      e.arc(rt.x, rt.y, _, x + Lt, q + Math.PI);
    }
    const G = (x - _ / h + (y + v / h)) / 2;
    if (e.arc(o, a, h, x - _ / h, G, !0), e.arc(o, a, h, G, y + v / h, !0), v > 0) {
      const rt = kn($, j, o, a);
      e.arc(rt.x, rt.y, v, j + Math.PI, y - Lt);
    }
    const st = kn(C, y, o, a);
    if (e.lineTo(st.x, st.y), w > 0) {
      const rt = kn(C, I, o, a);
      e.arc(rt.x, rt.y, w, y - Lt, I);
    }
  } else {
    e.moveTo(o, a);
    const B = Math.cos(I) * u + o, X = Math.sin(I) * u + a;
    e.lineTo(B, X);
    const G = Math.cos(V) * u + o, st = Math.sin(V) * u + a;
    e.lineTo(G, st);
  }
  e.closePath();
}
function Zv(e, t, n, i, s) {
  const { fullCircles: r, startAngle: o, circumference: a } = t;
  let l = t.endAngle;
  if (r) {
    Ps(e, t, n, i, l, s);
    for (let c = 0; c < r; ++c)
      e.fill();
    isNaN(a) || (l = o + (a % Ct || Ct));
  }
  return Ps(e, t, n, i, l, s), e.fill(), l;
}
function Jv(e, t, n, i, s) {
  const { fullCircles: r, startAngle: o, circumference: a, options: l } = t, { borderWidth: c, borderJoinStyle: d, borderDash: u, borderDashOffset: h, borderRadius: p } = l, m = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(u || []), e.lineDashOffset = h, m ? (e.lineWidth = c * 2, e.lineJoin = d || "round") : (e.lineWidth = c, e.lineJoin = d || "bevel");
  let g = t.endAngle;
  if (r) {
    Ps(e, t, n, i, g, s);
    for (let b = 0; b < r; ++b)
      e.stroke();
    isNaN(a) || (g = o + (a % Ct || Ct));
  }
  m && Gv(e, t, g), l.selfJoin && g - o >= pt && p === 0 && d !== "miter" && Xv(e, t, g), r || (Ps(e, t, n, i, g, s), e.stroke());
}
class Qn extends ge {
  constructor(n) {
    super();
    E(this, "circumference");
    E(this, "endAngle");
    E(this, "fullCircles");
    E(this, "innerRadius");
    E(this, "outerRadius");
    E(this, "pixelMargin");
    E(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, i, s) {
    const r = this.getProps([
      "x",
      "y"
    ], s), { angle: o, distance: a } = uu(r, {
      x: n,
      y: i
    }), { startAngle: l, endAngle: c, innerRadius: d, outerRadius: u, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], s), p = (this.options.spacing + this.options.borderWidth) / 2, m = nt(h, c - l), g = mi(o, l, c) && l !== c, b = m >= Ct || g, y = Te(a, d + p, u + p);
    return b && y;
  }
  getCenterPoint(n) {
    const { x: i, y: s, startAngle: r, endAngle: o, innerRadius: a, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: d } = this.options, u = (r + o) / 2, h = (a + l + d + c) / 2;
    return {
      x: i + Math.cos(u) * h,
      y: s + Math.sin(u) * h
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: i, circumference: s } = this, r = (i.offset || 0) / 4, o = (i.spacing || 0) / 2, a = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = s > Ct ? Math.floor(s / Ct) : 0, s === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * r, Math.sin(l) * r);
    const c = 1 - Math.sin(Math.min(pt, s || 0)), d = r * c;
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, Zv(n, this, d, o, a), Jv(n, this, d, o, a), n.restore();
  }
}
E(Qn, "id", "arc"), E(Qn, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0,
  selfJoin: !1
}), E(Qn, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), E(Qn, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function Uu(e, t, n = t) {
  e.lineCap = nt(n.borderCapStyle, t.borderCapStyle), e.setLineDash(nt(n.borderDash, t.borderDash)), e.lineDashOffset = nt(n.borderDashOffset, t.borderDashOffset), e.lineJoin = nt(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = nt(n.borderWidth, t.borderWidth), e.strokeStyle = nt(n.borderColor, t.borderColor);
}
function t1(e, t, n) {
  e.lineTo(n.x, n.y);
}
function e1(e) {
  return e.stepped ? Sy : e.tension || e.cubicInterpolationMode === "monotone" ? Cy : t1;
}
function Yu(e, t, n = {}) {
  const i = e.length, { start: s = 0, end: r = i - 1 } = n, { start: o, end: a } = t, l = Math.max(s, o), c = Math.min(r, a), d = s < o && r < o || s > a && r > a;
  return {
    count: i,
    start: l,
    loop: t.loop,
    ilen: c < l && !d ? i + c - l : c - l
  };
}
function n1(e, t, n, i) {
  const { points: s, options: r } = t, { count: o, start: a, loop: l, ilen: c } = Yu(s, n, i), d = e1(r);
  let { move: u = !0, reverse: h } = i || {}, p, m, g;
  for (p = 0; p <= c; ++p)
    m = s[(a + (h ? c - p : p)) % o], !m.skip && (u ? (e.moveTo(m.x, m.y), u = !1) : d(e, g, m, h, r.stepped), g = m);
  return l && (m = s[(a + (h ? c : 0)) % o], d(e, g, m, h, r.stepped)), !!l;
}
function i1(e, t, n, i) {
  const s = t.points, { count: r, start: o, ilen: a } = Yu(s, n, i), { move: l = !0, reverse: c } = i || {};
  let d = 0, u = 0, h, p, m, g, b, y;
  const x = (S) => (o + (c ? a - S : S)) % r, w = () => {
    g !== b && (e.lineTo(d, b), e.lineTo(d, g), e.lineTo(d, y));
  };
  for (l && (p = s[x(0)], e.moveTo(p.x, p.y)), h = 0; h <= a; ++h) {
    if (p = s[x(h)], p.skip)
      continue;
    const S = p.x, v = p.y, _ = S | 0;
    _ === m ? (v < g ? g = v : v > b && (b = v), d = (u * d + S) / ++u) : (w(), e.lineTo(S, v), m = _, u = 0, g = b = v), y = v;
  }
  w();
}
function Qr(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? i1 : n1;
}
function s1(e) {
  return e.stepped ? nx : e.tension || e.cubicInterpolationMode === "monotone" ? ix : hn;
}
function r1(e, t, n, i) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, n, i) && s.closePath()), Uu(e, t.options), e.stroke(s);
}
function o1(e, t, n, i) {
  const { segments: s, options: r } = t, o = Qr(t);
  for (const a of s)
    Uu(e, r, a.style), e.beginPath(), o(e, t, a, {
      start: n,
      end: n + i - 1
    }) && e.closePath(), e.stroke();
}
const a1 = typeof Path2D == "function";
function l1(e, t, n, i) {
  a1 && !t.options.segment ? r1(e, t, n, i) : o1(e, t, n, i);
}
class Ye extends ge {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const s = i.spanGaps ? this._loop : this._fullLoop;
      Xy(this._points, i, t, s, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = cx(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, i = t.length;
    return i && n[t[i - 1].end];
  }
  interpolate(t, n) {
    const i = this.options, s = t[n], r = this.points, o = Ou(this, {
      property: n,
      start: s,
      end: s
    });
    if (!o.length)
      return;
    const a = [], l = s1(i);
    let c, d;
    for (c = 0, d = o.length; c < d; ++c) {
      const { start: u, end: h } = o[c], p = r[u], m = r[h];
      if (p === m) {
        a.push(p);
        continue;
      }
      const g = Math.abs((s - p[n]) / (m[n] - p[n])), b = l(p, m, g, i.stepped);
      b[n] = t[n], a.push(b);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, n, i) {
    return Qr(this)(t, this, n, i);
  }
  path(t, n, i) {
    const s = this.segments, r = Qr(this);
    let o = this._loop;
    n = n || 0, i = i || this.points.length - n;
    for (const a of s)
      o &= r(t, this, a, {
        start: n,
        end: n + i - 1
      });
    return !!o;
  }
  draw(t, n, i, s) {
    const r = this.options || {};
    (this.points || []).length && r.borderWidth && (t.save(), l1(t, this, i, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
E(Ye, "id", "line"), E(Ye, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), E(Ye, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), E(Ye, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function ic(e, t, n, i) {
  const s = e.options, { [n]: r } = e.getProps([
    n
  ], i);
  return Math.abs(t - r) < s.radius + s.hitRadius;
}
class os extends ge {
  constructor(n) {
    super();
    E(this, "parsed");
    E(this, "skip");
    E(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, i, s) {
    const r = this.options, { x: o, y: a } = this.getProps([
      "x",
      "y"
    ], s);
    return Math.pow(n - o, 2) + Math.pow(i - a, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(n, i) {
    return ic(this, n, "x", i);
  }
  inYRange(n, i) {
    return ic(this, n, "y", i);
  }
  getCenterPoint(n) {
    const { x: i, y: s } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: i,
      y: s
    };
  }
  size(n) {
    n = n || this.options || {};
    let i = n.radius || 0;
    i = Math.max(i, i && n.hoverRadius || 0);
    const s = i && n.borderWidth || 0;
    return (i + s) * 2;
  }
  draw(n, i) {
    const s = this.options;
    this.skip || s.radius < 0.1 || !Re(this, i, this.size(s) / 2) || (n.strokeStyle = s.borderColor, n.lineWidth = s.borderWidth, n.fillStyle = s.backgroundColor, qr(n, s, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
E(os, "id", "point"), /**
* @type {any}
*/
E(os, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
E(os, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function qu(e, t) {
  const { x: n, y: i, base: s, width: r, height: o } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let a, l, c, d, u;
  return e.horizontal ? (u = o / 2, a = Math.min(n, s), l = Math.max(n, s), c = i - u, d = i + u) : (u = r / 2, a = n - u, l = n + u, c = Math.min(i, s), d = Math.max(i, s)), {
    left: a,
    top: c,
    right: l,
    bottom: d
  };
}
function qe(e, t, n, i) {
  return e ? 0 : jt(t, n, i);
}
function c1(e, t, n) {
  const i = e.options.borderWidth, s = e.borderSkipped, r = vu(i);
  return {
    t: qe(s.top, r.top, 0, n),
    r: qe(s.right, r.right, 0, t),
    b: qe(s.bottom, r.bottom, 0, n),
    l: qe(s.left, r.left, 0, t)
  };
}
function d1(e, t, n) {
  const { enableBorderRadius: i } = e.getProps([
    "enableBorderRadius"
  ]), s = e.options.borderRadius, r = mn(s), o = Math.min(t, n), a = e.borderSkipped, l = i || ut(s);
  return {
    topLeft: qe(!l || a.top || a.left, r.topLeft, 0, o),
    topRight: qe(!l || a.top || a.right, r.topRight, 0, o),
    bottomLeft: qe(!l || a.bottom || a.left, r.bottomLeft, 0, o),
    bottomRight: qe(!l || a.bottom || a.right, r.bottomRight, 0, o)
  };
}
function u1(e) {
  const t = qu(e), n = t.right - t.left, i = t.bottom - t.top, s = c1(e, n / 2, i / 2), r = d1(e, n / 2, i / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: i,
      radius: r
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: n - s.l - s.r,
      h: i - s.t - s.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, r.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function gr(e, t, n, i) {
  const s = t === null, r = n === null, a = e && !(s && r) && qu(e, i);
  return a && (s || Te(t, a.left, a.right)) && (r || Te(n, a.top, a.bottom));
}
function f1(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function h1(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function mr(e, t, n = {}) {
  const i = e.x !== n.x ? -t : 0, s = e.y !== n.y ? -t : 0, r = (e.x + e.w !== n.x + n.w ? t : 0) - i, o = (e.y + e.h !== n.y + n.h ? t : 0) - s;
  return {
    x: e.x + i,
    y: e.y + s,
    w: e.w + r,
    h: e.h + o,
    radius: e.radius
  };
}
class as extends ge {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: i, backgroundColor: s } } = this, { inner: r, outer: o } = u1(this), a = f1(o.radius) ? bi : h1;
    t.save(), (o.w !== r.w || o.h !== r.h) && (t.beginPath(), a(t, mr(o, n, r)), t.clip(), a(t, mr(r, -n, o)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), a(t, mr(r, n)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, n, i) {
    return gr(this, t, n, i);
  }
  inXRange(t, n) {
    return gr(this, t, null, n);
  }
  inYRange(t, n) {
    return gr(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: i, base: s, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: r ? (n + s) / 2 : n,
      y: r ? i : (i + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
E(as, "id", "bar"), E(as, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), E(as, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var p1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Qn,
  BarElement: as,
  LineElement: Ye,
  PointElement: os
});
const Zr = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], sc = /* @__PURE__ */ Zr.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function Xu(e) {
  return Zr[e % Zr.length];
}
function Gu(e) {
  return sc[e % sc.length];
}
function g1(e, t) {
  return e.borderColor = Xu(t), e.backgroundColor = Gu(t), ++t;
}
function m1(e, t) {
  return e.backgroundColor = e.data.map(() => Xu(t++)), t;
}
function b1(e, t) {
  return e.backgroundColor = e.data.map(() => Gu(t++)), t;
}
function y1(e) {
  let t = 0;
  return (n, i) => {
    const s = e.getDatasetMeta(i).controller;
    s instanceof gn ? t = m1(n, t) : s instanceof ai ? t = b1(n, t) : s && (t = g1(n, t));
  };
}
function rc(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function x1(e) {
  return e && (e.borderColor || e.backgroundColor);
}
function v1() {
  return At.borderColor !== "rgba(0,0,0,0.1)" || At.backgroundColor !== "rgba(0,0,0,0.1)";
}
var _1 = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: i }, options: s } = e.config, { elements: r } = s, o = rc(i) || x1(s) || r && rc(r) || v1();
    if (!n.forceOverride && o)
      return;
    const a = y1(e);
    i.forEach(a);
  }
};
function w1(e, t, n, i, s) {
  const r = s.samples || i;
  if (r >= n)
    return e.slice(t, t + n);
  const o = [], a = (n - 2) / (r - 2);
  let l = 0;
  const c = t + n - 1;
  let d = t, u, h, p, m, g;
  for (o[l++] = e[d], u = 0; u < r - 2; u++) {
    let b = 0, y = 0, x;
    const w = Math.floor((u + 1) * a) + 1 + t, S = Math.min(Math.floor((u + 2) * a) + 1, n) + t, v = S - w;
    for (x = w; x < S; x++)
      b += e[x].x, y += e[x].y;
    b /= v, y /= v;
    const _ = Math.floor(u * a) + 1 + t, C = Math.min(Math.floor((u + 1) * a) + 1, n) + t, { x: P, y: I } = e[d];
    for (p = m = -1, x = _; x < C; x++)
      m = 0.5 * Math.abs((P - b) * (e[x].y - I) - (P - e[x].x) * (y - I)), m > p && (p = m, h = e[x], g = x);
    o[l++] = h, d = g;
  }
  return o[l++] = e[c], o;
}
function S1(e, t, n, i) {
  let s = 0, r = 0, o, a, l, c, d, u, h, p, m, g;
  const b = [], y = t + n - 1, x = e[t].x, S = e[y].x - x;
  for (o = t; o < t + n; ++o) {
    a = e[o], l = (a.x - x) / S * i, c = a.y;
    const v = l | 0;
    if (v === d)
      c < m ? (m = c, u = o) : c > g && (g = c, h = o), s = (r * s + a.x) / ++r;
    else {
      const _ = o - 1;
      if (!dt(u) && !dt(h)) {
        const C = Math.min(u, h), P = Math.max(u, h);
        C !== p && C !== _ && b.push({
          ...e[C],
          x: s
        }), P !== p && P !== _ && b.push({
          ...e[P],
          x: s
        });
      }
      o > 0 && _ !== p && b.push(e[_]), b.push(a), d = v, r = 0, m = g = c, u = h = p = o;
    }
  }
  return b;
}
function Ku(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function oc(e) {
  e.data.datasets.forEach((t) => {
    Ku(t);
  });
}
function C1(e, t) {
  const n = t.length;
  let i = 0, s;
  const { iScale: r } = e, { min: o, max: a, minDefined: l, maxDefined: c } = r.getUserBounds();
  return l && (i = jt(Ee(t, r.axis, o).lo, 0, n - 1)), c ? s = jt(Ee(t, r.axis, a).hi + 1, i, n) - i : s = n - i, {
    start: i,
    count: s
  };
}
var k1 = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      oc(e);
      return;
    }
    const i = e.width;
    e.data.datasets.forEach((s, r) => {
      const { _data: o, indexAxis: a } = s, l = e.getDatasetMeta(r), c = o || s.data;
      if (Gn([
        a,
        e.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const d = e.scales[l.xAxisID];
      if (d.type !== "linear" && d.type !== "time" || e.options.parsing)
        return;
      let { start: u, count: h } = C1(l, c);
      const p = n.threshold || 4 * i;
      if (h <= p) {
        Ku(s);
        return;
      }
      dt(o) && (s._data = c, delete s.data, Object.defineProperty(s, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(g) {
          this._data = g;
        }
      }));
      let m;
      switch (n.algorithm) {
        case "lttb":
          m = w1(c, u, h, i, n);
          break;
        case "min-max":
          m = S1(c, u, h, i);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      s._decimated = m;
    });
  },
  destroy(e) {
    oc(e);
  }
};
function P1(e, t, n) {
  const i = e.segments, s = e.points, r = t.points, o = [];
  for (const a of i) {
    let { start: l, end: c } = a;
    c = Vs(l, c, s);
    const d = Jr(n, s[l], s[c], a.loop);
    if (!t.segments) {
      o.push({
        source: a,
        target: d,
        start: s[l],
        end: s[c]
      });
      continue;
    }
    const u = Ou(t, d);
    for (const h of u) {
      const p = Jr(n, r[h.start], r[h.end], h.loop), m = Du(a, s, p);
      for (const g of m)
        o.push({
          source: g,
          target: h,
          start: {
            [n]: ac(d, p, "start", Math.max)
          },
          end: {
            [n]: ac(d, p, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function Jr(e, t, n, i) {
  if (i)
    return;
  let s = t[e], r = n[e];
  return e === "angle" && (s = Ut(s), r = Ut(r)), {
    property: e,
    start: s,
    end: r
  };
}
function A1(e, t) {
  const { x: n = null, y: i = null } = e || {}, s = t.points, r = [];
  return t.segments.forEach(({ start: o, end: a }) => {
    a = Vs(o, a, s);
    const l = s[o], c = s[a];
    i !== null ? (r.push({
      x: l.x,
      y: i
    }), r.push({
      x: c.x,
      y: i
    })) : n !== null && (r.push({
      x: n,
      y: l.y
    }), r.push({
      x: n,
      y: c.y
    }));
  }), r;
}
function Vs(e, t, n) {
  for (; t > e; t--) {
    const i = n[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function ac(e, t, n, i) {
  return e && t ? i(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function Qu(e, t) {
  let n = [], i = !1;
  return Pt(e) ? (i = !0, n = e) : n = A1(e, t), n.length ? new Ye({
    points: n,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function lc(e) {
  return e && e.fill !== !1;
}
function M1(e, t, n) {
  let s = e[t].fill;
  const r = [
    t
  ];
  let o;
  if (!n)
    return s;
  for (; s !== !1 && r.indexOf(s) === -1; ) {
    if (!Ot(s))
      return s;
    if (o = e[s], !o)
      return !1;
    if (o.visible)
      return s;
    r.push(s), s = o.fill;
  }
  return !1;
}
function I1(e, t, n) {
  const i = E1(e);
  if (ut(i))
    return isNaN(i.value) ? !1 : i;
  let s = parseFloat(i);
  return Ot(s) && Math.floor(s) === s ? D1(i[0], t, s, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function D1(e, t, n, i) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= i ? !1 : n;
}
function O1(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : ut(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function T1(e, t, n) {
  let i;
  return e === "start" ? i = n : e === "end" ? i = t.options.reverse ? t.min : t.max : ut(e) ? i = e.value : i = t.getBaseValue(), i;
}
function E1(e) {
  const t = e.options, n = t.fill;
  let i = nt(n && n.target, n);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function R1(e) {
  const { scale: t, index: n, line: i } = e, s = [], r = i.segments, o = i.points, a = L1(t, n);
  a.push(Qu({
    x: null,
    y: t.bottom
  }, i));
  for (let l = 0; l < r.length; l++) {
    const c = r[l];
    for (let d = c.start; d <= c.end; d++)
      F1(s, o[d], a);
  }
  return new Ye({
    points: s,
    options: {}
  });
}
function L1(e, t) {
  const n = [], i = e.getMatchingVisibleMetas("line");
  for (let s = 0; s < i.length; s++) {
    const r = i[s];
    if (r.index === t)
      break;
    r.hidden || n.unshift(r.dataset);
  }
  return n;
}
function F1(e, t, n) {
  const i = [];
  for (let s = 0; s < n.length; s++) {
    const r = n[s], { first: o, last: a, point: l } = N1(r, t, "x");
    if (!(!l || o && a)) {
      if (o)
        i.unshift(l);
      else if (e.push(l), !a)
        break;
    }
  }
  e.push(...i);
}
function N1(e, t, n) {
  const i = e.interpolate(t, n);
  if (!i)
    return {};
  const s = i[n], r = e.segments, o = e.points;
  let a = !1, l = !1;
  for (let c = 0; c < r.length; c++) {
    const d = r[c], u = o[d.start][n], h = o[d.end][n];
    if (Te(s, u, h)) {
      a = s === u, l = s === h;
      break;
    }
  }
  return {
    first: a,
    last: l,
    point: i
  };
}
class Zu {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, i) {
    const { x: s, y: r, radius: o } = this;
    return n = n || {
      start: 0,
      end: Ct
    }, t.arc(s, r, o, n.end, n.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: n, y: i, radius: s } = this, r = t.angle;
    return {
      x: n + Math.cos(r) * s,
      y: i + Math.sin(r) * s,
      angle: r
    };
  }
}
function z1(e) {
  const { chart: t, fill: n, line: i } = e;
  if (Ot(n))
    return B1(t, n);
  if (n === "stack")
    return R1(e);
  if (n === "shape")
    return !0;
  const s = W1(e);
  return s instanceof Zu ? s : Qu(s, i);
}
function B1(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function W1(e) {
  return (e.scale || {}).getPointPositionForValue ? $1(e) : j1(e);
}
function j1(e) {
  const { scale: t = {}, fill: n } = e, i = O1(n, t);
  if (Ot(i)) {
    const s = t.isHorizontal();
    return {
      x: s ? i : null,
      y: s ? null : i
    };
  }
  return null;
}
function $1(e) {
  const { scale: t, fill: n } = e, i = t.options, s = t.getLabels().length, r = i.reverse ? t.max : t.min, o = T1(n, t, r), a = [];
  if (i.grid.circular) {
    const l = t.getPointPositionForValue(0, r);
    return new Zu({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(o)
    });
  }
  for (let l = 0; l < s; ++l)
    a.push(t.getPointPositionForValue(l, o));
  return a;
}
function br(e, t, n) {
  const i = z1(t), { chart: s, index: r, line: o, scale: a, axis: l } = t, c = o.options, d = c.fill, u = c.backgroundColor, { above: h = u, below: p = u } = d || {}, m = s.getDatasetMeta(r), g = Tu(s, m);
  i && o.points.length && (Bs(e, n), V1(e, {
    line: o,
    target: i,
    above: h,
    below: p,
    area: n,
    scale: a,
    axis: l,
    clip: g
  }), Ws(e));
}
function V1(e, t) {
  const { line: n, target: i, above: s, below: r, area: o, scale: a, clip: l } = t, c = n._loop ? "angle" : t.axis;
  e.save();
  let d = r;
  r !== s && (c === "x" ? (cc(e, i, o.top), yr(e, {
    line: n,
    target: i,
    color: s,
    scale: a,
    property: c,
    clip: l
  }), e.restore(), e.save(), cc(e, i, o.bottom)) : c === "y" && (dc(e, i, o.left), yr(e, {
    line: n,
    target: i,
    color: r,
    scale: a,
    property: c,
    clip: l
  }), e.restore(), e.save(), dc(e, i, o.right), d = s)), yr(e, {
    line: n,
    target: i,
    color: d,
    scale: a,
    property: c,
    clip: l
  }), e.restore();
}
function cc(e, t, n) {
  const { segments: i, points: s } = t;
  let r = !0, o = !1;
  e.beginPath();
  for (const a of i) {
    const { start: l, end: c } = a, d = s[l], u = s[Vs(l, c, s)];
    r ? (e.moveTo(d.x, d.y), r = !1) : (e.lineTo(d.x, n), e.lineTo(d.x, d.y)), o = !!t.pathSegment(e, a, {
      move: o
    }), o ? e.closePath() : e.lineTo(u.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function dc(e, t, n) {
  const { segments: i, points: s } = t;
  let r = !0, o = !1;
  e.beginPath();
  for (const a of i) {
    const { start: l, end: c } = a, d = s[l], u = s[Vs(l, c, s)];
    r ? (e.moveTo(d.x, d.y), r = !1) : (e.lineTo(n, d.y), e.lineTo(d.x, d.y)), o = !!t.pathSegment(e, a, {
      move: o
    }), o ? e.closePath() : e.lineTo(n, u.y);
  }
  e.lineTo(n, t.first().y), e.closePath(), e.clip();
}
function yr(e, t) {
  const { line: n, target: i, property: s, color: r, scale: o, clip: a } = t, l = P1(n, i, s);
  for (const { source: c, target: d, start: u, end: h } of l) {
    const { style: { backgroundColor: p = r } = {} } = c, m = i !== !0;
    e.save(), e.fillStyle = p, H1(e, o, a, m && Jr(s, u, h)), e.beginPath();
    const g = !!n.pathSegment(e, c);
    let b;
    if (m) {
      g ? e.closePath() : uc(e, i, h, s);
      const y = !!i.pathSegment(e, d, {
        move: g,
        reverse: !0
      });
      b = g && y, b || uc(e, i, u, s);
    }
    e.closePath(), e.fill(b ? "evenodd" : "nonzero"), e.restore();
  }
}
function H1(e, t, n, i) {
  const s = t.chart.chartArea, { property: r, start: o, end: a } = i || {};
  if (r === "x" || r === "y") {
    let l, c, d, u;
    r === "x" ? (l = o, c = s.top, d = a, u = s.bottom) : (l = s.left, c = o, d = s.right, u = a), e.beginPath(), n && (l = Math.max(l, n.left), d = Math.min(d, n.right), c = Math.max(c, n.top), u = Math.min(u, n.bottom)), e.rect(l, c, d - l, u - c), e.clip();
  }
}
function uc(e, t, n, i) {
  const s = t.interpolate(n, i);
  s && e.lineTo(s.x, s.y);
}
var U1 = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const i = (e.data.datasets || []).length, s = [];
    let r, o, a, l;
    for (o = 0; o < i; ++o)
      r = e.getDatasetMeta(o), a = r.dataset, l = null, a && a.options && a instanceof Ye && (l = {
        visible: e.isDatasetVisible(o),
        index: o,
        fill: I1(a, o, i),
        chart: e,
        axis: r.controller.options.indexAxis,
        scale: r.vScale,
        line: a
      }), r.$filler = l, s.push(l);
    for (o = 0; o < i; ++o)
      l = s[o], !(!l || l.fill === !1) && (l.fill = M1(s, o, n.propagate));
  },
  beforeDraw(e, t, n) {
    const i = n.drawTime === "beforeDraw", s = e.getSortedVisibleDatasetMetas(), r = e.chartArea;
    for (let o = s.length - 1; o >= 0; --o) {
      const a = s[o].$filler;
      a && (a.line.updateControlPoints(r, a.axis), i && a.fill && br(e.ctx, a, r));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const i = e.getSortedVisibleDatasetMetas();
    for (let s = i.length - 1; s >= 0; --s) {
      const r = i[s].$filler;
      lc(r) && br(e.ctx, r, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const i = t.meta.$filler;
    !lc(i) || n.drawTime !== "beforeDatasetDraw" || br(e.ctx, i, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const fc = (e, t) => {
  let { boxHeight: n = t, boxWidth: i = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), i = e.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, Y1 = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class hc extends ge {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, i) {
    this.maxWidth = t, this.maxHeight = n, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = wt(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((i) => t.filter(i, this.chart.data))), t.sort && (n = n.sort((i, s) => t.sort(i, s, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, s = Bt(i.font), r = s.size, o = this._computeTitleHeight(), { boxWidth: a, itemHeight: l } = fc(i, r);
    let c, d;
    n.font = s.string, this.isHorizontal() ? (c = this.maxWidth, d = this._fitRows(o, r, a, l) + 10) : (d = this.maxHeight, c = this._fitCols(o, s, a, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(d, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, i, s) {
    const { ctx: r, maxWidth: o, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], d = s + a;
    let u = t;
    r.textAlign = "left", r.textBaseline = "middle";
    let h = -1, p = -d;
    return this.legendItems.forEach((m, g) => {
      const b = i + n / 2 + r.measureText(m.text).width;
      (g === 0 || c[c.length - 1] + b + 2 * a > o) && (u += d, c[c.length - (g > 0 ? 0 : 1)] = 0, p += d, h++), l[g] = {
        left: 0,
        top: p,
        row: h,
        width: b,
        height: s
      }, c[c.length - 1] += b + a;
    }), u;
  }
  _fitCols(t, n, i, s) {
    const { ctx: r, maxHeight: o, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], d = o - t;
    let u = a, h = 0, p = 0, m = 0, g = 0;
    return this.legendItems.forEach((b, y) => {
      const { itemWidth: x, itemHeight: w } = q1(i, n, r, b, s);
      y > 0 && p + w + 2 * a > d && (u += h + a, c.push({
        width: h,
        height: p
      }), m += h + a, g++, h = p = 0), l[y] = {
        left: m,
        top: p,
        col: g,
        width: x,
        height: w
      }, h = Math.max(h, x), p += w + a;
    }), u += h, c.push({
      width: h,
      height: p
    }), u;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: i, labels: { padding: s }, rtl: r } } = this, o = On(r, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, l = Ht(i, this.left + s, this.right - this.lineWidths[a]);
      for (const c of n)
        a !== c.row && (a = c.row, l = Ht(i, this.left + s, this.right - this.lineWidths[a])), c.top += this.top + t + s, c.left = o.leftForLtr(o.x(l), c.width), l += c.width + s;
    } else {
      let a = 0, l = Ht(i, this.top + t + s, this.bottom - this.columnSizes[a].height);
      for (const c of n)
        c.col !== a && (a = c.col, l = Ht(i, this.top + t + s, this.bottom - this.columnSizes[a].height)), c.top = l, c.left += this.left + s, c.left = o.leftForLtr(o.x(c.left), c.width), l += c.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Bs(t, this), this._draw(), Ws(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: i, ctx: s } = this, { align: r, labels: o } = t, a = At.color, l = On(t.rtl, this.left, this.width), c = Bt(o.font), { padding: d } = o, u = c.size, h = u / 2;
    let p;
    this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = c.string;
    const { boxWidth: m, boxHeight: g, itemHeight: b } = fc(o, u), y = function(_, C, P) {
      if (isNaN(m) || m <= 0 || isNaN(g) || g < 0)
        return;
      s.save();
      const I = nt(P.lineWidth, 1);
      if (s.fillStyle = nt(P.fillStyle, a), s.lineCap = nt(P.lineCap, "butt"), s.lineDashOffset = nt(P.lineDashOffset, 0), s.lineJoin = nt(P.lineJoin, "miter"), s.lineWidth = I, s.strokeStyle = nt(P.strokeStyle, a), s.setLineDash(nt(P.lineDash, [])), o.usePointStyle) {
        const V = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: P.pointStyle,
          rotation: P.rotation,
          borderWidth: I
        }, $ = l.xPlus(_, m / 2), T = C + h;
        xu(s, V, $, T, o.pointStyleWidth && m);
      } else {
        const V = C + Math.max((u - g) / 2, 0), $ = l.leftForLtr(_, m), T = mn(P.borderRadius);
        s.beginPath(), Object.values(T).some((j) => j !== 0) ? bi(s, {
          x: $,
          y: V,
          w: m,
          h: g,
          radius: T
        }) : s.rect($, V, m, g), s.fill(), I !== 0 && s.stroke();
      }
      s.restore();
    }, x = function(_, C, P) {
      wn(s, P.text, _, C + b / 2, c, {
        strikethrough: P.hidden,
        textAlign: l.textAlign(P.textAlign)
      });
    }, w = this.isHorizontal(), S = this._computeTitleHeight();
    w ? p = {
      x: Ht(r, this.left + d, this.right - i[0]),
      y: this.top + d + S,
      line: 0
    } : p = {
      x: this.left + d,
      y: Ht(r, this.top + S + d, this.bottom - n[0].height),
      line: 0
    }, Au(this.ctx, t.textDirection);
    const v = b + d;
    this.legendItems.forEach((_, C) => {
      s.strokeStyle = _.fontColor, s.fillStyle = _.fontColor;
      const P = s.measureText(_.text).width, I = l.textAlign(_.textAlign || (_.textAlign = o.textAlign)), V = m + h + P;
      let $ = p.x, T = p.y;
      l.setWidth(this.width), w ? C > 0 && $ + V + d > this.right && (T = p.y += v, p.line++, $ = p.x = Ht(r, this.left + d, this.right - i[p.line])) : C > 0 && T + v > this.bottom && ($ = p.x = $ + n[p.line].width + d, p.line++, T = p.y = Ht(r, this.top + S + d, this.bottom - n[p.line].height));
      const j = l.x($);
      if (y(j, T, _), $ = fy(I, $ + m + h, w ? $ + V : this.right, t.rtl), x(l.x($), T, _), w)
        p.x += V + d;
      else if (typeof _.text != "string") {
        const q = c.lineHeight;
        p.y += Ju(_, q) + d;
      } else
        p.y += v;
    }), Mu(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, i = Bt(n.font), s = Xt(n.padding);
    if (!n.display)
      return;
    const r = On(t.rtl, this.left, this.width), o = this.ctx, a = n.position, l = i.size / 2, c = s.top + l;
    let d, u = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), d = this.top + c, u = Ht(t.align, u, this.right - h);
    else {
      const m = this.columnSizes.reduce((g, b) => Math.max(g, b.height), 0);
      d = c + Ht(t.align, this.top, this.bottom - m - t.labels.padding - this._computeTitleHeight());
    }
    const p = Ht(a, u, u + h);
    o.textAlign = r.textAlign(Vo(a)), o.textBaseline = "middle", o.strokeStyle = n.color, o.fillStyle = n.color, o.font = i.string, wn(o, n.text, p, d, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = Bt(t.font), i = Xt(t.padding);
    return t.display ? n.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, n) {
    let i, s, r;
    if (Te(t, this.left, this.right) && Te(n, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, i = 0; i < r.length; ++i)
        if (s = r[i], Te(t, s.left, s.left + s.width) && Te(n, s.top, s.top + s.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!K1(t.type, n))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, r = Y1(s, i);
      s && !r && wt(n.onLeave, [
        t,
        s,
        this
      ], this), this._hoveredItem = i, i && !r && wt(n.onHover, [
        t,
        i,
        this
      ], this);
    } else i && wt(n.onClick, [
      t,
      i,
      this
    ], this);
  }
}
function q1(e, t, n, i, s) {
  const r = X1(i, e, t, n), o = G1(s, i, t.lineHeight);
  return {
    itemWidth: r,
    itemHeight: o
  };
}
function X1(e, t, n, i) {
  let s = e.text;
  return s && typeof s != "string" && (s = s.reduce((r, o) => r.length > o.length ? r : o)), t + n.size / 2 + i.measureText(s).width;
}
function G1(e, t, n) {
  let i = e;
  return typeof t.text != "string" && (i = Ju(t, n)), i;
}
function Ju(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function K1(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var Q1 = {
  id: "legend",
  _element: hc,
  start(e, t, n) {
    const i = e.legend = new hc({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Yt.configure(e, i, n), Yt.addBox(e, i);
  },
  stop(e) {
    Yt.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const i = e.legend;
    Yt.configure(e, i, n), i.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const i = t.datasetIndex, s = n.chart;
      s.isDatasetVisible(i) ? (s.hide(i), t.hidden = !0) : (s.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: i, textAlign: s, color: r, useBorderRadius: o, borderRadius: a } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), d = Xt(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: r,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: i || c.pointStyle,
            rotation: c.rotation,
            textAlign: s || c.textAlign,
            borderRadius: o && (a || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class Zo extends ge {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const s = Pt(i.text) ? i.text.length : 1;
    this._padding = Xt(i.padding);
    const r = s * Bt(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: i, bottom: s, right: r, options: o } = this, a = o.align;
    let l = 0, c, d, u;
    return this.isHorizontal() ? (d = Ht(a, i, r), u = n + t, c = r - i) : (o.position === "left" ? (d = i + t, u = Ht(a, s, n), l = pt * -0.5) : (d = r - t, u = Ht(a, n, s), l = pt * 0.5), c = s - n), {
      titleX: d,
      titleY: u,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const i = Bt(n.font), r = i.lineHeight / 2 + this._padding.top, { titleX: o, titleY: a, maxWidth: l, rotation: c } = this._drawArgs(r);
    wn(t, n.text, 0, 0, i, {
      color: n.color,
      maxWidth: l,
      rotation: c,
      textAlign: Vo(n.align),
      textBaseline: "middle",
      translation: [
        o,
        a
      ]
    });
  }
}
function Z1(e, t) {
  const n = new Zo({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  Yt.configure(e, n, t), Yt.addBox(e, n), e.titleBlock = n;
}
var J1 = {
  id: "title",
  _element: Zo,
  start(e, t, n) {
    Z1(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    Yt.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const i = e.titleBlock;
    Yt.configure(e, i, n), i.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ui = /* @__PURE__ */ new WeakMap();
var t_ = {
  id: "subtitle",
  start(e, t, n) {
    const i = new Zo({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Yt.configure(e, i, n), Yt.addBox(e, i), Ui.set(e, i);
  },
  stop(e) {
    Yt.removeBox(e, Ui.get(e)), Ui.delete(e);
  },
  beforeUpdate(e, t, n) {
    const i = Ui.get(e);
    Yt.configure(e, i, n), i.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Zn = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, i = /* @__PURE__ */ new Set(), s = 0, r = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const a = e[t].element;
      if (a && a.hasValue()) {
        const l = a.tooltipPosition();
        i.add(l.x), s += l.y, ++r;
      }
    }
    return r === 0 || i.size === 0 ? !1 : {
      x: [
        ...i
      ].reduce((a, l) => a + l) / i.size,
      y: s / r
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, i = t.y, s = Number.POSITIVE_INFINITY, r, o, a;
    for (r = 0, o = e.length; r < o; ++r) {
      const l = e[r].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), d = Ur(t, c);
        d < s && (s = d, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, i = l.y;
    }
    return {
      x: n,
      y: i
    };
  }
};
function be(e, t) {
  return t && (Pt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function Ie(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function e_(e, t) {
  const { element: n, datasetIndex: i, index: s } = t, r = e.getDatasetMeta(i).controller, { label: o, value: a } = r.getLabelAndValue(s);
  return {
    chart: e,
    label: o,
    parsed: r.getParsed(s),
    raw: e.data.datasets[i].data[s],
    formattedValue: a,
    dataset: r.getDataset(),
    dataIndex: s,
    datasetIndex: i,
    element: n
  };
}
function pc(e, t) {
  const n = e.chart.ctx, { body: i, footer: s, title: r } = e, { boxWidth: o, boxHeight: a } = t, l = Bt(t.bodyFont), c = Bt(t.titleFont), d = Bt(t.footerFont), u = r.length, h = s.length, p = i.length, m = Xt(t.padding);
  let g = m.height, b = 0, y = i.reduce((S, v) => S + v.before.length + v.lines.length + v.after.length, 0);
  if (y += e.beforeBody.length + e.afterBody.length, u && (g += u * c.lineHeight + (u - 1) * t.titleSpacing + t.titleMarginBottom), y) {
    const S = t.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    g += p * S + (y - p) * l.lineHeight + (y - 1) * t.bodySpacing;
  }
  h && (g += t.footerMarginTop + h * d.lineHeight + (h - 1) * t.footerSpacing);
  let x = 0;
  const w = function(S) {
    b = Math.max(b, n.measureText(S).width + x);
  };
  return n.save(), n.font = c.string, xt(e.title, w), n.font = l.string, xt(e.beforeBody.concat(e.afterBody), w), x = t.displayColors ? o + 2 + t.boxPadding : 0, xt(i, (S) => {
    xt(S.before, w), xt(S.lines, w), xt(S.after, w);
  }), x = 0, n.font = d.string, xt(e.footer, w), n.restore(), b += m.width, {
    width: b,
    height: g
  };
}
function n_(e, t) {
  const { y: n, height: i } = t;
  return n < i / 2 ? "top" : n > e.height - i / 2 ? "bottom" : "center";
}
function i_(e, t, n, i) {
  const { x: s, width: r } = i, o = n.caretSize + n.caretPadding;
  if (e === "left" && s + r + o > t.width || e === "right" && s - r - o < 0)
    return !0;
}
function s_(e, t, n, i) {
  const { x: s, width: r } = n, { width: o, chartArea: { left: a, right: l } } = e;
  let c = "center";
  return i === "center" ? c = s <= (a + l) / 2 ? "left" : "right" : s <= r / 2 ? c = "left" : s >= o - r / 2 && (c = "right"), i_(c, e, t, n) && (c = "center"), c;
}
function gc(e, t, n) {
  const i = n.yAlign || t.yAlign || n_(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || s_(e, t, n, i),
    yAlign: i
  };
}
function r_(e, t) {
  let { x: n, width: i } = e;
  return t === "right" ? n -= i : t === "center" && (n -= i / 2), n;
}
function o_(e, t, n) {
  let { y: i, height: s } = e;
  return t === "top" ? i += n : t === "bottom" ? i -= s + n : i -= s / 2, i;
}
function mc(e, t, n, i) {
  const { caretSize: s, caretPadding: r, cornerRadius: o } = e, { xAlign: a, yAlign: l } = n, c = s + r, { topLeft: d, topRight: u, bottomLeft: h, bottomRight: p } = mn(o);
  let m = r_(t, a);
  const g = o_(t, l, c);
  return l === "center" ? a === "left" ? m += c : a === "right" && (m -= c) : a === "left" ? m -= Math.max(d, h) + s : a === "right" && (m += Math.max(u, p) + s), {
    x: jt(m, 0, i.width - t.width),
    y: jt(g, 0, i.height - t.height)
  };
}
function Yi(e, t, n) {
  const i = Xt(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - i.right : e.x + i.left;
}
function bc(e) {
  return be([], Ie(e));
}
function a_(e, t, n) {
  return en(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function yc(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const tf = {
  beforeTitle: Pe,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, i = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: Pe,
  beforeBody: Pe,
  beforeLabel: Pe,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return dt(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: Pe,
  afterBody: Pe,
  beforeFooter: Pe,
  footer: Pe,
  afterFooter: Pe
};
function Kt(e, t, n, i) {
  const s = e[t].call(n, i);
  return typeof s > "u" ? tf[t].call(n, i) : s;
}
class to extends ge {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, i = this.options.setContext(this.getContext()), s = i.enabled && n.options.animation && i.animations, r = new Eu(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = a_(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: i } = n, s = Kt(i, "beforeTitle", this, t), r = Kt(i, "title", this, t), o = Kt(i, "afterTitle", this, t);
    let a = [];
    return a = be(a, Ie(s)), a = be(a, Ie(r)), a = be(a, Ie(o)), a;
  }
  getBeforeBody(t, n) {
    return bc(Kt(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: i } = n, s = [];
    return xt(t, (r) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, a = yc(i, r);
      be(o.before, Ie(Kt(a, "beforeLabel", this, r))), be(o.lines, Kt(a, "label", this, r)), be(o.after, Ie(Kt(a, "afterLabel", this, r))), s.push(o);
    }), s;
  }
  getAfterBody(t, n) {
    return bc(Kt(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: i } = n, s = Kt(i, "beforeFooter", this, t), r = Kt(i, "footer", this, t), o = Kt(i, "afterFooter", this, t);
    let a = [];
    return a = be(a, Ie(s)), a = be(a, Ie(r)), a = be(a, Ie(o)), a;
  }
  _createItems(t) {
    const n = this._active, i = this.chart.data, s = [], r = [], o = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(e_(this.chart, n[l]));
    return t.filter && (a = a.filter((d, u, h) => t.filter(d, u, h, i))), t.itemSort && (a = a.sort((d, u) => t.itemSort(d, u, i))), xt(a, (d) => {
      const u = yc(t.callbacks, d);
      s.push(Kt(u, "labelColor", this, d)), r.push(Kt(u, "labelPointStyle", this, d)), o.push(Kt(u, "labelTextColor", this, d));
    }), this.labelColors = s, this.labelPointStyles = r, this.labelTextColors = o, this.dataPoints = a, a;
  }
  update(t, n) {
    const i = this.options.setContext(this.getContext()), s = this._active;
    let r, o = [];
    if (!s.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const a = Zn[i.position].call(this, s, this._eventPosition);
      o = this._createItems(i), this.title = this.getTitle(o, i), this.beforeBody = this.getBeforeBody(o, i), this.body = this.getBody(o, i), this.afterBody = this.getAfterBody(o, i), this.footer = this.getFooter(o, i);
      const l = this._size = pc(this, i), c = Object.assign({}, a, l), d = gc(this.chart, i, c), u = mc(i, c, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, r = {
        opacity: 1,
        x: u.x,
        y: u.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, r && this._resolveAnimations().update(this, r), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, i, s) {
    const r = this.getCaretPosition(t, i, s);
    n.lineTo(r.x1, r.y1), n.lineTo(r.x2, r.y2), n.lineTo(r.x3, r.y3);
  }
  getCaretPosition(t, n, i) {
    const { xAlign: s, yAlign: r } = this, { caretSize: o, cornerRadius: a } = i, { topLeft: l, topRight: c, bottomLeft: d, bottomRight: u } = mn(a), { x: h, y: p } = t, { width: m, height: g } = n;
    let b, y, x, w, S, v;
    return r === "center" ? (S = p + g / 2, s === "left" ? (b = h, y = b - o, w = S + o, v = S - o) : (b = h + m, y = b + o, w = S - o, v = S + o), x = b) : (s === "left" ? y = h + Math.max(l, d) + o : s === "right" ? y = h + m - Math.max(c, u) - o : y = this.caretX, r === "top" ? (w = p, S = w - o, b = y - o, x = y + o) : (w = p + g, S = w + o, b = y + o, x = y - o), v = w), {
      x1: b,
      x2: y,
      x3: x,
      y1: w,
      y2: S,
      y3: v
    };
  }
  drawTitle(t, n, i) {
    const s = this.title, r = s.length;
    let o, a, l;
    if (r) {
      const c = On(i.rtl, this.x, this.width);
      for (t.x = Yi(this, i.titleAlign, i), n.textAlign = c.textAlign(i.titleAlign), n.textBaseline = "middle", o = Bt(i.titleFont), a = i.titleSpacing, n.fillStyle = i.titleColor, n.font = o.string, l = 0; l < r; ++l)
        n.fillText(s[l], c.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + a, l + 1 === r && (t.y += i.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, n, i, s, r) {
    const o = this.labelColors[i], a = this.labelPointStyles[i], { boxHeight: l, boxWidth: c } = r, d = Bt(r.bodyFont), u = Yi(this, "left", r), h = s.x(u), p = l < d.lineHeight ? (d.lineHeight - l) / 2 : 0, m = n.y + p;
    if (r.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, b = s.leftForLtr(h, c) + c / 2, y = m + l / 2;
      t.strokeStyle = r.multiKeyBackground, t.fillStyle = r.multiKeyBackground, qr(t, g, b, y), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, qr(t, g, b, y);
    } else {
      t.lineWidth = ut(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const g = s.leftForLtr(h, c), b = s.leftForLtr(s.xPlus(h, 1), c - 2), y = mn(o.borderRadius);
      Object.values(y).some((x) => x !== 0) ? (t.beginPath(), t.fillStyle = r.multiKeyBackground, bi(t, {
        x: g,
        y: m,
        w: c,
        h: l,
        radius: y
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), bi(t, {
        x: b,
        y: m + 1,
        w: c - 2,
        h: l - 2,
        radius: y
      }), t.fill()) : (t.fillStyle = r.multiKeyBackground, t.fillRect(g, m, c, l), t.strokeRect(g, m, c, l), t.fillStyle = o.backgroundColor, t.fillRect(b, m + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, n, i) {
    const { body: s } = this, { bodySpacing: r, bodyAlign: o, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: d } = i, u = Bt(i.bodyFont);
    let h = u.lineHeight, p = 0;
    const m = On(i.rtl, this.x, this.width), g = function(P) {
      n.fillText(P, m.x(t.x + p), t.y + h / 2), t.y += h + r;
    }, b = m.textAlign(o);
    let y, x, w, S, v, _, C;
    for (n.textAlign = o, n.textBaseline = "middle", n.font = u.string, t.x = Yi(this, b, i), n.fillStyle = i.bodyColor, xt(this.beforeBody, g), p = a && b !== "right" ? o === "center" ? c / 2 + d : c + 2 + d : 0, S = 0, _ = s.length; S < _; ++S) {
      for (y = s[S], x = this.labelTextColors[S], n.fillStyle = x, xt(y.before, g), w = y.lines, a && w.length && (this._drawColorBox(n, t, S, m, i), h = Math.max(u.lineHeight, l)), v = 0, C = w.length; v < C; ++v)
        g(w[v]), h = u.lineHeight;
      xt(y.after, g);
    }
    p = 0, h = u.lineHeight, xt(this.afterBody, g), t.y -= r;
  }
  drawFooter(t, n, i) {
    const s = this.footer, r = s.length;
    let o, a;
    if (r) {
      const l = On(i.rtl, this.x, this.width);
      for (t.x = Yi(this, i.footerAlign, i), t.y += i.footerMarginTop, n.textAlign = l.textAlign(i.footerAlign), n.textBaseline = "middle", o = Bt(i.footerFont), n.fillStyle = i.footerColor, n.font = o.string, a = 0; a < r; ++a)
        n.fillText(s[a], l.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, n, i, s) {
    const { xAlign: r, yAlign: o } = this, { x: a, y: l } = t, { width: c, height: d } = i, { topLeft: u, topRight: h, bottomLeft: p, bottomRight: m } = mn(s.cornerRadius);
    n.fillStyle = s.backgroundColor, n.strokeStyle = s.borderColor, n.lineWidth = s.borderWidth, n.beginPath(), n.moveTo(a + u, l), o === "top" && this.drawCaret(t, n, i, s), n.lineTo(a + c - h, l), n.quadraticCurveTo(a + c, l, a + c, l + h), o === "center" && r === "right" && this.drawCaret(t, n, i, s), n.lineTo(a + c, l + d - m), n.quadraticCurveTo(a + c, l + d, a + c - m, l + d), o === "bottom" && this.drawCaret(t, n, i, s), n.lineTo(a + p, l + d), n.quadraticCurveTo(a, l + d, a, l + d - p), o === "center" && r === "left" && this.drawCaret(t, n, i, s), n.lineTo(a, l + u), n.quadraticCurveTo(a, l, a + u, l), n.closePath(), n.fill(), s.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, i = this.$animations, s = i && i.x, r = i && i.y;
    if (s || r) {
      const o = Zn[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const a = this._size = pc(this, t), l = Object.assign({}, o, this._size), c = gc(n, t, l), d = mc(t, l, c, n);
      (s._to !== d.x || r._to !== d.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(n);
    const s = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const o = Xt(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (t.save(), t.globalAlpha = i, this.drawBackground(r, t, s, n), Au(t, n.textDirection), r.y += o.top, this.drawTitle(r, t, n), this.drawBody(r, t, n), this.drawFooter(r, t, n), Mu(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const i = this._active, s = t.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), r = !vs(i, s), o = this._positionChanged(s, n);
    (r || o) && (this._active = s, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, i = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, r = this._active || [], o = this._getActiveElements(t, r, n, i), a = this._positionChanged(o, t), l = n || !vs(o, r) || a;
    return l && (this._active = o, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, i, s) {
    const r = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return n.filter((a) => this.chart.data.datasets[a.datasetIndex] && this.chart.getDatasetMeta(a.datasetIndex).controller.getParsed(a.index) !== void 0);
    const o = this.chart.getElementsAtEventForMode(t, r.mode, r, i);
    return r.reverse && o.reverse(), o;
  }
  _positionChanged(t, n) {
    const { caretX: i, caretY: s, options: r } = this, o = Zn[r.position].call(this, t, n);
    return o !== !1 && (i !== o.x || s !== o.y);
  }
}
E(to, "positioners", Zn);
var l_ = {
  id: "tooltip",
  _element: to,
  positioners: Zn,
  afterInit(e, t, n) {
    n && (e.tooltip = new to({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: tf
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, c_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: _1,
  Decimation: k1,
  Filler: U1,
  Legend: Q1,
  SubTitle: t_,
  Title: J1,
  Tooltip: l_
});
const d_ = (e, t, n, i) => (typeof t == "string" ? (n = e.push(t) - 1, i.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function u_(e, t, n, i) {
  const s = e.indexOf(t);
  if (s === -1)
    return d_(e, t, n, i);
  const r = e.lastIndexOf(t);
  return s !== r ? n : s;
}
const f_ = (e, t) => e === null ? null : jt(Math.round(e), 0, t);
function xc(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class eo extends Sn {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const i = this.getLabels();
      for (const { index: s, label: r } of n)
        i[s] === r && i.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (dt(t))
      return null;
    const i = this.getLabels();
    return n = isFinite(n) && i[n] === t ? n : u_(i, t, nt(n, t), this._addedLabels), f_(n, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: i, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), n || (s = this.getLabels().length - 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const t = this.min, n = this.max, i = this.options.offset, s = [];
    let r = this.getLabels();
    r = t === 0 && n === r.length - 1 ? r : r.slice(t, n + 1), this._valueRange = Math.max(r.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let o = t; o <= n; o++)
      s.push({
        value: o
      });
    return s;
  }
  getLabelForValue(t) {
    return xc.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
E(eo, "id", "category"), E(eo, "defaults", {
  ticks: {
    callback: xc
  }
});
function h_(e, t) {
  const n = [], { bounds: s, step: r, min: o, max: a, precision: l, count: c, maxTicks: d, maxDigits: u, includeBounds: h } = e, p = r || 1, m = d - 1, { min: g, max: b } = t, y = !dt(o), x = !dt(a), w = !dt(c), S = (b - g) / (u + 1);
  let v = pl((b - g) / m / p) * p, _, C, P, I;
  if (v < 1e-14 && !y && !x)
    return [
      {
        value: g
      },
      {
        value: b
      }
    ];
  I = Math.ceil(b / v) - Math.floor(g / v), I > m && (v = pl(I * v / m / p) * p), dt(l) || (_ = Math.pow(10, l), v = Math.ceil(v * _) / _), s === "ticks" ? (C = Math.floor(g / v) * v, P = Math.ceil(b / v) * v) : (C = g, P = b), y && x && r && ry((a - o) / r, v / 1e3) ? (I = Math.round(Math.min((a - o) / v, d)), v = (a - o) / I, C = o, P = a) : w ? (C = y ? o : C, P = x ? a : P, I = c - 1, v = (P - C) / I) : (I = (P - C) / v, si(I, Math.round(I), v / 1e3) ? I = Math.round(I) : I = Math.ceil(I));
  const V = Math.max(gl(v), gl(C));
  _ = Math.pow(10, dt(l) ? V : l), C = Math.round(C * _) / _, P = Math.round(P * _) / _;
  let $ = 0;
  for (y && (h && C !== o ? (n.push({
    value: o
  }), C < o && $++, si(Math.round((C + $ * v) * _) / _, o, vc(o, S, e)) && $++) : C < o && $++); $ < I; ++$) {
    const T = Math.round((C + $ * v) * _) / _;
    if (x && T > a)
      break;
    n.push({
      value: T
    });
  }
  return x && h && P !== a ? n.length && si(n[n.length - 1].value, a, vc(a, S, e)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!x || P === a) && n.push({
    value: P
  }), n;
}
function vc(e, t, { horizontal: n, minRotation: i }) {
  const s = he(i), r = (n ? Math.sin(s) : Math.cos(s)) || 1e-3, o = 0.75 * t * ("" + e).length;
  return Math.min(t / r, o);
}
class As extends Sn {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return dt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: i } = this.getUserBounds();
    let { min: s, max: r } = this;
    const o = (l) => s = n ? s : l, a = (l) => r = i ? r : l;
    if (t) {
      const l = Ce(s), c = Ce(r);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && o(0);
    }
    if (s === r) {
      let l = r === 0 ? 1 : Math.abs(r * 0.05);
      a(r + l), t || o(s - l);
    }
    this.min = s, this.max = r;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: i } = t, s;
    return i ? (s = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), n = n || 11), n && (s = Math.min(n, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const s = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, r = this._range || this, o = h_(s, r);
    return t.bounds === "ticks" && du(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (i - n) / Math.max(t.length - 1, 1) / 2;
      n -= s, i += s;
    }
    this._startValue = n, this._endValue = i, this._valueRange = i - n;
  }
  getLabelForValue(t) {
    return Mi(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class no extends As {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Ot(t) ? t : 0, this.max = Ot(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, i = he(this.options.ticks.minRotation), s = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, r.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
E(no, "id", "linear"), E(no, "defaults", {
  ticks: {
    callback: zs.formatters.numeric
  }
});
const xi = (e) => Math.floor(He(e)), un = (e, t) => Math.pow(10, xi(e) + t);
function _c(e) {
  return e / Math.pow(10, xi(e)) === 1;
}
function wc(e, t, n) {
  const i = Math.pow(10, n), s = Math.floor(e / i);
  return Math.ceil(t / i) - s;
}
function p_(e, t) {
  const n = t - e;
  let i = xi(n);
  for (; wc(e, t, i) > 10; )
    i++;
  for (; wc(e, t, i) < 10; )
    i--;
  return Math.min(i, xi(e));
}
function g_(e, { min: t, max: n }) {
  t = Jt(e.min, t);
  const i = [], s = xi(t);
  let r = p_(t, n), o = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
  const a = Math.pow(10, r), l = s > r ? Math.pow(10, s) : 0, c = Math.round((t - l) * o) / o, d = Math.floor((t - l) / a / 10) * a * 10;
  let u = Math.floor((c - d) / Math.pow(10, r)), h = Jt(e.min, Math.round((l + d + u * Math.pow(10, r)) * o) / o);
  for (; h < n; )
    i.push({
      value: h,
      major: _c(h),
      significand: u
    }), u >= 10 ? u = u < 15 ? 15 : 20 : u++, u >= 20 && (r++, u = 2, o = r >= 0 ? 1 : o), h = Math.round((l + d + u * Math.pow(10, r)) * o) / o;
  const p = Jt(e.max, h);
  return i.push({
    value: p,
    major: _c(p),
    significand: u
  }), i;
}
class io extends Sn {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const i = As.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return Ot(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Ot(t) ? Math.max(0, t) : null, this.max = Ot(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Ot(this._userMin) && (this.min = t === un(this.min, 0) ? un(this.min, -1) : un(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let i = this.min, s = this.max;
    const r = (a) => i = t ? i : a, o = (a) => s = n ? s : a;
    i === s && (i <= 0 ? (r(1), o(10)) : (r(un(i, -1)), o(un(s, 1)))), i <= 0 && r(un(s, -1)), s <= 0 && o(un(i, 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, i = g_(n, this);
    return t.bounds === "ticks" && du(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Mi(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = He(t), this._valueRange = He(this.max) - He(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (He(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
E(io, "id", "logarithmic"), E(io, "defaults", {
  ticks: {
    callback: zs.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function so(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = Xt(t.backdropPadding);
    return nt(t.font && t.font.size, At.font.size) + n.height;
  }
  return 0;
}
function m_(e, t, n) {
  return n = Pt(n) ? n : [
    n
  ], {
    w: wy(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function Sc(e, t, n, i, s) {
  return e === i || e === s ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < i || e > s ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function b_(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), i = [], s = [], r = e._pointLabels.length, o = e.options.pointLabels, a = o.centerPointLabels ? pt / r : 0;
  for (let l = 0; l < r; l++) {
    const c = o.setContext(e.getPointLabelContext(l));
    s[l] = c.padding;
    const d = e.getPointPosition(l, e.drawingArea + s[l], a), u = Bt(c.font), h = m_(e.ctx, u, e._pointLabels[l]);
    i[l] = h;
    const p = Ut(e.getIndexAngle(l) + a), m = Math.round(jo(p)), g = Sc(m, d.x, h.w, 0, 180), b = Sc(m, d.y, h.h, 90, 270);
    y_(n, t, p, g, b);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = __(e, i, s);
}
function y_(e, t, n, i, s) {
  const r = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n));
  let a = 0, l = 0;
  i.start < t.l ? (a = (t.l - i.start) / r, e.l = Math.min(e.l, t.l - a)) : i.end > t.r && (a = (i.end - t.r) / r, e.r = Math.max(e.r, t.r + a)), s.start < t.t ? (l = (t.t - s.start) / o, e.t = Math.min(e.t, t.t - l)) : s.end > t.b && (l = (s.end - t.b) / o, e.b = Math.max(e.b, t.b + l));
}
function x_(e, t, n) {
  const i = e.drawingArea, { extra: s, additionalAngle: r, padding: o, size: a } = n, l = e.getPointPosition(t, i + s + o, r), c = Math.round(jo(Ut(l.angle + Lt))), d = C_(l.y, a.h, c), u = w_(c), h = S_(l.x, a.w, u);
  return {
    visible: !0,
    x: l.x,
    y: d,
    textAlign: u,
    left: h,
    top: d,
    right: h + a.w,
    bottom: d + a.h
  };
}
function v_(e, t) {
  if (!t)
    return !0;
  const { left: n, top: i, right: s, bottom: r } = e;
  return !(Re({
    x: n,
    y: i
  }, t) || Re({
    x: n,
    y: r
  }, t) || Re({
    x: s,
    y: i
  }, t) || Re({
    x: s,
    y: r
  }, t));
}
function __(e, t, n) {
  const i = [], s = e._pointLabels.length, r = e.options, { centerPointLabels: o, display: a } = r.pointLabels, l = {
    extra: so(r) / 2,
    additionalAngle: o ? pt / s : 0
  };
  let c;
  for (let d = 0; d < s; d++) {
    l.padding = n[d], l.size = t[d];
    const u = x_(e, d, l);
    i.push(u), a === "auto" && (u.visible = v_(u, c), u.visible && (c = u));
  }
  return i;
}
function w_(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function S_(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function C_(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function k_(e, t, n) {
  const { left: i, top: s, right: r, bottom: o } = n, { backdropColor: a } = t;
  if (!dt(a)) {
    const l = mn(t.borderRadius), c = Xt(t.backdropPadding);
    e.fillStyle = a;
    const d = i - c.left, u = s - c.top, h = r - i + c.width, p = o - s + c.height;
    Object.values(l).some((m) => m !== 0) ? (e.beginPath(), bi(e, {
      x: d,
      y: u,
      w: h,
      h: p,
      radius: l
    }), e.fill()) : e.fillRect(d, u, h, p);
  }
}
function P_(e, t) {
  const { ctx: n, options: { pointLabels: i } } = e;
  for (let s = t - 1; s >= 0; s--) {
    const r = e._pointLabelItems[s];
    if (!r.visible)
      continue;
    const o = i.setContext(e.getPointLabelContext(s));
    k_(n, o, r);
    const a = Bt(o.font), { x: l, y: c, textAlign: d } = r;
    wn(n, e._pointLabels[s], l, c + a.lineHeight / 2, a, {
      color: o.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function ef(e, t, n, i) {
  const { ctx: s } = e;
  if (n)
    s.arc(e.xCenter, e.yCenter, t, 0, Ct);
  else {
    let r = e.getPointPosition(0, t);
    s.moveTo(r.x, r.y);
    for (let o = 1; o < i; o++)
      r = e.getPointPosition(o, t), s.lineTo(r.x, r.y);
  }
}
function A_(e, t, n, i, s) {
  const r = e.ctx, o = t.circular, { color: a, lineWidth: l } = t;
  !o && !i || !a || !l || n < 0 || (r.save(), r.strokeStyle = a, r.lineWidth = l, r.setLineDash(s.dash || []), r.lineDashOffset = s.dashOffset, r.beginPath(), ef(e, n, o, i), r.closePath(), r.stroke(), r.restore());
}
function M_(e, t, n) {
  return en(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Jn extends As {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = Xt(so(this.options) / 2), n = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, i) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = Ot(t) && !isNaN(t) ? t : 0, this.max = Ot(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / so(this.options));
  }
  generateTickLabels(t) {
    As.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, i) => {
      const s = wt(this.options.pointLabels.callback, [
        n,
        i
      ], this);
      return s || s === 0 ? s : "";
    }).filter((n, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? b_(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, i, s) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((i - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, i, s));
  }
  getIndexAngle(t) {
    const n = Ct / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return Ut(t * n + he(i));
  }
  getDistanceFromCenterForValue(t) {
    if (dt(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (dt(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return M_(this.getContext(), t, i);
    }
  }
  getPointPosition(t, n, i = 0) {
    const s = this.getIndexAngle(t) - Lt + i;
    return {
      x: Math.cos(s) * n + this.xCenter,
      y: Math.sin(s) * n + this.yCenter,
      angle: s
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: i, right: s, bottom: r } = this._pointLabelItems[t];
    return {
      left: n,
      top: i,
      right: s,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const i = this.ctx;
      i.save(), i.beginPath(), ef(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: i, grid: s, border: r } = n, o = this._pointLabels.length;
    let a, l, c;
    if (n.pointLabels.display && P_(this, o), s.display && this.ticks.forEach((d, u) => {
      if (u !== 0 || u === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(d.value);
        const h = this.getContext(u), p = s.setContext(h), m = r.setContext(h);
        A_(this, p, l, o, m);
      }
    }), i.display) {
      for (t.save(), a = o - 1; a >= 0; a--) {
        const d = i.setContext(this.getPointLabelContext(a)), { color: u, lineWidth: h } = d;
        !h || !u || (t.lineWidth = h, t.strokeStyle = u, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, l = this.getDistanceFromCenterForValue(n.reverse ? this.min : this.max), c = this.getPointPosition(a, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, i = n.ticks;
    if (!i.display)
      return;
    const s = this.getIndexAngle(0);
    let r, o;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(s), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && this.min >= 0 && !n.reverse)
        return;
      const c = i.setContext(this.getContext(l)), d = Bt(c.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = d.string, o = t.measureText(a.label).width, t.fillStyle = c.backdropColor;
        const u = Xt(c.backdropPadding);
        t.fillRect(-o / 2 - u.left, -r - d.size / 2 - u.top, o + u.width, d.size + u.height);
      }
      wn(t, a.label, 0, -r, d, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
E(Jn, "id", "radialLinear"), E(Jn, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: zs.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), E(Jn, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), E(Jn, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Hs = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Qt = /* @__PURE__ */ Object.keys(Hs);
function Cc(e, t) {
  return e - t;
}
function kc(e, t) {
  if (dt(t))
    return null;
  const n = e._adapter, { parser: i, round: s, isoWeekday: r } = e._parseOpts;
  let o = t;
  return typeof i == "function" && (o = i(o)), Ot(o) || (o = typeof i == "string" ? n.parse(o, i) : n.parse(o)), o === null ? null : (s && (o = s === "week" && (Rn(r) || r === !0) ? n.startOf(o, "isoWeek", r) : n.startOf(o, s)), +o);
}
function Pc(e, t, n, i) {
  const s = Qt.length;
  for (let r = Qt.indexOf(e); r < s - 1; ++r) {
    const o = Hs[Qt[r]], a = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((n - t) / (a * o.size)) <= i)
      return Qt[r];
  }
  return Qt[s - 1];
}
function I_(e, t, n, i, s) {
  for (let r = Qt.length - 1; r >= Qt.indexOf(n); r--) {
    const o = Qt[r];
    if (Hs[o].common && e._adapter.diff(s, i, o) >= t - 1)
      return o;
  }
  return Qt[n ? Qt.indexOf(n) : 0];
}
function D_(e) {
  for (let t = Qt.indexOf(e) + 1, n = Qt.length; t < n; ++t)
    if (Hs[Qt[t]].common)
      return Qt[t];
}
function Ac(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: i, hi: s } = $o(n, t), r = n[i] >= t ? n[i] : n[s];
    e[r] = !0;
  }
}
function O_(e, t, n, i) {
  const s = e._adapter, r = +s.startOf(t[0].value, i), o = t[t.length - 1].value;
  let a, l;
  for (a = r; a <= o; a = +s.add(a, 1, i))
    l = n[a], l >= 0 && (t[l].major = !0);
  return t;
}
function Mc(e, t, n) {
  const i = [], s = {}, r = t.length;
  let o, a;
  for (o = 0; o < r; ++o)
    a = t[o], s[a] = o, i.push({
      value: a,
      major: !1
    });
  return r === 0 || !n ? i : O_(e, i, s, n);
}
class vi extends Sn {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const i = t.time || (t.time = {}), s = this._adapter = new Bx._date(t.adapters.date);
    s.init(n), ii(i.displayFormats, s.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : kc(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, i = t.time.unit || "day";
    let { min: s, max: r, minDefined: o, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !o && !isNaN(c.min) && (s = Math.min(s, c.min)), !a && !isNaN(c.max) && (r = Math.max(r, c.max));
    }
    (!o || !a) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), s = Ot(s) && !isNaN(s) ? s : +n.startOf(Date.now(), i), r = Ot(r) && !isNaN(r) ? r : +n.endOf(Date.now(), i) + 1, this.min = Math.min(s, r - 1), this.max = Math.max(s + 1, r);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], i = t[t.length - 1]), {
      min: n,
      max: i
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, i = t.ticks, s = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
    const r = this.min, o = this.max, a = cy(s, r, o);
    return this._unit = n.unit || (i.autoSkip ? Pc(n.minUnit, this.min, this.max, this._getLabelCapacity(r)) : I_(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : D_(this._unit), this.initOffsets(s), t.reverse && a.reverse(), Mc(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, i = 0, s, r;
    this.options.offset && t.length && (s = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - s : n = (this.getDecimalForValue(t[1]) - s) / 2, r = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? i = r : i = (r - this.getDecimalForValue(t[t.length - 2])) / 2);
    const o = t.length < 3 ? 0.5 : 0.25;
    n = jt(n, 0, o), i = jt(i, 0, o), this._offsets = {
      start: n,
      end: i,
      factor: 1 / (n + 1 + i)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, i = this.max, s = this.options, r = s.time, o = r.unit || Pc(r.minUnit, n, i, this._getLabelCapacity(n)), a = nt(s.ticks.stepSize, 1), l = o === "week" ? r.isoWeekday : !1, c = Rn(l) || l === !0, d = {};
    let u = n, h, p;
    if (c && (u = +t.startOf(u, "isoWeek", l)), u = +t.startOf(u, c ? "day" : o), t.diff(i, n, o) > 1e5 * a)
      throw new Error(n + " and " + i + " are too far apart with stepSize of " + a + " " + o);
    const m = s.ticks.source === "data" && this.getDataTimestamps();
    for (h = u, p = 0; h < i; h = +t.add(h, a, o), p++)
      Ac(d, h, m);
    return (h === i || s.bounds === "ticks" || p === 1) && Ac(d, h, m), Object.keys(d).sort(Cc).map((g) => +g);
  }
  getLabelForValue(t) {
    const n = this._adapter, i = this.options.time;
    return i.tooltipFormat ? n.format(t, i.tooltipFormat) : n.format(t, i.displayFormats.datetime);
  }
  format(t, n) {
    const s = this.options.time.displayFormats, r = this._unit, o = n || s[r];
    return this._adapter.format(t, o);
  }
  _tickFormatFunction(t, n, i, s) {
    const r = this.options, o = r.ticks.callback;
    if (o)
      return wt(o, [
        t,
        n,
        i
      ], this);
    const a = r.time.displayFormats, l = this._unit, c = this._majorUnit, d = l && a[l], u = c && a[c], h = i[n], p = c && u && h && h.major;
    return this._adapter.format(t, s || (p ? u : d));
  }
  generateTickLabels(t) {
    let n, i, s;
    for (n = 0, i = t.length; n < i; ++n)
      s = t[n], s.label = this._tickFormatFunction(s.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, i = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + i) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, i = this.ctx.measureText(t).width, s = he(this.isHorizontal() ? n.maxRotation : n.minRotation), r = Math.cos(s), o = Math.sin(s), a = this._resolveTickFontOptions(0).size;
    return {
      w: i * r + a * o,
      h: i * o + a * r
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, i = n.displayFormats, s = i[n.unit] || i.millisecond, r = this._tickFormatFunction(t, 0, Mc(this, [
      t
    ], this._majorUnit), s), o = this._getLabelSize(r), a = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, i;
    if (t.length)
      return t;
    const s = this.getMatchingVisibleMetas();
    if (this._normalized && s.length)
      return this._cache.data = s[0].controller.getAllParsedValues(this);
    for (n = 0, i = s.length; n < i; ++n)
      t = t.concat(s[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, i;
    if (t.length)
      return t;
    const s = this.getLabels();
    for (n = 0, i = s.length; n < i; ++n)
      t.push(kc(this, s[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return hu(t.sort(Cc));
  }
}
E(vi, "id", "time"), E(vi, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function qi(e, t, n) {
  let i = 0, s = e.length - 1, r, o, a, l;
  n ? (t >= e[i].pos && t <= e[s].pos && ({ lo: i, hi: s } = Ee(e, "pos", t)), { pos: r, time: a } = e[i], { pos: o, time: l } = e[s]) : (t >= e[i].time && t <= e[s].time && ({ lo: i, hi: s } = Ee(e, "time", t)), { time: r, pos: a } = e[i], { time: o, pos: l } = e[s]);
  const c = o - r;
  return c ? a + (l - a) * (t - r) / c : a;
}
class ro extends vi {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = qi(n, this.min), this._tableRange = qi(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: i } = this, s = [], r = [];
    let o, a, l, c, d;
    for (o = 0, a = t.length; o < a; ++o)
      c = t[o], c >= n && c <= i && s.push(c);
    if (s.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (o = 0, a = s.length; o < a; ++o)
      d = s[o + 1], l = s[o - 1], c = s[o], Math.round((d + l) / 2) !== c && r.push({
        time: c,
        pos: o / (a - 1)
      });
    return r;
  }
  _generate() {
    const t = this.min, n = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(t) || !i.length) && i.splice(0, 0, t), (!i.includes(n) || i.length === 1) && i.push(n), i.sort((s, r) => s - r);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return n.length && i.length ? t = this.normalize(n.concat(i)) : t = n.length ? n : i, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (qi(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return qi(this._table, i * this._tableRange + this._minPos, !0);
  }
}
E(ro, "id", "timeseries"), E(ro, "defaults", vi.defaults);
var T_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: eo,
  LinearScale: no,
  LogarithmicScale: io,
  RadialLinearScale: Jn,
  TimeScale: vi,
  TimeSeriesScale: ro
});
const E_ = [
  zx,
  p1,
  c_,
  T_
], R_ = ({ attachments: e }) => {
  const [t, n] = Y(), i = ({ formId: s, studentId: r, rowId: o }) => {
    n({ formId: s, studentId: r, rowId: o, editMode: ct.Read });
  };
  return /* @__PURE__ */ k(R, { display: "flex", flexDirection: "column", pt: 1, alignItems: "flex-end", children: [
    t && /* @__PURE__ */ f(lo, { open: !!t, onClose: () => n(null), children: /* @__PURE__ */ f(R, { p: 2, children: /* @__PURE__ */ f(yb, { ...t }) }) }),
    e.filter((s) => s.AttachmentType === fs.Record).map((s) => {
      if (!s.Record)
        return /* @__PURE__ */ f(H, { children: "You do not have access to view the attached record" });
      const { StatusCaption: r, Created: o, Modified: a, Summary: l, FormId: c, StudentId: d, RowId: u } = s.Record;
      return /* @__PURE__ */ f(
        Jd,
        {
          status: r,
          created: o,
          modified: a,
          summary: l,
          onClick: () => i({
            formId: c,
            studentId: d,
            rowId: u
          })
        },
        s.AttachmentID
      );
    }),
    /* @__PURE__ */ f(R, { sx: { display: "flex", gap: 1 }, children: e == null ? void 0 : e.filter((s) => s.AttachmentType === fs.File).map((s) => {
      const { FileID: r, Ext: o, Name: a } = s.File;
      return /* @__PURE__ */ f(
        Eo,
        {
          extension: o,
          fileName: a,
          fileId: r,
          download: !0,
          size: "small"
        },
        r
      );
    }) })
  ] });
}, L_ = ({ MessageID: e, Text: t, SenderName: n, SentOn: i, SenderID: s, isSender: r, joinWithPrev: o, fadeIn: a, showOpenLink: l, Attachments: c, sentBySchool: d, onOpenMessage: u }) => {
  const [h, p] = Y(!a), m = tn(), g = r ? m.palette.primary.main : void 0, b = r ? m.palette.getContrastText(g) : void 0;
  return mt(() => {
    h || setTimeout(() => p(!0), 0);
  }, [h]), /* @__PURE__ */ f(Of, { in: h, children: /* @__PURE__ */ k(R, { sx: { display: "flex", gap: "11px", alignSelf: r ? "flex-end" : "flex-start", pt: o ? 0 : 2 }, children: [
    !r && /* @__PURE__ */ f(Fs, { contactId: d ? 0 : s, contactFullName: d ? "School" : n, sx: { marginTop: 1 } }),
    /* @__PURE__ */ k(R, { sx: { display: "flex", flexFlow: "column" }, children: [
      /* @__PURE__ */ k(R, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, pb: "3px", color: "var(--mui-palette-text-secondary)" }, children: [
        !r && /* @__PURE__ */ f(H, { sx: { fontWeight: "500", fontSize: ".9rem" }, children: d ? "School" : n }),
        /* @__PURE__ */ f(H, { sx: { fontSize: ".7rem", flexGrow: 1, textAlign: r ? "right" : void 0 }, children: !o && i && Zt(i) })
      ] }),
      /* @__PURE__ */ k(_i, { sx: { px: 2, py: 1, bgcolor: g, color: b, alignSelf: r ? "flex-end" : "flex-start" }, children: [
        typeof t == "string" ? /* @__PURE__ */ f("div", { dangerouslySetInnerHTML: { __html: t } }) : /* @__PURE__ */ f("div", { children: t }),
        !r && l && u && /* @__PURE__ */ k(Lc, { onClick: () => u(e), sx: { display: "inline-flex", alignItems: "center", gap: 1, pt: 1, cursor: "pointer" }, children: [
          /* @__PURE__ */ f(Z, { sx: { fontSize: "1.1rem" }, iconType: J.Return }),
          /* @__PURE__ */ f(H, { variant: "caption", children: "Open this message" })
        ] })
      ] }),
      c && c.length > 0 && /* @__PURE__ */ f(R_, { attachments: c })
    ] })
  ] }) });
}, Sk = () => /* @__PURE__ */ k(R, { sx: { display: "flex", gap: "11px", alignSelf: "flex-start", flexGrow: 1, width: "100%" }, children: [
  /* @__PURE__ */ f(at, { variant: "circular", width: 30, height: 30 }),
  /* @__PURE__ */ k(R, { sx: { display: "flex", flexFlow: "column", flexGrow: 1 }, children: [
    /* @__PURE__ */ f(at, { variant: "text", width: 70 }),
    /* @__PURE__ */ f(at, { variant: "rectangular", height: 80, sx: { flexGrow: 1 } })
  ] })
] }), F_ = "_highlight_1vlfy_1", N_ = "_located_1vlfy_7", Ic = {
  highlight: F_,
  located: N_
}, z_ = lf(
  () => import("./components/pdf/AnnotatedPdfViewer.js").then((e) => ({
    default: e.AnnotatedPdfViewer
  }))
);
function Ck({ fileId: e }) {
  const [t, n] = Y("document"), [i, s] = Y(), r = (o) => {
    n("document"), s(o);
  };
  return /* @__PURE__ */ k(gt, { gap: 2, children: [
    /* @__PURE__ */ k(Tf, { value: t, onChange: (o, a) => {
      s(void 0), n(`${a}`);
    }, "aria-label": "Feedback tabs", children: [
      /* @__PURE__ */ f(Jo, { label: "Document viewer", id: "document", value: "document" }),
      /* @__PURE__ */ f(Jo, { label: "All comments", id: "all comments", value: "all comments" })
    ] }),
    /* @__PURE__ */ f(Dc, { tabId: "document", value: t, children: /* @__PURE__ */ f(W_, { fileId: Number(e), scrollToId: i }) }),
    /* @__PURE__ */ f(Dc, { tabId: "all comments", value: t, children: /* @__PURE__ */ f(B_, { fileId: Number(e), onLocate: r }) })
  ] });
}
function Dc({ children: e, value: t, tabId: n }) {
  return /* @__PURE__ */ f("div", { role: "tabpanel", hidden: t !== n, style: { paddingTop: "20px" }, children: e });
}
function B_({ fileId: e, onLocate: t }) {
  const { data: n, isPending: i } = new Bf.Annotations({ fileId: Number(e) }).ToQuery();
  return i ? /* @__PURE__ */ f(Ds, { type: "listitems" }) : n ? /* @__PURE__ */ f(gt, { gap: 2, children: n.map((s) => /* @__PURE__ */ k(jc, { variant: "outlined", sx: { position: "relative", overflow: "auto" }, children: [
    /* @__PURE__ */ k(R, { sx: { display: "flex", justifyContent: "space-between" }, children: [
      /* @__PURE__ */ k(H, { sx: { alignSelf: "center", p: 1 }, children: [
        '"',
        s.Text,
        '"'
      ] }),
      /* @__PURE__ */ f(ot, { onClick: () => t(s.AnnotationID), startIcon: /* @__PURE__ */ f(Z, { iconType: J.FileFind }), children: "Locate in document" })
    ] }),
    /* @__PURE__ */ f($c, { variant: "fullWidth" }),
    /* @__PURE__ */ f(R, { p: 2, pt: 0, children: /* @__PURE__ */ f(nf, { comments: s.Comments }) })
  ] }, s.AnnotationID)) }) : /* @__PURE__ */ f(ke, { color: "error", children: "Could not get annotation data for file" });
}
function W_({ fileId: e, scrollToId: t }) {
  const { data: n, isPending: i } = new Si.FileInfo(Number(e)).ToQuery(), [s, r] = Y(100);
  if (i)
    return /* @__PURE__ */ f(Ds, { type: "page" });
  if (!n)
    throw new Error("Could not find file or you do not have permission");
  return /* @__PURE__ */ k(gt, { gap: 2, children: [
    /* @__PURE__ */ k(R, { display: "flex", justifyContent: "space-between", flexWrap: "wrap", children: [
      /* @__PURE__ */ f(Eo, { download: !0, fileId: n.Id, fileName: n.Name, extension: n.Ext }),
      /* @__PURE__ */ k(R, { display: "flex", gap: 1, alignItems: "center", children: [
        /* @__PURE__ */ k(H, { children: [
          s,
          "%"
        ] }),
        /* @__PURE__ */ f(li, { color: "primary", "aria-label": "Zoom Out", onClick: () => r(s - 10), children: /* @__PURE__ */ f(Z, { iconType: J.ZoomOut }) }),
        /* @__PURE__ */ f(li, { color: "primary", "aria-label": "Zoom In", onClick: () => r(s + 10), children: /* @__PURE__ */ f(Z, { iconType: J.ZoomIn }) }),
        /* @__PURE__ */ f(ot, { onClick: () => r(100), children: "Reset" })
      ] })
    ] }),
    /* @__PURE__ */ f(cf, { fallback: /* @__PURE__ */ f(R, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ f(wi, {}) }), children: /* @__PURE__ */ f(
      z_,
      {
        fileId: Number(e),
        scale: s / 100,
        scrollToId: t,
        highlightClassName: Ic.highlight,
        locatedClassName: Ic.located,
        renderAnnotationDialog: (o, a) => /* @__PURE__ */ f(Se, { open: !0, onClose: a, children: /* @__PURE__ */ k(gt, { gap: 1, p: 2, children: [
          /* @__PURE__ */ k(gt, { children: [
            /* @__PURE__ */ f(H, { variant: "caption", children: "Text" }),
            /* @__PURE__ */ k(H, { children: [
              '"',
              o.Text,
              '"'
            ] })
          ] }),
          /* @__PURE__ */ f(nf, { comments: o.Comments })
        ] }) })
      }
    ) })
  ] });
}
function nf({ comments: e }) {
  return e.map((t) => {
    let n = t.Text;
    return t.RecordingID && (n = /* @__PURE__ */ f(j_, { fileId: t.RecordingID })), /* @__PURE__ */ f(
      L_,
      {
        SenderID: t.ContactID,
        SenderName: `${t.Firstname} ${t.Surname}`,
        Text: n,
        SentOn: t.Uploaded,
        MessageID: t.CommentID
      },
      t.CommentID
    );
  });
}
function j_({ fileId: e }) {
  const { data: t, isPending: n } = new Si.FileDownLoadLink({ FileId: e, enable: !0 }).ToQuery();
  return n ? /* @__PURE__ */ f(wi, {}) : /* @__PURE__ */ k("audio", { controls: !0, style: { maxWidth: "100%" }, children: [
    /* @__PURE__ */ f("source", { src: t, type: "audio/wav" }),
    "Your browser does not support the audio element."
  ] });
}
var oo = /* @__PURE__ */ new Map(), Xi = /* @__PURE__ */ new WeakMap(), Oc = 0, $_ = void 0;
function V_(e) {
  return e ? (Xi.has(e) || (Oc += 1, Xi.set(e, Oc.toString())), Xi.get(e)) : "0";
}
function H_(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? V_(e.root) : e[t]}`).toString();
}
function U_(e) {
  const t = H_(e);
  let n = oo.get(t);
  if (!n) {
    const i = /* @__PURE__ */ new Map();
    let s;
    const r = new IntersectionObserver((o) => {
      o.forEach((a) => {
        var l;
        const c = a.isIntersecting && s.some((d) => a.intersectionRatio >= d);
        e.trackVisibility && typeof a.isVisible > "u" && (a.isVisible = c), (l = i.get(a.target)) == null || l.forEach((d) => {
          d(c, a);
        });
      });
    }, e);
    s = r.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: r,
      elements: i
    }, oo.set(t, n);
  }
  return n;
}
function Y_(e, t, n = {}, i = $_) {
  if (typeof window.IntersectionObserver > "u" && i !== void 0) {
    const l = e.getBoundingClientRect();
    return t(i, {
      isIntersecting: i,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: l,
      intersectionRect: l,
      rootBounds: l
    }), () => {
    };
  }
  const { id: s, observer: r, elements: o } = U_(n), a = o.get(e) || [];
  return o.has(e) || o.set(e, a), a.push(t), r.observe(e), function() {
    a.splice(a.indexOf(t), 1), a.length === 0 && (o.delete(e), r.unobserve(e)), o.size === 0 && (r.disconnect(), oo.delete(s));
  };
}
function q_({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: i,
  root: s,
  triggerOnce: r,
  skip: o,
  initialInView: a,
  fallbackInView: l,
  onChange: c
} = {}) {
  var d;
  const [u, h] = Wn.useState(null), p = Wn.useRef(c), [m, g] = Wn.useState({
    inView: !!a,
    entry: void 0
  });
  p.current = c, Wn.useEffect(
    () => {
      if (o || !u) return;
      let w;
      return w = Y_(
        u,
        (S, v) => {
          g({
            inView: S,
            entry: v
          }), p.current && p.current(S, v), v.isIntersecting && r && w && (w(), w = void 0);
        },
        {
          root: s,
          rootMargin: i,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        l
      ), () => {
        w && w();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      u,
      s,
      i,
      r,
      o,
      n,
      l,
      t
    ]
  );
  const b = (d = m.entry) == null ? void 0 : d.target, y = Wn.useRef(void 0);
  !u && b && !r && !o && y.current !== b && (y.current = b, g({
    inView: !!a,
    entry: void 0
  }));
  const x = [h, m.inView, m.entry];
  return x.ref = x[0], x.inView = x[1], x.entry = x[2], x;
}
const kk = Ft(({ folderId: e, pageLength: t, unreadOnly: n, onClick: i, setReadOnClick: s = !0, selectedIds: r = [], staleDate: o }, a) => {
  const { ref: l, inView: c } = q_({ threshold: 1 }), d = xo(), u = new Lf.folders.messages({ folderId: e, msgsPerPage: t, unreadOnly: n, staleDate: o }), {
    data: h,
    fetchNextPage: p,
    hasNextPage: m,
    isFetching: g,
    isFetchingNextPage: b,
    refetch: y
  } = u.ToQuery(), x = h, w = (S, v) => {
    i && i(S), s && setTimeout(() => {
      d.setQueryData(u.key, (_) => {
        if (!_) return _;
        const C = [..._.pages];
        return C[v] = C[v].map((P) => ({ ...P, Read: P.MessageID === S ? !0 : P.Read })), { ..._, pages: C };
      });
    }, 0);
  };
  return mt(() => {
    c && !g && !b && p();
  }, [c, g, b]), Wt(a, () => ({
    refetch: y
  })), g && !b ? /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
    /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 })
  ] }) : /* @__PURE__ */ k(ht, { children: [
    x == null ? void 0 : x.pages.map((S, v) => S.map((_) => /* @__PURE__ */ f(
      Kd,
      {
        messageType: _.MessageType,
        subject: _.Subject,
        sentFrom: _.SenderName,
        date: new Date(_.SentOn),
        read: e === "1" && _.Read,
        onClick: () => w(_.MessageID, v),
        selected: r.indexOf(_.MessageID) >= 0,
        attachments: _.Attachments,
        threadCount: _.ThreadCount
      },
      _.MessageID
    ))),
    b && /* @__PURE__ */ k(ht, { children: [
      /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
      /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
      /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 }),
      /* @__PURE__ */ f(at, { variant: "rectangular", height: 50 })
    ] }),
    !g && !b && (x == null ? void 0 : x.pages.length) === 1 && x.pages[0].length === 0 ? /* @__PURE__ */ f(bs, { children: "No messages" }) : m ? /* @__PURE__ */ f("div", { ref: l }) : /* @__PURE__ */ f(bs, { children: "End of messages" })
  ] });
}), Pk = ({ classId: e, year: t, onClick: n, selected: i }) => {
  const s = new Wf.CoursePosts({ classId: e, year: t }), { data: r, isLoading: o } = s.ToQuery();
  return o ? /* @__PURE__ */ f(Ds, { type: "listitems" }) : !r || r.length === 0 ? /* @__PURE__ */ f(bs, { children: "No posts found" }) : /* @__PURE__ */ f(R, { display: "flex", gap: 1, flexDirection: "column", children: r.map((a) => /* @__PURE__ */ f(
    Kd,
    {
      subject: a.Subject,
      sentFrom: a.SenderName,
      messageType: ue.Post,
      date: a.Sent ? new Date(a.Sent) : void 0,
      read: !1,
      onClick: () => n == null ? void 0 : n(a),
      selected: i === a.MessageID
    },
    a.MessageID
  )) });
}, X_ = "_textbox_1bat6_1", G_ = {
  textbox: X_
}, Ak = Ft(({ threadID: e, onMessageSent: t, actionsMask: n, messageProperties: i, messageType: s, canSendCheck: r, contactIds: o, subject: a }, l) => {
  const [c, d] = Y(""), [u, h] = Y(!1), [p, m] = Y(!1), { Post: g } = Ne(), { baseUrl: b } = me(), y = kt(null), x = kt(null), [w, S] = Y(), { files: v, addFiles: _, removeFile: C, uploadAll: P } = dd();
  Wt(l, () => ({
    clear: () => {
      d(""), y.current && (y.current.style.height = "auto");
    }
  })), mt(() => {
    c && S(null);
  }, [c]);
  const I = (n & Ii.Reply) !== 0, V = (n & Ii.ReplyAll) !== 0, $ = (n & Ii.Send) !== 0, T = () => {
    var B;
    I && V ? (B = x.current) == null || B.open() : q(V);
  }, j = () => {
    const B = y.current;
    B && (B.style.height = "auto", B.style.height = `${B.scrollHeight}px`);
  }, q = async (B) => {
    var st;
    if ((st = x.current) == null || st.close(), !c) {
      S(["NO_MSG_BODY", "Must enter a message to send"]);
      return;
    }
    if (r && !r())
      return;
    h(!0);
    const X = await g({
      url: `${b}/lms/api/coms/message/create`,
      data: {
        body: c,
        threadID: e,
        replyAll: B,
        properties: i,
        messageType: s,
        contactIds: o,
        subject: a
      },
      config: {}
    });
    X.Recipients = [], v.length > 0 && await P({ messageId: `${X.MessageID}` });
    const G = await g({
      url: `${b}/lms/api/coms/draft/send`,
      data: { ThreadID: X.ThreadID, MessageID: X.MessageID, MessageType: X.MessageType },
      config: {}
    });
    G && (t(G), d(""), h(!1));
  };
  return !I && !V && !(!e && $) ? null : /* @__PURE__ */ k(ht, { children: [
    /* @__PURE__ */ f(Se, { ref: x, children: /* @__PURE__ */ f(R, { children: /* @__PURE__ */ k(Ef, { children: [
      /* @__PURE__ */ k(cs, { onClick: () => q(!1), children: [
        /* @__PURE__ */ f(ta, { children: /* @__PURE__ */ f(Z, { iconType: J.Reply }) }),
        /* @__PURE__ */ f(ea, { children: "Reply" })
      ] }),
      /* @__PURE__ */ k(cs, { onClick: () => q(!0), children: [
        /* @__PURE__ */ f(ta, { children: /* @__PURE__ */ f(Z, { iconType: J.ReplyAll }) }),
        /* @__PURE__ */ f(ea, { children: "Reply All" })
      ] })
    ] }) }) }),
    w && /* @__PURE__ */ f(Rf, { in: !!w, children: /* @__PURE__ */ f(ke, { severity: "error", children: w[1] }) }),
    /* @__PURE__ */ k(_i, { sx: { display: "flex", flexFlow: "column", alignItems: "center", gap: 1, pr: 1, pb: 1 }, children: [
      /* @__PURE__ */ f(yp, { open: u, text: "Sending" }),
      /* @__PURE__ */ f(
        "textarea",
        {
          id: "txtMessage",
          name: "txtMessage",
          ref: y,
          placeholder: "Send new message...",
          onInput: j,
          onChange: (B) => d(B.target.value),
          value: c,
          className: G_.textbox
        }
      ),
      /* @__PURE__ */ k(R, { sx: { alignSelf: "flex-end" }, children: [
        p && /* @__PURE__ */ f(su, { files: v, addFiles: _, removeFile: C, type: ud.Message, onClose: () => m(!1) }),
        (n & Ii.Attach) > 0 && /* @__PURE__ */ f(ao, { color: "success", anchorOrigin: { horizontal: "left" }, badgeContent: v.length > 0 ? v.length : void 0, children: /* @__PURE__ */ f(ot, { startIcon: /* @__PURE__ */ f(Z, { iconType: J.Attachment }), size: "small", variant: "text", onClick: () => m(!0), sx: { minWidth: 0, pr: 1 } }) }),
        /* @__PURE__ */ f(ot, { size: "extraSmall", startIcon: /* @__PURE__ */ f(Z, { iconType: J.Send }), variant: "contained", onClick: T, children: "Send" })
      ] })
    ] })
  ] });
});
Oe.register(...E_);
const Gi = ["#aab2f2", "#aaf2e5", "#f2d2aa", "#f2f0aa", "#aaf2ed", "#b6f2aa", "#f2afaa", "#f2e1aa", "#aaf2d7", "#f2b3aa", "#aaddf2", "#d1aaf2", "#aaf2ad", "#f2bcaa", "#f2baaa", "#f2beaa", "#aabdf2", "#aaf2c5", "#f2c4aa", "#c5aaf2", "#aaaef2", "#baaaf2", "#aaf2c2", "#eff2aa", "#c4aaf2", "#aaeff2", "#d8f2aa", "#f2aaae", "#f2aac3", "#b5f2aa", "#aaf2cf", "#dff2aa", "#f2c9aa", "#e2aaf2", "#f2aab4", "#f2d4aa", "#aab3f2", "#aaf2e3", "#e3f2aa", "#e8f2aa", "#aaf2e7", "#def2aa", "#aac8f2", "#f2aac0", "#c9aaf2", "#f2d1aa", "#f2aaab", "#f2aad7", "#acaaf2", "#c9f2aa", "#f2b0aa", "#d8aaf2", "#f2dfaa", "#f2aab9", "#aae4f2", "#edf2aa", "#b9aaf2", "#ebaaf2", "#c5f2aa", "#aaf0f2", "#f2aac1", "#d3f2aa", "#d0aaf2", "#aaf2eb", "#e9f2aa", "#aaf2d2", "#c0aaf2", "#d3aaf2", "#aab8f2", "#aac7f2", "#aaf2d4", "#bff2aa", "#f2aacd", "#aacaf2", "#f2bbaa", "#c3aaf2", "#f2aad6", "#aaf2b8", "#f2eeaa", "#d2f2aa", "#aaf2c9", "#f2aad4", "#aaf2b9", "#bbf2aa", "#f2aabd"], Mk = ({ width: e = "100%", height: t = 400, onLoad: n }) => {
  const i = kt(null), s = kt(null), { data: r, isPending: o, error: a } = new zf.GetPointsGraphData().ToQuery();
  return mt(() => {
    if (!i.current || !r || o) return;
    s.current && s.current.destroy();
    const l = i.current.getContext("2d");
    if (!l) return;
    const c = {
      type: "bar",
      data: {
        labels: r.Data.map((d) => d.Group),
        datasets: [{
          label: "Points",
          data: r.Data.map((d) => d.Points),
          backgroundColor: r.Data.map((d, u) => d.Colour || Gi[u % Gi.length]),
          borderColor: r.Data.map((d, u) => d.Colour || Gi[u % Gi.length]),
          borderWidth: 1
        }]
      },
      options: {
        indexAxis: "y",
        // This makes it horizontal
        responsive: !0,
        maintainAspectRatio: !1,
        plugins: {
          legend: {
            display: !1
          },
          title: {
            display: !1
          }
        },
        scales: {
          x: {
            beginAtZero: !0,
            ticks: {
              precision: 0
            }
          }
        }
      }
    };
    return s.current = new Oe(l, c), () => {
      s.current && s.current.destroy();
    };
  }, [r, o]), mt(() => {
    r && n && n(r);
  }, [r, n]), o ? /* @__PURE__ */ f(Ds, { type: "pointsgraph" }) : a ? /* @__PURE__ */ f(ke, { severity: "error", children: "Error loading points graph" }) : /* @__PURE__ */ f(R, { width: e, height: t, children: /* @__PURE__ */ f("canvas", { ref: i }) });
};
export {
  ak as $,
  dk as A,
  L_ as B,
  gk as C,
  Z as D,
  bk as E,
  vp as F,
  Sk as G,
  R_ as H,
  wk as I,
  Ak as J,
  kk as K,
  _p as L,
  Kd as M,
  bs as N,
  Mk as O,
  Qd as P,
  ua as Q,
  Jd as R,
  Sp as S,
  tl as T,
  hk as U,
  Ja as V,
  xk as W,
  ck as X,
  Zd as Y,
  k0 as Z,
  ok as _,
  wp as a,
  Oe as a0,
  E_ as a1,
  e0 as a2,
  n0 as a3,
  b0 as a4,
  S0 as a5,
  C0 as a6,
  I0 as a7,
  D0 as a8,
  O0 as a9,
  T0 as aa,
  E0 as ab,
  R0 as ac,
  L0 as ad,
  F0 as ae,
  N0 as af,
  z0 as ag,
  B0 as ah,
  W0 as ai,
  ib as aj,
  lb as ak,
  ub as al,
  fb as am,
  Ae as an,
  hb as ao,
  pb as ap,
  ol as aq,
  vb as ar,
  Pk as as,
  J as b,
  lk as c,
  i0 as d,
  To as e,
  uk as f,
  Se as g,
  fk as h,
  yk as i,
  Eo as j,
  Ro as k,
  mk as l,
  g0 as m,
  Fs as n,
  t0 as o,
  vk as p,
  yb as q,
  ct as r,
  gb as s,
  pk as t,
  xp as u,
  f0 as v,
  p0 as w,
  su as x,
  _k as y,
  Ck as z
};
//# sourceMappingURL=pointsGraph-DTJju-rA.js.map
